/* eslint-disable */
import { Int64 } from '../custom-scalars';
import { NumericID } from '../custom-scalars';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  FilterType: any;
  Int64: Int64;
  JSON: any;
  NumericID: NumericID;
};

export type AiOverview = {
  readonly __typename?: 'AIOverview';
  readonly followupQuestions: Maybe<ReadonlyArray<FollowupQuestion>>;
  readonly inferredQuestion: Maybe<Scalars['String']>;
  readonly references: Maybe<Reference>;
  readonly summary: Maybe<Scalars['String']>;
  readonly variant: Maybe<Scalars['String']>;
};

export type AiRelatedQuestions = {
  readonly __typename?: 'AIRelatedQuestions';
  readonly items: Maybe<ReadonlyArray<Items>>;
};

export type Academy = {
  readonly __typename?: 'Academy';
  readonly product: Maybe<Scalars['String']>;
  readonly quizzes: Maybe<ReadonlyArray<Maybe<AcademyQuiz>>>;
  readonly userInfo: Maybe<AcademyUserInfo>;
};

export type AcademyQuestion = {
  readonly __typename?: 'AcademyQuestion';
  readonly description: Maybe<Scalars['String']>;
  readonly idx: Maybe<Scalars['Int']>;
  readonly isCorrect: Maybe<Scalars['Boolean']>;
  readonly kind: Maybe<Scalars['String']>;
  readonly label: Maybe<Scalars['String']>;
  readonly options: Maybe<ReadonlyArray<Maybe<AcademyQuestionOption>>>;
  readonly questionId: Maybe<Scalars['Int']>;
  readonly rewardAmount: Maybe<Scalars['Int']>;
  readonly rewardType: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
  readonly userAnswer: Maybe<ReadonlyArray<Maybe<Scalars['Int']>>>;
};

export type AcademyQuestionOption = {
  readonly __typename?: 'AcademyQuestionOption';
  readonly name: Maybe<Scalars['String']>;
  readonly value: Maybe<Scalars['Int']>;
};

export type AcademyQuiz = {
  readonly __typename?: 'AcademyQuiz';
  readonly idx: Maybe<Scalars['Int']>;
  readonly percentage: Maybe<Scalars['Float']>;
  readonly questions: Maybe<ReadonlyArray<Maybe<AcademyQuestion>>>;
  readonly quizId: Maybe<Scalars['Int']>;
  readonly status: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
  readonly totalAnsweredQuestions: Maybe<Scalars['Int']>;
  readonly totalQuestions: Maybe<Scalars['Int']>;
};

export type AcademyStats = {
  readonly __typename?: 'AcademyStats';
  readonly answered: Maybe<Scalars['Int']>;
  readonly available: Maybe<Scalars['Int']>;
  readonly lastQuestionDate: Maybe<Scalars['Float']>;
  readonly product: Maybe<Scalars['String']>;
  readonly total: Maybe<Scalars['Int']>;
};

export type AcademyUserInfo = {
  readonly __typename?: 'AcademyUserInfo';
  readonly lastSeen: Maybe<Scalars['Float']>;
  readonly sawWelcomeModal: Maybe<Scalars['Boolean']>;
  readonly startedAt: Maybe<Scalars['Float']>;
  readonly userId: Maybe<Scalars['Int']>;
};

export type AcceptBackgroundCheckTermsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type AcceptBackgroundCheckTermsPayload = {
  readonly __typename?: 'AcceptBackgroundCheckTermsPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type AcceptHubInviteInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly inviteId: Scalars['String'];
  readonly username: Scalars['String'];
};

export type AcceptHubInvitePayload = {
  readonly __typename?: 'AcceptHubInvitePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly errorCode: Maybe<Scalars['String']>;
  readonly invite: Maybe<HubInvite>;
  readonly message: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type AcceptInviteInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly inviteId: Scalars['String'];
};

export type AcceptInvitePayload = {
  readonly __typename?: 'AcceptInvitePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly message: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type AcceptOrganizationInviteInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly memberId: Scalars['Int'];
  readonly organizationId: Scalars['Int'];
};

export type AcceptOrganizationInvitePayload = {
  readonly __typename?: 'AcceptOrganizationInvitePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly cookie: Maybe<Scalars['String']>;
  readonly member: Maybe<OrganizationMember>;
};

export type AcceptShareEntityInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly shareId: Scalars['String'];
};

export type AcceptShareEntityPayload = {
  readonly __typename?: 'AcceptShareEntityPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly entity: Maybe<CrmEntity>;
  readonly organization: Maybe<Organization>;
  readonly share: Maybe<CrmEntityShare>;
};

export type ActivatePriceIncreaseInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly id?: InputMaybe<Scalars['String']>;
};

export type ActivatePriceIncreasePayload = {
  readonly __typename?: 'ActivatePriceIncreasePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly error: Maybe<Scalars['String']>;
  readonly priceIncrease: Maybe<PriceIncrease>;
};

export type ActivateStudentBenefitInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly course: Scalars['String'];
  readonly enrollmentPeriod: Scalars['String'];
  readonly experimentVariant?: InputMaybe<Scalars['String']>;
  readonly institution: Scalars['String'];
};

export type ActivateStudentBenefitPayload = {
  readonly __typename?: 'ActivateStudentBenefitPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly expiresAt: Maybe<Scalars['Float']>;
  readonly status: Maybe<StudentBenefitStatusEnum>;
  readonly waitlistReason: Maybe<WaitlistReasonEnum>;
};

export type ActivityInferenceClassification = {
  readonly __typename?: 'ActivityInferenceClassification';
  readonly completeClassification: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly judgment: Maybe<ClassificationJudgment>;
  readonly method: Maybe<Scalars['String']>;
};

export type AddBlockedNotificationTypeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly tipoNotificacaoBloqueada: Scalars['String'];
};

export type AddBlockedNotificationTypePayload = {
  readonly __typename?: 'AddBlockedNotificationTypePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly message: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type AddCrmCommentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly entityId: Scalars['String'];
  readonly entityType: Scalars['String'];
  readonly text: Scalars['String'];
};

export type AddCrmCommentPayload = {
  readonly __typename?: 'AddCRMCommentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly comment: Maybe<CrmComment>;
  readonly commentEdge: Maybe<CrmEntityCommentsEdge>;
  readonly commentableEntity: Maybe<CrmCommentable>;
};

export type AddCollectionDocumentsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly collectionId: Scalars['String'];
  readonly documents: ReadonlyArray<InputMaybe<Scalars['JSON']>>;
};

export type AddCollectionDocumentsPayload = {
  readonly __typename?: 'AddCollectionDocumentsPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly collectionId: Maybe<Scalars['String']>;
  readonly documents: Maybe<ReadonlyArray<Maybe<UserCollectionDocument>>>;
};

export type AddCommentDocumentInput = {
  readonly artifact: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId: Scalars['NumericID'];
  readonly text: Scalars['String'];
};

export type AddCommentDocumentPayload = {
  readonly __typename?: 'AddCommentDocumentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly comment: Maybe<Document>;
  readonly document: Maybe<Document>;
};

export type AddOnCitationQueuesInput = {
  readonly artifact: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId: Scalars['NumericID'];
};

export type AddOnCitationQueuesPayload = {
  readonly __typename?: 'AddOnCitationQueuesPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly document: Maybe<Document>;
};

export type AddOnboardingReminderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly reminders?: InputMaybe<Scalars['JSON']>;
};

export type AddOnboardingReminderPayload = {
  readonly __typename?: 'AddOnboardingReminderPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly user: Maybe<User>;
};

export type AddOptOutForAllNotificationTypesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly notificationChannel?: InputMaybe<NotificationChannelEnum>;
};

export type AddOptOutForAllNotificationTypesPayload = {
  readonly __typename?: 'AddOptOutForAllNotificationTypesPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly message: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type AddPipedrive4bizDealInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly source?: InputMaybe<Scalars['String']>;
};

export type AddPipedrive4bizDealPayload = {
  readonly __typename?: 'AddPipedrive4bizDealPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type AddPipedriveDealInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type AddPipedriveDealPayload = {
  readonly __typename?: 'AddPipedriveDealPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type AddReplyDocumentCommentInput = {
  readonly artifact: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly commentId: Scalars['NumericID'];
  readonly docId: Scalars['NumericID'];
  readonly text: Scalars['String'];
};

export type AddReplyDocumentCommentPayload = {
  readonly __typename?: 'AddReplyDocumentCommentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly commentParent: Maybe<Document>;
  readonly document: Maybe<Document>;
  readonly reply: Maybe<Document>;
};

export type AddScoreDocumentInput = {
  readonly artifact: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId: Scalars['NumericID'];
  readonly score: Scalars['Int'];
};

export type AddScoreDocumentPayload = {
  readonly __typename?: 'AddScoreDocumentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly document: Maybe<Document>;
};

export type AddToWhatsappBlockListInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly phoneNumber: Scalars['String'];
  readonly reason?: InputMaybe<Scalars['String']>;
  readonly source?: InputMaybe<Scalars['String']>;
};

export type AddToWhatsappBlockListPayload = {
  readonly __typename?: 'AddToWhatsappBlockListPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly message: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type AddTopicDocumentInput = {
  readonly artifact: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId: Scalars['NumericID'];
  readonly tid: Scalars['Int'];
};

export type AddTopicDocumentPayload = {
  readonly __typename?: 'AddTopicDocumentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly document: Maybe<Document>;
  readonly topicsEdge: Maybe<DocumentTopicsEdge>;
};

export type Address = {
  readonly __typename?: 'Address';
  readonly address: Maybe<Scalars['String']>;
  readonly addressId: Maybe<Scalars['Int']>;
  readonly city: Maybe<Topic>;
  readonly latitude: Maybe<Scalars['Float']>;
  readonly longitude: Maybe<Scalars['Float']>;
  readonly zipCode: Maybe<Scalars['String']>;
};

export type AdminOptionsInput = {
  readonly forceLock?: InputMaybe<BoxLockVariationType>;
  readonly pid?: InputMaybe<Scalars['Int']>;
  readonly simulateUnauthenticated?: InputMaybe<Scalars['Boolean']>;
};

export enum AgeRangeEnum {
  Between_25And_44 = 'BETWEEN_25_AND_44',
  Between_45And_64 = 'BETWEEN_45_AND_64',
  Over_64 = 'OVER_64',
  UpTo_24 = 'UP_TO_24'
}

export type AggregatedCounter = {
  readonly __typename?: 'AggregatedCounter';
  readonly counter: Maybe<Scalars['Int']>;
  readonly value: Maybe<Scalars['String']>;
};

export type AlertProfileConfig = Node & {
  readonly __typename?: 'AlertProfileConfig';
  readonly crmEnabled: Maybe<Scalars['Boolean']>;
  readonly crmEnabledDate: Maybe<Scalars['Float']>;
  readonly id: Scalars['ID'];
  readonly isMigrated: Maybe<Scalars['Boolean']>;
  readonly isMigrating: Maybe<Scalars['Boolean']>;
  readonly profileId: Maybe<Scalars['Int']>;
};

export type Alternative = {
  readonly __typename?: 'Alternative';
  readonly name: Maybe<Scalars['String']>;
};

export type AnonymizeLegalCaseInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly message: Scalars['String'];
};

export type AnonymizeLegalCasePayload = {
  readonly __typename?: 'AnonymizeLegalCasePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly message: Maybe<Scalars['String']>;
};

export type AnonymizedData = {
  readonly __typename?: 'AnonymizedData';
  readonly anonymizationDate: Maybe<Scalars['String']>;
  readonly anonymizedDataTypes: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly anonymizedId: Maybe<Scalars['String']>;
};

export type AnonymizedItem = {
  readonly __typename?: 'AnonymizedItem';
  readonly anonymizableType: Maybe<Scalars['String']>;
  readonly anonymizedItemId: Maybe<Scalars['String']>;
  readonly contactType: Maybe<Scalars['String']>;
  readonly removalRequestId: Maybe<Scalars['String']>;
  readonly text: Maybe<Scalars['String']>;
};

export enum Answer {
  Aprovado = 'APROVADO',
  EmAnalise = 'EM_ANALISE',
  Reprovado = 'REPROVADO'
}

export type AnswerAcademyQuestionInput = {
  readonly answer: ReadonlyArray<InputMaybe<Scalars['Int']>>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly context?: InputMaybe<Scalars['JSON']>;
  readonly questionId: Scalars['Int'];
};

export type AnswerAcademyQuestionPayload = {
  readonly __typename?: 'AnswerAcademyQuestionPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly isCorrect: Maybe<Scalars['Boolean']>;
  readonly updatedAt: Maybe<Scalars['Float']>;
  readonly userAnswerId: Maybe<Scalars['Int']>;
};

export type AppleLoginInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly nonce: Scalars['String'];
  readonly token: Scalars['String'];
};

export type AppleLoginPayload = {
  readonly __typename?: 'AppleLoginPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly cookie: Maybe<Scalars['String']>;
  readonly user: Maybe<User>;
};

export type ApproveDocumentInput = {
  readonly artifact: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId: Scalars['NumericID'];
};

export type ApproveDocumentPayload = {
  readonly __typename?: 'ApproveDocumentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly document: Maybe<Document>;
};

export type ApproveFeatureTaskInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly id: Scalars['String'];
};

export type ApproveFeatureTaskPayload = {
  readonly __typename?: 'ApproveFeatureTaskPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly featureTask: FeatureTask;
};

export type ApproveVirtualFeatureConfigInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly featureCode: Scalars['String'];
};

export type ApproveVirtualFeatureConfigPayload = {
  readonly __typename?: 'ApproveVirtualFeatureConfigPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly virtualFeatureConfig: VirtualFeatureConfig;
};

export type ApprovedLegalCaseMailInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId: Scalars['Float'];
};

export type ApprovedLegalCaseMailPayload = {
  readonly __typename?: 'ApprovedLegalCaseMailPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly sent: Maybe<Scalars['String']>;
};

export type ArchiveHubUserInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly forceArchival?: InputMaybe<Scalars['Boolean']>;
  readonly userId: Scalars['Int'];
};

export type ArchiveHubUserPayload = {
  readonly __typename?: 'ArchiveHubUserPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
  readonly userId: Scalars['Int'];
};

export type ArchiveLegalCaseInput = {
  readonly action?: InputMaybe<Scalars['String']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly legalCaseId: Scalars['Float'];
  readonly reason?: InputMaybe<Scalars['String']>;
  readonly reasonDescription?: InputMaybe<Scalars['String']>;
};

export type ArchiveLegalCasePayload = {
  readonly __typename?: 'ArchiveLegalCasePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly legalCase: Maybe<LegalCase>;
  readonly profile: Maybe<Profile>;
};

export type AreaCompanyPlanFeature = {
  readonly __typename?: 'AreaCompanyPlanFeature';
  readonly constraintType: Maybe<Scalars['String']>;
  readonly featureCode: Maybe<Scalars['String']>;
  readonly featureName: Maybe<Scalars['String']>;
  readonly value: Maybe<Scalars['String']>;
};

export type AreaCompanyPlanFeaturesResult = {
  readonly __typename?: 'AreaCompanyPlanFeaturesResult';
  readonly areaUuid: Maybe<Scalars['String']>;
  readonly companyUuid: Maybe<Scalars['String']>;
  readonly modules: Maybe<ReadonlyArray<Maybe<AreaCompanyPlanModule>>>;
};

export type AreaCompanyPlanModule = {
  readonly __typename?: 'AreaCompanyPlanModule';
  readonly plans: Maybe<ReadonlyArray<Maybe<AreaCompanyPlanPlan>>>;
  readonly slug: Maybe<Scalars['String']>;
};

export type AreaCompanyPlanPlan = {
  readonly __typename?: 'AreaCompanyPlanPlan';
  readonly features: Maybe<ReadonlyArray<Maybe<AreaCompanyPlanFeature>>>;
  readonly materialized: Maybe<Scalars['Boolean']>;
  readonly name: Maybe<Scalars['String']>;
  readonly planUuid: Maybe<Scalars['String']>;
  readonly subscriptionUuid: Maybe<Scalars['String']>;
};

export type AreaPlanGrantFeature = {
  readonly __typename?: 'AreaPlanGrantFeature';
  readonly companyValue: Maybe<Scalars['String']>;
  readonly constraintType: Maybe<Scalars['String']>;
  readonly featureCode: Maybe<Scalars['String']>;
  readonly featureName: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly value: Maybe<Scalars['String']>;
};

export type AreaPlanGrantModule = {
  readonly __typename?: 'AreaPlanGrantModule';
  readonly plans: Maybe<ReadonlyArray<Maybe<AreaPlanGrantPlan>>>;
  readonly slug: Maybe<Scalars['String']>;
};

export type AreaPlanGrantPlan = {
  readonly __typename?: 'AreaPlanGrantPlan';
  readonly features: Maybe<ReadonlyArray<Maybe<AreaPlanGrantFeature>>>;
  readonly materialized: Maybe<Scalars['Boolean']>;
  readonly name: Maybe<Scalars['String']>;
  readonly planUuid: Maybe<Scalars['String']>;
  readonly subscriptionUuid: Maybe<Scalars['String']>;
};

export type AreaPlanGrantsResult = {
  readonly __typename?: 'AreaPlanGrantsResult';
  readonly areaUuid: Maybe<Scalars['String']>;
  readonly companyUuid: Maybe<Scalars['String']>;
  readonly modules: Maybe<ReadonlyArray<Maybe<AreaPlanGrantModule>>>;
};

export type ArticleMetadata = {
  readonly __typename?: 'ArticleMetadata';
  readonly addons: Maybe<SearchMetadataAddons>;
  readonly author: SearchMetadataAuthor;
  readonly body: Maybe<Scalars['String']>;
  readonly date: Maybe<Scalars['Float']>;
  readonly docId: Scalars['String'];
  readonly features: Maybe<SearchMetadataFeatures>;
  readonly highlight: Maybe<Scalars['String']>;
  readonly slug: Scalars['String'];
  readonly tags: ReadonlyArray<SearchMetadataTags>;
  readonly title: Maybe<Scalars['String']>;
  readonly url: Scalars['String'];
};


export type ArticleMetadataBodyArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
  preferHighlight?: InputMaybe<Scalars['Boolean']>;
};

export type Artifact = {
  readonly __typename?: 'Artifact';
  readonly detectionContent: Maybe<ReadonlyArray<Maybe<Detection>>>;
  readonly id: Scalars['String'];
  readonly type: Scalars['String'];
};

export type AssignAdminRoleInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly profileId: Scalars['Int'];
};

export type AssignAdminRolePayload = {
  readonly __typename?: 'AssignAdminRolePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type AssignHubFeatureInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly featureCode: Scalars['String'];
  readonly profileId: Scalars['Int'];
};

export type AssignHubFeaturePayload = {
  readonly __typename?: 'AssignHubFeaturePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type AssignHubFeaturesBatchInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly featureTokens?: InputMaybe<ReadonlyArray<FeatureTokenInput>>;
  readonly profileId: Scalars['Int'];
};

export type AssignHubFeaturesBatchPayload = {
  readonly __typename?: 'AssignHubFeaturesBatchPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type AssignHubFeaturesByPlanInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly planUuid: Scalars['String'];
  readonly profileId: Scalars['Int'];
};

export type AssignHubFeaturesByPlanPayload = {
  readonly __typename?: 'AssignHubFeaturesByPlanPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type AssistantAskLawsuitUsage = {
  readonly __typename?: 'AssistantAskLawsuitUsage';
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly lawsuitId: Maybe<Scalars['String']>;
  readonly limit: Maybe<Scalars['Int']>;
  readonly pid: Maybe<Scalars['Float']>;
  readonly used: Maybe<Scalars['Int']>;
};

export type AssistantMessagesConnection = {
  readonly __typename?: 'AssistantMessagesConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<AssistantMessagesEdge>>>;
  readonly pageInfo: PageInfo;
};

export type AssistantMessagesEdge = {
  readonly __typename?: 'AssistantMessagesEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<LawsuitAssistantMessage>;
};

export type Association = {
  readonly __typename?: 'Association';
  readonly artifact: Maybe<Scalars['String']>;
  readonly associationRule: Maybe<Scalars['String']>;
  readonly associationType: Maybe<Scalars['String']>;
  readonly id: Maybe<Scalars['String']>;
};

export type Attachment = {
  readonly __typename?: 'Attachment';
  readonly bucket: Scalars['String'];
  readonly key: Scalars['String'];
  readonly storage: Scalars['String'];
};

export enum AttachmentSourcesType {
  ActivityItem = 'ACTIVITY_ITEM',
  Lawsuit = 'LAWSUIT'
}

export type AudienceSegment = {
  readonly __typename?: 'AudienceSegment';
  readonly createdAt: Maybe<Scalars['String']>;
  readonly createdByPid: Scalars['Int'];
  readonly description: Scalars['String'];
  readonly id: Scalars['String'];
  readonly jsonRule: Scalars['JSON'];
  readonly segmentName: Scalars['String'];
  readonly updatedAt: Maybe<Scalars['String']>;
};

export type AuthConfirmedAnonymousUserInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type AuthConfirmedAnonymousUserPayload = {
  readonly __typename?: 'AuthConfirmedAnonymousUserPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly confirmed: Maybe<Scalars['Boolean']>;
  readonly cookie: Maybe<Scalars['String']>;
};

export type AvailablePlan = {
  readonly __typename?: 'AvailablePlan';
  readonly benefitsList: Maybe<ReadonlyArray<Maybe<AvailablePlanBenefit>>>;
  readonly frequencyPeriodicityLabel: Maybe<Scalars['String']>;
  readonly frequencyText: Scalars['String'];
  readonly helpMessage: Scalars['String'];
  readonly installmentsText: Scalars['String'];
  readonly isDowngrade: Maybe<Scalars['Boolean']>;
  readonly isYearlyPlan: Maybe<Scalars['Boolean']>;
  readonly name: Scalars['String'];
  readonly planId: Maybe<Scalars['Int']>;
  readonly planInAnotherFrequency: Maybe<AvailablePlan>;
  readonly priceAfterPromotionalPeriodText: Maybe<Scalars['String']>;
  readonly pricePerInstallmentsText: Maybe<Scalars['String']>;
  readonly priceText: Scalars['String'];
  readonly priceTitle: Scalars['String'];
  readonly startingPrice: Maybe<StartingPrice>;
  readonly submitData: SubmitData;
  readonly templateId: Maybe<Scalars['Int']>;
  readonly yearlyDiscountLabel: Maybe<Scalars['String']>;
};

export type AvailablePlanBenefit = {
  readonly __typename?: 'AvailablePlanBenefit';
  readonly iconType: Maybe<BenefitIconTypeEnum>;
  readonly name: Scalars['String'];
};

export type AvailablePlans = {
  readonly __typename?: 'AvailablePlans';
  readonly lawsuitPlans: ReadonlyArray<Maybe<AvailablePlan>>;
  readonly legalResearchPlans: ReadonlyArray<Maybe<AvailablePlan>>;
};

export type B2BAreaInput = {
  readonly name: Scalars['String'];
  readonly seats?: InputMaybe<Scalars['Int']>;
};

export type B2BAreaPatchFeatureInput = {
  readonly code: Scalars['String'];
  readonly status: Scalars['String'];
  readonly value?: InputMaybe<Scalars['String']>;
};

export type B2BPatchFeatureInput = {
  readonly code: Scalars['String'];
  readonly constraintType?: InputMaybe<Scalars['String']>;
  readonly status: Scalars['String'];
  readonly value?: InputMaybe<Scalars['String']>;
};

export type B2BSubscriptionFeatureInput = {
  readonly code: Scalars['String'];
  readonly constraintType: Scalars['String'];
  readonly value: Scalars['String'];
};

export type B2BSubscriptionModuleInput = {
  readonly plans: ReadonlyArray<B2BSubscriptionPlanInput>;
  readonly slug: Scalars['String'];
};

export type B2BSubscriptionPlanInput = {
  readonly features?: InputMaybe<ReadonlyArray<B2BSubscriptionFeatureInput>>;
  readonly name: Scalars['String'];
};

export type Badge = Node & {
  readonly __typename?: 'Badge';
  readonly active: Maybe<Scalars['Boolean']>;
  readonly bid: Maybe<Scalars['Int']>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly description: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly label: Maybe<Scalars['String']>;
};

export enum BannerTypeEnum {
  Critical = 'CRITICAL',
  Discovery = 'DISCOVERY',
  Info = 'INFO',
  Positive = 'POSITIVE',
  Warning = 'WARNING'
}

export type BatchInviteFailedItem = {
  readonly __typename?: 'BatchInviteFailedItem';
  readonly email: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly reason: Maybe<Scalars['String']>;
};

export type BatchInviteHubUsersInput = {
  readonly areaUuid: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly companyUuid: Scalars['String'];
  readonly invites?: InputMaybe<ReadonlyArray<BatchInviteItemInput>>;
};

export type BatchInviteHubUsersPayload = {
  readonly __typename?: 'BatchInviteHubUsersPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly failed: Maybe<ReadonlyArray<Maybe<BatchInviteFailedItem>>>;
  readonly skipped: Maybe<ReadonlyArray<Maybe<BatchInviteSkippedItem>>>;
  readonly totalCreated: Scalars['Int'];
};

export type BatchInviteItemInput = {
  readonly email: Scalars['String'];
  readonly errors?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly jusBrasilSeats?: InputMaybe<Scalars['Boolean']>;
  readonly name: Scalars['String'];
  readonly role?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly row?: InputMaybe<Scalars['Int']>;
  readonly valid?: InputMaybe<Scalars['Boolean']>;
};

export type BatchInviteSkippedItem = {
  readonly __typename?: 'BatchInviteSkippedItem';
  readonly email: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly reason: Maybe<Scalars['String']>;
};

export enum BenefitIconTypeEnum {
  Ai = 'AI',
  Book = 'BOOK',
  Check = 'CHECK',
  CheckRound = 'CHECK_ROUND',
  Close = 'CLOSE',
  FileSearch = 'FILE_SEARCH'
}

export type BidLegalCaseInput = {
  readonly boxOptions?: InputMaybe<Scalars['JSON']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly conversationId: Scalars['Float'];
  readonly fromComponent?: InputMaybe<Scalars['String']>;
  readonly legalCaseId: Scalars['Float'];
};

export type BidLegalCasePayload = {
  readonly __typename?: 'BidLegalCasePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly conversation: Maybe<Conversation>;
  readonly profile: Maybe<Profile>;
};

export type BlockedSourcesPublicationMonitoringInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly monitoringId: Scalars['String'];
  readonly monitoringName: Scalars['String'];
  readonly payload: Scalars['JSON'];
  readonly shouldMonitorLawsuits?: InputMaybe<Scalars['Boolean']>;
};

export type BlockedSourcesPublicationMonitoringPayload = {
  readonly __typename?: 'BlockedSourcesPublicationMonitoringPayload';
  readonly alert: Maybe<PublicationAlert>;
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
};

export enum BonusCode {
  StudentsFreeBonus = 'STUDENTS_FREE_BONUS',
  ValentinesDayFreeBonus = 'VALENTINES_DAY_FREE_BONUS'
}

export type BonusFeatures = {
  readonly cancelOnChangePlan?: InputMaybe<Scalars['Boolean']>;
  readonly constraints?: InputMaybe<ReadonlyArray<InputMaybe<FeatureConstraintsType>>>;
  readonly featureCode?: InputMaybe<Scalars['String']>;
  readonly priority?: InputMaybe<Scalars['String']>;
  readonly requirements?: InputMaybe<ReadonlyArray<InputMaybe<RequirementsType>>>;
};

export type BonusSubscription = {
  readonly __typename?: 'BonusSubscription';
  readonly name: Scalars['String'];
  readonly planId: Maybe<Scalars['Int']>;
  readonly priceText: Scalars['String'];
  readonly subscriptionHelpText: Scalars['String'];
  readonly supportLink: Scalars['String'];
};

export type BonusType = {
  readonly cancelOnChangePlan?: InputMaybe<Scalars['Boolean']>;
  readonly constraints?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['JSON']>>>;
  readonly featureCode?: InputMaybe<Scalars['String']>;
  readonly priority?: InputMaybe<Scalars['String']>;
};

export type Book = {
  readonly __typename?: 'Book';
  readonly author: Maybe<Profile>;
  readonly bookId: Maybe<Scalars['Int']>;
  readonly cover: Maybe<Scalars['String']>;
  readonly date: Maybe<Scalars['Float']>;
  readonly description: Maybe<Scalars['String']>;
  readonly isbn: Maybe<Scalars['String']>;
  readonly link: Maybe<Scalars['String']>;
  readonly subtitle: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
};

export type BotEventInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly conversationId: Scalars['Int'];
  readonly eventType: Scalars['String'];
};

export type BotEventPayload = {
  readonly __typename?: 'BotEventPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly conversation: Maybe<Conversation>;
};

export type BoxChildLinkedAccount = {
  readonly __typename?: 'BoxChildLinkedAccount';
  readonly childProfile: Maybe<Profile>;
};

export type BoxCompanyClaims = {
  readonly __typename?: 'BoxCompanyClaims';
  readonly activeProducts: ReadonlyArray<Scalars['String']>;
  readonly companyFeatures: ReadonlyArray<BoxCompanyClaimFeature>;
};

export type BoxContextType = {
  readonly backTo?: InputMaybe<Scalars['String']>;
  readonly feature?: InputMaybe<Scalars['String']>;
  readonly featureCode?: InputMaybe<Scalars['String']>;
  readonly from_component?: InputMaybe<Scalars['String']>;
};

export type BoxFeature = {
  readonly __typename?: 'BoxFeature';
  readonly cancelDescription: Maybe<Scalars['String']>;
  readonly code: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
  readonly iconName: Maybe<Scalars['String']>;
  readonly label: Maybe<Scalars['String']>;
  readonly labelInfo: Maybe<FeatureLabelInfo>;
  readonly link: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly priority: Maybe<Scalars['Int']>;
  readonly status: Maybe<Scalars['String']>;
  readonly visibility: Maybe<Scalars['String']>;
};

export type BoxLock = {
  readonly __typename?: 'BoxLock';
  readonly lockVariationType: Maybe<BoxLockVariationType>;
  readonly metadataToDebug: Maybe<Scalars['JSON']>;
  readonly offerLockData: Maybe<OfferLockData>;
  readonly paywallData: Maybe<PaywallData>;
};

export enum BoxLockVariationType {
  CaseTrackingBgCheckFromBgCheckOffersLock = 'CASE_TRACKING_BG_CHECK_FROM_BG_CHECK_OFFERS_LOCK',
  CaseTrackingBgCheckFromLawsuitOffersLock = 'CASE_TRACKING_BG_CHECK_FROM_LAWSUIT_OFFERS_LOCK',
  CustomPlanLock = 'CUSTOM_PLAN_LOCK',
  DoctrineUnloggedLock = 'DOCTRINE_UNLOGGED_LOCK',
  DynamicMultipleOffersChooseFrequencyLaterLock = 'DYNAMIC_MULTIPLE_OFFERS_CHOOSE_FREQUENCY_LATER_LOCK',
  DynamicMultipleOffersChooseFrequencyLaterRedesignLock = 'DYNAMIC_MULTIPLE_OFFERS_CHOOSE_FREQUENCY_LATER_REDESIGN_LOCK',
  DynamicMultipleOffersSwitchFrequencyLock = 'DYNAMIC_MULTIPLE_OFFERS_SWITCH_FREQUENCY_LOCK',
  FeatureLockLinkedAccountLock = 'FEATURE_LOCK_LINKED_ACCOUNT_LOCK',
  InconsistentLock = 'INCONSISTENT_LOCK',
  LawsuitNameMonitoringLock = 'LAWSUIT_NAME_MONITORING_LOCK',
  LawsuitOneOfferLock = 'LAWSUIT_ONE_OFFER_LOCK',
  LawsuitPayPerViewLock = 'LAWSUIT_PAY_PER_VIEW_LOCK',
  LawsuitTwoOffersLock = 'LAWSUIT_TWO_OFFERS_LOCK',
  LimitOverflowLock = 'LIMIT_OVERFLOW_LOCK',
  NoLock = 'NO_LOCK',
  PixUpgradeLock = 'PIX_UPGRADE_LOCK',
  ThirdPartyBackgroundCheckThreeOffersLock = 'THIRD_PARTY_BACKGROUND_CHECK_THREE_OFFERS_LOCK',
  ThirdPartyBackgroundCheckTwoOffersLock = 'THIRD_PARTY_BACKGROUND_CHECK_TWO_OFFERS_LOCK',
  UnloggedUserLock = 'UNLOGGED_USER_LOCK',
  UpdatePaymentInfoLock = 'UPDATE_PAYMENT_INFO_LOCK',
  Upgrade_2StepCurrentLayoutLock = 'UPGRADE_2_STEP_CURRENT_LAYOUT_LOCK',
  Upgrade_2StepMessageLimitsLock = 'UPGRADE_2_STEP_MESSAGE_LIMITS_LOCK'
}

export type BoxOptionsInput = {
  readonly backTo?: InputMaybe<Scalars['String']>;
  readonly parentResourceId?: InputMaybe<Scalars['String']>;
  readonly planGroup?: InputMaybe<Scalars['String']>;
  readonly resource_id?: InputMaybe<Scalars['String']>;
  readonly utmSource?: InputMaybe<Scalars['String']>;
};

export type BoxParentLinkedAccount = {
  readonly __typename?: 'BoxParentLinkedAccount';
  readonly parentProfile: Maybe<Profile>;
};

export type BoxParticipanteExperimentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly experimentId: Scalars['String'];
};

export type BoxParticipanteExperimentPayload = {
  readonly __typename?: 'BoxParticipanteExperimentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type BoxProfileInfo = {
  readonly __typename?: 'BoxProfileInfo';
  readonly childLinkedAccounts: Maybe<ReadonlyArray<Maybe<BoxChildLinkedAccount>>>;
  readonly enableOneTimeFeeAutoRenew: Maybe<Scalars['Boolean']>;
  readonly lastOneTimeFeePixExpireAt: Maybe<Scalars['Float']>;
  readonly lastOneTimeFeePixPlanId: Maybe<Scalars['Int']>;
  readonly linkedAccount: Maybe<Scalars['Boolean']>;
  readonly overdue: Maybe<Scalars['Boolean']>;
  readonly parentLinkedAccounts: Maybe<ReadonlyArray<Maybe<BoxParentLinkedAccount>>>;
  readonly promotionalPlans: Maybe<ReadonlyArray<Maybe<Scalars['Int']>>>;
};

export type BoxSubscription = {
  readonly __typename?: 'BoxSubscription';
  readonly autoRenew: Maybe<Scalars['Boolean']>;
  readonly autoRenewNextPlanId: Maybe<Scalars['Int']>;
  readonly cancelledAt: Maybe<Scalars['Float']>;
  readonly changePaymentInfoURL: Maybe<Scalars['String']>;
  readonly contractedPricingPlan: Maybe<PricingPlan>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly expiresAt: Maybe<Scalars['Float']>;
  readonly features: Maybe<Features>;
  readonly isPaid: Maybe<Scalars['Boolean']>;
  readonly orderCode: Maybe<Scalars['String']>;
  readonly overdue: Maybe<Scalars['Boolean']>;
  readonly pendingChanges: Maybe<ReadonlyArray<Maybe<BoxSubscriptionChange>>>;
  readonly plan: Maybe<Plan>;
  readonly planGroupId: Maybe<Scalars['String']>;
  readonly pricingPlanSlug: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly subscriptionGroup: Maybe<Scalars['String']>;
  readonly subscriptionId: Maybe<Scalars['Int']>;
  readonly transactionInfo: Maybe<Scalars['JSON']>;
  readonly trialEndAt: Maybe<Scalars['Float']>;
  readonly type: Maybe<Scalars['String']>;
};

export type BoxSubscriptionChange = {
  readonly __typename?: 'BoxSubscriptionChange';
  readonly action: Maybe<Scalars['String']>;
  readonly changeData: Maybe<Scalars['JSON']>;
  readonly changeId: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly plan: Maybe<Plan>;
  readonly status: Maybe<Scalars['String']>;
  readonly subscription: Maybe<BoxSubscription>;
  readonly subscriptionGroup: Maybe<Scalars['String']>;
  readonly takeEffectOnDate: Maybe<Scalars['Float']>;
  readonly user: Maybe<Profile>;
};

export type BoxTokenStatement = {
  readonly __typename?: 'BoxTokenStatement';
  readonly endOfMonthBalance: Maybe<Scalars['Int']>;
  readonly startOfMonthBalance: Maybe<Scalars['Int']>;
  readonly transactions: Maybe<ReadonlyArray<Maybe<BoxTokenTransaction>>>;
};

export type BoxTokenTransaction = {
  readonly __typename?: 'BoxTokenTransaction';
  readonly action: Maybe<Scalars['String']>;
  readonly amount: Maybe<Scalars['Int']>;
  readonly conversation: Maybe<Conversation>;
  readonly featureCode: Maybe<Scalars['String']>;
  readonly kind: Maybe<Scalars['String']>;
  readonly kindReason: Maybe<Scalars['String']>;
  readonly legalCase: Maybe<LegalCase>;
  readonly subscription: Maybe<BoxSubscription>;
  readonly user: Maybe<Scalars['Int']>;
  readonly when: Maybe<Scalars['Float']>;
};

export type BoxUserClaims = {
  readonly __typename?: 'BoxUserClaims';
  readonly activeProducts: ReadonlyArray<Scalars['String']>;
  readonly userFeatures: ReadonlyArray<BoxClaimFeature>;
};

export type Breadcrumb = {
  readonly __typename?: 'Breadcrumb';
  readonly label: Scalars['String'];
  readonly link: Maybe<Scalars['String']>;
};

export type Broadcast = {
  readonly __typename?: 'Broadcast';
  readonly id: Scalars['String'];
  readonly payload: Scalars['JSON'];
  readonly setBy: Scalars['String'];
  readonly target: Scalars['String'];
};

export type BroadcastDelMutationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly target: Scalars['String'];
};

export type BroadcastDelMutationPayload = {
  readonly __typename?: 'BroadcastDelMutationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly output: Maybe<Scalars['String']>;
};

export type BroadcastSetMutationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly payload: Scalars['JSON'];
  readonly target: Scalars['String'];
  readonly ttlSeconds: Scalars['Int'];
};

export type BroadcastSetMutationPayload = {
  readonly __typename?: 'BroadcastSetMutationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly output: Maybe<Scalars['String']>;
};

export type BulkUpdateContactInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly contact: Scalars['JSON'];
  readonly contactIds: ReadonlyArray<InputMaybe<Scalars['String']>>;
};

export type BulkUpdateContactPayload = {
  readonly __typename?: 'BulkUpdateContactPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly contacts: Maybe<ReadonlyArray<Maybe<Contact>>>;
  readonly organization: Maybe<Organization>;
};

export enum ButtonKindEnum {
  Danger = 'danger',
  DangerSecondary = 'dangerSecondary',
  Plain = 'plain',
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary'
}

export type Cnae = {
  readonly __typename?: 'CNAE';
  readonly code: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
};

export type CnjNumber = {
  readonly __typename?: 'CNJNumber';
  readonly court: Maybe<CnjNumberCourt>;
  readonly data: Maybe<CnjNumberData>;
  readonly formattedCourt: Maybe<Scalars['String']>;
  readonly justice: Maybe<CnjNumberJustice>;
  readonly number: Maybe<Scalars['String']>;
  readonly source: Maybe<CnjNumberSource>;
  readonly sourceV2: Maybe<CnjNumberSourceV2>;
};


export type CnjNumberFormattedCourtArgs = {
  separator: InputMaybe<Scalars['String']>;
};

export type CnjNumberCourt = {
  readonly __typename?: 'CNJNumberCourt';
  readonly acronym: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
};

export type CnjNumberData = {
  readonly __typename?: 'CNJNumberData';
  readonly court: Maybe<Scalars['String']>;
  readonly justice: Maybe<Scalars['String']>;
  readonly number: Maybe<Scalars['String']>;
  readonly proc: Maybe<Scalars['String']>;
  readonly raw: Maybe<Scalars['String']>;
  readonly year: Maybe<Scalars['String']>;
};

export type CnjNumberJustice = {
  readonly __typename?: 'CNJNumberJustice';
  readonly name: Maybe<Scalars['String']>;
};

export type CnjNumberSource = {
  readonly __typename?: 'CNJNumberSource';
  readonly district: Maybe<Scalars['String']>;
  readonly type: Maybe<Scalars['String']>;
};

export type CnjNumberSourceV2 = {
  readonly __typename?: 'CNJNumberSourceV2';
  readonly district: Maybe<Scalars['String']>;
  readonly stateAcronym: Maybe<Scalars['String']>;
  readonly type: Maybe<Scalars['String']>;
};

export type CnjSubject = {
  readonly __typename?: 'CNJSubject';
  readonly code: Maybe<Scalars['Int']>;
  readonly name: Maybe<Scalars['String']>;
};

export type CnjSubjects = {
  readonly __typename?: 'CNJSubjects';
  readonly parent: Maybe<CnjSubject>;
  readonly parents: Maybe<ReadonlyArray<Maybe<CnjSubject>>>;
  readonly siblings: Maybe<ReadonlyArray<Maybe<CnjSubject>>>;
};

export enum CproAttachmentSourcesType {
  ActivityItem = 'ACTIVITY_ITEM',
  Lawsuit = 'LAWSUIT'
}

export type CproBnmp = {
  readonly __typename?: 'CPROBnmp';
  readonly documentNumber: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly warrants: ReadonlyArray<Maybe<CproBnmpWarrant>>;
};

export type CproBnmpTipification = {
  readonly __typename?: 'CPROBnmpTipification';
  readonly law: ReadonlyArray<Maybe<CproBnmpTipificationLaw>>;
  readonly occurenceType: Maybe<Scalars['String']>;
};

export type CproBnmpTipificationLaw = {
  readonly __typename?: 'CPROBnmpTipificationLaw';
  readonly expectedSentence: Maybe<Scalars['JSON']>;
  readonly law: Maybe<Scalars['String']>;
};

export type CproBnmpWarrant = {
  readonly __typename?: 'CPROBnmpWarrant';
  readonly bnmpNumber: Maybe<Scalars['String']>;
  readonly expirationDate: Maybe<Scalars['String']>;
  readonly imprisonmentType: Maybe<Scalars['String']>;
  readonly indentifiedType: Maybe<Scalars['Boolean']>;
  readonly inferredConfidence: Maybe<Scalars['String']>;
  readonly issuanceDate: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CproLawsuit>;
  readonly lawsuitLocale: Maybe<Scalars['String']>;
  readonly situation: Maybe<Scalars['String']>;
  readonly tipification: ReadonlyArray<Maybe<CproBnmpTipification>>;
};

export type CproCompanyMetadata = {
  readonly __typename?: 'CPROCompanyMetadata';
  readonly contractCount: Maybe<Scalars['Int']>;
  readonly requestCount: Maybe<Scalars['Int']>;
  readonly userCount: Maybe<Scalars['Int']>;
};

export type CproDocumentSummary = {
  readonly __typename?: 'CPRODocumentSummary';
  readonly lawsuitCount: Maybe<Scalars['Int']>;
  readonly status: Scalars['String'];
  readonly summary: Maybe<Scalars['String']>;
};

export type CproExtraValues = {
  readonly __typename?: 'CPROExtraValues';
  readonly createdAt: Scalars['String'];
  readonly description: Scalars['String'];
  readonly discount: Scalars['Boolean'];
  readonly extraValueId: Scalars['String'];
  readonly finishAt: Maybe<Scalars['String']>;
  readonly organizationId: Scalars['String'];
  readonly startAt: Scalars['String'];
  readonly value: Scalars['Float'];
};

export type CproFeature = {
  readonly __typename?: 'CPROFeature';
  readonly active: Scalars['Boolean'];
  readonly description: Maybe<Scalars['String']>;
  readonly featureId: Scalars['String'];
  readonly limit: Maybe<Scalars['Int64']>;
  readonly minRevenue: Maybe<Scalars['Int']>;
  readonly name: Scalars['String'];
  readonly slug: Maybe<Scalars['String']>;
  readonly trial: Scalars['Boolean'];
  readonly trialExpiryDate: Maybe<Scalars['String']>;
  readonly trialLimit: Maybe<Scalars['Int64']>;
};

export type CproInternalLawsuit = {
  readonly __typename?: 'CPROInternalLawsuit';
  readonly confidence: Maybe<Scalars['String']>;
  readonly county: Maybe<Scalars['String']>;
  readonly court: Maybe<Scalars['String']>;
  readonly distributionDate: Maybe<Scalars['String']>;
  readonly distributionYear: Maybe<Scalars['String']>;
  readonly inferredParts: CproInternalLawsuitInferredParts;
  readonly isLetterRogatory: Maybe<Scalars['Boolean']>;
  readonly isPrimaryLawsuit: Maybe<Scalars['Boolean']>;
  readonly kind: Maybe<Scalars['String']>;
  readonly lastActivityDate: Maybe<Scalars['String']>;
  readonly lastProviderUpdate: Maybe<Scalars['String']>;
  readonly lawItems: Maybe<Scalars['JSON']>;
  readonly lawsuitId: Maybe<Scalars['String']>;
  readonly nature: Maybe<Scalars['String']>;
  readonly normalizedClass: Maybe<Scalars['String']>;
  readonly number: Maybe<Scalars['String']>;
  readonly paper: Maybe<Scalars['String']>;
  readonly progress: Maybe<Scalars['String']>;
  readonly relatedLawsuits: Maybe<ReadonlyArray<Maybe<CproLawsuit>>>;
  readonly relatedPeople: Maybe<ReadonlyArray<Maybe<CproInternalLawsuitRelatedPerson>>>;
  readonly status: Maybe<Scalars['String']>;
  readonly subject: Maybe<Scalars['String']>;
  readonly uf: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
  readonly value: Maybe<Scalars['String']>;
};

export type CproInternalLawsuitInferredParts = {
  readonly __typename?: 'CPROInternalLawsuitInferredParts';
  readonly otherPersonName: Maybe<Scalars['String']>;
  readonly personName: Scalars['String'];
  readonly pole: Scalars['String'];
};

export type CproInternalLawsuitRelatedPerson = {
  readonly __typename?: 'CPROInternalLawsuitRelatedPerson';
  readonly name: Maybe<Scalars['String']>;
  readonly pole: Maybe<Scalars['String']>;
  readonly role: Maybe<Scalars['String']>;
};

export type CproInternalLawsuitsByDocument = {
  readonly __typename?: 'CPROInternalLawsuitsByDocument';
  readonly document: Maybe<Scalars['String']>;
  readonly lawsuits: ReadonlyArray<CproInternalLawsuit>;
  readonly name: Maybe<Scalars['String']>;
};

export type CproLawsuit = CrmTimelineProvider & Node & {
  readonly __typename?: 'CPROLawsuit';
  readonly alternativeNumber: Maybe<Scalars['String']>;
  readonly attachments: Maybe<CproLawsuitAttachmentsConnection>;
  readonly classifiedKindByNumber: Maybe<Scalars['String']>;
  readonly cnjNumber: Maybe<CnjNumber>;
  readonly computedStatus: Maybe<Scalars['String']>;
  readonly court: Maybe<CrmLawsuitRef>;
  readonly courtInstance: Maybe<Scalars['Int']>;
  readonly courtSection: Maybe<CrmLawsuitRef>;
  readonly courtUrl: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly createdBy: Maybe<Profile>;
  readonly decision: Maybe<CrmLawsuitResult>;
  readonly deletedAt: Maybe<Scalars['Float']>;
  readonly deletedBy: Maybe<Profile>;
  readonly description: Maybe<Scalars['String']>;
  readonly distributionDate: Maybe<Scalars['Float']>;
  readonly distributionType: Maybe<Scalars['String']>;
  readonly district: Maybe<Scalars['String']>;
  readonly documents: Maybe<CrmEntityDocumentConnection>;
  readonly entityId: Maybe<Scalars['NumericID']>;
  readonly entityRefId: Maybe<Scalars['String']>;
  readonly entityRefName: Maybe<Scalars['String']>;
  readonly entityRefType: Maybe<Scalars['String']>;
  readonly entityRefTypeRaw: Maybe<Scalars['String']>;
  readonly entityType: Maybe<Scalars['String']>;
  readonly extinct: Maybe<Scalars['Boolean']>;
  readonly forum: Maybe<Scalars['String']>;
  readonly hasCover: Maybe<Scalars['Boolean']>;
  readonly hasPublication: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly inferredKind: Maybe<Scalars['String']>;
  readonly inferredStatus: Maybe<Scalars['String']>;
  readonly isCNJ: Maybe<Scalars['Boolean']>;
  readonly isLetterRogatory: Maybe<Scalars['Boolean']>;
  readonly isPending: Maybe<Scalars['Boolean']>;
  readonly isPrimaryLawsuit: Maybe<Scalars['Boolean']>;
  readonly judgeName: Maybe<Scalars['String']>;
  readonly justiceSecret: Maybe<Scalars['Boolean']>;
  readonly kind: Maybe<Scalars['String']>;
  readonly lastActivityDate: Maybe<Scalars['Float']>;
  readonly lastModifiedLawsuit: Maybe<Scalars['Float']>;
  readonly lastProviderUpdate: Maybe<Scalars['Float']>;
  readonly lawsuitId: Maybe<Scalars['String']>;
  readonly lawsuitNumberType: Maybe<Scalars['String']>;
  readonly lawsuitTags: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly lawsuitType: Maybe<Scalars['String']>;
  readonly leanRelatedLawsuits: Maybe<ReadonlyArray<Maybe<CproLeanRelatedLawsuit>>>;
  readonly local: Maybe<Scalars['String']>;
  readonly missingOnProvider: Maybe<Scalars['Boolean']>;
  readonly nature: Maybe<Scalars['String']>;
  readonly normalizedClass: Maybe<Scalars['JSON']>;
  readonly normalizedNature: Maybe<Scalars['String']>;
  readonly normalizedSubject: Maybe<Scalars['JSON']>;
  readonly number: Maybe<Scalars['String']>;
  readonly rawSubject: Maybe<Scalars['String']>;
  readonly readOnly: Maybe<Scalars['Boolean']>;
  readonly relatedJuris: Maybe<ReadonlyArray<Maybe<Document>>>;
  readonly relatedLawsuits: Maybe<ReadonlyArray<Maybe<RelatedLawsuit>>>;
  readonly relatedMotions: Maybe<ReadonlyArray<Maybe<Document>>>;
  readonly relatedPeople: Maybe<ReadonlyArray<Maybe<CrmLawsuitRelatedPerson>>>;
  readonly representedPersonLawyers: Maybe<ReadonlyArray<Maybe<CrmLawsuitRepresentedPersonLawyer>>>;
  readonly result: Maybe<Scalars['String']>;
  readonly sensitive: Maybe<Scalars['Boolean']>;
  readonly situation: Maybe<CrmLawsuitRef>;
  readonly stage: Maybe<Scalars['String']>;
  readonly stateAcronym: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly subject: Maybe<Scalars['String']>;
  readonly summarization: Maybe<CrmLawsuitSummarization>;
  readonly timeline: Maybe<CrmEntityTimelineConnection>;
  readonly timelineItem: Maybe<CrmTimelineItem>;
  readonly title: Maybe<Scalars['String']>;
  readonly typification: Maybe<Scalars['JSON']>;
  readonly updateStatus: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['Float']>;
  readonly updatedBy: Maybe<Profile>;
  readonly url: Maybe<Scalars['String']>;
  readonly value: Maybe<Scalars['Float']>;
  readonly verdictDate: Maybe<Scalars['Float']>;
};


export type CproLawsuitAttachmentsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  kind: InputMaybe<Scalars['String']>;
  kindGroup: InputMaybe<Scalars['String']>;
  source: InputMaybe<Scalars['String']>;
  sources: InputMaybe<ReadonlyArray<InputMaybe<CproAttachmentSourcesType>>>;
};


export type CproLawsuitDocumentsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  lawsuitAttachment: InputMaybe<Scalars['Boolean']>;
};


export type CproLawsuitNumberArgs = {
  unmaskCNJ: InputMaybe<Scalars['Boolean']>;
};


export type CproLawsuitRelatedPeopleArgs = {
  groupType: InputMaybe<CproRelatedLawsuitPersonType>;
  limit: InputMaybe<Scalars['Int']>;
};


export type CproLawsuitRepresentedPersonLawyersArgs = {
  groupType: InputMaybe<CproRelatedLawsuitPersonType>;
  limit: InputMaybe<Scalars['Int']>;
};


export type CproLawsuitTimelineArgs = {
  actions: InputMaybe<Scalars['JSON']>;
  after: InputMaybe<Scalars['String']>;
  enableLimitDate?: InputMaybe<Scalars['Boolean']>;
  eventType: InputMaybe<Scalars['String']>;
  eventTypes: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  excludeStatus: InputMaybe<SuitsStatusType>;
  first: InputMaybe<Scalars['Int']>;
  groupType?: InputMaybe<CproTimelineGroupType>;
  important: InputMaybe<Scalars['Boolean']>;
  loadFromDB: InputMaybe<Scalars['Boolean']>;
  objectType: InputMaybe<Scalars['String']>;
  read: InputMaybe<Scalars['Boolean']>;
  source: InputMaybe<Scalars['JSON']>;
  status: InputMaybe<Scalars['String']>;
  types: InputMaybe<ReadonlyArray<InputMaybe<CproTimelineItemType>>>;
  usePrivateLawsuit?: InputMaybe<Scalars['Boolean']>;
  visibilityType: InputMaybe<Scalars['String']>;
  withAttachmentsOfDay?: InputMaybe<Scalars['Boolean']>;
};


export type CproLawsuitTimelineItemArgs = {
  timelineItemId: InputMaybe<Scalars['String']>;
};


export type CproLawsuitTitleArgs = {
  unmaskCNJ: InputMaybe<Scalars['Boolean']>;
};


export type CproLawsuitUpdateStatusArgs = {
  onLastHours: InputMaybe<Scalars['Int']>;
  searchErrorThresholdInMinutes: InputMaybe<Scalars['Int']>;
};

export type CproLawsuitAttachment = Node & {
  readonly __typename?: 'CPROLawsuitAttachment';
  readonly attachmentId: Maybe<Scalars['String']>;
  readonly classifiedKindGranular: Maybe<Scalars['String']>;
  readonly classifiedKindGroup: Maybe<Scalars['String']>;
  readonly downloadDatetime: Maybe<Scalars['Float']>;
  readonly fileType: Maybe<Scalars['String']>;
  readonly filename: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly kind: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CproLawsuit>;
  readonly lawsuitActivityItems: Maybe<ReadonlyArray<Maybe<CrmLawsuitActivityItem>>>;
  readonly networkDocument: Maybe<Document>;
  readonly networkDocumentUrl: Maybe<Scalars['String']>;
  readonly normalizedTitle: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
  readonly publicationDatetime: Maybe<Scalars['Float']>;
  readonly signedUrl: Maybe<Scalars['String']>;
  readonly text: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
};


export type CproLawsuitAttachmentSignedUrlArgs = {
  oneTimePurchase: InputMaybe<Scalars['Boolean']>;
};

export type CproLawsuitAttachmentsConnection = {
  readonly __typename?: 'CPROLawsuitAttachmentsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<CproLawsuitAttachmentsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type CproLawsuitAttachmentsEdge = {
  readonly __typename?: 'CPROLawsuitAttachmentsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CproLawsuitAttachment>;
};

export type CproLawsuitsByNameWithoutConfidenceConnection = {
  readonly __typename?: 'CPROLawsuitsByNameWithoutConfidenceConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<CproLawsuitsByNameWithoutConfidenceEdge>>>;
  readonly numHits: Maybe<Scalars['Int']>;
  readonly pageInfo: PageInfo;
  readonly partyName: Maybe<Scalars['String']>;
};

export type CproLawsuitsByNameWithoutConfidenceEdge = {
  readonly __typename?: 'CPROLawsuitsByNameWithoutConfidenceEdge';
  readonly confidence: Maybe<Scalars['String']>;
  readonly cursor: Scalars['String'];
  readonly lastReference: Maybe<Scalars['Float']>;
  readonly matchRelatedPeople: Maybe<CrmLawsuitRelatedPerson>;
  readonly node: Maybe<CproLawsuit>;
};

export type CproLawsuitsByPersonIdConnection = {
  readonly __typename?: 'CPROLawsuitsByPersonIdConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<CproLawsuitsByPersonIdEdge>>>;
  readonly numHits: Maybe<Scalars['Int']>;
  readonly pageInfo: PageInfo;
  readonly partyName: Maybe<Scalars['String']>;
};

export type CproLawsuitsByPersonIdEdge = {
  readonly __typename?: 'CPROLawsuitsByPersonIdEdge';
  readonly alias: Maybe<Scalars['String']>;
  readonly confidence: Maybe<Scalars['String']>;
  readonly cursor: Scalars['String'];
  readonly lastReference: Maybe<Scalars['Float']>;
  readonly matchRelatedPeople: Maybe<CrmLawsuitRelatedPerson>;
  readonly node: Maybe<CproLawsuit>;
  readonly score: Maybe<Scalars['Float']>;
  readonly source: Maybe<Scalars['String']>;
  readonly versions: Maybe<Scalars['JSON']>;
};

export type CproLeanRelatedLawsuit = {
  readonly __typename?: 'CPROLeanRelatedLawsuit';
  readonly lawsuit: Maybe<CproLawsuit>;
  readonly lawsuitId: Maybe<Scalars['String']>;
  readonly number: Maybe<Scalars['String']>;
  readonly relationType: Maybe<Scalars['String']>;
};

export type CproLimit = {
  readonly __typename?: 'CPROLimit';
  readonly highLimit: Maybe<Scalars['Int64']>;
  readonly lowLimit: Maybe<Scalars['Int64']>;
  readonly price: Scalars['Float'];
};

export type CproMp = {
  readonly __typename?: 'CPROMp';
  readonly documentNumber: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly procedures: ReadonlyArray<Maybe<CproMpProcedure>>;
};

export type CproMpMovimentation = {
  readonly __typename?: 'CPROMpMovimentation';
  readonly date: Maybe<Scalars['String']>;
  readonly detail: Maybe<Scalars['String']>;
  readonly movimentation: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
};

export type CproMpProcedure = {
  readonly __typename?: 'CPROMpProcedure';
  readonly acronym: Maybe<Scalars['String']>;
  readonly hasTipification: Maybe<Scalars['Boolean']>;
  readonly inferredConfidence: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CproLawsuit>;
  readonly movimentations: Maybe<ReadonlyArray<Maybe<CproMpMovimentation>>>;
  readonly mpNumber: Maybe<Scalars['String']>;
  readonly paper: Maybe<Scalars['String']>;
  readonly procedureType: Maybe<Scalars['String']>;
  readonly procedureUnity: Maybe<Scalars['String']>;
  readonly records: Maybe<Scalars['String']>;
  readonly situation: Maybe<Scalars['String']>;
  readonly state: Maybe<Scalars['String']>;
  readonly subject: Maybe<Scalars['String']>;
  readonly surveyYear: Maybe<Scalars['String']>;
  readonly tipification: ReadonlyArray<Maybe<CproMpTipification>>;
};

export type CproMpTipification = {
  readonly __typename?: 'CPROMpTipification';
  readonly law: ReadonlyArray<Maybe<CproMpTipificationLaw>>;
  readonly occurenceType: Maybe<Scalars['String']>;
};

export type CproMpTipificationLaw = {
  readonly __typename?: 'CPROMpTipificationLaw';
  readonly expectedSentence: Maybe<Scalars['JSON']>;
  readonly law: Maybe<Scalars['String']>;
};

export type CproOrganization = {
  readonly __typename?: 'CPROOrganization';
  readonly active: Scalars['Boolean'];
  readonly activeFeatures: ReadonlyArray<Maybe<CproFeature>>;
  readonly admin: Maybe<CproUser>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly digestoOpId: Maybe<Scalars['Int']>;
  readonly embeddedReportUrl: Maybe<Scalars['String']>;
  readonly extraValues: ReadonlyArray<Maybe<CproOrganizationExtraValues>>;
  readonly features: ReadonlyArray<Maybe<CproFeature>>;
  readonly minRevenue: Maybe<Scalars['Float']>;
  readonly name: Scalars['String'];
  readonly organizationId: Scalars['String'];
  readonly slug: Scalars['String'];
  readonly users: ReadonlyArray<Maybe<CproUser>>;
};


export type CproOrganizationUsersArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};

export type CproOrganizationExtraValues = {
  readonly __typename?: 'CPROOrganizationExtraValues';
  readonly createdAt: Scalars['String'];
  readonly description: Scalars['String'];
  readonly discount: Scalars['Boolean'];
  readonly extraValueId: Scalars['String'];
  readonly finishAt: Maybe<Scalars['String']>;
  readonly startAt: Scalars['String'];
  readonly value: Scalars['Float'];
};

export type CproOrganizationList = {
  readonly __typename?: 'CPROOrganizationList';
  readonly data: Maybe<ReadonlyArray<Maybe<CproOrganization>>>;
  readonly limit: Maybe<Scalars['Int']>;
  readonly offset: Maybe<Scalars['Int']>;
  readonly total: Maybe<Scalars['Int']>;
};

export type CproOrganizationMetadata = {
  readonly __typename?: 'CPROOrganizationMetadata';
  readonly organizationCount: Scalars['Int'];
  readonly userCount: Scalars['Int'];
};

export type CproPricingItem = {
  readonly __typename?: 'CPROPricingItem';
  readonly active: Scalars['Boolean'];
  readonly expiryDate: Maybe<Scalars['String']>;
  readonly globalLimit: Maybe<Scalars['Int64']>;
  readonly itemId: Maybe<Scalars['String']>;
  readonly limits: Maybe<ReadonlyArray<Maybe<CproLimit>>>;
  readonly minRevenue: Scalars['Int'];
  readonly trial: Scalars['Boolean'];
  readonly trialLimit: Maybe<Scalars['Int64']>;
};

export enum CproRelatedLawsuitPersonType {
  Author = 'AUTHOR',
  Defendant = 'DEFENDANT',
  Other = 'OTHER'
}

export enum CproTimelineGroupType {
  Network = 'NETWORK',
  None = 'NONE'
}

export enum CproTimelineItemType {
  LawsuitActivity = 'LAWSUIT_ACTIVITY',
  LawsuitAttachmentsOfDay = 'LAWSUIT_ATTACHMENTS_OF_DAY',
  Publication = 'PUBLICATION'
}

export type CproUser = {
  readonly __typename?: 'CPROUser';
  readonly email: Scalars['String'];
  readonly features: Maybe<ReadonlyArray<Maybe<CproFeature>>>;
  readonly isAdmin: Scalars['Boolean'];
  readonly isOwner: Scalars['Boolean'];
  readonly name: Scalars['String'];
  readonly networkId: Scalars['String'];
  readonly organization: CproUserOrganization;
  readonly organizationId: Scalars['String'];
  readonly userId: Scalars['String'];
};

export type CproUserAuthorization = {
  readonly __typename?: 'CPROUserAuthorization';
  readonly accessToken: Scalars['String'];
  readonly expiresIn: Maybe<Scalars['Int']>;
  readonly refreshToken: Maybe<Scalars['String']>;
  readonly tokenType: Maybe<Scalars['String']>;
};

export type CproUserOrganization = {
  readonly __typename?: 'CPROUserOrganization';
  readonly active: Scalars['Boolean'];
  readonly name: Scalars['String'];
  readonly organizationId: Scalars['String'];
  readonly parent_slug: Maybe<Scalars['String']>;
  readonly slug: Scalars['String'];
};

export type CrmActivityInferences = {
  readonly __typename?: 'CRMActivityInferences';
  readonly associations: Maybe<ReadonlyArray<Maybe<Association>>>;
  readonly classification: Maybe<ActivityInferenceClassification>;
};

export type CrmActivityLog = Node & {
  readonly __typename?: 'CRMActivityLog';
  readonly activityId: Maybe<Scalars['String']>;
  readonly activityType: Maybe<Scalars['String']>;
  readonly contact: Maybe<Contact>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly createdBy: Maybe<Profile>;
  readonly date: Maybe<Scalars['Float']>;
  readonly deletedAt: Maybe<Scalars['Float']>;
  readonly deletedBy: Maybe<Profile>;
  readonly description: Maybe<Scalars['String']>;
  readonly duration: Maybe<Scalars['Float']>;
  readonly entity: Maybe<CrmEntity>;
  readonly id: Scalars['ID'];
  readonly lawsuit: Maybe<CrmLawsuit>;
  readonly organization: Maybe<Organization>;
  readonly status: Maybe<Scalars['String']>;
  readonly timelineItem: Maybe<CrmTimelineItem>;
  readonly updatedAt: Maybe<Scalars['Float']>;
  readonly updatedBy: Maybe<Profile>;
};

export type CrmArrestWarrant = {
  readonly __typename?: 'CRMArrestWarrant';
  readonly accusedGender: Maybe<Scalars['String']>;
  readonly acronym: Maybe<Scalars['String']>;
  readonly agency: Maybe<Scalars['String']>;
  readonly baseSku: Maybe<Scalars['String']>;
  readonly confidentiality: Maybe<Scalars['String']>;
  readonly creationDate: Maybe<Scalars['String']>;
  readonly documentNumber: Maybe<Scalars['String']>;
  readonly expirationDate: Maybe<Scalars['String']>;
  readonly imprisonmentType: Maybe<Scalars['String']>;
  readonly inferredKind: Maybe<Scalars['String']>;
  readonly issuanceDate: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
  readonly lawsuitNumber: Maybe<Scalars['String']>;
  readonly procedureType: Maybe<Scalars['String']>;
  readonly sentenceTime: Maybe<Scalars['String']>;
  readonly situation: Maybe<Scalars['String']>;
  readonly subject: Maybe<Scalars['String']>;
  readonly uf: Maybe<Scalars['String']>;
};

export type CrmBnmp = {
  readonly __typename?: 'CRMBnmp';
  readonly alcunha_acusado: Maybe<Scalars['String']>;
  readonly assunto: Maybe<Scalars['String']>;
  readonly base_sku: Maybe<Scalars['String']>;
  readonly cumprimento: Maybe<Scalars['String']>;
  readonly data_criacao: Maybe<Scalars['String']>;
  readonly data_expedicao: Maybe<Scalars['String']>;
  readonly data_nascimento_acusado: Maybe<Scalars['String']>;
  readonly data_validade: Maybe<Scalars['String']>;
  readonly enderecos_acusado: Maybe<ReadonlyArray<Maybe<CrmBnmpAddress>>>;
  readonly especie_prisao: Maybe<Scalars['String']>;
  readonly filiacao_materna_acusado: Maybe<Scalars['String']>;
  readonly filiacao_paterna_acusado: Maybe<Scalars['String']>;
  readonly inferred_kind: Maybe<Scalars['String']>;
  readonly local_ocorrencia: Maybe<Scalars['String']>;
  readonly magistrado: Maybe<Scalars['String']>;
  readonly mandado: Maybe<Scalars['String']>;
  readonly motivo_internacao: Maybe<Scalars['String']>;
  readonly nacionalidade_acusado: Maybe<Scalars['String']>;
  readonly naturalidade_acusado: Maybe<Scalars['String']>;
  readonly numero_documento: Maybe<Scalars['String']>;
  readonly numero_individuo: Maybe<Scalars['String']>;
  readonly numero_processo: Maybe<Scalars['String']>;
  readonly observacao: Maybe<Scalars['String']>;
  readonly orgao: Maybe<Scalars['String']>;
  readonly outras_alcunhas_acusado: Maybe<Scalars['String']>;
  readonly outros_nomes_acusado: Maybe<Scalars['String']>;
  readonly partes: Maybe<ReadonlyArray<Maybe<CrmMpParte>>>;
  readonly processo_local: Maybe<Scalars['String']>;
  readonly profissao_acusado: Maybe<Scalars['String']>;
  readonly recaptura: Maybe<Scalars['String']>;
  readonly regime_prisional: Maybe<Scalars['String']>;
  readonly sexo_acusado: Maybe<Scalars['String']>;
  readonly sigilo: Maybe<Scalars['String']>;
  readonly sigla: Maybe<Scalars['String']>;
  readonly sintese_decisao: Maybe<Scalars['String']>;
  readonly situacao: Maybe<Scalars['String']>;
  readonly soltura_concedida: Maybe<Scalars['String']>;
  readonly telefone_acusado: Maybe<Scalars['String']>;
  readonly tempo_pena: Maybe<Scalars['String']>;
  readonly tipo_procedimento: Maybe<Scalars['String']>;
  readonly typification: Maybe<Scalars['JSON']>;
  readonly uf: Maybe<Scalars['String']>;
};

export type CrmBnmpAddress = {
  readonly __typename?: 'CRMBnmpAddress';
  readonly bairro: Maybe<Scalars['String']>;
  readonly cep: Maybe<Scalars['String']>;
  readonly complemento: Maybe<Scalars['String']>;
  readonly estado: Maybe<Scalars['String']>;
  readonly logradouro: Maybe<Scalars['String']>;
  readonly municipio: Maybe<Scalars['String']>;
  readonly numero: Maybe<Scalars['String']>;
  readonly pais: Maybe<Scalars['String']>;
};

export type CrmBulkAction = Node & {
  readonly __typename?: 'CRMBulkAction';
  readonly actionError: Maybe<Scalars['String']>;
  readonly actionType: Maybe<Scalars['String']>;
  readonly amount: Maybe<Scalars['Int']>;
  readonly bulkActionId: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly createdBy: Maybe<Profile>;
  readonly deletedAt: Maybe<Scalars['Float']>;
  readonly deletedBy: Maybe<Profile>;
  readonly entityIds: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly entityType: Maybe<Scalars['String']>;
  readonly finishedAt: Maybe<Scalars['Float']>;
  readonly id: Scalars['ID'];
  readonly organization: Maybe<Organization>;
  readonly searchRequest: Maybe<Scalars['JSON']>;
  readonly status: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['Float']>;
  readonly updatedBy: Maybe<Profile>;
};

export type CrmCalendar = Node & {
  readonly __typename?: 'CRMCalendar';
  readonly acls: Maybe<Scalars['JSON']>;
  readonly calendarId: Maybe<Scalars['String']>;
  readonly events: Maybe<ReadonlyArray<Maybe<CrmEvent>>>;
  readonly id: Scalars['ID'];
  readonly publicUrl: Maybe<Scalars['String']>;
  readonly summary: Maybe<Scalars['String']>;
};


export type CrmCalendarEventsArgs = {
  contactId: InputMaybe<Scalars['String']>;
  lawsuitId: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  organizationId: InputMaybe<Scalars['Int']>;
  singleEvents: InputMaybe<Scalars['Boolean']>;
  timeMax: InputMaybe<Scalars['Float']>;
  timeMin: InputMaybe<Scalars['Float']>;
};

export type CrmCaseLlmTitle = {
  readonly __typename?: 'CRMCaseLLMTitle';
  readonly caseId: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly llmTitle: Maybe<Scalars['String']>;
};

export type CrmCaseSummarization = {
  readonly __typename?: 'CRMCaseSummarization';
  readonly caseId: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly summarization: Maybe<Scalars['String']>;
};

export type CrmComment = Node & {
  readonly __typename?: 'CRMComment';
  readonly commentId: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly createdBy: Maybe<Profile>;
  readonly deletedAt: Maybe<Scalars['Float']>;
  readonly deletedBy: Maybe<Profile>;
  readonly id: Scalars['ID'];
  readonly organization: Maybe<Organization>;
  readonly status: Maybe<Scalars['String']>;
  readonly text: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['Float']>;
  readonly updatedBy: Maybe<Profile>;
};

export type CrmCommentable = {
  readonly comments: Maybe<CrmEntityCommentsConnection>;
  readonly entityRefId: Maybe<Scalars['String']>;
  readonly entityRefType: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
};


export type CrmCommentableCommentsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  status: InputMaybe<Scalars['String']>;
};

export type CrmCourtCredential = Node & {
  readonly __typename?: 'CRMCourtCredential';
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly createdBy: Maybe<Profile>;
  readonly credentialId: Maybe<Scalars['String']>;
  readonly data: Maybe<CrmCourtCredentialData>;
  readonly deletedAt: Maybe<Scalars['Float']>;
  readonly deletedBy: Maybe<Profile>;
  readonly id: Scalars['ID'];
  readonly lawsuit: Maybe<CrmLawsuit>;
  readonly organization: Maybe<Organization>;
  readonly status: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['Float']>;
  readonly updatedBy: Maybe<Profile>;
};

export type CrmCourtCredentialData = {
  readonly __typename?: 'CRMCourtCredentialData';
  readonly cpf: Maybe<Scalars['String']>;
  readonly key: Maybe<Scalars['String']>;
  readonly oab: Maybe<Scalars['String']>;
  readonly password: Maybe<Scalars['String']>;
  readonly username: Maybe<Scalars['String']>;
};

export type CrmDataExport = {
  readonly __typename?: 'CRMDataExport';
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly createdBy: Maybe<Scalars['Int']>;
  readonly dataExportId: Maybe<Scalars['String']>;
  readonly dataExportStatus: Maybe<Scalars['String']>;
  readonly dataExportType: Maybe<Scalars['String']>;
  readonly deletedAt: Maybe<Scalars['Float']>;
  readonly filename: Maybe<Scalars['String']>;
  readonly finishedAt: Maybe<Scalars['Float']>;
  readonly lawsuitsCount: Maybe<Scalars['Int']>;
  readonly metadata: Maybe<Scalars['JSON']>;
  readonly organization: Maybe<Organization>;
  readonly updatedAt: Maybe<Scalars['Float']>;
};

export type CrmDocument = Node & {
  readonly __typename?: 'CRMDocument';
  readonly attachmentKind: Maybe<Scalars['String']>;
  readonly contact: Maybe<Contact>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly createdBy: Maybe<Profile>;
  readonly deletedAt: Maybe<Scalars['Float']>;
  readonly deletedBy: Maybe<Profile>;
  readonly description: Maybe<Scalars['String']>;
  readonly documentId: Maybe<Scalars['String']>;
  readonly entity: Maybe<CrmEntity>;
  readonly favorited: Maybe<Scalars['Boolean']>;
  readonly filePath: Maybe<Scalars['String']>;
  readonly fileSize: Maybe<Scalars['Float']>;
  readonly fileType: Maybe<Scalars['String']>;
  readonly fileUrl: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly lawsuitAttachment: Maybe<Scalars['Boolean']>;
  readonly lawsuitId: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
  readonly owners: Maybe<ReadonlyArray<Maybe<Profile>>>;
  readonly readOnly: Maybe<Scalars['Boolean']>;
  readonly status: Maybe<Scalars['String']>;
  readonly thumborImage: Maybe<ThumborImage>;
  readonly title: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['Float']>;
  readonly updatedBy: Maybe<Profile>;
};

export type CrmEmpregadorIrregular = {
  readonly __typename?: 'CRMEmpregadorIrregular';
  readonly ano_acao_fiscal: Maybe<Scalars['String']>;
  readonly cnae: Maybe<Scalars['String']>;
  readonly data_decisao_administrativa: Maybe<Scalars['String']>;
  readonly data_inclusao: Maybe<Scalars['String']>;
  readonly data_publicacao: Maybe<Scalars['String']>;
  readonly estabelecimento: Maybe<Scalars['String']>;
  readonly inferred_kind: Maybe<Scalars['String']>;
  readonly partes: Maybe<ReadonlyArray<Maybe<CrmEmpregadorIrregularParte>>>;
  readonly quantidade_trabalhadores_envolvidos: Maybe<Scalars['Int']>;
  readonly sigilo: Maybe<Scalars['String']>;
  readonly sigla: Maybe<Scalars['String']>;
  readonly subtipo: Maybe<Scalars['String']>;
  readonly uf: Maybe<Scalars['String']>;
};

export type CrmEmpregadorIrregularParte = {
  readonly __typename?: 'CRMEmpregadorIrregularParte';
  readonly alias: Maybe<Scalars['String']>;
  readonly confidence: Maybe<Scalars['String']>;
  readonly identification: Maybe<CrmEmpregadorIrregularParteIdentification>;
  readonly nome: Maybe<Scalars['String']>;
  readonly papel: Maybe<Scalars['String']>;
  readonly source: Maybe<CrmEmpregadorIrregularParteSource>;
};

export type CrmEmpregadorIrregularParteIdentification = {
  readonly __typename?: 'CRMEmpregadorIrregularParteIdentification';
  readonly number: Maybe<Scalars['String']>;
  readonly type: Maybe<Scalars['String']>;
};

export type CrmEmpregadorIrregularParteSource = {
  readonly __typename?: 'CRMEmpregadorIrregularParteSource';
  readonly method: Scalars['String'];
  readonly score: Scalars['Float'];
};

export type CrmEntity = {
  readonly documents: Maybe<CrmEntityDocumentConnection>;
  readonly entityRefId: Maybe<Scalars['String']>;
  readonly entityRefName: Maybe<Scalars['String']>;
  readonly entityRefType: Maybe<Scalars['String']>;
  readonly entityRefTypeRaw: Maybe<Scalars['String']>;
  readonly events: Maybe<ReadonlyArray<Maybe<CrmEvent>>>;
  readonly eventsConnection: Maybe<CrmEntityEventsConnection>;
  readonly favorited: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly isShared: Maybe<Scalars['Boolean']>;
  readonly organization: Maybe<Organization>;
  readonly readOnly: Maybe<Scalars['Boolean']>;
  readonly status: Maybe<Scalars['String']>;
  readonly tasks: Maybe<ReadonlyArray<Maybe<CrmTask>>>;
  readonly tasksConnection: Maybe<CrmEntityTasksConnection>;
  readonly timeline: Maybe<CrmEntityTimelineConnection>;
};


export type CrmEntityDocumentsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type CrmEntityEventsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type CrmEntityTasksArgs = {
  dateRange: InputMaybe<Scalars['JSON']>;
  finished: InputMaybe<Scalars['Boolean']>;
  limit: InputMaybe<Scalars['Int']>;
  ownerId: InputMaybe<Scalars['Int']>;
};


export type CrmEntityTasksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  dateRange: InputMaybe<Scalars['JSON']>;
  finished: InputMaybe<Scalars['Boolean']>;
  first: InputMaybe<Scalars['Int']>;
  ownerId: InputMaybe<Scalars['Int']>;
};


export type CrmEntityTimelineArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};

export type CrmEntityCommentsConnection = {
  readonly __typename?: 'CRMEntityCommentsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<CrmEntityCommentsEdge>>>;
  readonly numHits: Maybe<Scalars['Int']>;
  readonly pageInfo: PageInfo;
};

export type CrmEntityCommentsEdge = {
  readonly __typename?: 'CRMEntityCommentsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmComment>;
};

export type CrmEntityDocumentConnection = {
  readonly __typename?: 'CRMEntityDocumentConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<CrmEntityDocumentEdge>>>;
  readonly numHits: Maybe<Scalars['Int']>;
  readonly pageInfo: PageInfo;
};

export type CrmEntityDocumentEdge = {
  readonly __typename?: 'CRMEntityDocumentEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmDocument>;
};

export type CrmEntityEventsConnection = {
  readonly __typename?: 'CRMEntityEventsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<CrmEntityEventsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type CrmEntityEventsEdge = {
  readonly __typename?: 'CRMEntityEventsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmEvent>;
};

export type CrmEntityImportance = Node & {
  readonly __typename?: 'CRMEntityImportance';
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly createdBy: Maybe<Profile>;
  readonly deletedAt: Maybe<Scalars['Float']>;
  readonly deletedBy: Maybe<Profile>;
  readonly entityId: Maybe<Scalars['String']>;
  readonly entityType: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly importance: Maybe<Scalars['String']>;
  readonly profileId: Maybe<Scalars['Int']>;
  readonly reason: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['Float']>;
  readonly updatedBy: Maybe<Profile>;
};

export type CrmEntityShare = Node & {
  readonly __typename?: 'CRMEntityShare';
  readonly contact: Maybe<Contact>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly createdBy: Maybe<Profile>;
  readonly deletedAt: Maybe<Scalars['Float']>;
  readonly deletedBy: Maybe<Profile>;
  readonly entity: Maybe<CrmEntity>;
  readonly id: Scalars['ID'];
  readonly organization: Maybe<Organization>;
  readonly permissions: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly profile: Maybe<Profile>;
  readonly shareId: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['Float']>;
  readonly updatedBy: Maybe<Profile>;
};

export type CrmEntitySummarization = {
  readonly __typename?: 'CRMEntitySummarization';
  readonly court: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly entityId: Maybe<Scalars['String']>;
  readonly summarization: Maybe<Scalars['String']>;
};

export type CrmEntityTagsConnection = {
  readonly __typename?: 'CRMEntityTagsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<CrmEntityTagsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type CrmEntityTagsEdge = {
  readonly __typename?: 'CRMEntityTagsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmTagLink>;
};

export type CrmEntityTasksConnection = {
  readonly __typename?: 'CRMEntityTasksConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<CrmEntityTasksEdge>>>;
  readonly pageInfo: PageInfo;
};

export type CrmEntityTasksEdge = {
  readonly __typename?: 'CRMEntityTasksEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmTask>;
};

export type CrmEntityTimelineConnection = {
  readonly __typename?: 'CRMEntityTimelineConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<CrmEntityTimelineEdge>>>;
  readonly numHits: Maybe<Scalars['Int']>;
  readonly pageInfo: PageInfo;
};

export type CrmEntityTimelineEdge = {
  readonly __typename?: 'CRMEntityTimelineEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmTimelineItem>;
};

export type CrmEvent = CrmCommentable & Node & {
  readonly __typename?: 'CRMEvent';
  readonly attendees: Maybe<ReadonlyArray<Maybe<CrmEventAttendee>>>;
  readonly calendarId: Maybe<Scalars['String']>;
  readonly comments: Maybe<CrmEntityCommentsConnection>;
  readonly contact: Maybe<Contact>;
  readonly createdBy: Maybe<Profile>;
  readonly description: Maybe<Scalars['String']>;
  readonly end: Maybe<CrmEventTime>;
  readonly entity: Maybe<CrmEntity>;
  readonly entityRefId: Maybe<Scalars['String']>;
  readonly entityRefType: Maybe<Scalars['String']>;
  readonly entityRefTypeRaw: Maybe<Scalars['String']>;
  readonly eventId: Maybe<Scalars['String']>;
  readonly eventType: Maybe<Scalars['String']>;
  readonly favorited: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly lastStatusBy: Maybe<Profile>;
  readonly lawsuit: Maybe<CrmLawsuit>;
  readonly location: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
  readonly organizer: Maybe<CrmEventAttendee>;
  readonly originTimelineItemId: Maybe<Scalars['String']>;
  readonly readOnly: Maybe<Scalars['Boolean']>;
  readonly start: Maybe<CrmEventTime>;
  readonly status: Maybe<Scalars['String']>;
  readonly summary: Maybe<Scalars['String']>;
  readonly timelineItem: Maybe<CrmTimelineItem>;
};


export type CrmEventCommentsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  status: InputMaybe<Scalars['String']>;
};

export type CrmEventAttendee = {
  readonly __typename?: 'CRMEventAttendee';
  readonly calendar: Maybe<CrmCalendar>;
  readonly contact: Maybe<Contact>;
  readonly displayName: Maybe<Scalars['String']>;
  readonly email: Maybe<Scalars['String']>;
  readonly organizer: Maybe<Scalars['Boolean']>;
  readonly profile: Maybe<Profile>;
  readonly responseStatus: Maybe<Scalars['String']>;
  readonly self: Maybe<Scalars['Boolean']>;
};

export type CrmEventTime = {
  readonly __typename?: 'CRMEventTime';
  readonly allDay: Maybe<Scalars['Boolean']>;
  readonly dateTime: Maybe<Scalars['Float']>;
  readonly timeZone: Maybe<Scalars['String']>;
};

export type CrmLawsuit = CrmEntity & CrmTaggable & CrmTimelineProvider & Node & ShareableEntity & {
  readonly __typename?: 'CRMLawsuit';
  readonly activityMonitoringActive: Maybe<Scalars['Boolean']>;
  readonly additionalInfo: Maybe<Scalars['String']>;
  readonly alternativeNumber: Maybe<Scalars['String']>;
  readonly anonymizedItems: Maybe<ReadonlyArray<Maybe<AnonymizedItem>>>;
  /** @deprecated Use `sessionAssistantMessages`. Removed after web migrates. */
  readonly assistantMessages: Maybe<AssistantMessagesConnection>;
  readonly assistantSuggestions: Maybe<LawsuitAssistantSuggestions>;
  readonly attachments: Maybe<CrmLawsuitAttachmentsConnection>;
  readonly canMonitor: Maybe<Scalars['Boolean']>;
  readonly canViewRestrictLawsuit: Maybe<Scalars['Boolean']>;
  readonly classifiedKindByNumber: Maybe<Scalars['String']>;
  readonly cnjNumber: Maybe<CnjNumber>;
  readonly comments: Maybe<Scalars['String']>;
  readonly consolidatedSkuStates: Maybe<SkuStateType>;
  readonly court: Maybe<CrmLawsuitRef>;
  readonly courtCredential: Maybe<CrmCourtCredential>;
  readonly courtCredentialFields: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly courtInstance: Maybe<Scalars['Int']>;
  readonly courtSection: Maybe<CrmLawsuitRef>;
  readonly courtUrl: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly createdBy: Maybe<Profile>;
  readonly currentExplanation: Maybe<CrmLawsuitCurrentExplanation>;
  readonly currentStep: Maybe<Scalars['String']>;
  readonly deletedAt: Maybe<Scalars['Float']>;
  readonly deletedBy: Maybe<Profile>;
  readonly description: Maybe<Scalars['String']>;
  readonly distributionDate: Maybe<Scalars['Float']>;
  readonly distributionType: Maybe<Scalars['String']>;
  readonly district: Maybe<Scalars['String']>;
  readonly documents: Maybe<CrmEntityDocumentConnection>;
  readonly entityId: Maybe<Scalars['NumericID']>;
  readonly entityRefId: Maybe<Scalars['String']>;
  readonly entityRefName: Maybe<Scalars['String']>;
  readonly entityRefType: Maybe<Scalars['String']>;
  readonly entityRefTypeRaw: Maybe<Scalars['String']>;
  readonly entityType: Maybe<Scalars['String']>;
  readonly events: Maybe<ReadonlyArray<Maybe<CrmEvent>>>;
  readonly eventsConnection: Maybe<CrmEntityEventsConnection>;
  readonly exceptionMessage: Maybe<Scalars['String']>;
  readonly extinct: Maybe<Scalars['Boolean']>;
  readonly favorited: Maybe<Scalars['Boolean']>;
  readonly forum: Maybe<Scalars['String']>;
  readonly hasActivity: Maybe<Scalars['Boolean']>;
  readonly hasCover: Maybe<Scalars['Boolean']>;
  readonly hasHiddenItems: Maybe<Scalars['Boolean']>;
  readonly hasParty: Maybe<Scalars['Boolean']>;
  readonly hasPublication: Maybe<Scalars['Boolean']>;
  readonly hasSensitiveReason: Maybe<Scalars['Boolean']>;
  readonly hasUnreadActivity: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly inferredKind: Maybe<Scalars['String']>;
  readonly inferredMotionTheme: Maybe<Scalars['String']>;
  readonly inferredStatus: Maybe<Scalars['String']>;
  readonly initialNumActivitiesFound: Maybe<Scalars['Int']>;
  readonly interaction: Maybe<CrmLawsuitInteraction>;
  readonly isAnonymized: Maybe<Scalars['Boolean']>;
  readonly isArchived: Maybe<Scalars['Boolean']>;
  readonly isCNJ: Maybe<Scalars['Boolean']>;
  readonly isDefinitiveArchived: Maybe<Scalars['Boolean']>;
  readonly isJusambiente: Maybe<Scalars['Boolean']>;
  readonly isLetterRogatory: Maybe<Scalars['Boolean']>;
  readonly isPending: Maybe<Scalars['Boolean']>;
  readonly isPrimaryLawsuit: Maybe<Scalars['Boolean']>;
  readonly isProvisionalArchived: Maybe<Scalars['Boolean']>;
  readonly isRemoved: Maybe<Scalars['Boolean']>;
  readonly isShared: Maybe<Scalars['Boolean']>;
  readonly isSuspended: Maybe<Scalars['Boolean']>;
  readonly isSuspendedAndGathered: Maybe<Scalars['Boolean']>;
  readonly judgeName: Maybe<Scalars['String']>;
  readonly justiceSecret: Maybe<Scalars['Boolean']>;
  readonly kind: Maybe<Scalars['String']>;
  readonly lastActiveMonitoringIntention: Maybe<Scalars['Float']>;
  readonly lastActivity: Maybe<CrmLawsuitActivityItem>;
  readonly lastActivityDate: Maybe<Scalars['Float']>;
  readonly lastActivityText: Maybe<Scalars['String']>;
  readonly lastActivityType: Maybe<Scalars['String']>;
  readonly lastAssistantMessage: Maybe<LawsuitAssistantMessage>;
  readonly lastModifiedLawsuit: Maybe<Scalars['Float']>;
  readonly lastProviderUpdate: Maybe<Scalars['Float']>;
  readonly lastReceivedActivity: Maybe<Scalars['Float']>;
  readonly lastRequestProviderUpdate: Maybe<Scalars['Float']>;
  /** @deprecated Please use `interaction.lastSeen` instead. */
  readonly lastSeenDate: Maybe<Scalars['Float']>;
  readonly lastUserRequestedLawsuitUpdate: Maybe<Scalars['Float']>;
  readonly lawsuitId: Maybe<Scalars['String']>;
  readonly lawsuitNumberDetails: Maybe<LawsuitNumberDetails>;
  readonly lawsuitNumberType: Maybe<Scalars['String']>;
  readonly lawsuitRestrictions: Maybe<LawsuitRestrictions>;
  readonly lawsuitSnapshotId: Maybe<Scalars['String']>;
  readonly lawsuitTags: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly lawsuitType: Maybe<Scalars['String']>;
  readonly leanRelatedLawsuits: Maybe<ReadonlyArray<Maybe<LeanRelatedLawsuit>>>;
  readonly limitVisibilityTo: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly linkedLawsuits: Maybe<LinkedLawsuitConnection>;
  readonly llmTitle: Maybe<CrmLawsuitLlmTitle>;
  readonly local: Maybe<Scalars['String']>;
  readonly missingOnProvider: Maybe<Scalars['Boolean']>;
  readonly monitoringActive: Maybe<Scalars['Boolean']>;
  readonly monitoringErrorMessage: Maybe<Scalars['String']>;
  readonly monitoringId: Maybe<Scalars['String']>;
  readonly monitoringIntentionActive: Maybe<Scalars['Boolean']>;
  readonly monitoringStatus: Maybe<Scalars['String']>;
  readonly myLawsuit: Maybe<CrmLawsuit>;
  readonly nature: Maybe<Scalars['String']>;
  readonly normalizedNature: Maybe<Scalars['String']>;
  readonly normalizedSubject: Maybe<Scalars['JSON']>;
  readonly numFoundNetworkActivities: Maybe<Scalars['Int']>;
  readonly number: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
  readonly owner: Maybe<Profile>;
  readonly owners: Maybe<ReadonlyArray<Maybe<Profile>>>;
  readonly pendingBackgroundAction: Maybe<Scalars['Boolean']>;
  readonly priority: Maybe<Scalars['String']>;
  readonly provider: Maybe<Scalars['String']>;
  readonly publicLawsuit: Maybe<CrmLawsuit>;
  readonly publicationMonitoringActive: Maybe<Scalars['Boolean']>;
  readonly rawSubject: Maybe<Scalars['String']>;
  readonly readOnly: Maybe<Scalars['Boolean']>;
  readonly relatedJuris: Maybe<ReadonlyArray<Maybe<Document>>>;
  readonly relatedLawsuits: Maybe<ReadonlyArray<Maybe<RelatedLawsuit>>>;
  readonly relatedMotions: Maybe<ReadonlyArray<Maybe<Document>>>;
  readonly relatedPeople: Maybe<ReadonlyArray<Maybe<CrmLawsuitRelatedPerson>>>;
  readonly relevantEventAttachments: Maybe<ReadonlyArray<Maybe<RelevantEventAttachment>>>;
  readonly relevantEvents: Maybe<ReadonlyArray<Maybe<LawsuitRelevantEvent>>>;
  readonly representedPersonLawyers: Maybe<ReadonlyArray<Maybe<CrmLawsuitRepresentedPersonLawyer>>>;
  readonly resourceAccess: Maybe<ResourceAccess>;
  readonly restrictLawsuit: Maybe<Scalars['Boolean']>;
  readonly restrictionLevel: Maybe<RestrictionLevel>;
  readonly result: Maybe<Scalars['String']>;
  readonly sensitive: Maybe<Scalars['Boolean']>;
  readonly seoNoIndex: Maybe<Scalars['Boolean']>;
  readonly sessionAssistantMessages: Maybe<ReadonlyArray<Maybe<LawsuitSessionAssistantMessage>>>;
  readonly shares: Maybe<ReadonlyArray<Maybe<CrmEntityShare>>>;
  readonly situation: Maybe<CrmLawsuitRef>;
  readonly stage: Maybe<Scalars['String']>;
  readonly stateAcronym: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly subject: Maybe<Scalars['String']>;
  readonly summarization: Maybe<CrmLawsuitSummarization>;
  readonly syncedAfterMonitoring: Maybe<Scalars['Boolean']>;
  readonly syncedWithNetworkActivities: Maybe<Scalars['String']>;
  readonly tags: Maybe<CrmEntityTagsConnection>;
  readonly tasks: Maybe<ReadonlyArray<Maybe<CrmTask>>>;
  readonly tasksConnection: Maybe<CrmEntityTasksConnection>;
  readonly timeline: Maybe<CrmEntityTimelineConnection>;
  readonly timelineItem: Maybe<CrmTimelineItem>;
  readonly title: Maybe<Scalars['String']>;
  readonly topicEntity: Maybe<TopicEntity>;
  readonly topicSource: Maybe<Topic>;
  readonly topicSourceId: Maybe<Scalars['Int']>;
  readonly topicSourceSlug: Maybe<Scalars['String']>;
  readonly tuxedoTypification: Maybe<Scalars['JSON']>;
  readonly typification: Maybe<Scalars['JSON']>;
  readonly updateStatus: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['Float']>;
  readonly updatedBy: Maybe<Profile>;
  readonly url: Maybe<Scalars['String']>;
  readonly userInteraction: Maybe<LawsuitUserInteraction>;
  readonly validatedProfile: Maybe<CrmLawsuitValidatedProfile>;
  readonly value: Maybe<Scalars['Float']>;
  readonly verdictDate: Maybe<Scalars['Float']>;
  readonly viewerHasCNPJMatch: Maybe<Scalars['Boolean']>;
  readonly viewerHasCPFMatch: Maybe<Scalars['Boolean']>;
  readonly viewerSharedConf: Maybe<CrmEntityShare>;
};


export type CrmLawsuitAssistantMessagesArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  type: InputMaybe<MessageType>;
};


export type CrmLawsuitAttachmentsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  kind: InputMaybe<Scalars['String']>;
  kindGranularIn: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  kindGranularNotIn: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  kindGroup: InputMaybe<Scalars['String']>;
  source: InputMaybe<Scalars['String']>;
  sources: InputMaybe<ReadonlyArray<InputMaybe<AttachmentSourcesType>>>;
};


export type CrmLawsuitDocumentsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  lawsuitAttachment: InputMaybe<Scalars['Boolean']>;
};


export type CrmLawsuitEventsArgs = {
  eventType: InputMaybe<Scalars['String']>;
  ownerId: InputMaybe<Scalars['Int']>;
  singleEvents: InputMaybe<Scalars['Boolean']>;
  timeMax: InputMaybe<Scalars['Float']>;
  timeMin: InputMaybe<Scalars['Float']>;
};


export type CrmLawsuitEventsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  eventType: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  ownerId: InputMaybe<Scalars['Int']>;
  singleEvents: InputMaybe<Scalars['Boolean']>;
  timeMax: InputMaybe<Scalars['Float']>;
  timeMin: InputMaybe<Scalars['Float']>;
};


export type CrmLawsuitLinkedLawsuitsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type CrmLawsuitNumberArgs = {
  unmaskCNJ: InputMaybe<Scalars['Boolean']>;
};


export type CrmLawsuitRelatedPeopleArgs = {
  groupType: InputMaybe<RelatedLawsuitPersonType>;
  limit: InputMaybe<Scalars['Int']>;
};


export type CrmLawsuitRelevantEventAttachmentsArgs = {
  eventTypes: InputMaybe<ReadonlyArray<InputMaybe<LawsuitRelevantEventType>>>;
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
};


export type CrmLawsuitRelevantEventsArgs = {
  eventType: InputMaybe<LawsuitRelevantEventType>;
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  providers: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type CrmLawsuitRepresentedPersonLawyersArgs = {
  groupType: InputMaybe<RelatedLawsuitPersonType>;
  limit: InputMaybe<Scalars['Int']>;
};


export type CrmLawsuitSummarizationArgs = {
  versionId?: InputMaybe<Scalars['String']>;
};


export type CrmLawsuitTagsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type CrmLawsuitTasksArgs = {
  dateRange: InputMaybe<Scalars['JSON']>;
  finished: InputMaybe<Scalars['Boolean']>;
  limit: InputMaybe<Scalars['Int']>;
  ownerId: InputMaybe<Scalars['Int']>;
};


export type CrmLawsuitTasksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  dateRange: InputMaybe<Scalars['JSON']>;
  finished: InputMaybe<Scalars['Boolean']>;
  first: InputMaybe<Scalars['Int']>;
  ownerId: InputMaybe<Scalars['Int']>;
};


export type CrmLawsuitTimelineArgs = {
  actions: InputMaybe<Scalars['JSON']>;
  after: InputMaybe<Scalars['String']>;
  enableLimitDate?: InputMaybe<Scalars['Boolean']>;
  eventType: InputMaybe<Scalars['String']>;
  eventTypes: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  excludeStatus: InputMaybe<SuitsStatusType>;
  first: InputMaybe<Scalars['Int']>;
  groupType?: InputMaybe<TimelineGroupType>;
  important: InputMaybe<Scalars['Boolean']>;
  loadFromDB: InputMaybe<Scalars['Boolean']>;
  objectType: InputMaybe<Scalars['String']>;
  providers: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  read: InputMaybe<Scalars['Boolean']>;
  source: InputMaybe<Scalars['JSON']>;
  status: InputMaybe<Scalars['String']>;
  types: InputMaybe<ReadonlyArray<InputMaybe<TimelineItemType>>>;
  usePrivateLawsuit?: InputMaybe<Scalars['Boolean']>;
  visibilityType: InputMaybe<Scalars['String']>;
  withAttachmentsOfDay?: InputMaybe<Scalars['Boolean']>;
};


export type CrmLawsuitTimelineItemArgs = {
  timelineItemId: InputMaybe<Scalars['String']>;
};


export type CrmLawsuitTitleArgs = {
  unmaskCNJ: InputMaybe<Scalars['Boolean']>;
};


export type CrmLawsuitUpdateStatusArgs = {
  onLastHours: InputMaybe<Scalars['Int']>;
  searchErrorThresholdInMinutes: InputMaybe<Scalars['Int']>;
};

export type CrmLawsuitActivityItem = CrmCommentable & CrmTaggable & Node & {
  readonly __typename?: 'CRMLawsuitActivityItem';
  readonly activityInferences: Maybe<CrmActivityInferences>;
  readonly attachments: Maybe<ReadonlyArray<Maybe<CrmLawsuitAttachment>>>;
  readonly category: Maybe<Scalars['String']>;
  readonly comments: Maybe<CrmEntityCommentsConnection>;
  readonly createdBy: Maybe<Profile>;
  readonly date: Maybe<Scalars['Float']>;
  readonly documents: Maybe<ReadonlyArray<Maybe<CrmDocument>>>;
  readonly entity: Maybe<CrmEntity>;
  readonly entityRefId: Maybe<Scalars['String']>;
  readonly entityRefType: Maybe<Scalars['String']>;
  readonly entityRefTypeRaw: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly importance: Maybe<CrmEntityImportance>;
  readonly isRelevant: Maybe<Scalars['Boolean']>;
  readonly itemId: Maybe<Scalars['String']>;
  readonly judgeName: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
  readonly provider: Maybe<Scalars['String']>;
  readonly refId: Maybe<Scalars['String']>;
  readonly sentenceDevice: Maybe<SentenceDevice>;
  readonly status: Maybe<Scalars['String']>;
  readonly subcategory: Maybe<Scalars['String']>;
  readonly tags: Maybe<CrmEntityTagsConnection>;
  readonly text: Maybe<Scalars['String']>;
  readonly timelineItem: Maybe<CrmTimelineItem>;
};


export type CrmLawsuitActivityItemCommentsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  status: InputMaybe<Scalars['String']>;
};


export type CrmLawsuitActivityItemTagsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};

export type CrmLawsuitAttachment = Node & {
  readonly __typename?: 'CRMLawsuitAttachment';
  readonly attachmentId: Maybe<Scalars['String']>;
  readonly classifiedKind: Maybe<Scalars['JSON']>;
  readonly classifiedKindGranular: Maybe<Scalars['String']>;
  readonly classifiedKindGroup: Maybe<Scalars['String']>;
  readonly downloadDatetime: Maybe<Scalars['Float']>;
  readonly fileType: Maybe<Scalars['String']>;
  readonly filename: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly kind: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
  readonly lawsuitActivityItems: Maybe<ReadonlyArray<Maybe<CrmLawsuitActivityItem>>>;
  readonly networkDocument: Maybe<Document>;
  readonly networkDocumentUrl: Maybe<Scalars['String']>;
  readonly normalizedTitle: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
  readonly publicationDatetime: Maybe<Scalars['Float']>;
  readonly signedUrl: Maybe<Scalars['String']>;
  readonly text: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
};


export type CrmLawsuitAttachmentSignedUrlArgs = {
  isFreemiumUser: InputMaybe<Scalars['Boolean']>;
  oneTimePurchase: InputMaybe<Scalars['Boolean']>;
};

export type CrmLawsuitAttachmentsConnection = {
  readonly __typename?: 'CRMLawsuitAttachmentsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<CrmLawsuitAttachmentsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type CrmLawsuitAttachmentsEdge = {
  readonly __typename?: 'CRMLawsuitAttachmentsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmLawsuitAttachment>;
};

export type CrmLawsuitCurrentExplanation = {
  readonly __typename?: 'CRMLawsuitCurrentExplanation';
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly explanation: Maybe<Scalars['String']>;
  readonly isSimplified: Maybe<Scalars['Boolean']>;
  readonly lastActivity: Maybe<CrmLawsuitActivityItem>;
  readonly lastActivityDate: Maybe<Scalars['Float']>;
  readonly lastActivityId: Maybe<Scalars['String']>;
  readonly lawsuitAssistantMessage: Maybe<LawsuitAssistantMessage>;
  readonly lawsuitId: Maybe<Scalars['String']>;
  readonly maxTokens: Maybe<Scalars['String']>;
  readonly model: Maybe<Scalars['String']>;
  readonly prompt: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly temperature: Maybe<Scalars['Float']>;
  readonly usedActivityIds: Maybe<Scalars['String']>;
  readonly versionId: Maybe<Scalars['String']>;
};

export type CrmLawsuitDetected = Node & {
  readonly __typename?: 'CRMLawsuitDetected';
  readonly artifact: Maybe<Scalars['String']>;
  readonly docId: Maybe<Scalars['Int']>;
  readonly id: Scalars['ID'];
  readonly lawsuit: Maybe<CrmLawsuit>;
  readonly lawsuitId: Maybe<Scalars['String']>;
  readonly lawsuitNumber: Maybe<Scalars['String']>;
  readonly publicLawsuit: Maybe<CrmLawsuit>;
};

export type CrmLawsuitInteraction = {
  readonly __typename?: 'CRMLawsuitInteraction';
  readonly answeredStageTimelineSurvey: Maybe<Scalars['Boolean']>;
  readonly lastSeen: Maybe<Scalars['Float']>;
  readonly lastUpdateRequest: Maybe<Scalars['Float']>;
  readonly lawsuitStage: Maybe<Scalars['String']>;
  readonly lockedItemsCount: Maybe<Scalars['Int']>;
  readonly monitoringReasonSent: Maybe<Scalars['Boolean']>;
  readonly participateStageTimelineExperiment: Maybe<Scalars['Boolean']>;
  readonly stageTimelineVisibility: Maybe<Scalars['String']>;
};

export type CrmLawsuitLlmTitle = {
  readonly __typename?: 'CRMLawsuitLLMTitle';
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly expiresAt: Maybe<Scalars['String']>;
  readonly lawsuitId: Maybe<Scalars['String']>;
  readonly llmTitle: Maybe<Scalars['String']>;
};

export type CrmLawsuitPartyEntity = Node & {
  readonly __typename?: 'CRMLawsuitPartyEntity';
  readonly age: Maybe<Scalars['String']>;
  readonly aggregations: Maybe<EntityPersistedAggregations>;
  readonly alternativeName: Maybe<Scalars['String']>;
  readonly canMonitorCPF: Maybe<Scalars['Boolean']>;
  readonly canUseFeature: Maybe<Scalars['Boolean']>;
  readonly canUseThirdPartySearchFeature: Maybe<Scalars['Boolean']>;
  readonly companyInfo: Maybe<CompanyInfo>;
  readonly displayName: Maybe<Scalars['String']>;
  readonly entityId: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly identificationName: Maybe<Scalars['String']>;
  readonly identificationNumber: Maybe<Scalars['String']>;
  readonly identificationType: Maybe<Scalars['String']>;
  readonly isMonitoringCPF: Maybe<Scalars['Boolean']>;
  readonly isViewerCPF: Maybe<Scalars['Boolean']>;
  readonly lawsuitCases: Maybe<LawsuitCasesByEntityConnection>;
  readonly lawsuitParties: Maybe<ReadonlyArray<Maybe<Contact>>>;
  readonly lawsuits: Maybe<CrmLawsuitPartyEntityLawsuitsConnection>;
  readonly lawsuitsCollectedAt: Maybe<Scalars['Float']>;
  readonly lawsuitsWithoutEntity: Maybe<CrmLawsuitPartyEntityLawsuitsWithoutEntityConnection>;
  readonly nonSensitiveBnmps: Maybe<ReadonlyArray<Maybe<CrmArrestWarrant>>>;
  readonly relatedCandidacies: Maybe<ReadonlyArray<Maybe<Candidacy>>>;
  readonly relatedEntities: Maybe<RelatedCrmLawsuitPartyEntitiesConnection>;
  readonly showConciergeBanner: Maybe<Scalars['Boolean']>;
  readonly state: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly summarization: Maybe<CrmEntitySummarization>;
  readonly uf: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['Float']>;
  readonly url: Maybe<Scalars['String']>;
  readonly usedResourcesByFeatureCode: Maybe<ReadonlyArray<Maybe<UsedResource>>>;
};


export type CrmLawsuitPartyEntityAlternativeNameArgs = {
  maskOnlySurname: InputMaybe<Scalars['Boolean']>;
  unlockName: InputMaybe<Scalars['Boolean']>;
};


export type CrmLawsuitPartyEntityCanUseFeatureArgs = {
  featureCode: Scalars['String'];
};


export type CrmLawsuitPartyEntityDisplayNameArgs = {
  maskOnlySurname: InputMaybe<Scalars['Boolean']>;
  unlockName: InputMaybe<Scalars['Boolean']>;
};


export type CrmLawsuitPartyEntityIdentificationNameArgs = {
  maskOnlySurname: InputMaybe<Scalars['Boolean']>;
  unlockName: InputMaybe<Scalars['Boolean']>;
};


export type CrmLawsuitPartyEntityIdentificationNumberArgs = {
  unlockUnlogged: InputMaybe<Scalars['Boolean']>;
};


export type CrmLawsuitPartyEntityLawsuitCasesArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  poles: InputMaybe<ReadonlyArray<InputMaybe<PersonIdPoleType>>>;
};


export type CrmLawsuitPartyEntityLawsuitPartiesArgs = {
  limit: InputMaybe<Scalars['Int']>;
};


export type CrmLawsuitPartyEntityLawsuitsArgs = {
  after: InputMaybe<Scalars['String']>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  entityConfidence?: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  onlyWithPole: InputMaybe<Scalars['Boolean']>;
  pole: InputMaybe<PersonIdPoleType>;
  poles: InputMaybe<ReadonlyArray<InputMaybe<PersonIdPoleType>>>;
  showRestrictedLawsuit?: InputMaybe<Scalars['Boolean']>;
};


export type CrmLawsuitPartyEntityLawsuitsWithoutEntityArgs = {
  after: InputMaybe<Scalars['String']>;
  filterByCpf: InputMaybe<Scalars['Boolean']>;
  filters: InputMaybe<LawsuitsFilterInput>;
  first: InputMaybe<Scalars['Int']>;
};


export type CrmLawsuitPartyEntityRelatedCandidaciesArgs = {
  cursor: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
};


export type CrmLawsuitPartyEntityRelatedEntitiesArgs = {
  after: InputMaybe<Scalars['String']>;
  filters: InputMaybe<LawsuitPartyEntitiesRelationshipFilterInput>;
  first: InputMaybe<Scalars['Int']>;
};


export type CrmLawsuitPartyEntityUsedResourcesByFeatureCodeArgs = {
  featureCode: Scalars['String'];
  limit: InputMaybe<Scalars['Int']>;
};

export type CrmLawsuitPartyEntityLawsuitsConnection = {
  readonly __typename?: 'CRMLawsuitPartyEntityLawsuitsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<CrmLawsuitPartyEntityLawsuitsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type CrmLawsuitPartyEntityLawsuitsEdge = {
  readonly __typename?: 'CRMLawsuitPartyEntityLawsuitsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmLawsuit>;
};

export type CrmLawsuitPartyEntityLawsuitsWithoutEntityConnection = {
  readonly __typename?: 'CRMLawsuitPartyEntityLawsuitsWithoutEntityConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<CrmLawsuitPartyEntityLawsuitsWithoutEntityEdge>>>;
  readonly pageInfo: PageInfo;
};

export type CrmLawsuitPartyEntityLawsuitsWithoutEntityEdge = {
  readonly __typename?: 'CRMLawsuitPartyEntityLawsuitsWithoutEntityEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmLawsuit>;
};

export type CrmLawsuitPerson = {
  readonly contact: Maybe<Contact>;
  readonly name: Maybe<Scalars['String']>;
  readonly personRefContactId: Maybe<Scalars['String']>;
  readonly personRefId: Maybe<Scalars['String']>;
  readonly personRefType: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
};

export type CrmLawsuitRef = {
  readonly __typename?: 'CRMLawsuitRef';
  readonly kind: Maybe<Scalars['String']>;
  readonly normalized: Maybe<Scalars['String']>;
  readonly rawValue: Maybe<Scalars['String']>;
};

export type CrmLawsuitRelatedPerson = CrmLawsuitPerson & {
  readonly __typename?: 'CRMLawsuitRelatedPerson';
  readonly anonymized: Maybe<Scalars['Boolean']>;
  readonly author: Maybe<Scalars['Boolean']>;
  readonly canonicalIdentificationNumber: Maybe<Scalars['String']>;
  readonly clientConfirmed: Maybe<Scalars['Boolean']>;
  readonly coauthor: Maybe<Scalars['Boolean']>;
  readonly contact: Maybe<Contact>;
  readonly defendant: Maybe<Scalars['Boolean']>;
  readonly foundInCoverIds: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly identificationNumber: Maybe<Scalars['String']>;
  readonly identificationType: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly nameTopicId: Maybe<Scalars['Int']>;
  readonly neutral: Maybe<Scalars['Boolean']>;
  readonly personId: Maybe<Scalars['String']>;
  readonly personRefContactId: Maybe<Scalars['String']>;
  readonly personRefId: Maybe<Scalars['String']>;
  readonly personRefType: Maybe<Scalars['String']>;
  readonly personType: Maybe<Scalars['String']>;
  readonly poleA: Maybe<Scalars['Boolean']>;
  readonly poleB: Maybe<Scalars['Boolean']>;
  readonly role: Maybe<CrmLawsuitRef>;
  readonly status: Maybe<Scalars['String']>;
  readonly topicEntity: Maybe<TopicEntity>;
  readonly url: Maybe<Scalars['String']>;
};

export type CrmLawsuitRepresentedPersonLawyer = CrmLawsuitPerson & {
  readonly __typename?: 'CRMLawsuitRepresentedPersonLawyer';
  readonly anonymized: Maybe<Scalars['Boolean']>;
  readonly contact: Maybe<Contact>;
  readonly cpf: Maybe<Scalars['String']>;
  readonly foundInCoverIds: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly lawsuitLawyerId: Maybe<Scalars['String']>;
  readonly lawyerId: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly oab: Maybe<Scalars['String']>;
  readonly oabNumber: Maybe<Scalars['Float']>;
  readonly oabUf: Maybe<Scalars['String']>;
  readonly personRefContactId: Maybe<Scalars['String']>;
  readonly personRefId: Maybe<Scalars['String']>;
  readonly personRefType: Maybe<Scalars['String']>;
  readonly representedPersonId: Maybe<Scalars['String']>;
  readonly stateAcronym: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly topicEntity: Maybe<TopicEntity>;
};

export type CrmLawsuitResult = {
  readonly __typename?: 'CRMLawsuitResult';
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly evidences: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly lastActivityDate: Maybe<Scalars['Float']>;
  readonly lawsuitId: Maybe<Scalars['String']>;
  readonly maxTokens: Maybe<Scalars['Int']>;
  readonly model: Maybe<Scalars['String']>;
  readonly observations: Maybe<Scalars['String']>;
  readonly prompt: Maybe<Scalars['String']>;
  readonly provider: Maybe<Scalars['String']>;
  readonly result: Maybe<Scalars['String']>;
  readonly temperature: Maybe<Scalars['Float']>;
  readonly updatedAt: Maybe<Scalars['Float']>;
};

export type CrmLawsuitSearch = Node & {
  readonly __typename?: 'CRMLawsuitSearch';
  readonly executionStatus: Maybe<Scalars['String']>;
  readonly existentLawsuits: Maybe<Scalars['Int']>;
  readonly id: Scalars['ID'];
  readonly lawsuitSearchId: Maybe<Scalars['String']>;
  readonly lawsuitSearchType: Maybe<Scalars['String']>;
  readonly monitoringIntentionActive: Maybe<Scalars['Boolean']>;
  readonly nonExistentLawsuits: Maybe<Scalars['Int']>;
  readonly status: Maybe<Scalars['String']>;
  readonly terms: Maybe<ReadonlyArray<Maybe<LawsuitSearchTerm>>>;
};

export type CrmLawsuitSearchUserInteraction = {
  readonly __typename?: 'CRMLawsuitSearchUserInteraction';
  readonly count: Maybe<Scalars['Int']>;
  readonly firstSearch: Maybe<Scalars['Float']>;
  readonly lastSearch: Maybe<Scalars['Float']>;
  readonly orgId: Maybe<Scalars['String']>;
  readonly query: Maybe<Scalars['String']>;
  readonly queryId: Maybe<Scalars['String']>;
  readonly relation: Maybe<Scalars['String']>;
};

export type CrmLawsuitSummarization = {
  readonly __typename?: 'CRMLawsuitSummarization';
  readonly court: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly expiresAt: Maybe<Scalars['String']>;
  readonly lawsuitId: Maybe<Scalars['String']>;
  readonly summarization: Maybe<Scalars['String']>;
};

export type CrmLawsuitValidatedProfile = Node & {
  readonly __typename?: 'CRMLawsuitValidatedProfile';
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly id: Scalars['ID'];
  readonly identity: Maybe<CrmLawsuitValidatedProfileIdentity>;
  readonly lawsuitId: Maybe<Scalars['String']>;
  readonly matchType: Maybe<Scalars['String']>;
  readonly profileId: Maybe<Scalars['Int']>;
  readonly relatedPersonId: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly validatedProfileId: Maybe<Scalars['String']>;
};

export type CrmLawsuitValidatedProfileIdentity = {
  readonly __typename?: 'CRMLawsuitValidatedProfileIdentity';
  readonly birthdate: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly number: Maybe<Scalars['String']>;
  readonly relatedPersonName: Maybe<Scalars['String']>;
  readonly relationship: Maybe<Scalars['String']>;
  readonly type: Maybe<Scalars['String']>;
};

export type CrmLawsuitView = {
  readonly __typename?: 'CRMLawsuitView';
  readonly activity: Maybe<ReadonlyArray<Maybe<CrmLawsuitActivityItem>>>;
  readonly attachments: Maybe<ReadonlyArray<Maybe<CrmLawsuitAttachment>>>;
  readonly lawsuit: Maybe<CrmLawsuit>;
};

export type CrmLawsuitsByNameWithoutConfidenceConnection = {
  readonly __typename?: 'CRMLawsuitsByNameWithoutConfidenceConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<CrmLawsuitsByNameWithoutConfidenceEdge>>>;
  readonly pageInfo: PageInfo;
};

export type CrmLawsuitsByNameWithoutConfidenceEdge = {
  readonly __typename?: 'CRMLawsuitsByNameWithoutConfidenceEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmLawsuit>;
};

export type CrmLawsuitsByPersonIdConnection = {
  readonly __typename?: 'CRMLawsuitsByPersonIdConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<CrmLawsuitsByPersonIdEdge>>>;
  readonly pageInfo: PageInfo;
};

export type CrmLawsuitsByPersonIdEdge = {
  readonly __typename?: 'CRMLawsuitsByPersonIdEdge';
  readonly alias: Maybe<Scalars['String']>;
  readonly confidence: Maybe<Scalars['String']>;
  readonly cursor: Scalars['String'];
  readonly lastReference: Maybe<Scalars['Float']>;
  readonly matchRelatedPeople: Maybe<CrmLawsuitRelatedPerson>;
  readonly node: Maybe<CrmLawsuit>;
  readonly score: Maybe<Scalars['Float']>;
  readonly source: Maybe<Scalars['String']>;
  readonly versions: Maybe<Scalars['JSON']>;
};

export type CrmLinkedLawsuit = {
  readonly __typename?: 'CRMLinkedLawsuit';
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly createdBy: Maybe<Profile>;
  readonly linkedLawsuit: Maybe<CrmLawsuit>;
};

export type CrmMessage = {
  readonly __typename?: 'CRMMessage';
  readonly conversation: Maybe<Conversation>;
  readonly createdAt: Maybe<Scalars['Int']>;
  readonly layerId: Maybe<Scalars['String']>;
  readonly legalCase: Maybe<LegalCase>;
  readonly messageId: Maybe<Scalars['String']>;
  readonly rawText: Maybe<Scalars['String']>;
  readonly sendAt: Maybe<Scalars['Int']>;
  readonly sender: Maybe<Profile>;
  readonly status: Maybe<Scalars['String']>;
  readonly text: Maybe<Scalars['String']>;
  readonly type: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['Int']>;
};

export type CrmMp = {
  readonly __typename?: 'CRMMp';
  readonly anexos: Maybe<ReadonlyArray<Maybe<CrmMpAnexo>>>;
  readonly assunto: Maybe<Scalars['String']>;
  readonly autos_classe: Maybe<Scalars['String']>;
  readonly autos_classe_sigla: Maybe<Scalars['String']>;
  readonly autos_local: Maybe<Scalars['String']>;
  readonly base_sku: Maybe<Scalars['String']>;
  readonly data_registro: Maybe<Scalars['String']>;
  readonly inferred_kind: Maybe<Scalars['String']>;
  readonly informacoes_complementares: Maybe<ReadonlyArray<Maybe<CrmMpInformation>>>;
  readonly movimentacoes: Maybe<ReadonlyArray<Maybe<CrmMpMovimentation>>>;
  readonly numero_cnmp: Maybe<Scalars['String']>;
  readonly numero_mp: Maybe<Scalars['String']>;
  readonly numero_tribunal: Maybe<Scalars['String']>;
  readonly partes: Maybe<ReadonlyArray<Maybe<CrmMpParte>>>;
  readonly pessoa_membra_mp: Maybe<Scalars['String']>;
  readonly sigilo: Maybe<Scalars['String']>;
  readonly sigla: Maybe<Scalars['String']>;
  readonly situacao: Maybe<Scalars['String']>;
  readonly tipo_procedimento: Maybe<Scalars['String']>;
  readonly typification: Maybe<Scalars['JSON']>;
  readonly uf: Maybe<Scalars['String']>;
  readonly unidade_mp: Maybe<Scalars['String']>;
};

export type CrmMpAnexo = {
  readonly __typename?: 'CRMMpAnexo';
  readonly nome_arquivo: Maybe<Scalars['String']>;
  readonly tipo: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
};

export type CrmMpInformation = {
  readonly __typename?: 'CRMMpInformation';
  readonly chave: Maybe<Scalars['String']>;
  readonly valor: Maybe<Scalars['String']>;
};

export type CrmMpMovimentation = {
  readonly __typename?: 'CRMMpMovimentation';
  readonly data: Maybe<Scalars['String']>;
  readonly detalhe: Maybe<Scalars['String']>;
  readonly movimento: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
};

export type CrmMpParte = {
  readonly __typename?: 'CRMMpParte';
  readonly alias: Maybe<Scalars['String']>;
  readonly confidence: Maybe<Scalars['String']>;
  readonly identification: Maybe<CrmMpParteIdentification>;
  readonly nome: Maybe<Scalars['String']>;
  readonly papel: Maybe<Scalars['String']>;
  readonly source: Maybe<CrmMpParteSource>;
};

export type CrmMpParteIdentification = {
  readonly __typename?: 'CRMMpParteIdentification';
  readonly number: Maybe<Scalars['String']>;
  readonly type: Maybe<Scalars['String']>;
};

export type CrmMpParteSource = {
  readonly __typename?: 'CRMMpParteSource';
  readonly method: Scalars['String'];
  readonly score: Scalars['String'];
};

export type CrmPublicationItem = CrmCommentable & CrmTaggable & Node & {
  readonly __typename?: 'CRMPublicationItem';
  readonly alertSources: Maybe<ReadonlyArray<Maybe<PublicationAlertSource>>>;
  readonly alerts: Maybe<ReadonlyArray<Maybe<PublicationAlert>>>;
  readonly comments: Maybe<CrmEntityCommentsConnection>;
  readonly date: Maybe<Scalars['Float']>;
  readonly description: Maybe<Scalars['String']>;
  readonly detectedLawsuit: Maybe<CrmLawsuitDetected>;
  readonly document: Maybe<Document>;
  readonly entityRefId: Maybe<Scalars['String']>;
  readonly entityRefType: Maybe<Scalars['String']>;
  readonly entityRefTypeRaw: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly importance: Maybe<CrmEntityImportance>;
  readonly itemId: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
  readonly organization: Maybe<Organization>;
  readonly status: Maybe<Scalars['String']>;
  readonly tags: Maybe<CrmEntityTagsConnection>;
  readonly text: Maybe<Scalars['String']>;
  readonly timelineItem: Maybe<CrmTimelineItem>;
  readonly title: Maybe<Scalars['String']>;
};


export type CrmPublicationItemCommentsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  status: InputMaybe<Scalars['String']>;
};


export type CrmPublicationItemTagsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type CrmPublicationItemTextArgs = {
  unmaskCNJ: InputMaybe<Scalars['Boolean']>;
};

export type CrmSearchItem = {
  readonly __typename?: 'CRMSearchItem';
  readonly activity: Maybe<CrmActivityLog>;
  readonly contact: Maybe<Contact>;
  readonly document: Maybe<CrmDocument>;
  readonly entityName: Maybe<Scalars['String']>;
  readonly highlight: Maybe<CrmSearchItemHighlight>;
  readonly lawsuit: Maybe<CrmLawsuit>;
  readonly lawsuitActivityItem: Maybe<CrmLawsuitActivityItem>;
  readonly message: Maybe<CrmMessage>;
  readonly publication: Maybe<CrmPublicationItem>;
  readonly task: Maybe<CrmTask>;
};

export type CrmSearchItemHighlight = {
  readonly __typename?: 'CRMSearchItemHighlight';
  readonly all: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
};

export type CrmSearchLawsuitPartyEntitiesConnection = {
  readonly __typename?: 'CRMSearchLawsuitPartyEntitiesConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<CrmSearchLawsuitPartyEntitiesEdge>>>;
  readonly pageInfo: PageInfo;
};

export type CrmSearchLawsuitPartyEntitiesEdge = {
  readonly __typename?: 'CRMSearchLawsuitPartyEntitiesEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmLawsuitPartyEntity>;
};

export type CrmTag = Node & {
  readonly __typename?: 'CRMTag';
  readonly color: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly createdBy: Maybe<Profile>;
  readonly deletedAt: Maybe<Scalars['Float']>;
  readonly deletedBy: Maybe<Profile>;
  readonly id: Scalars['ID'];
  readonly organization: Maybe<Organization>;
  readonly status: Maybe<Scalars['String']>;
  readonly systemTag: Maybe<Scalars['Boolean']>;
  readonly tagId: Maybe<Scalars['String']>;
  readonly targets: Maybe<ReadonlyArray<Maybe<CrmTagTarget>>>;
  readonly title: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['Float']>;
  readonly updatedBy: Maybe<Profile>;
};

export type CrmTagLink = Node & {
  readonly __typename?: 'CRMTagLink';
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly createdBy: Maybe<Profile>;
  readonly deletedAt: Maybe<Scalars['Float']>;
  readonly deletedBy: Maybe<Profile>;
  readonly entityId: Maybe<Scalars['String']>;
  readonly entityType: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly status: Maybe<Scalars['String']>;
  readonly tag: Maybe<CrmTag>;
  readonly tagId: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['Float']>;
  readonly updatedBy: Maybe<Profile>;
};

export type CrmTagTarget = {
  readonly __typename?: 'CRMTagTarget';
  readonly targetId: Maybe<Scalars['Float']>;
  readonly targetType: Maybe<Scalars['String']>;
};

export type CrmTaggable = {
  readonly entityRefId: Maybe<Scalars['String']>;
  readonly entityRefType: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly organization: Maybe<Organization>;
  readonly tags: Maybe<CrmEntityTagsConnection>;
};


export type CrmTaggableTagsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};

export type CrmTask = CrmCommentable & Node & {
  readonly __typename?: 'CRMTask';
  readonly allDay: Maybe<Scalars['Boolean']>;
  readonly comments: Maybe<CrmEntityCommentsConnection>;
  readonly contact: Maybe<Contact>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly createdBy: Maybe<Profile>;
  readonly date: Maybe<Scalars['Float']>;
  readonly deletedAt: Maybe<Scalars['Float']>;
  readonly deletedBy: Maybe<Profile>;
  readonly description: Maybe<Scalars['String']>;
  readonly entity: Maybe<CrmEntity>;
  readonly entityRefId: Maybe<Scalars['String']>;
  readonly entityRefType: Maybe<Scalars['String']>;
  readonly entityRefTypeRaw: Maybe<Scalars['String']>;
  readonly favorited: Maybe<Scalars['Boolean']>;
  readonly finished: Maybe<Scalars['Boolean']>;
  readonly finishedBy: Maybe<Profile>;
  readonly id: Scalars['ID'];
  readonly lastTimelineItem: Maybe<CrmTimelineItem>;
  readonly lawsuit: Maybe<CrmLawsuit>;
  readonly lawsuitId: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
  readonly originTimelineItemId: Maybe<Scalars['String']>;
  readonly owner: Maybe<Profile>;
  readonly priority: Maybe<Scalars['String']>;
  readonly readOnly: Maybe<Scalars['Boolean']>;
  readonly status: Maybe<Scalars['String']>;
  readonly taskId: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['Float']>;
  readonly updatedBy: Maybe<Profile>;
};


export type CrmTaskCommentsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  status: InputMaybe<Scalars['String']>;
};

export type CrmTimelineItem = CrmCommentable & Node & {
  readonly __typename?: 'CRMTimelineItem';
  readonly actions: Maybe<ReadonlyArray<Maybe<CrmTimelineItemAction>>>;
  readonly activity: Maybe<CrmActivityLog>;
  readonly comments: Maybe<CrmEntityCommentsConnection>;
  readonly contact: Maybe<Contact>;
  readonly contactTarget: Maybe<Contact>;
  readonly cproLawsuitAttachments: Maybe<ReadonlyArray<Maybe<CproLawsuitAttachment>>>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly createdBy: Maybe<Profile>;
  readonly date: Maybe<Scalars['Float']>;
  readonly deletedAt: Maybe<Scalars['Float']>;
  readonly deletedBy: Maybe<Profile>;
  readonly detectedLawsuit: Maybe<CrmLawsuitDetected>;
  readonly document: Maybe<CrmDocument>;
  readonly entity: Maybe<CrmEntity>;
  readonly entityRefId: Maybe<Scalars['String']>;
  readonly entityRefType: Maybe<Scalars['String']>;
  readonly entityRefTypeRaw: Maybe<Scalars['String']>;
  readonly event: Maybe<CrmEvent>;
  readonly eventType: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly itemId: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
  readonly lawsuitActivityItem: Maybe<CrmLawsuitActivityItem>;
  readonly lawsuitAttachment: Maybe<CrmLawsuitAttachment>;
  readonly lawsuitAttachments: Maybe<ReadonlyArray<Maybe<CrmLawsuitAttachment>>>;
  readonly lawsuitJournalBlock: Maybe<Document>;
  readonly lawsuitPublication: Maybe<CrmPublicationItem>;
  readonly lawsuitSearch: Maybe<CrmLawsuitSearch>;
  readonly lawsuitTarget: Maybe<CrmLawsuit>;
  readonly mergedContacts: Maybe<ReadonlyArray<Maybe<Contact>>>;
  readonly metadata: Maybe<Scalars['JSON']>;
  readonly objectId: Maybe<Scalars['String']>;
  readonly objectType: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
  readonly sources: Maybe<ReadonlyArray<Maybe<CrmTimelineItemSource>>>;
  readonly status: Maybe<Scalars['String']>;
  readonly targets: Maybe<ReadonlyArray<Maybe<CrmTimelineItemTarget>>>;
  readonly task: Maybe<CrmTask>;
  readonly updatedAt: Maybe<Scalars['Float']>;
  readonly updatedBy: Maybe<Profile>;
};


export type CrmTimelineItemCommentsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  status: InputMaybe<Scalars['String']>;
};


export type CrmTimelineItemCproLawsuitAttachmentsArgs = {
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
};


export type CrmTimelineItemLawsuitAttachmentsArgs = {
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
};

export type CrmTimelineItemAction = {
  readonly __typename?: 'CRMTimelineItemAction';
  readonly action: Maybe<Scalars['String']>;
  readonly actionId: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly event: Maybe<CrmEvent>;
  readonly objectId: Maybe<Scalars['String']>;
  readonly objectType: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
  readonly status: Maybe<Scalars['String']>;
  readonly task: Maybe<CrmTask>;
};

export type CrmTimelineItemSource = {
  readonly __typename?: 'CRMTimelineItemSource';
  readonly alert: Maybe<PublicationAlert>;
  readonly counter: Maybe<Scalars['Int']>;
  readonly lawsuitSearch: Maybe<CrmLawsuitSearch>;
  readonly sourceId: Maybe<Scalars['String']>;
  readonly sourceType: Maybe<Scalars['String']>;
};

export type CrmTimelineItemTarget = {
  readonly __typename?: 'CRMTimelineItemTarget';
  readonly targetId: Maybe<Scalars['String']>;
  readonly targetType: Maybe<Scalars['String']>;
};

export type CrmTimelineProvider = {
  readonly id: Scalars['ID'];
  readonly readOnly: Maybe<Scalars['Boolean']>;
  readonly timeline: Maybe<CrmEntityTimelineConnection>;
  readonly timelineItem: Maybe<CrmTimelineItem>;
};


export type CrmTimelineProviderTimelineArgs = {
  actions: InputMaybe<Scalars['JSON']>;
  after: InputMaybe<Scalars['String']>;
  eventType: InputMaybe<Scalars['String']>;
  eventTypes: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  excludeStatus: InputMaybe<SuitsStatusType>;
  first: InputMaybe<Scalars['Int']>;
  important: InputMaybe<Scalars['Boolean']>;
  loadFromDB: InputMaybe<Scalars['Boolean']>;
  objectType: InputMaybe<Scalars['String']>;
  read: InputMaybe<Scalars['Boolean']>;
  source: InputMaybe<Scalars['JSON']>;
  status: InputMaybe<Scalars['String']>;
  visibilityType: InputMaybe<Scalars['String']>;
};


export type CrmTimelineProviderTimelineItemArgs = {
  timelineItemId: InputMaybe<Scalars['String']>;
};

export type CachedDocuments = {
  readonly __typename?: 'CachedDocuments';
  readonly count: Maybe<Scalars['Int']>;
  readonly documents: ReadonlyArray<DocumentSearchSnippet>;
};

export type CamadaConversation = {
  readonly __typename?: 'CamadaConversation';
  readonly conversationId: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly kind: Maybe<Scalars['String']>;
  readonly lastMessage: Maybe<CamadaMessage>;
  readonly layerConversationId: Maybe<Scalars['String']>;
  readonly otherParticipants: Maybe<ReadonlyArray<Maybe<Profile>>>;
  readonly participants: Maybe<ReadonlyArray<Maybe<Profile>>>;
  readonly totalMessages: Maybe<Scalars['Int']>;
  readonly unreadCount: Maybe<Scalars['Int']>;
};

export type CamadaMessage = {
  readonly __typename?: 'CamadaMessage';
  readonly isUnread: Maybe<Scalars['String']>;
  readonly messageId: Maybe<Scalars['String']>;
  readonly parts: Maybe<ReadonlyArray<Maybe<CamadaMessagePart>>>;
  readonly receivedAt: Maybe<Scalars['Float']>;
  readonly recipientStatus: Maybe<Scalars['JSON']>;
  readonly sender: Maybe<Profile>;
  readonly sentAt: Maybe<Scalars['Float']>;
};

export type CamadaMessagePart = {
  readonly __typename?: 'CamadaMessagePart';
  readonly body: Maybe<Scalars['String']>;
  readonly mimeType: Maybe<Scalars['String']>;
};

export type CanUseFeatureResult = {
  readonly __typename?: 'CanUseFeatureResult';
  readonly canUse: Scalars['Boolean'];
  readonly featureCode: Scalars['String'];
};

export type CancelFeatureTaskInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly id: Scalars['String'];
};

export type CancelFeatureTaskPayload = {
  readonly __typename?: 'CancelFeatureTaskPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly featureTask: FeatureTask;
};

export type CancelHubInviteInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly uuid: Scalars['String'];
};

export type CancelHubInvitePayload = {
  readonly __typename?: 'CancelHubInvitePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly errorCode: Maybe<Scalars['String']>;
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type CancelIapSubscriptionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CancelIapSubscriptionPayload = {
  readonly __typename?: 'CancelIAPSubscriptionPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly user: Maybe<Profile>;
};

export type CancelPriceIncreaseInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly id?: InputMaybe<Scalars['String']>;
};

export type CancelPriceIncreasePayload = {
  readonly __typename?: 'CancelPriceIncreasePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly error: Maybe<Scalars['String']>;
  readonly priceIncrease: Maybe<PriceIncrease>;
};

export type CancelStudentBenefitAsAdminInput = {
  readonly benefitId: Scalars['Int'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CancelStudentBenefitAsAdminPayload = {
  readonly __typename?: 'CancelStudentBenefitAsAdminPayload';
  readonly boxSubscriptionsCancelled: Scalars['Int'];
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly studentBenefit: StudentBenefit;
};

export type CancelSubscriptionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly reason: Scalars['String'];
  readonly subscriptionId: Scalars['Int'];
  readonly testimonial?: InputMaybe<Scalars['String']>;
};

export type CancelSubscriptionPayload = {
  readonly __typename?: 'CancelSubscriptionPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type CancellationPriceProtectionInfo = {
  readonly __typename?: 'CancellationPriceProtectionInfo';
  readonly benefitsList: Maybe<ReadonlyArray<Maybe<CurrentPlanBenefit>>>;
  readonly cancellationWarningText: Scalars['String'];
  readonly description: Scalars['String'];
  readonly discountPercentageText: Scalars['String'];
  readonly newPriceText: Scalars['String'];
  readonly planName: Scalars['String'];
  readonly priceProtectedLabel: Scalars['String'];
  readonly title: Scalars['String'];
};

export type Candidacy = Node & {
  readonly __typename?: 'Candidacy';
  readonly ballotName: Maybe<Scalars['String']>;
  readonly ballotNumber: Maybe<Scalars['Int']>;
  readonly birthCity: Maybe<Scalars['String']>;
  readonly birthDate: Maybe<Scalars['String']>;
  readonly birthState: Maybe<Scalars['String']>;
  readonly candidacyStatusDetail: Maybe<Scalars['String']>;
  readonly candidacyType: Maybe<Scalars['String']>;
  readonly coligationName: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly educationLevel: Maybe<Scalars['String']>;
  readonly electionResult: Maybe<Scalars['String']>;
  readonly electionRound: Maybe<Scalars['Int']>;
  readonly electionType: Maybe<Scalars['String']>;
  readonly electionYear: Maybe<Scalars['Int']>;
  readonly electoralDistrictName: Maybe<Scalars['String']>;
  readonly electoralDistrictUf: Maybe<Scalars['String']>;
  readonly electoralJurisdiction: Maybe<Scalars['String']>;
  readonly entityId: Maybe<Scalars['String']>;
  readonly federationUnit: Maybe<Scalars['String']>;
  readonly gender: Maybe<Scalars['String']>;
  readonly hasDeclaredAssets: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly indigenousEthnicity: Maybe<Scalars['String']>;
  readonly isQuilombola: Maybe<Scalars['Boolean']>;
  readonly isReelection: Maybe<Scalars['Boolean']>;
  readonly maritalStatus: Maybe<Scalars['String']>;
  readonly maxCampaignSpendingLimit: Maybe<Scalars['Float']>;
  readonly nationality: Maybe<Scalars['String']>;
  readonly partyInitials: Maybe<Scalars['String']>;
  readonly partyName: Maybe<Scalars['String']>;
  readonly partyNumber: Maybe<Scalars['String']>;
  readonly personFullName: Maybe<Scalars['String']>;
  readonly personId: Maybe<Scalars['String']>;
  readonly personSocialName: Maybe<Scalars['String']>;
  readonly raceEthnicity: Maybe<Scalars['String']>;
  readonly revocationReason: Maybe<Scalars['String']>;
  readonly revocationStatus: Maybe<Scalars['String']>;
  readonly socialMediaUrls: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly totalAssetsValue: Maybe<Scalars['Float']>;
  readonly totalCampaignReceived: Maybe<Scalars['Float']>;
  readonly tseId: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['String']>;
};

export enum CandidacyTypeEnum {
  DeputadoDistrital = 'DEPUTADO_DISTRITAL',
  DeputadoEstadual = 'DEPUTADO_ESTADUAL',
  DeputadoFederal = 'DEPUTADO_FEDERAL',
  Governador = 'GOVERNADOR',
  Presidente = 'PRESIDENTE',
  PrimeiroSuplente = 'PRIMEIRO_SUPLENTE',
  SegundoSuplente = 'SEGUNDO_SUPLENTE',
  Senador = 'SENADOR',
  ViceGovernador = 'VICE_GOVERNADOR',
  VicePresidente = 'VICE_PRESIDENTE'
}

export type ChangeCpfAccountInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly token: Scalars['String'];
};

export type ChangeCpfAccountPayload = {
  readonly __typename?: 'ChangeCPFAccountPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type ChangeCProUserAdminStateInput = {
  readonly active: Scalars['Boolean'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly organizationId: Scalars['String'];
  readonly userId: Scalars['String'];
};

export type ChangeCProUserAdminStatePayload = {
  readonly __typename?: 'ChangeCProUserAdminStatePayload';
  readonly changed: Maybe<Scalars['Boolean']>;
  readonly clientMutationId: Maybe<Scalars['String']>;
};

export type ChangeHubUserAreaInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly toAreaId: Scalars['String'];
  readonly userId: Scalars['String'];
};

export type ChangeHubUserAreaPayload = {
  readonly __typename?: 'ChangeHubUserAreaPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly errorCode: Maybe<Scalars['String']>;
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
  readonly userId: Maybe<Scalars['String']>;
};

export type ChangePasswordInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly newPassword: Scalars['String'];
  readonly oldPassword?: InputMaybe<Scalars['String']>;
};

export type ChangePasswordPayload = {
  readonly __typename?: 'ChangePasswordPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly user: Maybe<User>;
};

export type ChangePublicationAlertItemStatusInput = {
  readonly active: Scalars['Boolean'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly documentArtifact: Scalars['String'];
  readonly documentId: Scalars['Int'];
  readonly entityRefId?: InputMaybe<Scalars['String']>;
  readonly entityRefType?: InputMaybe<Scalars['String']>;
};

export type ChangePublicationAlertItemStatusPayload = {
  readonly __typename?: 'ChangePublicationAlertItemStatusPayload';
  readonly alertItem: Maybe<PublicationAlertItem>;
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly crmEntity: Maybe<CrmEntity>;
  readonly organization: Maybe<Organization>;
  readonly timelineEdge: Maybe<CrmEntityTimelineEdge>;
};

export type CheckInviteByEmailResult = {
  readonly __typename?: 'CheckInviteByEmailResult';
  readonly hasActiveUser: Maybe<Scalars['Boolean']>;
  readonly hasContract: Maybe<Scalars['Boolean']>;
};

export type CheckMigratedLegalCaseInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly migratedId: Scalars['Int'];
};

export type CheckMigratedLegalCasePayload = {
  readonly __typename?: 'CheckMigratedLegalCasePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly cookie: Maybe<Scalars['String']>;
  readonly created: Maybe<Scalars['Boolean']>;
  readonly legalCase: Maybe<LegalCase>;
};

export type CheckStudentBenefitEligibilityInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cpf: Scalars['String'];
};

export type CheckStudentBenefitEligibilityPayload = {
  readonly __typename?: 'CheckStudentBenefitEligibilityPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly expiresAt: Maybe<Scalars['Float']>;
  readonly requestId: Maybe<Scalars['String']>;
  readonly status: Maybe<StudentBenefitStatusEnum>;
};

export type CheckoutDataResult = {
  readonly __typename?: 'CheckoutDataResult';
  readonly data: Maybe<Scalars['JSON']>;
  readonly jwt: Maybe<Scalars['String']>;
};

export type ChildrenLocationTopicsConnection = {
  readonly __typename?: 'ChildrenLocationTopicsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ChildrenLocationTopicsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ChildrenLocationTopicsEdge = {
  readonly __typename?: 'ChildrenLocationTopicsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Topic>;
};

export type ChildrenTopicsConnection = {
  readonly __typename?: 'ChildrenTopicsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ChildrenTopicsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ChildrenTopicsEdge = {
  readonly __typename?: 'ChildrenTopicsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Topic>;
};

export enum ChipKindEnum {
  Info = 'info',
  Negative = 'negative',
  Positive = 'positive',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Warning = 'warning'
}

export type ChiquinhaTransaction = {
  readonly __typename?: 'ChiquinhaTransaction';
  readonly commandName: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly externalEntity: Maybe<Scalars['String']>;
  readonly externalId: Maybe<Scalars['String']>;
  readonly finishedAt: Maybe<Scalars['String']>;
  readonly hasError: Maybe<Scalars['Boolean']>;
  readonly steps: ReadonlyArray<Maybe<ChiquinhaTransactionStep>>;
  readonly transactionId: Maybe<Scalars['String']>;
};

export type ChiquinhaTransactionStep = {
  readonly __typename?: 'ChiquinhaTransactionStep';
  readonly commandContext: Maybe<Scalars['JSON']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly finishedAt: Maybe<Scalars['String']>;
  readonly hasError: Maybe<Scalars['Boolean']>;
  readonly message: Maybe<Scalars['String']>;
  readonly stepName: Maybe<Scalars['String']>;
  readonly transactionId: Maybe<Scalars['String']>;
  readonly transactionStepId: Maybe<Scalars['String']>;
};

export type CitySearch = {
  readonly __typename?: 'CitySearch';
  readonly directoryUrl: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
  readonly topicId: Maybe<Scalars['Int']>;
  readonly url: Maybe<Scalars['String']>;
};

export type CityState = {
  readonly __typename?: 'CityState';
  readonly name: Maybe<Scalars['String']>;
  readonly uf: Maybe<Scalars['String']>;
};

export type Classification = {
  readonly __typename?: 'Classification';
  readonly artifact: Maybe<Scalars['String']>;
  readonly probability: Maybe<Scalars['Float']>;
};

export type ClassificationJudgment = {
  readonly __typename?: 'ClassificationJudgment';
  readonly decidesMerit: Maybe<Scalars['Boolean']>;
  readonly result: Maybe<Scalars['String']>;
};

export enum CollectionRequestSource {
  BackgroundCheckSeeLawsuitsByEntity = 'BACKGROUND_CHECK_SEE_LAWSUITS_BY_ENTITY',
  SeeLawsuitsByName = 'SEE_LAWSUITS_BY_NAME',
  SignUpWithCpf = 'SIGN_UP_WITH_CPF'
}

export type Commentary = {
  readonly __typename?: 'Commentary';
  readonly commentaryId: Maybe<Scalars['NumericID']>;
  readonly text: Maybe<Scalars['String']>;
};

export type CompanyInfo = {
  readonly __typename?: 'CompanyInfo';
  readonly activityStartDate: Maybe<Scalars['String']>;
  readonly age: Maybe<Scalars['Int']>;
  readonly city: Maybe<Scalars['String']>;
  readonly cnaeCode: Maybe<Scalars['String']>;
  readonly cnaeDescription: Maybe<Scalars['String']>;
  readonly cnaeSecondaryFiscalCodes: Maybe<ReadonlyArray<Maybe<Cnae>>>;
  readonly cnpj: Maybe<Scalars['String']>;
  readonly companySize: Maybe<Scalars['String']>;
  readonly companyType: Maybe<Scalars['String']>;
  readonly complement: Maybe<Scalars['String']>;
  readonly district: Maybe<Scalars['String']>;
  readonly email: Maybe<Scalars['String']>;
  readonly natureCode: Maybe<Scalars['String']>;
  readonly natureDescription: Maybe<Scalars['String']>;
  readonly phoneNumber1: Maybe<Scalars['String']>;
  readonly phoneNumber2: Maybe<Scalars['String']>;
  readonly registrationStatus: Maybe<Scalars['String']>;
  readonly shareCapital: Maybe<Scalars['String']>;
  readonly streetName: Maybe<Scalars['String']>;
  readonly streetNumber: Maybe<Scalars['String']>;
  readonly streetType: Maybe<Scalars['String']>;
  readonly timeSinceStart: Maybe<Scalars['String']>;
  readonly uf: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['Float']>;
  readonly zipCode: Maybe<Scalars['String']>;
};

export type ConfirmAnonymousUserInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly encodedUser: Scalars['String'];
};

export type ConfirmAnonymousUserPayload = {
  readonly __typename?: 'ConfirmAnonymousUserPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly cookie: Maybe<Scalars['String']>;
};

export type ConfirmConvertedCreditsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ConfirmConvertedCreditsPayload = {
  readonly __typename?: 'ConfirmConvertedCreditsPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type ConfirmEmailChangeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly token: Scalars['String'];
};

export type ConfirmEmailChangePayload = {
  readonly __typename?: 'ConfirmEmailChangePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly email: Maybe<Scalars['String']>;
};

export type ConfirmLawsuitValidatedProfileInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
  readonly relatedPersonId: Scalars['String'];
};

export type ConfirmLawsuitValidatedProfilePayload = {
  readonly __typename?: 'ConfirmLawsuitValidatedProfilePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuitValidatedProfile: Maybe<CrmLawsuitValidatedProfile>;
};

export type ConfirmOabPartnershipByCertificateInput = {
  readonly birthdate?: InputMaybe<Scalars['String']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cpf: Scalars['String'];
  readonly email?: InputMaybe<Scalars['String']>;
  readonly fullName?: InputMaybe<Scalars['String']>;
  readonly oabNumber?: InputMaybe<Scalars['String']>;
  readonly oabSubscriptionDate?: InputMaybe<Scalars['String']>;
  readonly oabUf: Scalars['String'];
};

export type ConfirmOabPartnershipByCertificatePayload = {
  readonly __typename?: 'ConfirmOabPartnershipByCertificatePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly inviteId: Maybe<Scalars['String']>;
  readonly message: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type ConfirmOabPartnershipInvitationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cpf: Scalars['String'];
  readonly email: Scalars['String'];
  readonly name: Scalars['String'];
  readonly oab: Scalars['String'];
  readonly phone: Scalars['String'];
};

export type ConfirmOabPartnershipInvitationPayload = {
  readonly __typename?: 'ConfirmOabPartnershipInvitationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly inviteId: Maybe<Scalars['String']>;
  readonly message: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type ConsumeAssistantSuggestionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
  readonly suggestionId: Scalars['String'];
  readonly versionId: Scalars['String'];
};

export type ConsumeAssistantSuggestionPayload = {
  readonly __typename?: 'ConsumeAssistantSuggestionPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuitAssistantSuggestions: Maybe<LawsuitAssistantSuggestions>;
  readonly success: Maybe<Scalars['Boolean']>;
  readonly suggestionId: Maybe<Scalars['String']>;
};

export type ConsumeFreemiumAttachmentDownloadInput = {
  readonly attachmentId: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly fromComponent?: InputMaybe<Scalars['String']>;
};

export type ConsumeFreemiumAttachmentDownloadPayload = {
  readonly __typename?: 'ConsumeFreemiumAttachmentDownloadPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type Contact = CrmEntity & CrmTaggable & CrmTimelineProvider & Node & {
  readonly __typename?: 'Contact';
  readonly addresses: Maybe<ReadonlyArray<Maybe<ContactAddress>>>;
  readonly bankAccounts: Maybe<ReadonlyArray<Maybe<ContactBankAccount>>>;
  readonly birthDate: Maybe<Scalars['Float']>;
  readonly citizenship: Maybe<Scalars['String']>;
  readonly civilStatus: Maybe<Scalars['String']>;
  readonly cnh: Maybe<Scalars['String']>;
  readonly cnpj: Maybe<Scalars['String']>;
  readonly comments: Maybe<Scalars['String']>;
  readonly companyName: Maybe<Scalars['String']>;
  readonly contactId: Maybe<Scalars['String']>;
  readonly contactSource: Maybe<Scalars['String']>;
  readonly contactType: Maybe<Scalars['String']>;
  readonly conversation: Maybe<Conversation>;
  readonly cpf: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly ctps: Maybe<Scalars['String']>;
  readonly documents: Maybe<CrmEntityDocumentConnection>;
  readonly documentsComments: Maybe<Scalars['String']>;
  readonly emails: Maybe<ReadonlyArray<Maybe<ContactEmail>>>;
  readonly entityRefId: Maybe<Scalars['String']>;
  readonly entityRefName: Maybe<Scalars['String']>;
  readonly entityRefType: Maybe<Scalars['String']>;
  readonly entityRefTypeRaw: Maybe<Scalars['String']>;
  readonly entityType: Maybe<Scalars['String']>;
  readonly events: Maybe<ReadonlyArray<Maybe<CrmEvent>>>;
  readonly eventsConnection: Maybe<CrmEntityEventsConnection>;
  readonly facebookUrl: Maybe<Scalars['String']>;
  readonly fatherName: Maybe<Scalars['String']>;
  readonly favorited: Maybe<Scalars['Boolean']>;
  readonly gender: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly instagram: Maybe<Scalars['String']>;
  readonly isShared: Maybe<Scalars['Boolean']>;
  readonly jusbrasil: Maybe<Scalars['String']>;
  readonly lastTimelineItem: Maybe<CrmTimelineItem>;
  readonly lawsuitPartyEntities: Maybe<ContactLawsuitPartyEntitiesConnection>;
  readonly lawsuits: Maybe<ContactLawsuitsConnection>;
  readonly linkedinUrl: Maybe<Scalars['String']>;
  readonly mergeStatus: Maybe<Scalars['String']>;
  readonly mergedAt: Maybe<Scalars['Float']>;
  readonly mergedBy: Maybe<Profile>;
  readonly mergedContacts: Maybe<ReadonlyArray<Maybe<Contact>>>;
  readonly mergedWithKey: Maybe<Scalars['String']>;
  readonly motherName: Maybe<Scalars['String']>;
  readonly municipalRegistration: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly nameVariations: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly oab: Maybe<Scalars['String']>;
  readonly oabType: Maybe<Scalars['String']>;
  readonly oabUf: Maybe<Scalars['String']>;
  readonly occupation: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
  readonly organizationCount: Maybe<Scalars['Int']>;
  readonly otherSocialNetworks: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly passport: Maybe<Scalars['String']>;
  readonly phones: Maybe<ReadonlyArray<Maybe<ContactPhone>>>;
  readonly pis: Maybe<Scalars['String']>;
  readonly placeOfBirth: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
  readonly readOnly: Maybe<Scalars['Boolean']>;
  readonly relatedLawsuitsCounterByCourt: Maybe<ContactRelatedCounterByCourtConnection>;
  readonly relatedLawsuitsCounterByIdentificationType: Maybe<ReadonlyArray<Maybe<AggregatedCounter>>>;
  readonly relatedLawsuitsCounterByPole: Maybe<ContactLegalSummary>;
  readonly relatedLawsuitsCounterByState: Maybe<ContactRelatedCounterByStateConnection>;
  readonly relatedPersonsWithMostOccurrences: Maybe<ContactRelatedPersonsWithMostOccurrencesConnection>;
  readonly reservistCertificate: Maybe<Scalars['String']>;
  readonly rg: Maybe<Scalars['String']>;
  readonly role: Maybe<Scalars['String']>;
  readonly simpleTax: Maybe<Scalars['Boolean']>;
  readonly stateRegistration: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly tags: Maybe<CrmEntityTagsConnection>;
  readonly tasks: Maybe<ReadonlyArray<Maybe<CrmTask>>>;
  readonly tasksConnection: Maybe<CrmEntityTasksConnection>;
  readonly thumborAvatar: Maybe<ThumborImage>;
  readonly timeline: Maybe<CrmEntityTimelineConnection>;
  readonly timelineItem: Maybe<CrmTimelineItem>;
  readonly topic: Maybe<Topic>;
  readonly totalCanonicalEntities: Maybe<Scalars['Int']>;
  readonly totalLawsuits: Maybe<Scalars['Int']>;
  readonly tradeName: Maybe<Scalars['String']>;
  readonly twitter: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['Float']>;
  readonly url: Maybe<Scalars['String']>;
  readonly voterRegistration: Maybe<Scalars['String']>;
  readonly website: Maybe<Scalars['String']>;
  readonly youtube: Maybe<Scalars['String']>;
};


export type ContactDocumentsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type ContactEventsArgs = {
  eventType: InputMaybe<Scalars['String']>;
  ownerId: InputMaybe<Scalars['Int']>;
  singleEvents: InputMaybe<Scalars['Boolean']>;
  timeMax: InputMaybe<Scalars['Float']>;
  timeMin: InputMaybe<Scalars['Float']>;
};


export type ContactEventsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  eventType: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  ownerId: InputMaybe<Scalars['Int']>;
  singleEvents: InputMaybe<Scalars['Boolean']>;
  timeMax: InputMaybe<Scalars['Float']>;
  timeMin: InputMaybe<Scalars['Float']>;
};


export type ContactLawsuitPartyEntitiesArgs = {
  after: InputMaybe<Scalars['String']>;
  filters: InputMaybe<LawsuitPartyEntitiesFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
  withLawsuits?: InputMaybe<Scalars['Boolean']>;
};


export type ContactLawsuitsArgs = {
  after: InputMaybe<Scalars['String']>;
  byUf: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  court: InputMaybe<Scalars['String']>;
  courts: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  first: InputMaybe<Scalars['Int']>;
  forceSearchOnElastic: InputMaybe<Scalars['Boolean']>;
  orderBy: InputMaybe<SortOptionsType>;
  status: InputMaybe<Scalars['String']>;
  usingHaystack: InputMaybe<Scalars['Boolean']>;
};


export type ContactRelatedLawsuitsCounterByCourtArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type ContactRelatedLawsuitsCounterByStateArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type ContactRelatedPersonsWithMostOccurrencesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type ContactTagsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type ContactTasksArgs = {
  dateRange: InputMaybe<Scalars['JSON']>;
  finished: InputMaybe<Scalars['Boolean']>;
  limit: InputMaybe<Scalars['Int']>;
  ownerId: InputMaybe<Scalars['Int']>;
};


export type ContactTasksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  dateRange: InputMaybe<Scalars['JSON']>;
  finished: InputMaybe<Scalars['Boolean']>;
  first: InputMaybe<Scalars['Int']>;
  ownerId: InputMaybe<Scalars['Int']>;
};


export type ContactTimelineArgs = {
  actions: InputMaybe<Scalars['JSON']>;
  after: InputMaybe<Scalars['String']>;
  eventType: InputMaybe<Scalars['String']>;
  eventTypes: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  excludeStatus: InputMaybe<SuitsStatusType>;
  first: InputMaybe<Scalars['Int']>;
  important: InputMaybe<Scalars['Boolean']>;
  loadFromDB: InputMaybe<Scalars['Boolean']>;
  objectType: InputMaybe<Scalars['String']>;
  read: InputMaybe<Scalars['Boolean']>;
  source: InputMaybe<Scalars['JSON']>;
  status: InputMaybe<Scalars['String']>;
  visibilityType: InputMaybe<Scalars['String']>;
};


export type ContactTimelineItemArgs = {
  timelineItemId: InputMaybe<Scalars['String']>;
};

export type ContactAddress = {
  readonly __typename?: 'ContactAddress';
  readonly cep: Maybe<Scalars['String']>;
  readonly city: Maybe<Topic>;
  readonly complement: Maybe<Scalars['String']>;
  readonly contactAddressId: Maybe<Scalars['Float']>;
  readonly country: Maybe<Scalars['String']>;
  readonly neighborhood: Maybe<Scalars['String']>;
  readonly primary: Maybe<Scalars['Boolean']>;
  readonly status: Maybe<Scalars['String']>;
  readonly street: Maybe<Scalars['String']>;
};

export type ContactBankAccount = {
  readonly __typename?: 'ContactBankAccount';
  readonly accountNumber: Maybe<Scalars['String']>;
  readonly accountType: Maybe<Scalars['String']>;
  readonly agency: Maybe<Scalars['String']>;
  readonly bank: Maybe<Scalars['String']>;
  readonly contactBankAccountId: Maybe<Scalars['Float']>;
  readonly holderName: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
};

export type ContactEmail = {
  readonly __typename?: 'ContactEmail';
  readonly contactEmailId: Maybe<Scalars['Float']>;
  readonly email: Maybe<Scalars['String']>;
  readonly primary: Maybe<Scalars['Boolean']>;
  readonly status: Maybe<Scalars['String']>;
};

export type ContactLawsuitPartyEntitiesConnection = {
  readonly __typename?: 'ContactLawsuitPartyEntitiesConnection';
  readonly aggregations: Maybe<Scalars['JSON']>;
  readonly edges: Maybe<ReadonlyArray<Maybe<ContactLawsuitPartyEntitiesEdge>>>;
  readonly pageInfo: PageInfo;
  readonly total: Maybe<Scalars['Int']>;
};

export type ContactLawsuitPartyEntitiesEdge = {
  readonly __typename?: 'ContactLawsuitPartyEntitiesEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmLawsuitPartyEntity>;
};

export type ContactLawsuitsConnection = {
  readonly __typename?: 'ContactLawsuitsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ContactLawsuitsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ContactLawsuitsEdge = {
  readonly __typename?: 'ContactLawsuitsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmLawsuit>;
};

export type ContactLegalSummary = {
  readonly __typename?: 'ContactLegalSummary';
  readonly poleA: Maybe<ContactLegalSummaryPole>;
  readonly poleB: Maybe<ContactLegalSummaryPole>;
  readonly poleUnknown: Maybe<ContactLegalSummaryPole>;
};

export type ContactLegalSummaryPole = {
  readonly __typename?: 'ContactLegalSummaryPole';
  readonly counterByAreaLaw: Maybe<ContactLegalSummaryPoleAreaLaw>;
  readonly counterByCourt: Maybe<ReadonlyArray<Maybe<AggregatedCounter>>>;
  readonly counterByYear: Maybe<ReadonlyArray<Maybe<AggregatedCounter>>>;
  readonly lawsuitAmount: Maybe<Scalars['Int']>;
  readonly type: Maybe<Scalars['String']>;
};


export type ContactLegalSummaryPoleCounterByAreaLawArgs = {
  limit: InputMaybe<Scalars['Int']>;
};

export type ContactLegalSummaryPoleAreaLaw = {
  readonly __typename?: 'ContactLegalSummaryPoleAreaLaw';
  readonly hasMore: Maybe<Scalars['Boolean']>;
  readonly node: Maybe<ReadonlyArray<Maybe<ContactLegalSummaryPoleAreaLawNode>>>;
};

export type ContactLegalSummaryPoleAreaLawNode = {
  readonly __typename?: 'ContactLegalSummaryPoleAreaLawNode';
  readonly counter: Maybe<Scalars['String']>;
  readonly subjects: Maybe<ReadonlyArray<Maybe<ContactLegalSummaryPoleSubjects>>>;
  readonly value: Maybe<Scalars['String']>;
};

export type ContactLegalSummaryPoleSubjects = {
  readonly __typename?: 'ContactLegalSummaryPoleSubjects';
  readonly lawsuitId: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly value: Maybe<Scalars['String']>;
};

export type ContactPhone = {
  readonly __typename?: 'ContactPhone';
  readonly contactPhoneId: Maybe<Scalars['Float']>;
  readonly number: Maybe<Scalars['String']>;
  readonly phoneType: Maybe<Scalars['String']>;
  readonly primary: Maybe<Scalars['Boolean']>;
  readonly status: Maybe<Scalars['String']>;
  readonly whatsapp: Maybe<Scalars['Boolean']>;
};

export type ContactRelatedCounterByCourtConnection = {
  readonly __typename?: 'ContactRelatedCounterByCourtConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ContactRelatedCounterByCourtEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ContactRelatedCounterByCourtEdge = {
  readonly __typename?: 'ContactRelatedCounterByCourtEdge';
  readonly counter: Maybe<Scalars['Int']>;
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Court>;
};

export type ContactRelatedCounterByStateConnection = {
  readonly __typename?: 'ContactRelatedCounterByStateConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ContactRelatedCounterByStateEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ContactRelatedCounterByStateEdge = {
  readonly __typename?: 'ContactRelatedCounterByStateEdge';
  readonly counter: Maybe<Scalars['Int']>;
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CityState>;
};

export type ContactRelatedPersonsWithMostOccurrencesConnection = {
  readonly __typename?: 'ContactRelatedPersonsWithMostOccurrencesConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ContactRelatedPersonsWithMostOccurrencesEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ContactRelatedPersonsWithMostOccurrencesEdge = {
  readonly __typename?: 'ContactRelatedPersonsWithMostOccurrencesEdge';
  readonly counter: Maybe<Scalars['Int']>;
  readonly cursor: Scalars['String'];
  readonly name: Maybe<Scalars['String']>;
  readonly node: Maybe<Contact>;
  readonly url: Maybe<Scalars['String']>;
};

export type ContactSalesHubCompanyRequestInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ContactSalesHubCompanyRequestPayload = {
  readonly __typename?: 'ContactSalesHubCompanyRequestPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly hubCompanyRequest: Maybe<HubCompanyRequest>;
};

export type Conversation = Node & {
  readonly __typename?: 'Conversation';
  readonly camadaConversation: Maybe<CamadaConversation>;
  readonly canUse: Maybe<Scalars['Boolean']>;
  readonly contactParticipants: Maybe<ReadonlyArray<Maybe<Contact>>>;
  readonly conversationId: Maybe<Scalars['Float']>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly deletedAt: Maybe<Scalars['Float']>;
  readonly deletedBy: Maybe<Profile>;
  readonly id: Scalars['ID'];
  readonly layerConversationId: Maybe<Scalars['String']>;
  readonly legalCase: Maybe<LegalCase>;
  readonly legalCaseOutcome: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
  readonly otherParticipant: Maybe<Profile>;
  readonly otherParticipantEmail: Maybe<Scalars['String']>;
  readonly participants: Maybe<ParticipantsConversationProfileConnection>;
  readonly price: Maybe<Scalars['Int']>;
  readonly profileParticipants: Maybe<ReadonlyArray<Maybe<Profile>>>;
  readonly rating: Maybe<Scalars['String']>;
  readonly requestPrivateChat: Maybe<Scalars['Boolean']>;
  readonly status: Maybe<Scalars['String']>;
  readonly tags: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly testimonial: Maybe<Scalars['String']>;
  readonly transactionStatus: Maybe<Scalars['String']>;
  readonly unreadProfile: Maybe<UnreadProfileConnection>;
  readonly updatedAt: Maybe<Scalars['Float']>;
};


export type ConversationCanUseArgs = {
  featureCode: Scalars['String'];
};


export type ConversationParticipantsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type ConversationUnreadProfileArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

export type ConvertDocumentInput = {
  readonly artifact: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId: Scalars['String'];
  readonly fromComponent: Scalars['String'];
};

export type ConvertDocumentPayload = {
  readonly __typename?: 'ConvertDocumentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly metadata: Maybe<Scalars['JSON']>;
  readonly signedUrl: Maybe<Scalars['String']>;
};

export type ConvertExperimentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly experimentGroup: Scalars['String'];
  readonly experimentName: Scalars['String'];
};

export type ConvertExperimentPayload = {
  readonly __typename?: 'ConvertExperimentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly experiment: Maybe<Experiment>;
};

export type CopyFactsForReferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly fromComponent?: InputMaybe<Scalars['String']>;
  readonly jurisId: Scalars['Float'];
};

export type CopyFactsForReferencePayload = {
  readonly __typename?: 'CopyFactsForReferencePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type Court = {
  readonly __typename?: 'Court';
  readonly name: Maybe<Scalars['String']>;
};

export type CproAuthUser = {
  readonly __typename?: 'CproAuthUser';
  readonly authorization: Maybe<CproUserAuthorization>;
  readonly companyId: Scalars['String'];
  readonly email: Scalars['String'];
  readonly hasModuleEnabled: Scalars['Boolean'];
  readonly isAdmin: Scalars['Boolean'];
  readonly organization: Maybe<CproOrganization>;
  readonly roles: ReadonlyArray<Maybe<Scalars['String']>>;
};


export type CproAuthUserHasModuleEnabledArgs = {
  module: Scalars['String'];
};

export type CrawlerMetadata = {
  readonly __typename?: 'CrawlerMetadata';
  readonly downloadUrl: Maybe<Scalars['String']>;
  readonly profileName: Maybe<Scalars['String']>;
  readonly visitDate: Maybe<Scalars['Float']>;
};

export type CreateAnonymizationRequestInput = {
  readonly anonymizeText: Scalars['String'];
  readonly attachmentsUrl: ReadonlyArray<InputMaybe<Scalars['String']>>;
  readonly birthDate: Scalars['Float'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cpf: Scalars['String'];
  readonly lawsuitUrl: Scalars['String'];
  readonly reason: Scalars['String'];
};

export type CreateAnonymizationRequestPayload = {
  readonly __typename?: 'CreateAnonymizationRequestPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly cpfVerified: Maybe<Scalars['Boolean']>;
  readonly removalRequestId: Maybe<Scalars['Int']>;
};

export type CreateAssistantQuestionsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
  readonly numberOfQuestions?: InputMaybe<Scalars['Int']>;
  readonly refreshQuestions?: InputMaybe<Scalars['Boolean']>;
  readonly versionId?: InputMaybe<Scalars['String']>;
};

export type CreateAssistantQuestionsPayload = {
  readonly __typename?: 'CreateAssistantQuestionsPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuitAssistantQuestions: Maybe<LawsuitAssistantQuestions>;
};

export type CreateAssistantSuggestionsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
  readonly numberOfSuggestions?: InputMaybe<Scalars['Int']>;
  readonly refresh?: InputMaybe<Scalars['Boolean']>;
  readonly versionId: Scalars['String'];
};

export type CreateAssistantSuggestionsPayload = {
  readonly __typename?: 'CreateAssistantSuggestionsPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuitAssistantSuggestions: Maybe<LawsuitAssistantSuggestions>;
};

export type CreateAudienceSegmentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly description: Scalars['String'];
  readonly jsonRule: Scalars['JSON'];
  readonly segmentName: Scalars['String'];
};

export type CreateAudienceSegmentPayload = {
  readonly __typename?: 'CreateAudienceSegmentPayload';
  readonly audienceSegment: Maybe<AudienceSegment>;
  readonly clientMutationId: Maybe<Scalars['String']>;
};

export type CreateB2BAreasInput = {
  readonly areas: ReadonlyArray<B2BAreaInput>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly companyUuid: Scalars['String'];
};

export type CreateB2BAreasPayload = {
  readonly __typename?: 'CreateB2BAreasPayload';
  readonly allAreas: Maybe<ReadonlyArray<Maybe<HubB2BAreaResult>>>;
  readonly areas: Maybe<ReadonlyArray<Maybe<HubB2BAreaResult>>>;
  readonly clientMutationId: Maybe<Scalars['String']>;
};

export type CreateB2BCompanyInput = {
  readonly brandName: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cproEmbeddedUrl?: InputMaybe<Scalars['String']>;
  readonly expiresAt?: InputMaybe<Scalars['String']>;
  readonly isTrial?: InputMaybe<Scalars['Boolean']>;
  readonly legalName: Scalars['String'];
  readonly legalNumber: Scalars['String'];
  readonly ownerEmail: Scalars['String'];
  readonly ownerName: Scalars['String'];
  readonly sendOwnerWelcomeEmail?: InputMaybe<Scalars['Boolean']>;
};

export type CreateB2BCompanyPayload = {
  readonly __typename?: 'CreateB2BCompanyPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly company: Maybe<HubB2BCompanyResult>;
};

export type CreateB2BDomainInput = {
  readonly areaUuid: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly companyUuid: Scalars['String'];
  readonly domain: Scalars['String'];
  readonly inactivityTtlSecs?: InputMaybe<Scalars['Int']>;
  readonly renewalTtlSecs?: InputMaybe<Scalars['Int']>;
};

export type CreateB2BDomainPayload = {
  readonly __typename?: 'CreateB2BDomainPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly domain: Maybe<HubB2BDomainResult>;
};

export type CreateB2BSubscriptionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly companyUuid: Scalars['String'];
  readonly modules: ReadonlyArray<B2BSubscriptionModuleInput>;
};

export type CreateB2BSubscriptionPayload = {
  readonly __typename?: 'CreateB2BSubscriptionPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly subscription: Maybe<HubB2BSubscriptionResult>;
};

export type CreateBiddedConversationInput = {
  readonly boxOptions?: InputMaybe<Scalars['JSON']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly fromComponent?: InputMaybe<Scalars['String']>;
  readonly hidden?: InputMaybe<Scalars['Boolean']>;
  readonly legalCaseId: Scalars['Int'];
  readonly price?: InputMaybe<Scalars['Int']>;
};

export type CreateBiddedConversationPayload = {
  readonly __typename?: 'CreateBiddedConversationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly conversation: Maybe<Conversation>;
  readonly legalCase: Maybe<LegalCase>;
  readonly profile: Maybe<Profile>;
};

export type CreateBounceUserActivityInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly metadata?: InputMaybe<Scalars['JSON']>;
  readonly sourceId: Scalars['String'];
  readonly sourceType: Scalars['String'];
  readonly utmSource: Scalars['String'];
};

export type CreateBounceUserActivityPayload = {
  readonly __typename?: 'CreateBounceUserActivityPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type CreateCproOrganizationExtraValuesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly description: Scalars['String'];
  readonly discount: Scalars['Boolean'];
  readonly finishAt?: InputMaybe<Scalars['String']>;
  readonly organizationId: Scalars['String'];
  readonly startAt: Scalars['String'];
  readonly value: Scalars['Float'];
};

export type CreateCproOrganizationExtraValuesPayload = {
  readonly __typename?: 'CreateCPROOrganizationExtraValuesPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly saved: Scalars['Boolean'];
};

export type CreateCproOrganizationInput = {
  readonly active: Scalars['Boolean'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly digestoOpId?: InputMaybe<Scalars['Int']>;
  readonly embeddedReportUrl?: InputMaybe<Scalars['String']>;
  readonly minRevenue?: InputMaybe<Scalars['Float']>;
  readonly name: Scalars['String'];
};

export type CreateCproOrganizationPayload = {
  readonly __typename?: 'CreateCPROOrganizationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly organizationId: Maybe<Scalars['String']>;
  readonly saved: Scalars['Boolean'];
};

export type CreateCProOrganizationLimitsInput = {
  readonly active?: InputMaybe<Scalars['Boolean']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly expiryDate?: InputMaybe<Scalars['String']>;
  readonly featureId: Scalars['String'];
  readonly intervals?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['JSON']>>>;
  readonly organizationId: Scalars['String'];
  readonly trial?: InputMaybe<Scalars['Boolean']>;
  readonly trialLimit?: InputMaybe<Scalars['Int']>;
};

export type CreateCProOrganizationLimitsPayload = {
  readonly __typename?: 'CreateCProOrganizationLimitsPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly saved: Maybe<Scalars['Boolean']>;
};

export type CreateCrmActivityLogInput = {
  readonly activity: Scalars['JSON'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly entityRefId: Scalars['String'];
  readonly entityRefType: Scalars['String'];
};

export type CreateCrmActivityLogPayload = {
  readonly __typename?: 'CreateCRMActivityLogPayload';
  readonly activity: Maybe<CrmActivityLog>;
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly crmEntity: Maybe<CrmEntity>;
  readonly timelineEdge: Maybe<CrmEntityTimelineEdge>;
};

export type CreateCrmBulkActionInput = {
  readonly action: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly entityIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly entityType: Scalars['String'];
  readonly searchRequest?: InputMaybe<Scalars['JSON']>;
};

export type CreateCrmBulkActionPayload = {
  readonly __typename?: 'CreateCRMBulkActionPayload';
  readonly bulkAction: Maybe<CrmBulkAction>;
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
};

export type CreateCrmCourtCredentialLawsuitInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly data: Scalars['JSON'];
  readonly lawsuitId: Scalars['String'];
};

export type CreateCrmCourtCredentialLawsuitPayload = {
  readonly __typename?: 'CreateCRMCourtCredentialLawsuitPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly credential: Maybe<CrmCourtCredential>;
  readonly lawsuit: Maybe<CrmLawsuit>;
};

export type CreateCrmDataExportInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly dataExportType?: InputMaybe<Scalars['String']>;
  readonly metadata?: InputMaybe<Scalars['JSON']>;
};

export type CreateCrmDataExportPayload = {
  readonly __typename?: 'CreateCRMDataExportPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly dataExport: Maybe<CrmDataExport>;
  readonly organization: Maybe<Organization>;
};

export type CreateCrmDocumentsInput = {
  readonly boxOptions?: InputMaybe<Scalars['JSON']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly documents?: InputMaybe<ReadonlyArray<Scalars['JSON']>>;
  readonly entityRefId?: InputMaybe<Scalars['String']>;
  readonly entityRefType?: InputMaybe<Scalars['String']>;
  readonly useCredits?: InputMaybe<Scalars['Boolean']>;
};

export type CreateCrmDocumentsPayload = {
  readonly __typename?: 'CreateCRMDocumentsPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly crmEntity: Maybe<CrmEntity>;
  readonly documentEdges: Maybe<ReadonlyArray<Maybe<CrmEntityDocumentEdge>>>;
  readonly documents: Maybe<ReadonlyArray<Maybe<CrmDocument>>>;
  readonly organization: Maybe<Organization>;
  readonly timelineEdges: Maybe<ReadonlyArray<Maybe<CrmEntityTimelineEdge>>>;
};

export type CreateCrmEventInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly entityRefId?: InputMaybe<Scalars['String']>;
  readonly entityRefType?: InputMaybe<Scalars['String']>;
  readonly event: Scalars['JSON'];
};

export type CreateCrmEventPayload = {
  readonly __typename?: 'CreateCRMEventPayload';
  readonly calendar: Maybe<CrmCalendar>;
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly entity: Maybe<CrmEntity>;
  readonly event: Maybe<CrmEvent>;
  readonly eventEdge: Maybe<CrmEntityEventsEdge>;
  readonly legalCaseProfileInfo: Maybe<LegalCaseProfileInfo>;
  readonly organization: Maybe<Organization>;
  readonly timelineEdge: Maybe<CrmEntityTimelineEdge>;
};

export type CreateCrmImportedLawsuitInput = {
  readonly boxOptions?: InputMaybe<Scalars['JSON']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly detectedLawsuit?: InputMaybe<Scalars['JSON']>;
  readonly lawsuit: Scalars['JSON'];
  readonly shouldSwitchToEscritorioOnlineEnvironment?: InputMaybe<Scalars['Boolean']>;
};

export type CreateCrmImportedLawsuitPayload = {
  readonly __typename?: 'CreateCRMImportedLawsuitPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly detectedLawsuit: Maybe<CrmLawsuitDetected>;
  readonly existingLawsuit: Maybe<CrmLawsuit>;
  readonly lawsuitEdge: Maybe<OrganizationLawsuitsEdge>;
  readonly lawsuitView: Maybe<CrmLawsuitView>;
  readonly organization: Maybe<Organization>;
  readonly publicLawsuit: Maybe<CrmLawsuit>;
};

export type CreateCrmLawsuitFollowUpInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitNumber?: InputMaybe<Scalars['String']>;
  readonly topicId: Scalars['Int'];
  readonly utmSource?: InputMaybe<Scalars['String']>;
};

export type CreateCrmLawsuitFollowUpPayload = {
  readonly __typename?: 'CreateCRMLawsuitFollowUpPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type CreateCrmLawsuitPersonInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly contact: Scalars['JSON'];
  readonly lawsuitId: Scalars['String'];
  readonly person: Scalars['JSON'];
  readonly personRefType: Scalars['String'];
};

export type CreateCrmLawsuitPersonPayload = {
  readonly __typename?: 'CreateCRMLawsuitPersonPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
};

export type CreateCrmLawsuitsHistoryInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
};

export type CreateCrmLawsuitsHistoryPayload = {
  readonly __typename?: 'CreateCRMLawsuitsHistoryPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type CreateCrmTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly tag: Scalars['JSON'];
};

export type CreateCrmTagPayload = {
  readonly __typename?: 'CreateCRMTagPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
  readonly tag: Maybe<CrmTag>;
  readonly tagEdge: Maybe<OrganizationCrmTagsEdge>;
};

export type CreateCrmTaskInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly entityRefId?: InputMaybe<Scalars['String']>;
  readonly entityRefType?: InputMaybe<Scalars['String']>;
  readonly task: Scalars['JSON'];
};

export type CreateCrmTaskPayload = {
  readonly __typename?: 'CreateCRMTaskPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly crmEntity: Maybe<CrmEntity>;
  readonly organization: Maybe<Organization>;
  readonly task: Maybe<CrmTask>;
  readonly taskEdge: Maybe<CrmEntityTasksEdge>;
  readonly timelineEdge: Maybe<CrmEntityTimelineEdge>;
};

export type CreateCamadaAuthTokenInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CreateCamadaAuthTokenPayload = {
  readonly __typename?: 'CreateCamadaAuthTokenPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly token: Maybe<Scalars['String']>;
  readonly userId: Maybe<Scalars['String']>;
};

export type CreateCaseLlmTitleInput = {
  readonly caseId: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CreateCaseLlmTitlePayload = {
  readonly __typename?: 'CreateCaseLLMTitlePayload';
  readonly caseLLMTitle: Maybe<CrmCaseLlmTitle>;
  readonly clientMutationId: Maybe<Scalars['String']>;
};

export type CreateCaseSummarizationInput = {
  readonly caseId: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CreateCaseSummarizationPayload = {
  readonly __typename?: 'CreateCaseSummarizationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly summarization: Maybe<CrmCaseSummarization>;
};

export type CreateContactInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly contact: Scalars['JSON'];
};

export type CreateContactPayload = {
  readonly __typename?: 'CreateContactPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly contact: Maybe<Contact>;
  readonly contactEdge: Maybe<OrganizationContactsEdge>;
  readonly organization: Maybe<Organization>;
};

export type CreateConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly legalCaseId: Scalars['Int'];
};

export type CreateConversationPayload = {
  readonly __typename?: 'CreateConversationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly conversation: Maybe<Conversation>;
  readonly legalCase: Maybe<LegalCase>;
};

export type CreateCurrentExplanationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lastActivityId?: InputMaybe<Scalars['String']>;
  readonly lawsuitArchived?: InputMaybe<Scalars['Boolean']>;
  readonly lawsuitId: Scalars['String'];
  readonly lawsuitKind?: InputMaybe<Scalars['String']>;
  readonly withSabiazinhoModel?: InputMaybe<Scalars['Boolean']>;
};

export type CreateCurrentExplanationPayload = {
  readonly __typename?: 'CreateCurrentExplanationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly currentExplanation: Maybe<CrmLawsuitCurrentExplanation>;
};

export type CreateCustomPlanBasedFeatureTokenLimitsInput = {
  readonly applyDiscount?: InputMaybe<ReadonlyArray<InputMaybe<DiscountFeature>>>;
  readonly boxContext?: InputMaybe<BoxContextType>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly featureTokenLimits: FeatureTokenLimitsInputType;
  readonly materializePlan?: InputMaybe<Scalars['Boolean']>;
  readonly targetPlan?: InputMaybe<TargetPlanInputType>;
};

export type CreateCustomPlanBasedFeatureTokenLimitsPayload = {
  readonly __typename?: 'CreateCustomPlanBasedFeatureTokenLimitsPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly currentPlan: Maybe<Plan>;
  readonly featuresInfo: Maybe<FeaturesInfoType>;
  readonly frequency: Maybe<PlanFrequencyType>;
  readonly installments: Maybe<Scalars['Int']>;
  readonly plan: Maybe<Plan>;
  readonly planBasePrice: Maybe<Scalars['Float']>;
  readonly planPrice: Maybe<Scalars['Float']>;
  readonly planPricePerInstallments: Maybe<Scalars['Float']>;
  readonly submitData: Maybe<SubmitDataType>;
};

export type CreateCustomPlanInput = {
  readonly boxContext?: InputMaybe<Scalars['JSON']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly coupon?: InputMaybe<Scalars['String']>;
  readonly templateSlug: Scalars['String'];
  readonly variables: Scalars['JSON'];
};

export type CreateCustomPlanPayload = {
  readonly __typename?: 'CreateCustomPlanPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly plan: Maybe<Plan>;
  readonly subscribeFormData: Maybe<Scalars['JSON']>;
  readonly subscribeFormUrl: Maybe<Scalars['String']>;
};

export type CreateDirectConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly otherParticipantId: Scalars['String'];
};

export type CreateDirectConversationPayload = {
  readonly __typename?: 'CreateDirectConversationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly conversation: Maybe<CamadaConversation>;
};

export type CreateDraftInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly futureArtifact?: InputMaybe<Scalars['String']>;
  readonly subtitle?: InputMaybe<Scalars['String']>;
  readonly text?: InputMaybe<Scalars['String']>;
  readonly title?: InputMaybe<Scalars['String']>;
};

export type CreateDraftPayload = {
  readonly __typename?: 'CreateDraftPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly document: Maybe<Document>;
};

export type CreateEntityLawsuitCollectionRequestInput = {
  readonly client?: InputMaybe<Scalars['String']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cpf?: InputMaybe<Scalars['String']>;
  readonly entityId?: InputMaybe<Scalars['String']>;
  readonly from?: InputMaybe<CollectionRequestSource>;
  readonly system?: InputMaybe<Scalars['String']>;
  readonly team?: InputMaybe<Scalars['String']>;
};

export type CreateEntityLawsuitCollectionRequestPayload = {
  readonly __typename?: 'CreateEntityLawsuitCollectionRequestPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly requestId: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
};

export type CreateEntityQueryViewInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly entityId: Scalars['String'];
  readonly entityMatch: Scalars['Boolean'];
  readonly query: Scalars['String'];
  readonly queryBase64: Scalars['String'];
};

export type CreateEntityQueryViewPayload = {
  readonly __typename?: 'CreateEntityQueryViewPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly entityQueryView: Maybe<EntityQueryView>;
};

export type CreateEntitySummarizationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly entityId: Scalars['String'];
};

export type CreateEntitySummarizationPayload = {
  readonly __typename?: 'CreateEntitySummarizationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly summarization: Maybe<CrmEntitySummarization>;
};

export type CreateFeatureTaskInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly dryRun?: InputMaybe<Scalars['Boolean']>;
  readonly featureCode: Scalars['String'];
  readonly featureDefinition: Scalars['JSON'];
  readonly operation: FeatureTaskOperation;
  readonly planCriteriaMust?: InputMaybe<Scalars['String']>;
  readonly planCriterias?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['JSON']>>>;
  readonly planTemplateCriteriaMust?: InputMaybe<Scalars['String']>;
  readonly planTemplateCriterias?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['JSON']>>>;
  readonly reason: Scalars['String'];
};

export type CreateFeatureTaskPayload = {
  readonly __typename?: 'CreateFeatureTaskPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly featureTask: FeatureTask;
};

export type CreateFreePublicationMonitoringInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CreateFreePublicationMonitoringPayload = {
  readonly __typename?: 'CreateFreePublicationMonitoringPayload';
  readonly alert: Maybe<PublicationAlert>;
  readonly alertEdge: Maybe<PublicationAlertsEdge>;
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
};

export type CreateHubCompanyRequestInput = {
  readonly brandName: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cnaeCode: Scalars['String'];
  readonly cnaeDescription?: InputMaybe<Scalars['String']>;
  readonly employeeCount?: InputMaybe<Scalars['Int']>;
  readonly legalName: Scalars['String'];
  readonly legalNumber: Scalars['String'];
  readonly ownerPhone: Scalars['String'];
  readonly planId?: InputMaybe<Scalars['Int']>;
  readonly useCases: ReadonlyArray<Scalars['String']>;
};

export type CreateHubCompanyRequestPayload = {
  readonly __typename?: 'CreateHubCompanyRequestPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly hubCompanyRequest: Maybe<HubCompanyRequest>;
};

export type CreateHubOrganizationInput = {
  readonly brandName: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cproEmbeddedUrl?: InputMaybe<Scalars['String']>;
  readonly legalName: Scalars['String'];
  readonly legalNumber: Scalars['String'];
  readonly name: Scalars['String'];
};

export type CreateHubOrganizationPayload = {
  readonly __typename?: 'CreateHubOrganizationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly hubOrganization: Maybe<HubOrganization>;
};

export type CreateHubSubscriptionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly companyUuid: Scalars['String'];
  readonly planUuid: Scalars['String'];
};

export type CreateHubSubscriptionPayload = {
  readonly __typename?: 'CreateHubSubscriptionPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly subscription: Maybe<HubSubscription>;
};

export type CreateHubUserBatchError = {
  readonly __typename?: 'CreateHubUserBatchError';
  readonly email: Maybe<Scalars['String']>;
  readonly error_key: Maybe<Scalars['String']>;
  readonly index: Maybe<Scalars['Int']>;
  readonly name: Maybe<Scalars['String']>;
};

export type CreateHubUserBatchInput = {
  readonly email: Scalars['String'];
  readonly name: Scalars['String'];
  readonly roles?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly userCompanyId: Scalars['Int'];
};

export type CreateHubUserBatchUser = {
  readonly __typename?: 'CreateHubUserBatchUser';
  readonly email: Maybe<Scalars['String']>;
  readonly id: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly userCompanyId: Maybe<Scalars['Int']>;
};

export type CreateHubUserInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly name: Scalars['String'];
  readonly roles?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly userCompanyId: Scalars['Int'];
};

export type CreateHubUserPayload = {
  readonly __typename?: 'CreateHubUserPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly hubUser: Maybe<HubUser>;
};

export type CreateHubUsersBatchInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly users?: InputMaybe<ReadonlyArray<CreateHubUserBatchInput>>;
};

export type CreateHubUsersBatchPayload = {
  readonly __typename?: 'CreateHubUsersBatchPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly created: Scalars['Int'];
  readonly createdUsers: Maybe<ReadonlyArray<CreateHubUserBatchUser>>;
  readonly errors: Maybe<ReadonlyArray<CreateHubUserBatchError>>;
  readonly failed: Scalars['Int'];
  readonly total: Scalars['Int'];
};

export type CreateInstitutionalProfileInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly introduction?: InputMaybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly pidAdmins: ReadonlyArray<InputMaybe<Scalars['Int']>>;
  readonly profileChanges?: InputMaybe<Scalars['JSON']>;
  readonly type: Scalars['String'];
  readonly username: Scalars['String'];
  readonly website?: InputMaybe<Scalars['String']>;
};

export type CreateInstitutionalProfilePayload = {
  readonly __typename?: 'CreateInstitutionalProfilePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly createdProfile: Maybe<Profile>;
};

export type CreateJpvLastAccessInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CreateJpvLastAccessPayload = {
  readonly __typename?: 'CreateJPVLastAccessPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type CreateLawsuitAssistantMessageInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly currentExplanationVersion?: InputMaybe<Scalars['String']>;
  readonly lastActivityId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
  readonly question: Scalars['String'];
};

export type CreateLawsuitAssistantMessagePayload = {
  readonly __typename?: 'CreateLawsuitAssistantMessagePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuitAssistantMessage: Maybe<LawsuitAssistantMessage>;
};

export type CreateLawsuitDeadlineForecastInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lastActivityId: Scalars['String'];
  readonly lawsuitId: Scalars['String'];
};

export type CreateLawsuitDeadlineForecastPayload = {
  readonly __typename?: 'CreateLawsuitDeadlineForecastPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly deadlineForecast: Maybe<Scalars['JSON']>;
  readonly lawsuitAssistantMessage: Maybe<LawsuitAssistantMessage>;
};

export type CreateLawsuitLlmTitleInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
};

export type CreateLawsuitLlmTitlePayload = {
  readonly __typename?: 'CreateLawsuitLLMTitlePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly llmTitle: Maybe<CrmLawsuitLlmTitle>;
};

export type CreateLawsuitQaEvaluatorFeatureInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly feature: Scalars['String'];
  readonly judgeModel?: InputMaybe<LawsuitQaEvaluatorModel>;
  readonly judgePrompt?: InputMaybe<Scalars['String']>;
  readonly lawsuitIds: ReadonlyArray<Scalars['String']>;
  readonly maxDocuments?: InputMaybe<Scalars['Int']>;
  readonly maxTokens?: InputMaybe<Scalars['Int']>;
  readonly model?: InputMaybe<LawsuitQaEvaluatorModel>;
  readonly prompts?: InputMaybe<Scalars['JSON']>;
  readonly skipDocumentTypeFilter?: InputMaybe<Scalars['Boolean']>;
  readonly skipFactsFilter?: InputMaybe<Scalars['Boolean']>;
  readonly systemPrompt?: InputMaybe<Scalars['String']>;
  readonly temperature?: InputMaybe<Scalars['Float']>;
  readonly userMessage?: InputMaybe<Scalars['String']>;
};

export type CreateLawsuitQaEvaluatorFeaturePayload = {
  readonly __typename?: 'CreateLawsuitQaEvaluatorFeaturePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuitQaEvaluator: Maybe<LawsuitQaEvaluator>;
};

export type CreateLawsuitQaEvaluatorJudgeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly includeFeatureSystemPrompt?: InputMaybe<Scalars['Boolean']>;
  readonly judgeCases: Scalars['JSON'];
  readonly judgeModel?: InputMaybe<LawsuitQaEvaluatorModel>;
  readonly judgePrompt?: InputMaybe<Scalars['String']>;
};

export type CreateLawsuitQaEvaluatorJudgePayload = {
  readonly __typename?: 'CreateLawsuitQaEvaluatorJudgePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuitQaEvaluator: Maybe<LawsuitQaEvaluator>;
};

export type CreateLawsuitResultInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly kind: Scalars['String'];
  readonly lawsuitId: Scalars['String'];
};

export type CreateLawsuitResultPayload = {
  readonly __typename?: 'CreateLawsuitResultPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly result: Maybe<CrmLawsuitResult>;
};

export type CreateLawsuitServiceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuit: Scalars['JSON'];
};

export type CreateLawsuitServicePayload = {
  readonly __typename?: 'CreateLawsuitServicePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
  readonly lawsuitEdge: Maybe<OrganizationLawsuitsEdge>;
  readonly organization: Maybe<Organization>;
};

export type CreateLawsuitSummarizationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly court: Scalars['String'];
  readonly lawsuitId: Scalars['String'];
  readonly versionId?: InputMaybe<Scalars['String']>;
};

export type CreateLawsuitSummarizationPayload = {
  readonly __typename?: 'CreateLawsuitSummarizationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly summarization: Maybe<CrmLawsuitSummarization>;
};

export type CreateMagicLinkConfigInput = {
  readonly areaUuid: Scalars['String'];
  readonly autoInvite?: InputMaybe<Scalars['Boolean']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly companyUuid: Scalars['String'];
  readonly domain: Scalars['String'];
  readonly inactivityTtlSecs?: InputMaybe<Scalars['Int']>;
  readonly renewalTtlSecs?: InputMaybe<Scalars['Int']>;
};

export type CreateMagicLinkConfigPayload = {
  readonly __typename?: 'CreateMagicLinkConfigPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly magicLinkConfig: Maybe<HubMagicLinkConfig>;
};

export type CreateNameFollowUpInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly personName: Scalars['String'];
  readonly topicId: Scalars['Int'];
  readonly utmSource?: InputMaybe<Scalars['String']>;
};

export type CreateNameFollowUpPayload = {
  readonly __typename?: 'CreateNameFollowUpPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type CreateOrganizationCalendarInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CreateOrganizationCalendarPayload = {
  readonly __typename?: 'CreateOrganizationCalendarPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
};

export type CreateOrganizationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly profileInfos?: InputMaybe<Scalars['JSON']>;
};

export type CreateOrganizationPayload = {
  readonly __typename?: 'CreateOrganizationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly createdOrganization: Maybe<Organization>;
  readonly createdProfile: Maybe<Profile>;
};

export type CreatePendingConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly legalCaseId: Scalars['Int'];
};

export type CreatePendingConversationPayload = {
  readonly __typename?: 'CreatePendingConversationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly conversation: Maybe<Conversation>;
  readonly legalCase: Maybe<LegalCase>;
};

export type CreatePlanGroupInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly defaultPlanTemplateId?: InputMaybe<Scalars['Int']>;
  readonly multiPlanPosition?: InputMaybe<Scalars['Int']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly plans?: InputMaybe<ReadonlyArray<InputMaybe<CreatePlanGroupItem>>>;
  readonly slug?: InputMaybe<Scalars['String']>;
};

export type CreatePlanGroupItem = {
  readonly associatedAt?: InputMaybe<Scalars['Int']>;
  readonly percentageOfUsersVisibleTo?: InputMaybe<Scalars['Float']>;
  readonly planId?: InputMaybe<Scalars['Int']>;
  readonly position?: InputMaybe<Scalars['Int']>;
};

export type CreatePlanGroupPayload = {
  readonly __typename?: 'CreatePlanGroupPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly planGroup: Maybe<PlanGroup>;
};

export type CreatePlanInput = {
  readonly appliedDiscount?: InputMaybe<Scalars['Float']>;
  readonly autoRenewDiscount?: InputMaybe<Scalars['Float']>;
  readonly bonus?: InputMaybe<ReadonlyArray<InputMaybe<BonusType>>>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly computedDiscount?: InputMaybe<Scalars['Float']>;
  readonly currency?: InputMaybe<Scalars['String']>;
  readonly daysUntilExpireDeprecated?: InputMaybe<Scalars['Int']>;
  readonly defaultPricingPlanSlug?: InputMaybe<Scalars['String']>;
  readonly deprecated?: InputMaybe<Scalars['Boolean']>;
  readonly features?: InputMaybe<ReadonlyArray<InputMaybe<FeaturesType>>>;
  readonly featuresPrice?: InputMaybe<Scalars['JSON']>;
  readonly frequency?: InputMaybe<PlanFrequencyType>;
  readonly installments?: InputMaybe<Scalars['Int']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly notificationInfo?: InputMaybe<NotificationInfoType>;
  readonly notifyTokensExpirations?: InputMaybe<Scalars['Boolean']>;
  readonly offerInfo?: InputMaybe<OfferInfoType>;
  readonly planIdToUpgrade?: InputMaybe<Scalars['Int']>;
  readonly presentationDataIsHiddenOnSettings?: InputMaybe<Scalars['Boolean']>;
  readonly presentationName?: InputMaybe<Scalars['String']>;
  readonly price?: InputMaybe<Scalars['Float']>;
  readonly priceAttributionByProduct?: InputMaybe<Scalars['JSON']>;
  readonly productId?: InputMaybe<Scalars['Int']>;
  readonly promotional?: InputMaybe<Scalars['Boolean']>;
  readonly promotionalPriceMonths?: InputMaybe<Scalars['Int']>;
  readonly slug?: InputMaybe<Scalars['String']>;
  readonly status?: InputMaybe<Scalars['String']>;
  readonly templateId?: InputMaybe<Scalars['String']>;
  readonly templateVariables?: InputMaybe<Scalars['JSON']>;
  readonly trialDays?: InputMaybe<Scalars['Int']>;
  readonly type?: InputMaybe<PlanType>;
};

export type CreatePlanPayload = {
  readonly __typename?: 'CreatePlanPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly plan: Maybe<Plan>;
};

export type CreatePlanTemplateInput = {
  readonly allowedFrequencies?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly basePrice?: InputMaybe<Scalars['Float']>;
  readonly bonusFeatures?: InputMaybe<ReadonlyArray<InputMaybe<BonusFeatures>>>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly description?: InputMaybe<Scalars['String']>;
  readonly discount?: InputMaybe<Scalars['Float']>;
  readonly editableFeatures?: InputMaybe<ReadonlyArray<InputMaybe<EditableFeatures>>>;
  readonly fixedFeatures?: InputMaybe<ReadonlyArray<InputMaybe<FeaturesType>>>;
  readonly groupName?: InputMaybe<Scalars['String']>;
  readonly installments?: InputMaybe<Scalars['Int']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly notificationInfo?: InputMaybe<NotificationInfoType>;
  readonly offerInfo?: InputMaybe<OfferInfoType>;
  readonly presentationNameTemplate?: InputMaybe<Scalars['String']>;
  readonly productId?: InputMaybe<Scalars['Int']>;
  readonly slug?: InputMaybe<Scalars['String']>;
  readonly version?: InputMaybe<PlanTemplateVersionType>;
};

export type CreatePlanTemplatePayload = {
  readonly __typename?: 'CreatePlanTemplatePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly template: Maybe<PlanTemplate>;
};

export type CreatePriceIncreaseInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly emailTemplateId?: InputMaybe<Scalars['String']>;
  readonly fromPlanId?: InputMaybe<Scalars['Int']>;
  readonly subscriptionRulesType?: InputMaybe<PriceIncreaseTypeEnum>;
  readonly toPlanGroupId?: InputMaybe<Scalars['Int']>;
  readonly toPlanId?: InputMaybe<Scalars['Int']>;
};

export type CreatePriceIncreasePayload = {
  readonly __typename?: 'CreatePriceIncreasePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly error: Maybe<Scalars['String']>;
  readonly priceIncrease: Maybe<PriceIncrease>;
};

export type CreateProfileCalendarAcLsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly resources?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['JSON']>>>;
  readonly sendNotifications?: InputMaybe<Scalars['Boolean']>;
};

export type CreateProfileCalendarAcLsPayload = {
  readonly __typename?: 'CreateProfileCalendarACLsPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly legalCaseProfileInfo: Maybe<LegalCaseProfileInfo>;
};

export type CreateProfileCalendarInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CreateProfileCalendarPayload = {
  readonly __typename?: 'CreateProfileCalendarPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly legalCaseProfileInfo: Maybe<LegalCaseProfileInfo>;
};

export type CreatePublicationMonitoringInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly idExternalReference?: InputMaybe<Scalars['Int']>;
  readonly monitoringName: Scalars['String'];
  readonly monitoringType: Scalars['String'];
  readonly payload: Scalars['JSON'];
  readonly shouldFailWhenOabMonitoredAlreadyExists?: InputMaybe<Scalars['Boolean']>;
  readonly shouldMonitorLawsuits?: InputMaybe<Scalars['Boolean']>;
  readonly variations?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type CreatePublicationMonitoringPayload = {
  readonly __typename?: 'CreatePublicationMonitoringPayload';
  readonly alert: Maybe<PublicationAlert>;
  readonly alertEdge: Maybe<PublicationAlertsEdge>;
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly existingOabMonitored: Maybe<PublicationAlert>;
  readonly organization: Maybe<Organization>;
};

export type CreateSmartLinkInput = {
  readonly campaign?: InputMaybe<Scalars['String']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly keyName: Scalars['String'];
  readonly linkURL: Scalars['String'];
};

export type CreateSmartLinkPayload = {
  readonly __typename?: 'CreateSmartLinkPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly smartLink: Maybe<SmartLink>;
};

export type CreateStudentBenefitInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cpf: Scalars['String'];
  readonly experimentVariant?: InputMaybe<Scalars['String']>;
};

export type CreateStudentBenefitPayload = {
  readonly __typename?: 'CreateStudentBenefitPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly requestId: Maybe<Scalars['String']>;
  readonly status: Maybe<StudentBenefitStatusEnum>;
};

export type CreateSubscriptionOnPatinhasInput = {
  readonly ccToken?: InputMaybe<Scalars['String']>;
  readonly client: Scalars['JSON'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly creditCard?: InputMaybe<Scalars['JSON']>;
  readonly hash: Scalars['String'];
  readonly jwt: Scalars['String'];
  readonly utmParams: Scalars['JSON'];
};

export type CreateSubscriptionOnPatinhasPayload = {
  readonly __typename?: 'CreateSubscriptionOnPatinhasPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly orderCode: Scalars['String'];
};

export type CreateSupportTicketInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly comment: Scalars['String'];
  readonly howCanWeHelp?: InputMaybe<Scalars['String']>;
  readonly platform?: InputMaybe<SupportPlatform>;
  readonly subject: Scalars['String'];
  readonly tags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type CreateSupportTicketPayload = {
  readonly __typename?: 'CreateSupportTicketPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly ticketID: Maybe<Scalars['String']>;
};

export type CreateTextDocumentInput = {
  readonly artifact: Scalars['String'];
  readonly authorTextSummary?: InputMaybe<Scalars['String']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly futureArtifact?: InputMaybe<Scalars['String']>;
  readonly isAIGenerated?: InputMaybe<Scalars['Boolean']>;
  readonly subtitle?: InputMaybe<Scalars['String']>;
  readonly text: Scalars['String'];
  readonly title: Scalars['String'];
  readonly typeSegmentation?: InputMaybe<Scalars['String']>;
};

export type CreateTextDocumentPayload = {
  readonly __typename?: 'CreateTextDocumentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly document: Maybe<Document>;
};

export type CreateTopicDocumentInput = {
  readonly artifact: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId: Scalars['NumericID'];
  readonly title: Scalars['String'];
};

export type CreateTopicDocumentPayload = {
  readonly __typename?: 'CreateTopicDocumentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly document: Maybe<Document>;
  readonly topicsEdge: Maybe<DocumentTopicsEdge>;
};

export type CreateTopicTipoInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly tipo: TopicTipoEnum;
  readonly title: Scalars['String'];
};

export type CreateTopicTipoPayload = {
  readonly __typename?: 'CreateTopicTipoPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly topic: Maybe<Topic>;
};

export type CreateUserCollectionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cnjSubject?: InputMaybe<Scalars['Int']>;
  readonly description?: InputMaybe<Scalars['String']>;
  readonly documents?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['JSON']>>>;
  readonly isPublic: Scalars['Boolean'];
  readonly title: Scalars['String'];
};

export type CreateUserCollectionPayload = {
  readonly __typename?: 'CreateUserCollectionPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly cnjSubject: Maybe<Scalars['Int']>;
  readonly collectionId: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
  readonly documents: Maybe<ReadonlyArray<Maybe<UserCollectionDocument>>>;
  readonly isPublic: Maybe<Scalars['Boolean']>;
  readonly title: Maybe<Scalars['String']>;
  readonly userProfileId: Maybe<Scalars['Int']>;
};

export type CreditCard = {
  readonly __typename?: 'CreditCard';
  readonly brandName: Maybe<Scalars['String']>;
  readonly ccToken: Maybe<Scalars['String']>;
  readonly expMonth: Maybe<Scalars['String']>;
  readonly expYear: Maybe<Scalars['String']>;
  readonly lastDigits: Maybe<Scalars['String']>;
};

export type CurrentPlan = {
  readonly __typename?: 'CurrentPlan';
  readonly benefitsList: Maybe<ReadonlyArray<Maybe<CurrentPlanBenefit>>>;
  readonly bonusSubscription: Maybe<BonusSubscription>;
  readonly cancellationPriceProtectionInfo: Maybe<CancellationPriceProtectionInfo>;
  readonly frequencyText: Scalars['String'];
  readonly gateway: Scalars['String'];
  readonly includedItems: CurrentPlanIncludedItems;
  readonly installmentsText: Scalars['String'];
  readonly isB2BAccount: Scalars['Boolean'];
  readonly isB2bOrganizationOwner: Scalars['Boolean'];
  readonly isFreePlan: Maybe<Scalars['Boolean']>;
  readonly isLoggedPlan: Maybe<Scalars['Boolean']>;
  readonly isOneTimeFeeSubscription: Maybe<Scalars['Boolean']>;
  readonly isYearlyPlan: Maybe<Scalars['Boolean']>;
  readonly name: Scalars['String'];
  readonly oneTimeFeeSubscription: Maybe<OneTimeFeeSubscription>;
  readonly orderCode: Maybe<Scalars['String']>;
  readonly overdue: Scalars['Boolean'];
  readonly paidInstallments: Maybe<CurrentPlanPaidInstallments>;
  readonly planId: Maybe<Scalars['Int']>;
  readonly priceAfterPromotionalPeriodText: Maybe<Scalars['String']>;
  readonly pricePerInstallmentsText: Maybe<Scalars['String']>;
  readonly priceText: Scalars['String'];
  readonly priceTitle: Scalars['String'];
  readonly promotionalBannerInfo: Maybe<CurrentPlanPromotionalBannerInfo>;
  readonly scheduledDowngrade: Maybe<BoxSubscriptionChange>;
  readonly subscriptionHelpText: Scalars['String'];
  readonly switchToAnnualBannerInfo: Maybe<CurrentPlanSwitchToAnnualBannerInfo>;
  readonly userSubscriptionId: Maybe<Scalars['Int']>;
};

export enum CurrentPlanBannerIconTypeEnum {
  Calendar = 'CALENDAR',
  Money = 'MONEY'
}

export type CurrentPlanBenefit = {
  readonly __typename?: 'CurrentPlanBenefit';
  readonly iconType: Maybe<BenefitIconTypeEnum>;
  readonly name: Scalars['String'];
};

export type CurrentPlanIncludedItems = {
  readonly __typename?: 'CurrentPlanIncludedItems';
  readonly includedLawsuitMonitor: Scalars['String'];
  readonly includedPublicationMonitor: Scalars['String'];
  readonly includedUsers: Scalars['String'];
};

export type CurrentPlanPaidInstallments = {
  readonly __typename?: 'CurrentPlanPaidInstallments';
  readonly paidCount: Maybe<Scalars['Int']>;
  readonly total: Maybe<Scalars['Int']>;
};

export type CurrentPlanPromotionalBannerInfo = {
  readonly __typename?: 'CurrentPlanPromotionalBannerInfo';
  readonly bannerType: Maybe<PromotionalBannerType>;
  readonly promotionalPriceMonths: Maybe<Scalars['Int']>;
};

export type CurrentPlanSwitchToAnnualBannerInfo = {
  readonly __typename?: 'CurrentPlanSwitchToAnnualBannerInfo';
  readonly buttonLabel: Scalars['String'];
  readonly description: Scalars['String'];
  readonly icon: Maybe<CurrentPlanBannerIconTypeEnum>;
  readonly submitData: SubmitData;
  readonly title: Scalars['String'];
  readonly type: Scalars['String'];
};

export type DeactivateOrganizationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly id: Scalars['String'];
};

export type DeactivateOrganizationPayload = {
  readonly __typename?: 'DeactivateOrganizationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly hubOrganization: Maybe<HubOrganization>;
};

export type DeactivateProfileInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly pid: Scalars['Int'];
};

export type DeactivateProfilePayload = {
  readonly __typename?: 'DeactivateProfilePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type DecisionAcademicReference = {
  readonly __typename?: 'DecisionAcademicReference';
  readonly author: Maybe<Scalars['String']>;
  readonly literaryWork: Maybe<Scalars['String']>;
};

export type DecisionComplementarInfo = {
  readonly __typename?: 'DecisionComplementarInfo';
  readonly description: Maybe<Scalars['String']>;
  readonly references: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
};

export type DecisionFacts = {
  readonly __typename?: 'DecisionFacts';
  readonly header: Maybe<Scalars['String']>;
  readonly paragraphs: ReadonlyArray<Maybe<Scalars['String']>>;
};

export type DecisionLink = {
  readonly __typename?: 'DecisionLink';
  readonly document: Maybe<Document>;
  readonly jurisId: Maybe<Scalars['Float']>;
  readonly label: Maybe<Scalars['String']>;
  readonly linkId: Maybe<Scalars['Float']>;
  readonly localFiles: Maybe<ReadonlyArray<Maybe<FileInfo>>>;
  readonly remoteFiles: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly url: Maybe<Scalars['String']>;
};

export type DecisionPublication = {
  readonly __typename?: 'DecisionPublication';
  readonly date: Maybe<Scalars['Float']>;
  readonly description: Maybe<Scalars['String']>;
};


export type DecisionPublicationDescriptionArgs = {
  stripTags: InputMaybe<Scalars['Boolean']>;
};

export type DecisionReference = {
  readonly __typename?: 'DecisionReference';
  readonly description: Maybe<Scalars['String']>;
  readonly publication: Maybe<Scalars['String']>;
};

export type DeleteB2BAreaInput = {
  readonly areaUuid: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly companyUuid: Scalars['String'];
};

export type DeleteB2BAreaPayload = {
  readonly __typename?: 'DeleteB2BAreaPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
};

export type DeleteCProUserFromOrganizationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly organizationId: Scalars['String'];
  readonly userId: Scalars['String'];
};

export type DeleteCProUserFromOrganizationPayload = {
  readonly __typename?: 'DeleteCProUserFromOrganizationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly deleted: Maybe<Scalars['Boolean']>;
};

export type DeleteCrmActivityLogInput = {
  readonly activityId: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly entityRefId: Scalars['String'];
  readonly entityRefType: Scalars['String'];
};

export type DeleteCrmActivityLogPayload = {
  readonly __typename?: 'DeleteCRMActivityLogPayload';
  readonly activity: Maybe<CrmActivityLog>;
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly crmEntity: Maybe<CrmEntity>;
  readonly organization: Maybe<Organization>;
  readonly timelineEdge: Maybe<CrmEntityTimelineEdge>;
};

export type DeleteCrmDocumentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly documentId: Scalars['String'];
  readonly entityRefId: Scalars['String'];
  readonly entityRefType: Scalars['String'];
};

export type DeleteCrmDocumentPayload = {
  readonly __typename?: 'DeleteCRMDocumentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly crmEntity: Maybe<CrmEntity>;
  readonly document: Maybe<CrmDocument>;
  readonly organization: Maybe<Organization>;
};

export type DeleteCrmEventInput = {
  readonly calendarId: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly eventId: Scalars['String'];
};

export type DeleteCrmEventPayload = {
  readonly __typename?: 'DeleteCRMEventPayload';
  readonly calendar: Maybe<CrmCalendar>;
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly entity: Maybe<CrmEntity>;
  readonly event: Maybe<CrmEvent>;
  readonly legalCaseProfileInfo: Maybe<LegalCaseProfileInfo>;
  readonly organization: Maybe<Organization>;
};

export type DeleteCrmLawsuitActivityItemInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly itemId: Scalars['String'];
};

export type DeleteCrmLawsuitActivityItemPayload = {
  readonly __typename?: 'DeleteCRMLawsuitActivityItemPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly crmEntity: Maybe<CrmEntity>;
  readonly lawsuitActivityItem: Maybe<CrmLawsuitActivityItem>;
  readonly organization: Maybe<Organization>;
  readonly timelineEdge: Maybe<CrmEntityTimelineEdge>;
};

export type DeleteCrmTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly tagId: Scalars['String'];
};

export type DeleteCrmTagPayload = {
  readonly __typename?: 'DeleteCRMTagPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
  readonly tag: Maybe<CrmTag>;
};

export type DeleteCrmTaskInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly entityRefId?: InputMaybe<Scalars['String']>;
  readonly entityRefType?: InputMaybe<Scalars['String']>;
  readonly taskId: Scalars['String'];
};

export type DeleteCrmTaskPayload = {
  readonly __typename?: 'DeleteCRMTaskPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly crmEntity: Maybe<CrmEntity>;
  readonly organization: Maybe<Organization>;
  readonly task: Maybe<CrmTask>;
};

export type DeleteContactInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly contactId: Scalars['String'];
};

export type DeleteContactPayload = {
  readonly __typename?: 'DeleteContactPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly contact: Maybe<Contact>;
  readonly organization: Maybe<Organization>;
};

export type DeleteDocumentInput = {
  readonly artifact: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId: Scalars['NumericID'];
};

export type DeleteDocumentPayload = {
  readonly __typename?: 'DeleteDocumentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly document: Maybe<Document>;
};

export type DeleteForcedExperimentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type DeleteForcedExperimentPayload = {
  readonly __typename?: 'DeleteForcedExperimentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly result: Scalars['Boolean'];
};

export type DeleteLatestExplanationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lastActivityId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
  readonly versionId?: InputMaybe<Scalars['String']>;
};

export type DeleteLatestExplanationPayload = {
  readonly __typename?: 'DeleteLatestExplanationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly currentExplanation: Maybe<CrmLawsuitCurrentExplanation>;
};

export type DeleteLawsuitUserInteractionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
};

export type DeleteLawsuitUserInteractionPayload = {
  readonly __typename?: 'DeleteLawsuitUserInteractionPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
};

export type DeleteLegalCaseInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly legalCaseId: Scalars['Float'];
};

export type DeleteLegalCasePayload = {
  readonly __typename?: 'DeleteLegalCasePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly legalCase: Maybe<LegalCase>;
};

export type DeleteMagicLinkConfigInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly companyUuid: Scalars['String'];
  readonly configUuid: Scalars['String'];
};

export type DeleteMagicLinkConfigPayload = {
  readonly __typename?: 'DeleteMagicLinkConfigPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type DeleteOrganizationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly id: Scalars['String'];
};

export type DeleteOrganizationPayload = {
  readonly __typename?: 'DeleteOrganizationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly hubOrganization: Maybe<HubOrganization>;
};

export type DeletePersonalDataInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly requestDeletion?: InputMaybe<Scalars['Boolean']>;
  readonly uid?: InputMaybe<Scalars['Int']>;
};

export type DeletePersonalDataPayload = {
  readonly __typename?: 'DeletePersonalDataPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly user: Maybe<User>;
};

export type DeletePublicationMonitoringInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly monitoringId?: InputMaybe<Scalars['String']>;
  readonly topicId?: InputMaybe<Scalars['Int']>;
};

export type DeletePublicationMonitoringPayload = {
  readonly __typename?: 'DeletePublicationMonitoringPayload';
  readonly alert: Maybe<PublicationAlert>;
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
};

export type DeleteRatingInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly conversationId: Scalars['Int'];
  readonly evaluatorId: Scalars['Int'];
  readonly legalCaseId: Scalars['Int'];
};

export type DeleteRatingPayload = {
  readonly __typename?: 'DeleteRatingPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly conversation: Maybe<Conversation>;
};

export type DeleteSmartLinkInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly id: Scalars['String'];
};

export type DeleteSmartLinkPayload = {
  readonly __typename?: 'DeleteSmartLinkPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type DemoteHubUserAdminInput = {
  readonly actorUuid: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly companyUuid: Scalars['String'];
  readonly userUuid: Scalars['String'];
};

export type DemoteHubUserAdminPayload = {
  readonly __typename?: 'DemoteHubUserAdminPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly errorCode: Maybe<Scalars['String']>;
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
  readonly userUuid: Maybe<Scalars['String']>;
};

export enum DeniedReason {
  CpfEDataDeNascimentoNaoCorrespondem = 'CPF_E_DATA_DE_NASCIMENTO_NAO_CORRESPONDEM',
  CpfJaVerificadoEmOutraConta = 'CPF_JA_VERIFICADO_EM_OUTRA_CONTA',
  NomeNaoEncontradoNoProcesso = 'NOME_NAO_ENCONTRADO_NO_PROCESSO',
  PartesNaoCorrespondem = 'PARTES_NAO_CORRESPONDEM',
  PartesNaoPodemCorresponderParaOMotivo = 'PARTES_NAO_PODEM_CORRESPONDER_PARA_O_MOTIVO',
  TipoProcessoReportadoInvalidoParaOMotivo = 'TIPO_PROCESSO_REPORTADO_INVALIDO_PARA_O_MOTIVO'
}

export type Detection = {
  readonly __typename?: 'Detection';
  readonly detectionInfo: Maybe<DetectionInfo>;
  readonly label: Scalars['String'];
  readonly textPosition: Maybe<TextPosition>;
  readonly value: Scalars['String'];
};

export type DetectionInfo = {
  readonly __typename?: 'DetectionInfo';
  readonly source: Scalars['String'];
  readonly type: Scalars['String'];
};

export type DigestoUser = {
  readonly __typename?: 'DigestoUser';
  readonly companyId: Maybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly encryptedApiKey: Maybe<Scalars['String']>;
  readonly hasModuleEnabled: Scalars['Boolean'];
  readonly roles: ReadonlyArray<Maybe<Scalars['String']>>;
};


export type DigestoUserHasModuleEnabledArgs = {
  module: Scalars['String'];
};

export type DirectLegislation = {
  readonly __typename?: 'DirectLegislation';
  readonly body: Maybe<Scalars['String']>;
  readonly link: Maybe<Scalars['String']>;
  readonly tid: Maybe<Scalars['Int']>;
  readonly title: Maybe<Scalars['String']>;
};

export enum DiscountFeature {
  All = 'ALL',
  AbntQuoteDoctrine = 'abnt_quote_doctrine',
  CopyDoctrineContent = 'copy_doctrine_content',
  DoctrineUsers = 'doctrine_users',
  EoLeadsAnswer = 'eo_leads_answer',
  HomeDoctrine = 'home_doctrine',
  HomeFaqDoctrine = 'home_faq_doctrine',
  LandingDoctrine = 'landing_doctrine',
  LeadsAnswer = 'leads_answer',
  MonitorLawsuit = 'monitor_lawsuit',
  MonitorPublications = 'monitor_publications',
  OrganizationDocuments = 'organization_documents',
  OrganizationUsers = 'organization_users',
  ViewDoctrineContent = 'view_doctrine_content',
  ViewLawsuitDetails = 'view_lawsuit_details'
}

export type DismissHubUserInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly userId: Scalars['String'];
};

export type DismissHubUserPayload = {
  readonly __typename?: 'DismissHubUserPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly errorCode: Maybe<Scalars['String']>;
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
  readonly userId: Maybe<Scalars['String']>;
};

export type DoctrineCursor = {
  readonly __typename?: 'DoctrineCursor';
  readonly anchor: Maybe<Scalars['String']>;
  readonly cursorId: Maybe<Scalars['String']>;
  readonly noFollow: Maybe<Scalars['Boolean']>;
  readonly parentCursorId: Maybe<Scalars['String']>;
  readonly sectionUrl: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
};

export type DoctrineMetadata = {
  readonly __typename?: 'DoctrineMetadata';
  readonly addons: Maybe<SearchMetadataAddons>;
  readonly author: SearchMetadataAuthor;
  readonly body: Maybe<Scalars['String']>;
  readonly coverUrl: ThumborImage;
  readonly date: Maybe<Scalars['Float']>;
  readonly docId: Scalars['String'];
  readonly features: Maybe<SearchMetadataFeatures>;
  readonly highlight: Maybe<Scalars['String']>;
  readonly isbn: Scalars['String'];
  readonly keywords: ReadonlyArray<Scalars['String']>;
  readonly parent: SearchMetadataParent;
  readonly sections: ReadonlyArray<DoctrineMetadata>;
  readonly slug: Scalars['String'];
  readonly tags: ReadonlyArray<SearchMetadataTags>;
  readonly title: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly url: Scalars['String'];
  readonly writers: Maybe<ReadonlyArray<Scalars['String']>>;
};


export type DoctrineMetadataBodyArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
  preferHighlight?: InputMaybe<Scalars['Boolean']>;
};

export type DoctrineNavigation = {
  readonly __typename?: 'DoctrineNavigation';
  readonly indexTitle: Maybe<Scalars['String']>;
  readonly indexUrl: Maybe<Scalars['String']>;
  readonly nextNoFollow: Maybe<Scalars['Boolean']>;
  readonly nextTitle: Maybe<Scalars['String']>;
  readonly nextUrl: Maybe<Scalars['String']>;
  readonly prevNoFollow: Maybe<Scalars['Boolean']>;
  readonly prevTitle: Maybe<Scalars['String']>;
  readonly prevUrl: Maybe<Scalars['String']>;
};

export type DoctrineSearchSnippet = {
  readonly __typename?: 'DoctrineSearchSnippet';
  readonly authorNames: ReadonlyArray<Scalars['String']>;
  readonly doctrineId: Maybe<Scalars['Int']>;
  readonly document: Maybe<Document>;
  readonly isbn: Maybe<Scalars['String']>;
  readonly publishedAt: Maybe<Scalars['String']>;
  readonly publishedYear: Maybe<Scalars['Int']>;
  readonly publisherName: Maybe<Scalars['String']>;
  readonly sections: ReadonlyArray<DocumentSearchSnippet>;
  readonly thumborArtwork: Maybe<ThumborImage>;
  readonly title: Maybe<Scalars['String']>;
  readonly type: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
};

export type Document = Node & ShareableEntity & {
  readonly __typename?: 'Document';
  readonly abntQuote: Maybe<Scalars['String']>;
  readonly academicReferences: Maybe<ReadonlyArray<Maybe<DecisionAcademicReference>>>;
  readonly accessCondition: Maybe<Scalars['String']>;
  readonly additionalDecisionInfos: Maybe<ReadonlyArray<Maybe<DecisionComplementarInfo>>>;
  readonly admissibilityDecision: Maybe<Scalars['Boolean']>;
  readonly anonymizedData: Maybe<Scalars['JSON']>;
  readonly artifact: Scalars['String'];
  readonly artifactLabel: Scalars['String'];
  readonly attachment: Maybe<Attachment>;
  readonly authorTextSummary: Maybe<Scalars['String']>;
  readonly boxResourceId: Maybe<Scalars['String']>;
  readonly chairman: Maybe<Scalars['String']>;
  readonly cobertoSearch: Maybe<Scalars['JSON']>;
  readonly collectiveDecision: Maybe<Scalars['String']>;
  readonly commentary: Maybe<Scalars['String']>;
  readonly comments: Maybe<DocumentCommentsConnection>;
  readonly conflict: Maybe<Scalars['String']>;
  readonly courtPublishingDate: Maybe<Scalars['Float']>;
  readonly courtSection: Maybe<Scalars['String']>;
  readonly date: Maybe<Scalars['Float']>;
  readonly decision: Maybe<Scalars['String']>;
  readonly decisionAttachmentType: Maybe<Scalars['String']>;
  readonly decisionDepartament: Maybe<Scalars['String']>;
  readonly decisionExtraContents: Maybe<ReadonlyArray<Maybe<DecisionLink>>>;
  readonly decisionFacts: Maybe<DecisionFacts>;
  readonly decisionFactsForReference: Maybe<Scalars['String']>;
  readonly decisionFiles: Maybe<ReadonlyArray<Maybe<DecisionLink>>>;
  readonly decisionHtml: Maybe<Scalars['String']>;
  readonly decisionLabel: Maybe<Scalars['String']>;
  readonly decisionNote: Maybe<Scalars['String']>;
  readonly decisionProgress: Maybe<Scalars['String']>;
  readonly decisionPublications: Maybe<ReadonlyArray<Maybe<DecisionPublication>>>;
  readonly decisionReferences: Maybe<ReadonlyArray<Maybe<DecisionReference>>>;
  readonly decisionTabs: Maybe<ReadonlyArray<Maybe<DecisionLink>>>;
  readonly degree: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
  readonly detectedLawsuit: Maybe<CrmLawsuitDetected>;
  readonly distributionDate: Maybe<Scalars['Float']>;
  readonly docId: Scalars['Float'];
  readonly doctrineAuthorNames: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly doctrineCursors: Maybe<ReadonlyArray<Maybe<DoctrineCursor>>>;
  readonly doctrineEdition: Maybe<Scalars['String']>;
  readonly doctrineKeywords: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly doctrineLawAreas: ReadonlyArray<Scalars['String']>;
  readonly doctrineNavigation: Maybe<DoctrineNavigation>;
  readonly doctrinePaywallText: Maybe<Scalars['String']>;
  readonly doctrinePublishedAt: Maybe<Scalars['String']>;
  readonly doctrinePurchaseLink: Maybe<Scalars['String']>;
  readonly doctrineSectionText: Maybe<Scalars['String']>;
  readonly doctrineThumborArtwork: Maybe<ThumborImage>;
  readonly doctrineTitle: Maybe<Scalars['String']>;
  readonly doctrineType: Maybe<Scalars['String']>;
  readonly doctrineVolume: Maybe<Scalars['String']>;
  readonly editUrl: Maybe<Scalars['String']>;
  /** @deprecated Please use the `enrichedContents` field instead */
  readonly enrichedContent: Maybe<EnrichedContents>;
  readonly enrichedContents: Maybe<ReadonlyArray<Maybe<EnrichedContents>>>;
  readonly entityId: Maybe<Scalars['NumericID']>;
  readonly entityRefId: Maybe<Scalars['String']>;
  readonly entityRefType: Maybe<Scalars['String']>;
  readonly entityType: Maybe<Scalars['String']>;
  readonly formattedJournalSection: Maybe<Scalars['String']>;
  readonly hasDecisionFactsForReference: Maybe<Scalars['Boolean']>;
  readonly hasProceduralActs: Scalars['Boolean'];
  readonly hasSummary: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly images: Maybe<ReadonlyArray<Maybe<Image>>>;
  readonly inteiroTeorDocuments: ReadonlyArray<Maybe<Document>>;
  readonly involvedParties: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly isAIGenerated: Scalars['Boolean'];
  readonly isActive: Maybe<Scalars['Boolean']>;
  readonly isAutomatic: Maybe<Scalars['Boolean']>;
  readonly isPrecedenteObrigatorio: Maybe<Scalars['Boolean']>;
  readonly isbn: Maybe<Scalars['String']>;
  readonly journalBlocks: Maybe<JournalBlocksConnection>;
  readonly journalCompleteClassification: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly journalDistributionDate: Maybe<Scalars['Float']>;
  readonly journalHeader: Maybe<Scalars['String']>;
  readonly journalNextPageUrl: Maybe<Scalars['String']>;
  readonly journalPage: Maybe<Scalars['String']>;
  readonly journalPageBreadcrumb: Maybe<ReadonlyArray<Maybe<Breadcrumb>>>;
  readonly journalPrevPageUrl: Maybe<Scalars['String']>;
  readonly journalPublicationDate: Maybe<Scalars['Float']>;
  readonly journalSection: Maybe<Scalars['String']>;
  readonly journalSectionSummary: Maybe<JournalSectionSummary>;
  readonly journalText: Maybe<Scalars['String']>;
  readonly journalUrl: Maybe<Scalars['String']>;
  readonly judge: Maybe<Scalars['String']>;
  readonly judgementDate: Maybe<Scalars['Float']>;
  readonly judgmentDate: Maybe<Scalars['Float']>;
  readonly jurisGuidanceHistory: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly jurisGuidanceNote: Maybe<Scalars['String']>;
  readonly jurisGuidanceNumber: Maybe<Scalars['Int']>;
  readonly jurisGuidancePrecedents: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly jurisGuidancePublications: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly jurisGuidanceStatusLabel: Maybe<Scalars['String']>;
  readonly jurisGuidanceSubjectMatter: Maybe<Scalars['String']>;
  readonly jurisGuidanceThesis: Maybe<Scalars['String']>;
  readonly jurisGuidanceUpdatedAt: Maybe<Scalars['Float']>;
  readonly jurisId: Maybe<Scalars['Float']>;
  readonly jurisTypeLabel: Maybe<Scalars['String']>;
  readonly jurisprudence: Maybe<Document>;
  readonly jurisprudencesLikeThis: Maybe<JurisprudencesLikeThisConnection>;
  readonly keywords: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly lawAreas: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly lawItems: Maybe<ReadonlyArray<Maybe<LawItem>>>;
  readonly lawReferences: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly lawsuit: Maybe<Lawsuit>;
  readonly lawsuitAcronym: Maybe<Scalars['String']>;
  readonly lawsuitDecision: Maybe<LawsuitDecision>;
  readonly lawsuitEntity: Maybe<TopicEntity>;
  readonly lawsuitLocal: Maybe<Scalars['String']>;
  readonly lawsuitMotionTheme: Maybe<Scalars['String']>;
  readonly lawsuitNumber: Maybe<Scalars['String']>;
  readonly lawsuitProtocol: Maybe<Scalars['String']>;
  readonly lawsuitTopic: Maybe<Topic>;
  readonly lawsuitType: Maybe<Scalars['String']>;
  readonly legalUnderstandingChips: ReadonlyArray<Maybe<Scalars['String']>>;
  readonly legisDates: Maybe<Scalars['String']>;
  readonly legisHouse: Maybe<Scalars['String']>;
  readonly legisLevel: Maybe<Scalars['String']>;
  readonly legisNickname: Maybe<Scalars['String']>;
  readonly legisNumber: Maybe<Scalars['String']>;
  readonly legisState: Maybe<Scalars['String']>;
  readonly legisType: Maybe<Scalars['String']>;
  readonly listMotionsOfLawsuit: Maybe<ReadonlyArray<Maybe<Document>>>;
  readonly mandatoryPrecedent: Maybe<Scalars['Boolean']>;
  readonly meritDecision: Maybe<Scalars['Boolean']>;
  readonly meta: Maybe<Scalars['JSON']>;
  readonly metadata: Maybe<Scalars['JSON']>;
  readonly motionTypeLabel: Maybe<Scalars['String']>;
  readonly negativeVotesAmount: Maybe<Scalars['Int']>;
  readonly noIndex: Maybe<Scalars['Boolean']>;
  readonly numComments: Maybe<Scalars['Int']>;
  readonly originalTitle: Maybe<Scalars['String']>;
  readonly originalTopic: Maybe<Topic>;
  readonly parentComment: Maybe<Document>;
  readonly parentDocument: Maybe<Document>;
  readonly postBlogUrl: Maybe<Scalars['String']>;
  readonly postComponentName: Maybe<Scalars['String']>;
  readonly privacyContext: Maybe<PrivacyContext>;
  readonly profilesNegativeVote: Maybe<ProfilesNegativeVoteConnection>;
  readonly profilesVote: Maybe<ProfilesVoteConnection>;
  readonly publicationSegmentation: Maybe<PublicationSegmentation>;
  readonly publishedDate: Maybe<Scalars['Float']>;
  readonly publisher: Maybe<Profile>;
  readonly rawTitle: Maybe<Scalars['String']>;
  readonly readingTime: Maybe<Scalars['Int']>;
  readonly recommendations: ReadonlyArray<Maybe<Recommendation>>;
  readonly redirectTo: Maybe<Scalars['Int']>;
  readonly relatedJuris: Maybe<ReadonlyArray<Maybe<Document>>>;
  readonly relatedLegalUnderstanding: Maybe<JurisUnderstandingsThesis>;
  readonly relatedMotions: Maybe<ReadonlyArray<Maybe<Document>>>;
  readonly review: Maybe<Review>;
  readonly searchBySourceDocuments: Maybe<HaystackResponse>;
  readonly sensitive: Maybe<Scalars['Boolean']>;
  readonly slug: Maybe<Scalars['String']>;
  readonly sourceDocuments: Maybe<SourceDocumentsConnection>;
  readonly sourceLawsuit: Maybe<CrmLawsuit>;
  readonly sourceUrl: Maybe<Scalars['String']>;
  readonly stats: Maybe<Scalars['JSON']>;
  readonly status: Maybe<Scalars['String']>;
  readonly subject: Maybe<Scalars['String']>;
  readonly subjectMatter: Maybe<Scalars['String']>;
  readonly subjectMatterNumber: Maybe<Scalars['String']>;
  readonly subjects: ReadonlyArray<Maybe<Scalars['String']>>;
  readonly subtitle: Maybe<Scalars['String']>;
  readonly summaryJudgement: Maybe<Scalars['String']>;
  readonly summaryPrecedentApprovalDate: Maybe<Scalars['Float']>;
  readonly summaryPrecedentNumber: Maybe<Scalars['Int']>;
  readonly summaryPrecedentPrecedents: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly summaryPrecedentPublications: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly summaryPrecedentReferences: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly summaryPrecedentStatement: Maybe<Scalars['String']>;
  readonly summaryPrecedentStatusLabel: Maybe<Scalars['String']>;
  readonly summaryPrecedentUpdatedAt: Maybe<Scalars['Float']>;
  readonly temporalScope: Maybe<ReadonlyArray<Maybe<Scalars['Float']>>>;
  readonly text: Maybe<Scalars['String']>;
  readonly thesis: Maybe<Scalars['String']>;
  readonly thesisText: Maybe<Scalars['String']>;
  readonly thesisType: Maybe<Scalars['String']>;
  readonly thesisTypeLabel: Maybe<Scalars['String']>;
  readonly thumbs: Maybe<ReadonlyArray<Maybe<Image>>>;
  readonly tipoPrecedenteObrigatorio: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
  readonly topicSnippet: Maybe<Scalars['String']>;
  readonly topics: Maybe<DocumentTopicsConnection>;
  readonly type: Maybe<Scalars['String']>;
  readonly unidentifieds: Maybe<ReadonlyArray<Maybe<UnidentifiedDecisionPart>>>;
  readonly updatedDate: Maybe<Scalars['Float']>;
  readonly url: Maybe<Scalars['String']>;
  readonly viewStat: Maybe<Stat>;
  readonly viewerCanAccessFullDocument: Maybe<Scalars['Boolean']>;
  readonly viewerCanUseFeature: Maybe<Scalars['Boolean']>;
  readonly viewerDisliked: Maybe<Scalars['Boolean']>;
  readonly viewerLiked: Maybe<Scalars['Boolean']>;
  readonly viewerSaved: Maybe<Scalars['Boolean']>;
  readonly visibility: Maybe<Scalars['String']>;
  readonly votesAmount: Maybe<Scalars['Int']>;
  readonly wingmanDocumentGPTSummaryOnDocview: Maybe<WingmanDocumentGptSummaryOnDocview>;
};


export type DocumentCobertoSearchArgs = {
  query: Scalars['String'];
  threshold?: InputMaybe<Scalars['Float']>;
  topK?: InputMaybe<Scalars['Int']>;
};


export type DocumentCommentsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type DocumentDecisionFactsArgs = {
  disableHighlight: InputMaybe<Scalars['Boolean']>;
};


export type DocumentDecisionFilesArgs = {
  onlyCurrentType: InputMaybe<Scalars['Boolean']>;
};


export type DocumentDecisionHtmlArgs = {
  disableHighlight: InputMaybe<Scalars['Boolean']>;
};


export type DocumentDecisionTabsArgs = {
  includeEnrichContentByKeys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  includeProceduralActs?: InputMaybe<Scalars['Boolean']>;
};


export type DocumentDescriptionArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
  stripTags: InputMaybe<Scalars['Boolean']>;
};


export type DocumentDoctrineSectionTextArgs = {
  highlight: InputMaybe<Scalars['Boolean']>;
};


export type DocumentEnrichedContentArgs = {
  keys: ReadonlyArray<InputMaybe<Scalars['String']>>;
};


export type DocumentEnrichedContentsArgs = {
  keys: ReadonlyArray<InputMaybe<Scalars['String']>>;
};


export type DocumentInteiroTeorDocumentsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type DocumentJournalBlocksArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type DocumentJournalTextArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
  stripLineBreak: InputMaybe<Scalars['Boolean']>;
  stripTags: InputMaybe<Scalars['Boolean']>;
  unmaskCNJ: InputMaybe<Scalars['Boolean']>;
};


export type DocumentJurisprudencesLikeThisArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type DocumentLawItemsArgs = {
  end: InputMaybe<Scalars['Int']>;
  start: InputMaybe<Scalars['Int']>;
};


export type DocumentProfilesNegativeVoteArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type DocumentProfilesVoteArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type DocumentRecommendationsArgs = {
  artifactBooster: InputMaybe<Scalars['String']>;
  artifactFilter: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  limit: InputMaybe<Scalars['Int']>;
  page: InputMaybe<Scalars['Int']>;
  personaRerank: InputMaybe<Scalars['Boolean']>;
  recommenderId: Scalars['String'];
};


export type DocumentRelatedLegalUnderstandingArgs = {
  comment_search?: InputMaybe<Scalars['Boolean']>;
  court: InputMaybe<Scalars['String']>;
  filterByClassifier?: InputMaybe<Scalars['Boolean']>;
  filterByCurrentDocId?: InputMaybe<Scalars['Boolean']>;
  filter_author?: InputMaybe<Scalars['String']>;
  filter_doc_ids: InputMaybe<ReadonlyArray<Scalars['Int']>>;
  min_similarity?: InputMaybe<Scalars['Float']>;
  ner_filtering?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  segmentation_by_user_location?: InputMaybe<SegmentationMode>;
  semantic_cache_only?: InputMaybe<Scalars['Boolean']>;
  semantic_search?: InputMaybe<Scalars['Boolean']>;
  semantic_text_filtering?: InputMaybe<Scalars['Boolean']>;
  static_search?: InputMaybe<Scalars['Boolean']>;
  strict_search?: InputMaybe<Scalars['Boolean']>;
  text_search?: InputMaybe<Scalars['Boolean']>;
  text_search_msm?: InputMaybe<Scalars['Boolean']>;
};


export type DocumentSourceDocumentsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type DocumentSummaryPrecedentStatementArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
  stripTags: InputMaybe<Scalars['Boolean']>;
};


export type DocumentTextArgs = {
  highlight: InputMaybe<Scalars['Boolean']>;
  skipLimit: InputMaybe<Scalars['Boolean']>;
};


export type DocumentTopicSnippetArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
  tid: Scalars['Int'];
};


export type DocumentTopicsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filterCondition: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  type: InputMaybe<Scalars['String']>;
};


export type DocumentViewerCanUseFeatureArgs = {
  featureCode: InputMaybe<Scalars['String']>;
};

export type DocumentBatchInput = {
  readonly artifact: Scalars['String'];
  readonly docId: Scalars['NumericID'];
  readonly indexable: Scalars['Boolean'];
};

export type DocumentByCourt = {
  readonly __typename?: 'DocumentByCourt';
  readonly court: Maybe<Scalars['String']>;
  readonly total: Maybe<Scalars['Int']>;
};

export type DocumentByType = {
  readonly __typename?: 'DocumentByType';
  readonly total: Maybe<Scalars['Int']>;
  readonly type: Maybe<Scalars['String']>;
};

export type DocumentComment = {
  readonly __typename?: 'DocumentComment';
  readonly accessCondition: Scalars['String'];
  readonly date: Scalars['Float'];
  readonly documentId: Scalars['NumericID'];
  readonly id: Scalars['NumericID'];
  readonly parentCommentId: Maybe<Scalars['NumericID']>;
  readonly profile: Maybe<Profile>;
  readonly profileId: Scalars['NumericID'];
  readonly replies: ReadonlyArray<DocumentComment>;
  readonly review: Maybe<Review>;
  readonly text: Scalars['String'];
  readonly upVotes: Scalars['Int'];
  readonly viewerDownVoted: Scalars['Boolean'];
  readonly viewerUpVoted: Scalars['Boolean'];
};

export type DocumentCommentsConnection = {
  readonly __typename?: 'DocumentCommentsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<DocumentCommentsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type DocumentCommentsEdge = {
  readonly __typename?: 'DocumentCommentsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<DocumentComment>;
};

export type DocumentIdentifier = {
  readonly artifact: Scalars['String'];
  readonly docId: Scalars['NumericID'];
};

export type DocumentSearchSnippet = {
  readonly __typename?: 'DocumentSearchSnippet';
  readonly admissibilityDecision: Maybe<Scalars['Boolean']>;
  readonly artifact: Maybe<Scalars['String']>;
  readonly body: Maybe<Scalars['String']>;
  readonly cnjNumber: Maybe<CnjNumber>;
  readonly contact: Maybe<Contact>;
  readonly courtPublishingDate: Maybe<Scalars['Float']>;
  readonly courtSection: Maybe<CrmLawsuitRef>;
  readonly date: Maybe<Scalars['Float']>;
  readonly decision: Maybe<Scalars['String']>;
  readonly decisionFacts: Maybe<Scalars['String']>;
  readonly defaultBody: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
  readonly detectedEntityType: Maybe<Scalars['String']>;
  readonly distributionDate: Maybe<Scalars['Float']>;
  readonly docId: Maybe<Scalars['Int']>;
  readonly doctrine: Maybe<DoctrineSearchSnippet>;
  readonly document: Maybe<Document>;
  readonly explanation: Maybe<Scalars['String']>;
  readonly hasDecisionFacts: Maybe<Scalars['Boolean']>;
  readonly image: Maybe<Scalars['String']>;
  readonly indexedAllContent: Maybe<Scalars['String']>;
  readonly indexedHighlight: Maybe<Scalars['String']>;
  readonly indexedTitle: Maybe<Scalars['String']>;
  readonly isFollowedByViewer: Maybe<Scalars['Boolean']>;
  readonly journalBody: Maybe<Scalars['String']>;
  readonly jurisBody: Maybe<Scalars['String']>;
  readonly jurisGuidance: Maybe<JurisGuidanceSearchSnippent>;
  readonly lawsuit: Maybe<LawsuitSearchSnippet>;
  readonly legislationArticles: ReadonlyArray<DocumentSearchSnippet>;
  readonly mandatoryPrecedent: Maybe<Scalars['Boolean']>;
  readonly meritDecision: Maybe<Scalars['Boolean']>;
  readonly numFollowers: Maybe<Scalars['Int']>;
  readonly originalTitle: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
  readonly publisher: Maybe<Profile>;
  readonly score: Maybe<Scalars['Float']>;
  readonly shouldRedirectToSERP: Maybe<Scalars['Boolean']>;
  readonly slug: Maybe<Scalars['String']>;
  readonly subjectMatter: Maybe<Scalars['String']>;
  readonly subjectMatterNumber: Maybe<Scalars['String']>;
  readonly summaryPrecedent: Maybe<SummaryPrecedentSearchSnippet>;
  readonly synonym: Maybe<Scalars['String']>;
  readonly thesis: Maybe<Scalars['String']>;
  readonly thesisType: Maybe<Scalars['String']>;
  readonly thesisTypeLabel: Maybe<Scalars['String']>;
  readonly thumborImage: Maybe<ThumborImage>;
  readonly title: Maybe<Scalars['String']>;
  readonly topic: Maybe<Topic>;
  readonly topicSourceId: Maybe<Scalars['Int']>;
  readonly totalLawsuits: Maybe<Scalars['Int']>;
  readonly trialDate: Maybe<Scalars['Float']>;
  readonly url: Maybe<Scalars['String']>;
};


export type DocumentSearchSnippetBodyArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
};


export type DocumentSearchSnippetDecisionArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
};


export type DocumentSearchSnippetDefaultBodyArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
};


export type DocumentSearchSnippetJournalBodyArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
};


export type DocumentSearchSnippetJurisBodyArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
};

export type DocumentTopicsConnection = {
  readonly __typename?: 'DocumentTopicsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<DocumentTopicsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type DocumentTopicsEdge = {
  readonly __typename?: 'DocumentTopicsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Topic>;
};

export type DownloadPersonalDataInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type DownloadPersonalDataPayload = {
  readonly __typename?: 'DownloadPersonalDataPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly content: Maybe<Scalars['String']>;
  readonly filename: Maybe<Scalars['String']>;
};

export type EditCproOrganizationInput = {
  readonly active: Scalars['Boolean'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly digestoOpId?: InputMaybe<Scalars['Int']>;
  readonly embeddedReportUrl?: InputMaybe<Scalars['String']>;
  readonly minRevenue?: InputMaybe<Scalars['Float']>;
  readonly name: Scalars['String'];
  readonly organizationId: Scalars['String'];
};

export type EditCproOrganizationPayload = {
  readonly __typename?: 'EditCPROOrganizationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly organizationId: Maybe<Scalars['String']>;
  readonly saved: Scalars['Boolean'];
};

export type EditCrmActivityLogInput = {
  readonly activity: Scalars['JSON'];
  readonly activityId: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type EditCrmActivityLogPayload = {
  readonly __typename?: 'EditCRMActivityLogPayload';
  readonly activity: Maybe<CrmActivityLog>;
  readonly clientMutationId: Maybe<Scalars['String']>;
};

export type EditCrmCommentInput = {
  readonly changes: Scalars['JSON'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly commentId: Scalars['String'];
};

export type EditCrmCommentPayload = {
  readonly __typename?: 'EditCRMCommentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly comment: Maybe<CrmComment>;
};

export type EditCrmCourtCredentialInput = {
  readonly changes?: InputMaybe<Scalars['JSON']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly credentialId: Scalars['String'];
  readonly data: Scalars['JSON'];
};

export type EditCrmCourtCredentialPayload = {
  readonly __typename?: 'EditCRMCourtCredentialPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly credential: Maybe<CrmCourtCredential>;
};

export type EditCrmDocumentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly document: Scalars['JSON'];
  readonly documentId: Scalars['String'];
  readonly entityRefId?: InputMaybe<Scalars['String']>;
  readonly entityRefType?: InputMaybe<Scalars['String']>;
};

export type EditCrmDocumentPayload = {
  readonly __typename?: 'EditCRMDocumentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly document: Maybe<CrmDocument>;
  readonly documentEdge: Maybe<CrmEntityDocumentEdge>;
  readonly organization: Maybe<Organization>;
};

export type EditCrmEventInput = {
  readonly calendarId: Scalars['String'];
  readonly changes: Scalars['JSON'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly entityRefId?: InputMaybe<Scalars['String']>;
  readonly entityRefType?: InputMaybe<Scalars['String']>;
  readonly eventId: Scalars['String'];
};

export type EditCrmEventPayload = {
  readonly __typename?: 'EditCRMEventPayload';
  readonly calendar: Maybe<CrmCalendar>;
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly entity: Maybe<CrmEntity>;
  readonly event: Maybe<CrmEvent>;
  readonly eventEdge: Maybe<CrmEntityEventsEdge>;
  readonly legalCaseProfileInfo: Maybe<LegalCaseProfileInfo>;
  readonly organization: Maybe<Organization>;
  readonly originalEvent: Maybe<CrmEvent>;
};

export type EditCrmLawsuitActivityItemInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly itemId: Scalars['String'];
  readonly lawsuitActivityItem: Scalars['JSON'];
};

export type EditCrmLawsuitActivityItemPayload = {
  readonly __typename?: 'EditCRMLawsuitActivityItemPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuitActivityItem: Maybe<CrmLawsuitActivityItem>;
};

export type EditCrmLawsuitInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuit: Scalars['JSON'];
  readonly lawsuitId: Scalars['String'];
};

export type EditCrmLawsuitInteractionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
  readonly lawsuitInteraction: Scalars['JSON'];
};

export type EditCrmLawsuitInteractionPayload = {
  readonly __typename?: 'EditCRMLawsuitInteractionPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
};

export type EditCrmLawsuitPayload = {
  readonly __typename?: 'EditCRMLawsuitPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly crmEntity: Maybe<CrmEntity>;
  readonly lawsuit: Maybe<CrmLawsuit>;
  readonly lawsuitEdge: Maybe<OrganizationLawsuitsEdge>;
  readonly organization: Maybe<Organization>;
};

export type EditCrmLawsuitPersonInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly contact?: InputMaybe<Scalars['JSON']>;
  readonly lawsuitId: Scalars['String'];
  readonly person?: InputMaybe<Scalars['JSON']>;
  readonly personRefContactId: Scalars['String'];
  readonly personRefId: Scalars['String'];
  readonly personRefType: Scalars['String'];
};

export type EditCrmLawsuitPersonPayload = {
  readonly __typename?: 'EditCRMLawsuitPersonPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
};

export type EditCrmPublicationItemInput = {
  readonly changes: Scalars['JSON'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly itemId: Scalars['String'];
};

export type EditCrmPublicationItemPayload = {
  readonly __typename?: 'EditCRMPublicationItemPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly item: Maybe<CrmPublicationItem>;
  readonly organization: Maybe<Organization>;
};

export type EditCrmTagInput = {
  readonly changes: Scalars['JSON'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly tagId: Scalars['String'];
};

export type EditCrmTagPayload = {
  readonly __typename?: 'EditCRMTagPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
  readonly tag: Maybe<CrmTag>;
};

export type EditCrmTaskInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly task: Scalars['JSON'];
  readonly taskId: Scalars['String'];
};

export type EditCrmTaskPayload = {
  readonly __typename?: 'EditCRMTaskPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly task: Maybe<CrmTask>;
};

export type EditCrmTimelineItemInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly item: Scalars['JSON'];
  readonly itemId: Scalars['String'];
};

export type EditCrmTimelineItemPayload = {
  readonly __typename?: 'EditCRMTimelineItemPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly item: Maybe<CrmTimelineItem>;
};

export type EditConversationInput = {
  readonly changes?: InputMaybe<Scalars['JSON']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly conversationId?: InputMaybe<Scalars['Float']>;
};

export type EditConversationPayload = {
  readonly __typename?: 'EditConversationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly conversation: Maybe<Conversation>;
};

export type EditHistory = Node & {
  readonly __typename?: 'EditHistory';
  readonly action: Maybe<Scalars['String']>;
  readonly author: Maybe<Profile>;
  readonly date: Maybe<Scalars['Float']>;
  readonly document: Maybe<Document>;
  readonly historyId: Maybe<Scalars['String']>;
  readonly historyReverser: Maybe<EditHistory>;
  readonly id: Scalars['ID'];
  readonly isAutomatic: Maybe<Scalars['Boolean']>;
  readonly isReversible: Maybe<Scalars['Boolean']>;
  readonly profile: Maybe<Profile>;
  readonly properties: Maybe<Scalars['JSON']>;
  readonly relatedTopic: Maybe<Topic>;
  readonly topic: Maybe<Topic>;
  readonly wasReverted: Maybe<Scalars['Boolean']>;
};

export type EditLawsuitSearchInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitSearch: Scalars['JSON'];
  readonly lawsuitSearchId: Scalars['String'];
};

export type EditLawsuitSearchPayload = {
  readonly __typename?: 'EditLawsuitSearchPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuitSearch: Maybe<CrmLawsuitSearch>;
  readonly organization: Maybe<Organization>;
};

export type EditLawsuitServiceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuit: Scalars['JSON'];
  readonly lawsuitId: Scalars['String'];
};

export type EditLawsuitServicePayload = {
  readonly __typename?: 'EditLawsuitServicePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
  readonly organization: Maybe<Organization>;
};

export type EditOrganizationInput = {
  readonly changes?: InputMaybe<Scalars['JSON']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type EditOrganizationMemberInput = {
  readonly changes?: InputMaybe<Scalars['JSON']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly memberId: Scalars['Int'];
  readonly organizationId?: InputMaybe<Scalars['Int']>;
};

export type EditOrganizationMemberPayload = {
  readonly __typename?: 'EditOrganizationMemberPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly member: Maybe<OrganizationMember>;
};

export type EditOrganizationPayload = {
  readonly __typename?: 'EditOrganizationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly legalCaseProfileInfo: Maybe<LegalCaseProfileInfo>;
  readonly organization: Maybe<Organization>;
};

export type EditOrganizationProfileInput = {
  readonly changes?: InputMaybe<Scalars['JSON']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type EditOrganizationProfilePayload = {
  readonly __typename?: 'EditOrganizationProfilePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
  readonly profile: Maybe<Profile>;
};

export type EditProfileAddressInput = {
  readonly action: Scalars['String'];
  readonly address?: InputMaybe<Scalars['String']>;
  readonly addressId?: InputMaybe<Scalars['Float']>;
  readonly cityId?: InputMaybe<Scalars['Float']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly zipCode?: InputMaybe<Scalars['String']>;
};

export type EditProfileAddressPayload = {
  readonly __typename?: 'EditProfileAddressPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type EditProfileBooksInput = {
  readonly action: Scalars['String'];
  readonly bookId?: InputMaybe<Scalars['Float']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cover?: InputMaybe<Scalars['String']>;
  readonly description?: InputMaybe<Scalars['String']>;
  readonly link?: InputMaybe<Scalars['String']>;
  readonly title?: InputMaybe<Scalars['String']>;
};

export type EditProfileBooksPayload = {
  readonly __typename?: 'EditProfileBooksPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type EditProfileInfoInput = {
  readonly changes?: InputMaybe<Scalars['JSON']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type EditProfileInfoPayload = {
  readonly __typename?: 'EditProfileInfoPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type EditProfileInput = {
  readonly changes?: InputMaybe<Scalars['JSON']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly pid?: InputMaybe<Scalars['Int']>;
};

export type EditProfilePayload = {
  readonly __typename?: 'EditProfilePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type EditProfilePhoneInput = {
  readonly action: Scalars['String'];
  readonly area?: InputMaybe<Scalars['String']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly origin?: InputMaybe<Scalars['String']>;
  readonly phone?: InputMaybe<Scalars['String']>;
  readonly phoneId?: InputMaybe<Scalars['Float']>;
  readonly sendNumberRegistrationWhatsappMessage?: InputMaybe<Scalars['Boolean']>;
};

export type EditProfilePhonePayload = {
  readonly __typename?: 'EditProfilePhonePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type EditPublicationAlertItemInput = {
  readonly changes: Scalars['JSON'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly documentArtifact: Scalars['String'];
  readonly documentId: Scalars['Int'];
  readonly entityRefId?: InputMaybe<Scalars['String']>;
  readonly entityRefType?: InputMaybe<Scalars['String']>;
};

export type EditPublicationAlertItemPayload = {
  readonly __typename?: 'EditPublicationAlertItemPayload';
  readonly alertItem: Maybe<PublicationAlertItem>;
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
};

export type EditPublicationMonitoringInput = {
  readonly alertId: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly payload: Scalars['JSON'];
};

export type EditPublicationMonitoringPayload = {
  readonly __typename?: 'EditPublicationMonitoringPayload';
  readonly alert: Maybe<PublicationAlert>;
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
};

export type EditSmartLinkInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly payload: SmartLinkEditInput;
};

export type EditSmartLinkPayload = {
  readonly __typename?: 'EditSmartLinkPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly smartLink: Maybe<SmartLink>;
};

export type EditSubscriptionInput = {
  readonly autoRenew?: InputMaybe<Scalars['Boolean']>;
  readonly autoRenewNextPlanId?: InputMaybe<Scalars['Int']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly subscriptionId: Scalars['Int'];
};

export type EditSubscriptionPayload = {
  readonly __typename?: 'EditSubscriptionPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type EditTextDocumentInput = {
  readonly artifact: Scalars['String'];
  readonly authorTextSummary?: InputMaybe<Scalars['String']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId: Scalars['NumericID'];
  readonly isAIGenerated?: InputMaybe<Scalars['Boolean']>;
  readonly parentDocArtifact?: InputMaybe<Scalars['String']>;
  readonly parentDocId?: InputMaybe<Scalars['NumericID']>;
  readonly subtitle?: InputMaybe<Scalars['String']>;
  readonly text?: InputMaybe<Scalars['String']>;
  readonly title?: InputMaybe<Scalars['String']>;
  readonly typeSegmentation?: InputMaybe<Scalars['String']>;
};

export type EditTextDocumentPayload = {
  readonly __typename?: 'EditTextDocumentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly document: Maybe<Document>;
};

export type EditTopicInput = {
  readonly changes?: InputMaybe<Scalars['JSON']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly tid: Scalars['Int'];
};

export type EditTopicPayload = {
  readonly __typename?: 'EditTopicPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly topic: Maybe<Topic>;
};

export type EditUserAdminLevelInput = {
  readonly action: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly uid: Scalars['Int'];
};

export type EditUserAdminLevelPayload = {
  readonly __typename?: 'EditUserAdminLevelPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly user: Maybe<User>;
};

export type EditUserInput = {
  readonly changes?: InputMaybe<Scalars['JSON']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly uid?: InputMaybe<Scalars['Int']>;
};

export type EditUserPayload = {
  readonly __typename?: 'EditUserPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly user: Maybe<User>;
};

export type EditableFeatures = {
  readonly constraints?: InputMaybe<ReadonlyArray<InputMaybe<FeatureConstraintsType>>>;
  readonly featureCode?: InputMaybe<Scalars['String']>;
  readonly freeAmountTriggers?: InputMaybe<ReadonlyArray<InputMaybe<FreeAmountTriggersType>>>;
  readonly options?: InputMaybe<ReadonlyArray<InputMaybe<OptionsType>>>;
  readonly priority?: InputMaybe<Scalars['String']>;
};

export enum EmailNotificationPreferenceFlowType {
  EmailCourtHearing = 'email_court_hearing',
  EmailJusIaEvents = 'email_jus_ia_events',
  EmailLawsuitDecisions = 'email_lawsuit_decisions',
  EmailNewLawsuitForCpf = 'email_new_lawsuit_for_cpf'
}

export type EmailNotificationTypeInfo = {
  readonly __typename?: 'EmailNotificationTypeInfo';
  readonly description: Scalars['String'];
  readonly enabled: Maybe<Scalars['Boolean']>;
  readonly title: Scalars['String'];
  readonly type: Maybe<EmailNotificationPreferenceFlowType>;
};

export type EmecLawInstitution = {
  readonly __typename?: 'EmecLawInstitution';
  readonly nome: Scalars['String'];
  readonly sigla: Maybe<Scalars['String']>;
};

export type EndErpBetaInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type EndErpBetaPayload = {
  readonly __typename?: 'EndERPBetaPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
  readonly profile: Maybe<Profile>;
};

export type EnrichedContents = {
  readonly __typename?: 'EnrichedContents';
  readonly artefato: Maybe<Scalars['String']>;
  readonly dataAtualizacao: Maybe<Scalars['String']>;
  readonly dataCriacao: Maybe<Scalars['String']>;
  readonly idDocumento: Maybe<Scalars['Int']>;
  readonly metadata: Maybe<Scalars['JSON']>;
  readonly payload: Maybe<Scalars['JSON']>;
  readonly status: Maybe<Scalars['String']>;
  readonly tipo: Maybe<Scalars['String']>;
};

export type EntityAggregatedCounter = {
  readonly __typename?: 'EntityAggregatedCounter';
  readonly counter: Maybe<Scalars['Int']>;
  readonly value: Maybe<Scalars['String']>;
};

export type EntityAggregatedCounterWithState = {
  readonly __typename?: 'EntityAggregatedCounterWithState';
  readonly counter: Maybe<Scalars['Int']>;
  readonly state: Maybe<Scalars['String']>;
  readonly value: Maybe<Scalars['String']>;
};

export type EntityCandidacyAutocomplete = {
  readonly __typename?: 'EntityCandidacyAutocomplete';
  readonly candidacies: ReadonlyArray<EntityCandidacyAutocompleteItem>;
  readonly hits: Maybe<Scalars['Int']>;
};

export type EntityCandidacyAutocompleteItem = {
  readonly __typename?: 'EntityCandidacyAutocompleteItem';
  readonly ballotName: Maybe<Scalars['String']>;
  readonly ballotNumber: Maybe<Scalars['String']>;
  readonly candidacyType: Maybe<Scalars['String']>;
  readonly electionYear: Maybe<Scalars['String']>;
  readonly electoralDistrictUf: Maybe<Scalars['String']>;
  readonly entityId: Maybe<Scalars['String']>;
  readonly id: Maybe<Scalars['String']>;
  readonly partyInitials: Maybe<Scalars['String']>;
  readonly tseId: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
};

export type EntityCompany = Node & {
  readonly __typename?: 'EntityCompany';
  readonly activityStartDate: Maybe<Scalars['String']>;
  readonly age: Maybe<Scalars['Int']>;
  readonly canUseFeature: Maybe<Scalars['Boolean']>;
  readonly canUseThirdPartySearchFeature: Maybe<Scalars['Boolean']>;
  readonly city: Maybe<Scalars['String']>;
  readonly cnaeCode: Maybe<Scalars['String']>;
  readonly cnaeDescription: Maybe<Scalars['String']>;
  readonly cnaeSecondaryFiscalCodes: Maybe<Scalars['JSON']>;
  readonly cnpj: Maybe<Scalars['String']>;
  readonly companyId: Maybe<Scalars['String']>;
  readonly companySize: Maybe<Scalars['String']>;
  readonly companyType: Maybe<Scalars['String']>;
  readonly complement: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly district: Maybe<Scalars['String']>;
  readonly email: Maybe<Scalars['String']>;
  readonly entityId: Maybe<Scalars['String']>;
  readonly fantasyName: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly lawsuitCases: Maybe<EntityCompanyLawsuitCasesConnection>;
  readonly lawsuits: Maybe<EntityCompanyLawsuitsConnection>;
  readonly lawsuitsAggregations: Maybe<EntityLawsuitsAggregations>;
  readonly lawsuitsCollectedAt: Maybe<Scalars['Float']>;
  readonly lawsuitsWithoutEntity: Maybe<EntityCompanyLawsuitsByNameConnection>;
  readonly name: Maybe<Scalars['String']>;
  readonly natureCode: Maybe<Scalars['String']>;
  readonly natureDescription: Maybe<Scalars['String']>;
  readonly partnerships: Maybe<EntityCompanyPartnershipsConnection>;
  readonly phoneNumber1: Maybe<Scalars['String']>;
  readonly phoneNumber2: Maybe<Scalars['String']>;
  readonly registrationStatus: Maybe<Scalars['String']>;
  readonly relationships: Maybe<EntityGraphRelationships>;
  readonly shareCapital: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly streetName: Maybe<Scalars['String']>;
  readonly streetNumber: Maybe<Scalars['String']>;
  readonly streetType: Maybe<Scalars['String']>;
  readonly summarization: Maybe<CrmEntitySummarization>;
  readonly timeSinceStart: Maybe<Scalars['String']>;
  readonly uf: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
  readonly usedResourcesByFeatureCode: Maybe<ReadonlyArray<Maybe<UsedResource>>>;
  readonly zipCode: Maybe<Scalars['String']>;
};


export type EntityCompanyCanUseFeatureArgs = {
  featureCode: Scalars['String'];
};


export type EntityCompanyLawsuitCasesArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  poles: InputMaybe<ReadonlyArray<InputMaybe<PersonIdPoleType>>>;
};


export type EntityCompanyLawsuitsArgs = {
  after: InputMaybe<Scalars['String']>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  entityConfidence?: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  onlyWithPole: InputMaybe<Scalars['Boolean']>;
  pole: InputMaybe<PersonIdPoleType>;
  poles: InputMaybe<ReadonlyArray<InputMaybe<PersonIdPoleType>>>;
  showRestrictedLawsuit?: InputMaybe<Scalars['Boolean']>;
};


export type EntityCompanyLawsuitsWithoutEntityArgs = {
  after: InputMaybe<Scalars['String']>;
  filters: InputMaybe<LawsuitsFilterInput>;
  first: InputMaybe<Scalars['Int']>;
};


export type EntityCompanyPartnershipsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type EntityCompanyRelationshipsArgs = {
  relations: InputMaybe<ReadonlyArray<InputMaybe<EntityRelationshipType>>>;
};


export type EntityCompanyUsedResourcesByFeatureCodeArgs = {
  featureCode: Scalars['String'];
  limit: InputMaybe<Scalars['Int']>;
};

export type EntityCompanyLawsuitCasesConnection = {
  readonly __typename?: 'EntityCompanyLawsuitCasesConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<EntityCompanyLawsuitCasesEdge>>>;
  readonly pageInfo: PageInfo;
};

export type EntityCompanyLawsuitCasesEdge = {
  readonly __typename?: 'EntityCompanyLawsuitCasesEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<LawsuitCaseEntityRef>;
};

export type EntityCompanyLawsuitsByNameConnection = {
  readonly __typename?: 'EntityCompanyLawsuitsByNameConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<EntityCompanyLawsuitsByNameEdge>>>;
  readonly pageInfo: PageInfo;
};

export type EntityCompanyLawsuitsByNameEdge = {
  readonly __typename?: 'EntityCompanyLawsuitsByNameEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmLawsuit>;
};

export type EntityCompanyLawsuitsConnection = {
  readonly __typename?: 'EntityCompanyLawsuitsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<EntityCompanyLawsuitsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type EntityCompanyLawsuitsEdge = {
  readonly __typename?: 'EntityCompanyLawsuitsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmLawsuit>;
};

export type EntityCompanyPartnershipsConnection = {
  readonly __typename?: 'EntityCompanyPartnershipsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<EntityCompanyPartnershipsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type EntityCompanyPartnershipsEdge = {
  readonly __typename?: 'EntityCompanyPartnershipsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<EntityRelationshipNode>;
};

export type EntityFollowersConnection = {
  readonly __typename?: 'EntityFollowersConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<EntityFollowersEdge>>>;
  readonly pageInfo: PageInfo;
};

export type EntityFollowersEdge = {
  readonly __typename?: 'EntityFollowersEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Profile>;
};

export type EntityGraphRelationshipEdge = {
  readonly __typename?: 'EntityGraphRelationshipEdge';
  readonly sourceId: Maybe<Scalars['String']>;
  readonly targetId: Maybe<Scalars['String']>;
  readonly type: Maybe<Scalars['String']>;
};

export type EntityGraphRelationshipNode = {
  readonly __typename?: 'EntityGraphRelationshipNode';
  readonly properties: Maybe<EntityRelationshipNode>;
  readonly type: Maybe<Scalars['String']>;
};

export type EntityGraphRelationships = {
  readonly __typename?: 'EntityGraphRelationships';
  readonly edges: Maybe<ReadonlyArray<Maybe<EntityGraphRelationshipEdge>>>;
  readonly nodes: Maybe<ReadonlyArray<Maybe<EntityGraphRelationshipNode>>>;
};

export type EntityLawsuitsAggregations = {
  readonly __typename?: 'EntityLawsuitsAggregations';
  readonly counterByCasePole: Maybe<ReadonlyArray<Maybe<EntityAggregatedCounter>>>;
  readonly counterByCourt: Maybe<ReadonlyArray<Maybe<EntityAggregatedCounter>>>;
  readonly counterByPole: Maybe<ReadonlyArray<Maybe<EntityAggregatedCounter>>>;
  readonly counterByState: Maybe<ReadonlyArray<Maybe<EntityAggregatedCounterWithState>>>;
  readonly totalCases: Maybe<Scalars['Int']>;
  readonly totalLawsuits: Maybe<Scalars['Int']>;
};

export type EntityPersistedAggregations = {
  readonly __typename?: 'EntityPersistedAggregations';
  readonly counterByCasePole: Maybe<ReadonlyArray<Maybe<EntityAggregatedCounter>>>;
  readonly counterByCourt: Maybe<ReadonlyArray<Maybe<EntityAggregatedCounter>>>;
  readonly counterByPole: Maybe<ReadonlyArray<Maybe<EntityAggregatedCounter>>>;
  readonly counterByState: Maybe<ReadonlyArray<Maybe<EntityAggregatedCounterWithState>>>;
  readonly totalCases: Maybe<Scalars['Int']>;
  readonly totalLawsuits: Maybe<Scalars['Int']>;
};

export type EntityPerson = Node & {
  readonly __typename?: 'EntityPerson';
  readonly age: Maybe<Scalars['String']>;
  readonly birthDate: Maybe<Scalars['String']>;
  readonly canUseFeature: Maybe<Scalars['Boolean']>;
  readonly canUseThirdPartySearchFeature: Maybe<Scalars['Boolean']>;
  readonly cpf: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly displayName: Maybe<Scalars['String']>;
  readonly entityId: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly isMonitoringCPF: Maybe<Scalars['Boolean']>;
  readonly isViewerCPF: Maybe<Scalars['Boolean']>;
  readonly lawsuitCases: Maybe<EntityPersonLawsuitCasesConnection>;
  readonly lawsuits: Maybe<EntityPersonLawsuitsConnection>;
  readonly lawsuitsAggregations: Maybe<EntityLawsuitsAggregations>;
  readonly lawsuitsCollectedAt: Maybe<Scalars['Float']>;
  readonly lawsuitsWithoutEntity: Maybe<EntityPersonLawsuitsByNameConnection>;
  readonly motherName: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly personId: Maybe<Scalars['String']>;
  readonly relatedCandidacies: Maybe<ReadonlyArray<Maybe<Candidacy>>>;
  readonly relatedCompanies: Maybe<RelatedCompaniesConnection>;
  readonly relationships: Maybe<EntityGraphRelationships>;
  readonly socialName: Maybe<Scalars['String']>;
  readonly state: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly summarization: Maybe<CrmEntitySummarization>;
  readonly uf: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
  readonly usedResourcesByFeatureCode: Maybe<ReadonlyArray<Maybe<UsedResource>>>;
};


export type EntityPersonCanUseFeatureArgs = {
  featureCode: Scalars['String'];
};


export type EntityPersonCpfArgs = {
  locked?: InputMaybe<Scalars['Boolean']>;
};


export type EntityPersonDisplayNameArgs = {
  mode?: InputMaybe<EntityPersonNameMode>;
};


export type EntityPersonLawsuitCasesArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  poles: InputMaybe<ReadonlyArray<InputMaybe<PersonIdPoleType>>>;
};


export type EntityPersonLawsuitsArgs = {
  after: InputMaybe<Scalars['String']>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  entityConfidence?: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  onlyWithPole: InputMaybe<Scalars['Boolean']>;
  pole: InputMaybe<PersonIdPoleType>;
  poles: InputMaybe<ReadonlyArray<InputMaybe<PersonIdPoleType>>>;
  showRestrictedLawsuit?: InputMaybe<Scalars['Boolean']>;
};


export type EntityPersonLawsuitsWithoutEntityArgs = {
  after: InputMaybe<Scalars['String']>;
  filterByCpf: InputMaybe<Scalars['Boolean']>;
  filters: InputMaybe<LawsuitsFilterInput>;
  first: InputMaybe<Scalars['Int']>;
};


export type EntityPersonNameArgs = {
  mode?: InputMaybe<EntityPersonNameMode>;
};


export type EntityPersonRelatedCandidaciesArgs = {
  cursor: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
};


export type EntityPersonRelatedCompaniesArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type EntityPersonRelationshipsArgs = {
  relations: InputMaybe<ReadonlyArray<InputMaybe<EntityRelationshipType>>>;
};


export type EntityPersonSocialNameArgs = {
  mode?: InputMaybe<EntityPersonNameMode>;
};


export type EntityPersonUsedResourcesByFeatureCodeArgs = {
  featureCode: Scalars['String'];
  limit: InputMaybe<Scalars['Int']>;
};

export type EntityPersonLawsuitCasesConnection = {
  readonly __typename?: 'EntityPersonLawsuitCasesConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<EntityPersonLawsuitCasesEdge>>>;
  readonly pageInfo: PageInfo;
};

export type EntityPersonLawsuitCasesEdge = {
  readonly __typename?: 'EntityPersonLawsuitCasesEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<LawsuitCaseEntityRef>;
};

export type EntityPersonLawsuitsByNameConnection = {
  readonly __typename?: 'EntityPersonLawsuitsByNameConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<EntityPersonLawsuitsByNameEdge>>>;
  readonly pageInfo: PageInfo;
};

export type EntityPersonLawsuitsByNameEdge = {
  readonly __typename?: 'EntityPersonLawsuitsByNameEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmLawsuit>;
};

export type EntityPersonLawsuitsConnection = {
  readonly __typename?: 'EntityPersonLawsuitsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<EntityPersonLawsuitsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type EntityPersonLawsuitsEdge = {
  readonly __typename?: 'EntityPersonLawsuitsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmLawsuit>;
};

export enum EntityPersonNameMode {
  Full = 'FULL',
  Locked = 'LOCKED',
  Partial = 'PARTIAL'
}

export type EntityQueryView = {
  readonly __typename?: 'EntityQueryView';
  readonly entityId: Maybe<Scalars['String']>;
  readonly entityMatch: Maybe<Scalars['Boolean']>;
  readonly firstView: Maybe<Scalars['Float']>;
  readonly lastView: Maybe<Scalars['Float']>;
  readonly orgId: Maybe<Scalars['String']>;
  readonly query: Maybe<Scalars['String']>;
  readonly queryBase64: Maybe<Scalars['String']>;
  readonly viewsCount: Maybe<Scalars['Int']>;
};

export type EntityRelationshipNode = Candidacy | EntityCompany | EntityPerson;

export enum EntityRelationshipType {
  Controls = 'CONTROLS',
  HasStakeIn = 'HAS_STAKE_IN',
  OperatesAs = 'OPERATES_AS',
  RanAs = 'RAN_AS'
}

export type EntityRelationshipsConnection = {
  readonly __typename?: 'EntityRelationshipsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<EntityRelationshipsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type EntityRelationshipsEdge = {
  readonly __typename?: 'EntityRelationshipsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<VisionRelation>;
};

export enum EntityType {
  Documento = 'DOCUMENTO',
  Outro = 'OUTRO',
  PedidoRemocao = 'PEDIDO_REMOCAO',
  Perfil = 'PERFIL',
  Processo = 'PROCESSO',
  Topico = 'TOPICO',
  Usuario = 'USUARIO'
}

export type Event = {
  readonly __typename?: 'Event';
  readonly context: Maybe<Scalars['JSON']>;
  readonly eventId: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
  readonly tags: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly timestamp: Maybe<Scalars['Float']>;
};

export enum EventFilterType {
  Deadline = 'DEADLINE',
  Hearing = 'HEARING',
  Meeting = 'MEETING',
  Reminder = 'REMINDER'
}

export type Experiment = {
  readonly __typename?: 'Experiment';
  readonly alternative: Maybe<Alternative>;
  readonly apiResponseStatus: Maybe<Scalars['String']>;
  readonly clientId: Maybe<Scalars['String']>;
  readonly experimentGroup: Maybe<ExperimentGroup>;
  readonly name: Maybe<Scalars['String']>;
  readonly participating: Maybe<Scalars['Boolean']>;
  readonly simulated: Maybe<Scalars['Boolean']>;
};

export type ExperimentGroup = {
  readonly __typename?: 'ExperimentGroup';
  readonly name: Maybe<Scalars['String']>;
};

export type ExpertiseInfo = {
  readonly __typename?: 'ExpertiseInfo';
  readonly description: Maybe<Scalars['String']>;
  readonly frequency: Maybe<Scalars['Int']>;
  readonly tid: Maybe<Scalars['Int']>;
};

export type ExpireResourcesByParentIdInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly parentResourceId: Scalars['String'];
};

export type ExpireResourcesByParentIdPayload = {
  readonly __typename?: 'ExpireResourcesByParentIdPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
  readonly totalExpired: Maybe<Scalars['Int']>;
};

export type ExposedContent = {
  readonly __typename?: 'ExposedContent';
  readonly createdAt: Scalars['String'];
  readonly exposedContentId: Scalars['String'];
  readonly exposedData: Maybe<ExposedData>;
  readonly reportId: Scalars['String'];
  readonly sourceId: Scalars['String'];
  readonly sourceType: Scalars['String'];
  readonly updatedAt: Scalars['String'];
};

export type ExposedData = {
  readonly __typename?: 'ExposedData';
  readonly matches: Maybe<ReadonlyArray<Maybe<Match>>>;
};

export type ExtractCnjInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly fileName?: InputMaybe<Scalars['String']>;
};

export type ExtractCnjPayload = {
  readonly __typename?: 'ExtractCnjPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly cnjNumbers: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
};

export type FacebookAccountAssociationInput = {
  readonly accessToken: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly confirmAnonymUser?: InputMaybe<Scalars['Boolean']>;
};

export type FacebookAccountAssociationPayload = {
  readonly __typename?: 'FacebookAccountAssociationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly cookie: Maybe<Scalars['String']>;
};

export type FacebookLoginInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly fbId?: InputMaybe<Scalars['String']>;
  readonly token: Scalars['String'];
};

export type FacebookLoginPayload = {
  readonly __typename?: 'FacebookLoginPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly cookie: Maybe<Scalars['String']>;
  readonly user: Maybe<User>;
};

export type FavoriteCrmEntityInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly entityRefId: Scalars['String'];
  readonly entityRefType: Scalars['String'];
};

export type FavoriteCrmEntityPayload = {
  readonly __typename?: 'FavoriteCRMEntityPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly entity: Maybe<CrmEntity>;
};

export enum FcmTokenAppKindType {
  Browser = 'BROWSER',
  Native = 'NATIVE',
  Pwa = 'PWA'
}

export enum FcmTokenPlatformType {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type Feature = {
  readonly __typename?: 'Feature';
  readonly code: Maybe<Scalars['String']>;
  readonly constraints: Maybe<Scalars['JSON']>;
  readonly iconName: Maybe<Scalars['String']>;
  readonly labelInfo: Maybe<FeatureLabelInfo>;
};

export type FeatureConstraintsType = {
  readonly constraintCode?: InputMaybe<Scalars['String']>;
  readonly constraintType?: InputMaybe<Scalars['String']>;
  readonly description?: InputMaybe<Scalars['String']>;
  readonly limit?: InputMaybe<Scalars['Int']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly periodUntilExpire?: InputMaybe<Scalars['Int']>;
  readonly renewSeconds?: InputMaybe<Scalars['Int']>;
  readonly visibility?: InputMaybe<Scalars['String']>;
};

export type FeatureInfoType = {
  readonly __typename?: 'FeatureInfoType';
  readonly basePrice: Maybe<Scalars['Float']>;
  readonly discount: Maybe<Scalars['Float']>;
  readonly limit: Maybe<Scalars['Int']>;
  readonly price: Maybe<Scalars['Float']>;
  readonly pricePerInstallments: Maybe<Scalars['Float']>;
  readonly unitPrice: Maybe<Scalars['Float']>;
  readonly unitPricePerInstallments: Maybe<Scalars['Float']>;
};

export type FeatureLabelInfo = {
  readonly __typename?: 'FeatureLabelInfo';
  readonly plural: Maybe<Scalars['String']>;
  readonly singular: Maybe<Scalars['String']>;
};

export type FeaturePrice = {
  readonly __typename?: 'FeaturePrice';
  readonly discount: Maybe<Scalars['Float']>;
  readonly price: Maybe<Scalars['Float']>;
};

export type FeatureTask = {
  readonly __typename?: 'FeatureTask';
  readonly approvedAt: Maybe<Scalars['String']>;
  readonly approvedBy: Maybe<Scalars['String']>;
  readonly boxFeatureTaskId: Maybe<Scalars['Int']>;
  readonly cancelledAt: Maybe<Scalars['String']>;
  readonly cancelledBy: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly dryRun: Maybe<Scalars['Boolean']>;
  readonly featureCode: Maybe<Scalars['String']>;
  readonly featureDefinition: Maybe<Scalars['JSON']>;
  readonly id: Maybe<Scalars['String']>;
  readonly impactPreviewFeatures: Maybe<Scalars['Int']>;
  readonly impactPreviewGeneratedAt: Maybe<Scalars['String']>;
  readonly impactPreviewPlans: Maybe<Scalars['Int']>;
  readonly impactPreviewSubscriptions: Maybe<Scalars['Int']>;
  readonly impactPreviewTemplates: Maybe<Scalars['Int']>;
  readonly operation: Maybe<FeatureTaskOperation>;
  readonly owner: Maybe<Scalars['String']>;
  readonly pausedAt: Maybe<Scalars['String']>;
  readonly pausedBy: Maybe<Scalars['String']>;
  readonly planCriteriaMust: Maybe<Scalars['String']>;
  readonly planCriterias: Maybe<Scalars['JSON']>;
  readonly planTemplateCriteriaMust: Maybe<Scalars['String']>;
  readonly planTemplateCriterias: Maybe<Scalars['JSON']>;
  readonly reason: Maybe<Scalars['String']>;
  readonly rejectedAt: Maybe<Scalars['String']>;
  readonly rejectedBy: Maybe<Scalars['String']>;
  readonly rejectionReason: Maybe<Scalars['String']>;
  readonly resultFeaturesProcessed: Maybe<Scalars['Int']>;
  readonly resultFinishedAt: Maybe<Scalars['String']>;
  readonly resultPlansProcessed: Maybe<Scalars['Int']>;
  readonly resultStartedAt: Maybe<Scalars['String']>;
  readonly resultSubscriptionsProcessed: Maybe<Scalars['Int']>;
  readonly resultTemplatesProcessed: Maybe<Scalars['Int']>;
  readonly status: Maybe<FeatureTaskStatus>;
  readonly updatedAt: Maybe<Scalars['String']>;
};

export type FeatureTaskList = {
  readonly __typename?: 'FeatureTaskList';
  readonly data: ReadonlyArray<FeatureTask>;
  readonly limit: Scalars['Int'];
  readonly offset: Scalars['Int'];
  readonly total: Scalars['Int'];
};

export enum FeatureTaskOperation {
  AddFeature = 'ADD_FEATURE',
  EditFeature = 'EDIT_FEATURE',
  RemoveFeature = 'REMOVE_FEATURE'
}

export enum FeatureTaskStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Finished = 'FINISHED',
  IdentifyingImpact = 'IDENTIFYING_IMPACT',
  Paused = 'PAUSED',
  PendingReview = 'PENDING_REVIEW',
  Rejected = 'REJECTED',
  Running = 'RUNNING'
}

export type FeatureTokenConstraintInput = {
  readonly constraintType: Scalars['String'];
  readonly limit: Scalars['Int'];
};

export type FeatureTokenInput = {
  readonly active: Scalars['Boolean'];
  readonly constraint?: InputMaybe<FeatureTokenConstraintInput>;
  readonly featureCode: Scalars['String'];
};

export type FeatureTokenLimitsInputType = {
  readonly organization_users: Scalars['Int'];
};

export type FeatureTokens = {
  readonly __typename?: 'FeatureTokens';
  readonly constraintType: Maybe<Scalars['String']>;
  readonly creditsToExpire: Maybe<ReadonlyArray<Maybe<TokenExpireInfo>>>;
  readonly expireAt: Maybe<Scalars['Float']>;
  readonly limit: Maybe<Scalars['Int']>;
  readonly nextRenew: Maybe<Scalars['Float']>;
  readonly renewAmount: Maybe<Scalars['Int']>;
  readonly used: Maybe<Scalars['Int']>;
};

export enum FeatureType {
  Boolean = 'boolean',
  Quota = 'quota'
}

export type Features = {
  readonly __typename?: 'Features';
  readonly allowed: Maybe<ReadonlyArray<Maybe<TokenStat>>>;
  readonly blocked: Maybe<ReadonlyArray<Maybe<TokenStat>>>;
};

export type FeaturesInfoType = {
  readonly __typename?: 'FeaturesInfoType';
  readonly abnt_quote_doctrine: Maybe<FeatureInfoType>;
  readonly copy_doctrine_content: Maybe<FeatureInfoType>;
  readonly doctrine_users: Maybe<FeatureInfoType>;
  readonly eo_leads_answer: Maybe<FeatureInfoType>;
  readonly home_doctrine: Maybe<FeatureInfoType>;
  readonly home_faq_doctrine: Maybe<FeatureInfoType>;
  readonly landing_doctrine: Maybe<FeatureInfoType>;
  readonly leads_answer: Maybe<FeatureInfoType>;
  readonly monitor_lawsuit: Maybe<FeatureInfoType>;
  readonly monitor_publications: Maybe<FeatureInfoType>;
  readonly organization_documents: Maybe<FeatureInfoType>;
  readonly organization_users: Maybe<FeatureInfoType>;
  readonly view_doctrine_content: Maybe<FeatureInfoType>;
  readonly view_lawsuit_details: Maybe<FeatureInfoType>;
};

export type FeaturesType = {
  readonly constraints?: InputMaybe<ReadonlyArray<InputMaybe<FeatureConstraintsType>>>;
  readonly featureCode?: InputMaybe<Scalars['String']>;
  readonly priority?: InputMaybe<Scalars['String']>;
};

export type Feed = {
  readonly __typename?: 'Feed';
  readonly hotDocuments: Maybe<FeedHotDocumentsConnection>;
  readonly lastDocuments: Maybe<FeedLastDocumentsConnection>;
};


export type FeedHotDocumentsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type FeedLastDocumentsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};

export type FeedHotDocumentsConnection = {
  readonly __typename?: 'FeedHotDocumentsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<FeedHotDocumentsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type FeedHotDocumentsEdge = {
  readonly __typename?: 'FeedHotDocumentsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Document>;
};

export type FeedLastDocumentsConnection = {
  readonly __typename?: 'FeedLastDocumentsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<FeedLastDocumentsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type FeedLastDocumentsEdge = {
  readonly __typename?: 'FeedLastDocumentsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Document>;
};

export type FeedSource = {
  readonly __typename?: 'FeedSource';
  readonly profiles: Maybe<ReadonlyArray<Maybe<Profile>>>;
  readonly topics: Maybe<ReadonlyArray<Maybe<Topic>>>;
};

export type FileInfo = {
  readonly __typename?: 'FileInfo';
  readonly bucket: Maybe<Scalars['String']>;
  readonly filename: Maybe<Scalars['String']>;
  readonly jurisId: Maybe<Scalars['NumericID']>;
  readonly linkType: Maybe<Scalars['String']>;
  readonly path: Maybe<Scalars['String']>;
  readonly storageType: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
};

export enum FileUploadTypeEnum {
  UserDocumentBack = 'USER_DOCUMENT_BACK',
  UserDocumentFront = 'USER_DOCUMENT_FRONT'
}

export type FilterInput = {
  readonly field: Scalars['String'];
  readonly kind?: InputMaybe<SearchKind>;
  readonly operator?: InputMaybe<FilterOperator>;
  readonly value?: InputMaybe<Scalars['FilterType']>;
};

export enum FilterOperator {
  And = 'and',
  Between = 'between',
  Equals = 'equals',
  Exists = 'exists',
  Greaterequalsthan = 'greaterequalsthan',
  Greaterthan = 'greaterthan',
  In = 'in',
  Lessequalsthan = 'lessequalsthan',
  Lessthan = 'lessthan',
  Match = 'match',
  Matchall = 'matchall',
  Matchexact = 'matchexact',
  Matchnegative = 'matchnegative',
  Not = 'not',
  Notequals = 'notequals',
  Or = 'or',
  Regexp = 'regexp'
}

export type FindRepresentedClientByMeResult = {
  readonly __typename?: 'FindRepresentedClientByMeResult';
  readonly clientName: Maybe<Scalars['String']>;
};

export enum FirebaseClientName {
  Jusapp = 'JUSAPP'
}

export type Flashtag = {
  readonly __typename?: 'Flashtag';
  readonly show: Scalars['Boolean'];
};

export enum FollowUpEnvironment {
  Eo = 'EO',
  Jpv = 'JPV'
}

export type FollowableEntity = {
  readonly entityId: Maybe<Scalars['NumericID']>;
  readonly entityType: Maybe<Scalars['String']>;
  readonly followers: Maybe<EntityFollowersConnection>;
  readonly followersAmount: Maybe<Scalars['Int']>;
  readonly id: Scalars['ID'];
  readonly isFollowedByViewer: Maybe<Scalars['Boolean']>;
};


export type FollowableEntityFollowersArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};

export type FollowedProfilesConnection = {
  readonly __typename?: 'FollowedProfilesConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<FollowedProfilesEdge>>>;
  readonly pageInfo: PageInfo;
};

export type FollowedProfilesEdge = {
  readonly __typename?: 'FollowedProfilesEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Profile>;
};

export type FollowedTopicsConnection = {
  readonly __typename?: 'FollowedTopicsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<FollowedTopicsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type FollowedTopicsEdge = {
  readonly __typename?: 'FollowedTopicsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Topic>;
};

export type FollowupQuestion = {
  readonly __typename?: 'FollowupQuestion';
  readonly question: Scalars['String'];
};

export type ForceAcademicVerificationAsAdminInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly type: ForceAcademicVerificationTypeEnum;
};

export type ForceAcademicVerificationAsAdminPayload = {
  readonly __typename?: 'ForceAcademicVerificationAsAdminPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export enum ForceAcademicVerificationTypeEnum {
  None = 'NONE',
  Verified = 'VERIFIED'
}

export type ForceExperimentInput = {
  readonly alternative: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly experiment: Scalars['String'];
  readonly group: Scalars['String'];
};

export type ForceExperimentPayload = {
  readonly __typename?: 'ForceExperimentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly result: Scalars['Boolean'];
};

export enum ForceIcpCertificateKindEnum {
  Cpf = 'CPF',
  Oab = 'OAB'
}

export type ForceIcpCertificateValidationInput = {
  readonly certificateKind?: InputMaybe<ForceIcpCertificateKindEnum>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly pid: Scalars['NumericID'];
  readonly type: ForceIcpCertificateValidationTypeEnum;
};

export type ForceIcpCertificateValidationPayload = {
  readonly __typename?: 'ForceIcpCertificateValidationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export enum ForceIcpCertificateValidationTypeEnum {
  Expired = 'EXPIRED',
  None = 'NONE',
  Valid = 'VALID'
}

export type ForceIdentityVerificationAsAdminInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly type: ForceIdentityVerificationTypeEnum;
};

export type ForceIdentityVerificationAsAdminPayload = {
  readonly __typename?: 'ForceIdentityVerificationAsAdminPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export enum ForceIdentityVerificationTypeEnum {
  None = 'NONE',
  Verified = 'VERIFIED'
}

export type ForceOabStateAsAdminInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly inscricaoOab?: InputMaybe<Scalars['String']>;
  readonly tipoInscricaoOab?: InputMaybe<Scalars['String']>;
  readonly type: ForceOabStateTypeEnum;
  readonly ufInscricaoOab?: InputMaybe<Scalars['Int']>;
};

export type ForceOabStateAsAdminPayload = {
  readonly __typename?: 'ForceOabStateAsAdminPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export enum ForceOabStateTypeEnum {
  Filled = 'FILLED',
  None = 'NONE',
  Outdated = 'OUTDATED'
}

export type ForcedExperiment = {
  readonly __typename?: 'ForcedExperiment';
  readonly alternative: Scalars['String'];
  readonly experiment: Scalars['String'];
  readonly group: Scalars['String'];
};

export type FreeAmountTriggersType = {
  readonly freeAmount?: InputMaybe<Scalars['Int']>;
  readonly triggerAmount?: InputMaybe<Scalars['Int']>;
  readonly triggerFeatureCode?: InputMaybe<Scalars['String']>;
};

export type FullAddress = {
  readonly __typename?: 'FullAddress';
  readonly address: Maybe<Scalars['String']>;
  readonly city: Maybe<Scalars['String']>;
  readonly code: Maybe<Scalars['String']>;
  readonly neighborhood: Maybe<Scalars['String']>;
  readonly state: Maybe<Scalars['String']>;
};

export type GenerateKeycloakImpersonationLinkInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly pid: Scalars['Float'];
};

export type GenerateKeycloakImpersonationLinkPayload = {
  readonly __typename?: 'GenerateKeycloakImpersonationLinkPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly cookie: Maybe<Scalars['String']>;
  readonly magicLink: Maybe<Scalars['String']>;
};

export type GenerateUploadUrlInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly filename?: InputMaybe<Scalars['String']>;
  readonly type?: InputMaybe<FileUploadTypeEnum>;
};

export type GenerateUploadUrlPayload = {
  readonly __typename?: 'GenerateUploadUrlPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly contentType: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
};

export type GenericMetadata = {
  readonly __typename?: 'GenericMetadata';
  readonly addons: Maybe<SearchMetadataAddons>;
  readonly author: SearchMetadataAuthor;
  readonly body: Maybe<Scalars['String']>;
  readonly date: Maybe<Scalars['Float']>;
  readonly docId: Scalars['String'];
  readonly features: Maybe<SearchMetadataFeatures>;
  readonly genericType: Scalars['String'];
  readonly highlight: Maybe<Scalars['String']>;
  readonly slug: Scalars['String'];
  readonly tags: ReadonlyArray<SearchMetadataTags>;
  readonly title: Maybe<Scalars['String']>;
  readonly url: Scalars['String'];
};


export type GenericMetadataBodyArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
  preferHighlight?: InputMaybe<Scalars['Boolean']>;
};

export type GetOrCreateCproDocumentSummaryInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly documentNumber: Scalars['String'];
  readonly model?: InputMaybe<Scalars['String']>;
  readonly noCache?: InputMaybe<Scalars['Boolean']>;
};

export type GetOrCreateCproDocumentSummaryPayload = {
  readonly __typename?: 'GetOrCreateCPRODocumentSummaryPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuitCount: Maybe<Scalars['Int']>;
  readonly status: Scalars['String'];
  readonly summary: Maybe<Scalars['String']>;
};

export enum GoogleAuthClients {
  Jusapp = 'JUSAPP',
  OnlineOffice = 'ONLINE_OFFICE'
}

export type GoogleLoginInput = {
  readonly clientApp?: InputMaybe<GoogleAuthClients>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly token: Scalars['String'];
};

export type GoogleLoginPayload = {
  readonly __typename?: 'GoogleLoginPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly cookie: Maybe<Scalars['String']>;
  readonly user: Maybe<User>;
};

export type GrantAreaPlansFeature = {
  readonly __typename?: 'GrantAreaPlansFeature';
  readonly code: Maybe<Scalars['String']>;
  readonly constraintType: Maybe<Scalars['String']>;
  readonly value: Maybe<Scalars['String']>;
};

export type GrantAreaPlansInput = {
  readonly areaUuid: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly modules: ReadonlyArray<B2BSubscriptionModuleInput>;
};

export type GrantAreaPlansModule = {
  readonly __typename?: 'GrantAreaPlansModule';
  readonly plans: Maybe<ReadonlyArray<Maybe<GrantAreaPlansPlan>>>;
  readonly slug: Maybe<Scalars['String']>;
};

export type GrantAreaPlansPayload = {
  readonly __typename?: 'GrantAreaPlansPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly result: Maybe<GrantAreaPlansResult>;
};

export type GrantAreaPlansPlan = {
  readonly __typename?: 'GrantAreaPlansPlan';
  readonly features: Maybe<ReadonlyArray<Maybe<GrantAreaPlansFeature>>>;
  readonly name: Maybe<Scalars['String']>;
  readonly planUuid: Maybe<Scalars['String']>;
};

export type GrantAreaPlansResult = {
  readonly __typename?: 'GrantAreaPlansResult';
  readonly areaUuid: Maybe<Scalars['String']>;
  readonly modules: Maybe<ReadonlyArray<Maybe<GrantAreaPlansModule>>>;
};

export type GrantBonusInput = {
  readonly bonusCode: BonusCode;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type GrantBonusPayload = {
  readonly __typename?: 'GrantBonusPayload';
  readonly alreadyGranted: Maybe<Scalars['Boolean']>;
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
  readonly subscription: Maybe<BoxSubscription>;
};

export type GrowthBookExperiment = {
  readonly __typename?: 'GrowthBookExperiment';
  readonly allVariants: ReadonlyArray<Scalars['String']>;
  readonly bucket: Maybe<Scalars['Float']>;
  readonly experimentKey: Scalars['String'];
  readonly experimentName: Scalars['String'];
  readonly isForced: Scalars['Boolean'];
  readonly variantName: Scalars['String'];
};

export type HaystackItem = {
  readonly __typename?: 'HaystackItem';
  readonly data: SearchMetadata;
  readonly explanation: Maybe<Scalars['JSON']>;
  readonly itemId: Scalars['ID'];
  readonly kind: SearchKind;
  readonly score: Maybe<Scalars['Float']>;
};

export enum HaystackKind {
  Artigo = 'artigo',
  ArtigoNoticias = 'artigo_noticias',
  Diarios = 'diarios',
  Doutrina = 'doutrina',
  Jurisprudencia = 'jurisprudencia',
  JurisprudenciaSumula = 'jurisprudencia_sumula',
  Legislacao = 'legislacao',
  ModeloPeca = 'modelo_peca',
  Noticias = 'noticias',
  Peca = 'peca',
  Perfil = 'perfil',
  SecaoDoutrina = 'secao_doutrina',
  Sumula = 'sumula',
  Topicos = 'topicos'
}

export type HaystackResponse = {
  readonly __typename?: 'HaystackResponse';
  readonly facets: Maybe<Scalars['JSON']>;
  readonly hits: Scalars['Int'];
  readonly items: ReadonlyArray<HaystackItem>;
  readonly metadata: Maybe<Scalars['JSON']>;
  readonly query: Scalars['String'];
};

export type HaystackSerpDeferredResponse = {
  readonly __typename?: 'HaystackSerpDeferredResponse';
  readonly ready: Scalars['Boolean'];
  readonly response: Maybe<HaystackSerpResponse>;
};

export enum HaystackSerpKind {
  Artigos = 'ARTIGOS',
  ArtigosNoticias = 'ARTIGOS_NOTICIAS',
  ConsultaProcessual = 'CONSULTA_PROCESSUAL',
  Diarios = 'DIARIOS',
  Doutrina = 'DOUTRINA',
  Geral = 'GERAL',
  Jurisprudencia = 'JURISPRUDENCIA',
  Legislacao = 'LEGISLACAO',
  Modelos = 'MODELOS',
  Noticias = 'NOTICIAS',
  Outros = 'OUTROS',
  Pecas = 'PECAS',
  Pessoas = 'PESSOAS',
  Smart = 'SMART'
}

export type HaystackSerpResponse = {
  readonly __typename?: 'HaystackSerpResponse';
  readonly content: Scalars['JSON'];
};

export type Highlight = {
  readonly __typename?: 'Highlight';
  readonly text: Maybe<Scalars['String']>;
};

export type HighlightInput = {
  readonly field: Scalars['String'];
  readonly mode?: InputMaybe<HighlightMode>;
};

export enum HighlightMode {
  Compact = 'compact',
  Complete = 'complete',
  Default = 'default'
}

export type HubB2BAreaListResult = {
  readonly __typename?: 'HubB2BAreaListResult';
  readonly items: Maybe<ReadonlyArray<Maybe<HubB2BAreaResult>>>;
  readonly total: Maybe<Scalars['Int']>;
};

export type HubB2BAreaResult = {
  readonly __typename?: 'HubB2BAreaResult';
  readonly activeUsers: Maybe<Scalars['Int']>;
  readonly b2bProfileId: Maybe<Scalars['Int']>;
  readonly b2cProfileId: Maybe<Scalars['Int']>;
  readonly isDefault: Maybe<Scalars['Boolean']>;
  readonly name: Maybe<Scalars['String']>;
  readonly seats: Maybe<Scalars['Int']>;
  readonly status: Maybe<Scalars['String']>;
  readonly uuid: Maybe<Scalars['String']>;
};

export type HubB2BCatalogModule = {
  readonly __typename?: 'HubB2BCatalogModule';
  readonly description: Maybe<Scalars['String']>;
  readonly isMultiplan: Maybe<Scalars['Boolean']>;
  readonly name: Scalars['String'];
  readonly slug: Scalars['String'];
  readonly status: Maybe<Scalars['String']>;
  readonly uuid: Scalars['String'];
};

export type HubB2BCatalogPlan = {
  readonly __typename?: 'HubB2BCatalogPlan';
  readonly isSelfService: Maybe<Scalars['Boolean']>;
  readonly moduleName: Maybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly status: Maybe<Scalars['String']>;
  readonly uuid: Scalars['String'];
};

export type HubB2BCatalogPlanFeature = {
  readonly __typename?: 'HubB2BCatalogPlanFeature';
  readonly constraintType: Maybe<Scalars['String']>;
  readonly featureCode: Scalars['String'];
  readonly featureName: Maybe<Scalars['String']>;
  readonly featureUuid: Scalars['String'];
  readonly moduleName: Maybe<Scalars['String']>;
  readonly planName: Maybe<Scalars['String']>;
  readonly value: Maybe<Scalars['String']>;
};

export type HubB2BCompanyDefaultArea = {
  readonly __typename?: 'HubB2BCompanyDefaultArea';
  readonly name: Maybe<Scalars['String']>;
  readonly uuid: Maybe<Scalars['String']>;
};

export type HubB2BCompanyResult = {
  readonly __typename?: 'HubB2BCompanyResult';
  readonly brandName: Maybe<Scalars['String']>;
  readonly cproEmbeddedUrl: Maybe<Scalars['String']>;
  readonly cproSlug: Maybe<Scalars['String']>;
  readonly defaultArea: Maybe<HubB2BCompanyDefaultArea>;
  readonly legalName: Maybe<Scalars['String']>;
  readonly legalNumber: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly uuid: Maybe<Scalars['String']>;
};

export type HubB2BDomainResult = {
  readonly __typename?: 'HubB2BDomainResult';
  readonly areaUuid: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly domain: Maybe<Scalars['String']>;
  readonly id: Maybe<Scalars['String']>;
  readonly inactivityTtlSecs: Maybe<Scalars['Int']>;
  readonly renewalTtlSecs: Maybe<Scalars['Int']>;
  readonly seats: Maybe<Scalars['Int']>;
  readonly updatedAt: Maybe<Scalars['String']>;
};

export type HubB2BSubscriptionResult = {
  readonly __typename?: 'HubB2BSubscriptionResult';
  readonly companyUuid: Maybe<Scalars['String']>;
  readonly id: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
};

export type HubCompanyPlan = {
  readonly __typename?: 'HubCompanyPlan';
  readonly currency: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
  readonly formattedPrice: Maybe<Scalars['String']>;
  readonly frequency: Maybe<Scalars['String']>;
  readonly frequencyLabel: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly presentationName: Maybe<Scalars['String']>;
  readonly price: Maybe<Scalars['Float']>;
};

export type HubCompanyPlanGroup = {
  readonly __typename?: 'HubCompanyPlanGroup';
  readonly id: Maybe<Scalars['Int']>;
  readonly name: Maybe<Scalars['String']>;
  readonly slug: Maybe<Scalars['String']>;
};

export type HubCompanyRequest = {
  readonly __typename?: 'HubCompanyRequest';
  readonly companyProfileId: Maybe<Scalars['Int']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly ownerNetworkUid: Maybe<Scalars['Int']>;
  readonly planId: Maybe<Scalars['Int']>;
  readonly requestId: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['String']>;
};

export type HubCompanySubscription = {
  readonly __typename?: 'HubCompanySubscription';
  readonly boxPlanGroupId: Maybe<Scalars['Int']>;
  readonly boxPlanId: Maybe<Scalars['Int']>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly frequency: Maybe<Scalars['String']>;
  readonly isSelfService: Maybe<Scalars['Boolean']>;
  readonly orderCode: Maybe<Scalars['String']>;
  readonly plan: Maybe<HubCompanyPlan>;
  readonly planGroup: Maybe<HubCompanyPlanGroup>;
  readonly planUuid: Maybe<Scalars['String']>;
  readonly pricingPlanSlug: Maybe<Scalars['String']>;
  readonly renewAt: Maybe<Scalars['Float']>;
  readonly status: Maybe<Scalars['String']>;
  readonly uuid: Maybe<Scalars['String']>;
};

export type HubCompanySubscriptionsResult = {
  readonly __typename?: 'HubCompanySubscriptionsResult';
  readonly subscriptions: Maybe<ReadonlyArray<Maybe<HubCompanySubscription>>>;
};

export type HubInvite = {
  readonly __typename?: 'HubInvite';
  readonly area: Maybe<HubInviteArea>;
  readonly company: Maybe<HubInviteCompany>;
  readonly email: Maybe<Scalars['String']>;
  readonly id: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly role: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly status: Maybe<Scalars['String']>;
};

export type HubInviteArea = {
  readonly __typename?: 'HubInviteArea';
  readonly b2cProfileId: Maybe<Scalars['String']>;
  readonly magicLinkDomain: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly uuid: Maybe<Scalars['String']>;
};

export type HubInviteCompany = {
  readonly __typename?: 'HubInviteCompany';
  readonly brandName: Maybe<Scalars['String']>;
  readonly profileId: Maybe<Scalars['String']>;
};

export type HubInviteCounts = {
  readonly __typename?: 'HubInviteCounts';
  readonly accepted: Maybe<Scalars['Int']>;
  readonly cancelled: Maybe<Scalars['Int']>;
  readonly expired: Maybe<Scalars['Int']>;
  readonly pending: Maybe<Scalars['Int']>;
  readonly total: Maybe<Scalars['Int']>;
};

export type HubInvitesResult = {
  readonly __typename?: 'HubInvitesResult';
  readonly items: Maybe<ReadonlyArray<Maybe<HubInvite>>>;
  readonly total: Maybe<Scalars['Int']>;
};

export type HubInvoice = {
  readonly __typename?: 'HubInvoice';
  readonly amount: Scalars['Float'];
  readonly name: Scalars['String'];
  readonly periodStart: Maybe<Scalars['String']>;
  readonly uuid: Scalars['String'];
};

export type HubInvoiceAreaItem = {
  readonly __typename?: 'HubInvoiceAreaItem';
  readonly amount: Maybe<Scalars['Float']>;
  readonly areaName: Scalars['String'];
  readonly areaUuid: Scalars['String'];
};

export type HubInvoiceDetail = {
  readonly __typename?: 'HubInvoiceDetail';
  readonly amount: Scalars['Float'];
  readonly name: Scalars['String'];
  readonly periodStart: Maybe<Scalars['String']>;
  readonly uuid: Scalars['String'];
};

export type HubInvoiceDetailsResult = {
  readonly __typename?: 'HubInvoiceDetailsResult';
  readonly areas: ReadonlyArray<Maybe<HubInvoiceAreaItem>>;
  readonly availableModules: ReadonlyArray<Maybe<Scalars['String']>>;
  readonly details: HubInvoiceDetail;
  readonly isApproximate: Scalars['Boolean'];
};

export type HubInvoiceEventItem = {
  readonly __typename?: 'HubInvoiceEventItem';
  readonly amount: Scalars['Float'];
  readonly areaName: Scalars['String'];
  readonly eventName: Scalars['String'];
  readonly eventSlug: Scalars['String'];
  readonly moduleName: Scalars['String'];
  readonly units: Scalars['Int'];
};

export type HubInvoiceEventsResult = {
  readonly __typename?: 'HubInvoiceEventsResult';
  readonly events: ReadonlyArray<Maybe<HubInvoiceEventItem>>;
};

export type HubInvoicesResult = {
  readonly __typename?: 'HubInvoicesResult';
  readonly hasMore: Scalars['Boolean'];
  readonly items: ReadonlyArray<Maybe<HubInvoice>>;
  readonly total: Scalars['Int'];
};

export type HubJusiaPlanPreview = {
  readonly __typename?: 'HubJusiaPlanPreview';
  readonly features: Maybe<ReadonlyArray<Maybe<HubJusiaPreviewFeature>>>;
  readonly module: Maybe<Scalars['String']>;
  readonly plan: Maybe<Scalars['String']>;
  readonly scope: Maybe<Scalars['String']>;
};

export type HubJusiaPreviewFeature = {
  readonly __typename?: 'HubJusiaPreviewFeature';
  readonly code: Scalars['String'];
  readonly constraintType: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly value: Maybe<Scalars['String']>;
};

export type HubMagicLinkConfig = {
  readonly __typename?: 'HubMagicLinkConfig';
  readonly areaName: Maybe<Scalars['String']>;
  readonly areaUuid: Maybe<Scalars['String']>;
  readonly autoInvite: Maybe<Scalars['Boolean']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly domain: Maybe<Scalars['String']>;
  readonly id: Maybe<Scalars['String']>;
  readonly inactivityTtlSecs: Maybe<Scalars['Int']>;
  readonly renewalTtlSecs: Maybe<Scalars['Int']>;
  readonly updatedAt: Maybe<Scalars['String']>;
};

export type HubOrganization = {
  readonly __typename?: 'HubOrganization';
  readonly brandName: Maybe<Scalars['String']>;
  readonly canAccessApi: Maybe<Scalars['Boolean']>;
  readonly companyProfileId: Maybe<Scalars['Int']>;
  readonly cproEmbeddedUrl: Maybe<Scalars['String']>;
  readonly cproSlug: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly defaultArea: Maybe<HubOrganizationDefaultArea>;
  readonly id: Maybe<Scalars['String']>;
  readonly legalName: Maybe<Scalars['String']>;
  readonly legalNumber: Maybe<Scalars['String']>;
  readonly owner: Maybe<HubOrganizationOwner>;
  readonly ownerEmail: Maybe<Scalars['String']>;
  readonly ownerName: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['String']>;
  readonly userAccountUuid: Maybe<Scalars['String']>;
  readonly userArea: Maybe<HubOrganizationUserArea>;
};

export type HubOrganizationDefaultArea = {
  readonly __typename?: 'HubOrganizationDefaultArea';
  readonly name: Maybe<Scalars['String']>;
  readonly uuid: Maybe<Scalars['String']>;
};

export type HubOrganizationList = {
  readonly __typename?: 'HubOrganizationList';
  readonly companies: Maybe<ReadonlyArray<Maybe<HubOrganization>>>;
  readonly total: Maybe<Scalars['Int']>;
};

export type HubOrganizationOwner = {
  readonly __typename?: 'HubOrganizationOwner';
  readonly email: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly pid: Maybe<Scalars['Int']>;
  readonly uid: Maybe<Scalars['Int']>;
};

export type HubOrganizationUserArea = {
  readonly __typename?: 'HubOrganizationUserArea';
  readonly name: Maybe<Scalars['String']>;
  readonly uuid: Maybe<Scalars['String']>;
};

export type HubSelfCheckoutPlanOffer = {
  readonly __typename?: 'HubSelfCheckoutPlanOffer';
  readonly description: Maybe<Scalars['String']>;
  readonly offerInfo: Maybe<HubSelfCheckoutPlanOfferInfo>;
  readonly planId: Maybe<Scalars['Int']>;
  readonly presentationName: Maybe<Scalars['String']>;
  readonly price: Maybe<Scalars['Float']>;
  readonly submitData: Maybe<SubmitData>;
};

export type HubSelfCheckoutPlanOfferInfo = {
  readonly __typename?: 'HubSelfCheckoutPlanOfferInfo';
  readonly benefits: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly name: Maybe<Scalars['String']>;
  readonly tags: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
};

export type HubSelfCheckoutPlans = {
  readonly __typename?: 'HubSelfCheckoutPlans';
  readonly planOffers: ReadonlyArray<Maybe<HubSelfCheckoutPlanOffer>>;
};

export type HubSubscription = {
  readonly __typename?: 'HubSubscription';
  readonly companyUuid: Maybe<Scalars['String']>;
  readonly id: Maybe<Scalars['String']>;
  readonly planUuid: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
};

export type HubUseCase = {
  readonly __typename?: 'HubUseCase';
  readonly displayName: Scalars['String'];
  readonly slug: Scalars['String'];
};

export type HubUser = {
  readonly __typename?: 'HubUser';
  readonly archivedAt: Maybe<Scalars['String']>;
  readonly areaUuid: Maybe<Scalars['String']>;
  readonly companyId: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly documentNumber: Maybe<Scalars['String']>;
  readonly email: Maybe<Scalars['String']>;
  readonly hasRoles: Maybe<Scalars['Boolean']>;
  readonly id: Maybe<Scalars['String']>;
  readonly id_v2: Maybe<Scalars['String']>;
  readonly isActive: Maybe<Scalars['Boolean']>;
  readonly isAdmin: Maybe<Scalars['Boolean']>;
  readonly jusBrasilSeats: Maybe<Scalars['Boolean']>;
  readonly lastLoginAt: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly profileId: Maybe<Scalars['String']>;
  readonly roles: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly status: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['String']>;
  readonly uri: Maybe<Scalars['String']>;
  readonly userCompany: Maybe<UserCompany>;
  readonly userCompanyId: Maybe<Scalars['Int']>;
};


export type HubUserHasRolesArgs = {
  roles: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type HubUsersResult = {
  readonly __typename?: 'HubUsersResult';
  readonly items: Maybe<ReadonlyArray<Maybe<HubUser>>>;
  readonly total: Maybe<Scalars['Int']>;
};

export type HubWhoIsCompanyResult = {
  readonly __typename?: 'HubWhoIsCompanyResult';
  readonly address: Maybe<Scalars['String']>;
  readonly brandName: Maybe<Scalars['String']>;
  readonly cnae: Maybe<Scalars['String']>;
  readonly cnaeDescription: Maybe<Scalars['String']>;
  readonly cnpj: Maybe<Scalars['String']>;
  readonly legalName: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
};

export type IapOneTimePurchase = {
  readonly __typename?: 'IAPOneTimePurchase';
  readonly featureCode: Maybe<Scalars['String']>;
  readonly originalTransactionId: Maybe<Scalars['String']>;
  readonly platform: Maybe<Scalars['String']>;
  readonly productId: Maybe<Scalars['String']>;
  readonly purchaseDate: Maybe<Scalars['String']>;
  readonly resourceId: Maybe<Scalars['String']>;
  readonly userId: Maybe<Scalars['String']>;
};

export enum IapPlanType {
  Initial = 'INITIAL',
  Monthly = 'MONTHLY'
}

export enum IapPlatformType {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type IapReceiptExcerpt = {
  readonly __typename?: 'IAPReceiptExcerpt';
  readonly autoRenewStatus: Maybe<Scalars['String']>;
  readonly purchaseDate: Maybe<Scalars['String']>;
  readonly transactionId: Maybe<Scalars['String']>;
};

export type IapSubscription = {
  readonly __typename?: 'IAPSubscription';
  readonly autoRenewStatus: Maybe<Scalars['String']>;
  readonly cancellationDate: Maybe<Scalars['String']>;
  readonly expiresDate: Maybe<Scalars['String']>;
  readonly gracePeriod: Maybe<Scalars['Boolean']>;
  readonly originalTransactionId: Maybe<Scalars['String']>;
  readonly planGroupId: Maybe<Scalars['Int']>;
  readonly planId: Maybe<Scalars['Int']>;
  readonly platform: Maybe<Scalars['String']>;
  readonly productId: Maybe<Scalars['String']>;
  readonly purchaseDate: Maybe<Scalars['String']>;
  readonly receipts: Maybe<ReadonlyArray<Maybe<IapReceiptExcerpt>>>;
  readonly status: Maybe<Scalars['String']>;
  readonly subscriptionId: Maybe<Scalars['Int']>;
};

export type IapVerifyOneTimePurchaseInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cnjNumber: Scalars['String'];
  readonly platform?: InputMaybe<IapPlatformType>;
  readonly productId: Scalars['String'];
  readonly production: Scalars['Boolean'];
  readonly token: Scalars['String'];
};

export type IapVerifyOneTimePurchasePayload = {
  readonly __typename?: 'IAPVerifyOneTimePurchasePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly iapOneTimePurchase: Maybe<IapOneTimePurchase>;
  readonly user: Maybe<Profile>;
};

export type IapVerifyPurchaseSubscriptionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly platform?: InputMaybe<IapPlatformType>;
  readonly productId?: InputMaybe<Scalars['String']>;
  readonly production: Scalars['Boolean'];
  readonly token: Scalars['String'];
  readonly triggerFeature?: InputMaybe<Scalars['String']>;
};

export type IapVerifyPurchaseSubscriptionPayload = {
  readonly __typename?: 'IAPVerifyPurchaseSubscriptionPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly iapSubscription: Maybe<IapSubscription>;
  readonly user: Maybe<Profile>;
};

export enum IconTypeEnum {
  Academy = 'ACADEMY',
  Ai = 'AI',
  Book = 'BOOK',
  Check = 'CHECK',
  CheckRound = 'CHECK_ROUND',
  Close = 'CLOSE',
  FileSearch = 'FILE_SEARCH',
  Info = 'INFO',
  JusIa = 'JUS_IA',
  JusIaBrand = 'JUS_IA_BRAND',
  Scales = 'SCALES',
  UserMulti = 'USER_MULTI',
  Warning = 'WARNING'
}

export type IdoxIntegration = {
  readonly __typename?: 'IdoxIntegration';
  readonly organization: Maybe<Organization>;
  readonly profile: Maybe<Profile>;
};

export type Image = {
  readonly __typename?: 'Image';
  readonly alt: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
  readonly path: Maybe<Scalars['String']>;
  readonly thumbor: Maybe<ThumborImage>;
  readonly url: Maybe<Scalars['String']>;
};

export type ImpersonationState = {
  readonly __typename?: 'ImpersonationState';
  readonly impersonatedUser: Maybe<Profile>;
  readonly originalUser: Maybe<Profile>;
};

export type InAppPurchaseProduct = {
  readonly __typename?: 'InAppPurchaseProduct';
  readonly appStoreProductId: Maybe<Scalars['String']>;
  readonly googlePlayProductId: Maybe<Scalars['String']>;
  readonly plan: Maybe<Plan>;
  readonly productId: Maybe<Scalars['String']>;
  readonly promotionalPlan: Maybe<Plan>;
};

export type IncrementConciergeDailySalesCountInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type IncrementConciergeDailySalesCountPayload = {
  readonly __typename?: 'IncrementConciergeDailySalesCountPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly count: Scalars['Int'];
};

export type InstitutionalProfileAdminsConnection = {
  readonly __typename?: 'InstitutionalProfileAdminsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<InstitutionalProfileAdminsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type InstitutionalProfileAdminsEdge = {
  readonly __typename?: 'InstitutionalProfileAdminsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<User>;
};

export type IntentionSortedSearch = {
  readonly __typename?: 'IntentionSortedSearch';
  readonly artifactResults: Maybe<Search>;
  readonly sortedHaystackKinds: ReadonlyArray<HaystackKind>;
};


export type IntentionSortedSearchArtifactResultsArgs = {
  facets: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  filters: InputMaybe<ReadonlyArray<InputMaybe<Scalars['JSON']>>>;
  flags: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  highlights: InputMaybe<ReadonlyArray<InputMaybe<Scalars['JSON']>>>;
  kind: HaystackKind;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  sorts: InputMaybe<ReadonlyArray<InputMaybe<Scalars['JSON']>>>;
};

export type InviteHubUserInput = {
  readonly areaUuid: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly companyUuid: Scalars['String'];
  readonly email: Scalars['String'];
  readonly name: Scalars['String'];
  readonly role?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly username: Scalars['String'];
};

export type InviteHubUserPayload = {
  readonly __typename?: 'InviteHubUserPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly errorCode: Maybe<Scalars['String']>;
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly invite: Maybe<HubInvite>;
};

export type InviteToOrganizationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly invitations?: InputMaybe<Scalars['JSON']>;
};

export type InviteToOrganizationPayload = {
  readonly __typename?: 'InviteToOrganizationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
};

export type InviteToShareEntityInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly contactId: Scalars['String'];
  readonly entityRefId: Scalars['String'];
  readonly entityRefType: Scalars['String'];
  readonly permissions: ReadonlyArray<InputMaybe<Scalars['String']>>;
};

export type InviteToShareEntityPayload = {
  readonly __typename?: 'InviteToShareEntityPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly entity: Maybe<CrmEntity>;
  readonly organization: Maybe<Organization>;
  readonly share: Maybe<CrmEntityShare>;
};

export type Items = {
  readonly __typename?: 'Items';
  readonly answer: Scalars['String'];
  readonly question: Scalars['String'];
};

export enum Jus_Ia_Prompt_Id {
  ExploreJuris = 'EXPLORE_JURIS',
  GenerateOrModifyDocument = 'GENERATE_OR_MODIFY_DOCUMENT',
  JurisprudenceSummary = 'JURISPRUDENCE_SUMMARY',
  JurisDocviewFactualInfluenceQuestion = 'JURIS_DOCVIEW_FACTUAL_INFLUENCE_QUESTION',
  JurisDocviewKeyLegalProvisionsQuestion = 'JURIS_DOCVIEW_KEY_LEGAL_PROVISIONS_QUESTION',
  JurisDocviewLegalIssuesSummaryQuestion = 'JURIS_DOCVIEW_LEGAL_ISSUES_SUMMARY_QUESTION',
  JurisDocviewOpenInputQuestion = 'JURIS_DOCVIEW_OPEN_INPUT_QUESTION',
  JurisDocviewSearchText = 'JURIS_DOCVIEW_SEARCH_TEXT',
  JusiaShortcut = 'JUSIA_SHORTCUT',
  LawsuitAnalysis = 'LAWSUIT_ANALYSIS',
  ModelSuggestions = 'MODEL_SUGGESTIONS',
  ModelUse = 'MODEL_USE',
  Motions = 'MOTIONS',
  SearchFromDoctrineHome = 'SEARCH_FROM_DOCTRINE_HOME',
  SearchFromLegisHome = 'SEARCH_FROM_LEGIS_HOME',
  SearchFromMotionHome = 'SEARCH_FROM_MOTION_HOME',
  Thesis = 'THESIS',
  ThesisSecurityDecisionAnalysis = 'THESIS_SECURITY_DECISION_ANALYSIS'
}

export enum Jus_Ia_Source {
  Docview = 'DOCVIEW',
  Serp = 'SERP'
}

export enum Jus_Ia_Template_Id {
  ExploreJuris = 'EXPLORE_JURIS',
  GenerateMotion = 'GENERATE_MOTION',
  GenerateOrModifyDocument = 'GENERATE_OR_MODIFY_DOCUMENT',
  JurisprudenceSummary = 'JURISPRUDENCE_SUMMARY',
  LawsuitAnalysis = 'LAWSUIT_ANALYSIS',
  ModelSuggestions = 'MODEL_SUGGESTIONS',
  ModelUse = 'MODEL_USE',
  RelatedQuestionsInJurisDocview = 'RELATED_QUESTIONS_IN_JURIS_DOCVIEW',
  SearchFromArtifactHomes = 'SEARCH_FROM_ARTIFACT_HOMES',
  SearchTextFromJurisDocview = 'SEARCH_TEXT_FROM_JURIS_DOCVIEW',
  SelectedDocuments = 'SELECTED_DOCUMENTS',
  SimilarDocuments = 'SIMILAR_DOCUMENTS',
  ThesisSecurityDecisionAnalysis = 'THESIS_SECURITY_DECISION_ANALYSIS'
}

export type JobsAgreeWithDemandCancelInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly demandId: Scalars['Int'];
};

export type JobsAgreeWithDemandCancelPayload = {
  readonly __typename?: 'JobsAgreeWithDemandCancelPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly message: Maybe<Scalars['String']>;
};

export type JobsArchiveDemandInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly demandId: Scalars['Int'];
  readonly isArchived?: InputMaybe<Scalars['Boolean']>;
};

export type JobsArchiveDemandPayload = {
  readonly __typename?: 'JobsArchiveDemandPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly demand: Maybe<JobsDemand>;
};

export type JobsAvailableExtensions = {
  readonly __typename?: 'JobsAvailableExtensions';
  readonly extension: Maybe<Scalars['String']>;
  readonly fileType: Maybe<Scalars['String']>;
};

export type JobsBank = {
  readonly __typename?: 'JobsBank';
  readonly accountMask: Maybe<Scalars['String']>;
  readonly agencyMask: Maybe<Scalars['String']>;
  readonly bankCode: Maybe<Scalars['String']>;
  readonly bankId: Maybe<Scalars['Int']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly isIuguBank: Maybe<Scalars['Boolean']>;
  readonly name: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['String']>;
};

export type JobsCepData = {
  readonly __typename?: 'JobsCepData';
  readonly city: Maybe<Topic>;
  readonly cityId: Maybe<Scalars['Int']>;
  readonly district: Maybe<Scalars['String']>;
  readonly queryResult: Maybe<Scalars['Boolean']>;
  readonly resultCity: Maybe<Scalars['String']>;
  readonly resultState: Maybe<Scalars['String']>;
  readonly resultText: Maybe<Scalars['String']>;
  readonly stateId: Maybe<Scalars['Int']>;
  readonly streetKind: Maybe<Scalars['String']>;
  readonly streetName: Maybe<Scalars['String']>;
};

export type JobsConcludeDemandInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly demandId: ReadonlyArray<InputMaybe<Scalars['Int']>>;
};

export type JobsConcludeDemandPayload = {
  readonly __typename?: 'JobsConcludeDemandPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly demand: Maybe<JobsDemand>;
};

export type JobsConfigurations = Node & {
  readonly __typename?: 'JobsConfigurations';
  readonly id: Scalars['ID'];
  readonly maxUploadSizeMb: Maybe<Scalars['Int']>;
  readonly pagDeadline: Maybe<Scalars['String']>;
};

export type JobsCreateDemandChargeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly demandId: Scalars['Int'];
  readonly description: Scalars['String'];
  readonly proposalId: Scalars['Int'];
  readonly value: Scalars['Float'];
};

export type JobsCreateDemandChargePayload = {
  readonly __typename?: 'JobsCreateDemandChargePayload';
  readonly charge: Maybe<JobsDemandCharge>;
  readonly clientMutationId: Maybe<Scalars['String']>;
};

export type JobsCreateDemandProposalInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly deadline: Scalars['Int'];
  readonly demandId: Scalars['Int'];
  readonly message?: InputMaybe<Scalars['String']>;
  readonly value: Scalars['Float'];
};

export type JobsCreateDemandProposalPayload = {
  readonly __typename?: 'JobsCreateDemandProposalPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly demand: Maybe<JobsDemand>;
  readonly proposal: Maybe<JobsDemandProposal>;
};

export type JobsDemand = Node & {
  readonly __typename?: 'JobsDemand';
  readonly acceptanceTerm: Maybe<Scalars['Boolean']>;
  readonly acceptanceTermUrl: Maybe<Scalars['String']>;
  readonly address: Maybe<Scalars['String']>;
  readonly answers: Maybe<Scalars['Int']>;
  readonly archived: Maybe<Scalars['Boolean']>;
  readonly attendedCity: Maybe<Scalars['Boolean']>;
  readonly business: Maybe<Scalars['Boolean']>;
  readonly businessDates: Maybe<JobsDemandBusinessDates>;
  readonly camadaConversation: Maybe<CamadaConversation>;
  readonly city: Maybe<Topic>;
  readonly conclusionConfirmed: Maybe<Scalars['Boolean']>;
  readonly contestedPayments: Maybe<Scalars['Int']>;
  readonly contractor: Maybe<JobsDemandContractor>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly deadline: Maybe<Scalars['String']>;
  readonly demandId: Maybe<Scalars['Int']>;
  readonly details: Maybe<ReadonlyArray<Maybe<JobsDemandDetail>>>;
  readonly direct: Maybe<Scalars['Boolean']>;
  readonly done: Maybe<Scalars['Boolean']>;
  readonly fileMessages: Maybe<ReadonlyArray<Maybe<JobsDemandFileMessage>>>;
  readonly finished: Maybe<Scalars['Boolean']>;
  readonly freeDemand: Maybe<Scalars['Boolean']>;
  readonly fullProposal: Maybe<JobsDemandProposal>;
  readonly hash: Maybe<Scalars['String']>;
  readonly hired: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly invoice: Maybe<JobsDemandInvoice>;
  readonly lastMessageDate: Maybe<Scalars['String']>;
  readonly latitude: Maybe<Scalars['Float']>;
  readonly longitude: Maybe<Scalars['Float']>;
  readonly messages: Maybe<ReadonlyArray<Maybe<JobsDemandMessage>>>;
  readonly newMessages: Maybe<Scalars['Int']>;
  readonly observations: Maybe<Scalars['String']>;
  readonly pagTax: Maybe<Scalars['Float']>;
  readonly place: Maybe<Scalars['String']>;
  readonly processNumber: Maybe<Scalars['String']>;
  readonly proposal: Maybe<JobsDemandProposal>;
  readonly proximity: Maybe<Scalars['Boolean']>;
  readonly read: Maybe<Scalars['Boolean']>;
  readonly refundRequest: Maybe<JobsDemandRefundRequest>;
  readonly refundRequests: Maybe<ReadonlyArray<Maybe<JobsDemandRefundRequest>>>;
  readonly service: Maybe<Scalars['String']>;
  readonly state: Maybe<JobsDemandState>;
  readonly statusColor: Maybe<Scalars['String']>;
  readonly statusDescription: Maybe<Scalars['String']>;
  readonly statusId: Maybe<Scalars['Int']>;
  readonly statusName: Maybe<Scalars['String']>;
  readonly views: Maybe<Scalars['Int']>;
};


export type JobsDemandRefundRequestArgs = {
  refundRequestId: Scalars['Int'];
};

export type JobsDemandBusinessDates = {
  readonly __typename?: 'JobsDemandBusinessDates';
  readonly invoiceClosedAfter: Maybe<Scalars['String']>;
  readonly invoiceClosedUntil: Maybe<Scalars['String']>;
  readonly paymentAfter: Maybe<Scalars['String']>;
  readonly paymentUntil: Maybe<Scalars['String']>;
};

export type JobsDemandCharge = {
  readonly __typename?: 'JobsDemandCharge';
  readonly business: Maybe<Scalars['Boolean']>;
  readonly chargeId: Maybe<Scalars['String']>;
  readonly chargeStatus: Maybe<Scalars['String']>;
  readonly chargeStatusId: Maybe<Scalars['Int']>;
  readonly chargedValue: Maybe<Scalars['Float']>;
  readonly contestationReason: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly demandId: Maybe<Scalars['Int']>;
  readonly description: Maybe<Scalars['String']>;
  readonly hash: Maybe<Scalars['String']>;
  readonly history: Maybe<ReadonlyArray<Maybe<JobsDemandChargeHistory>>>;
  readonly modifiedAt: Maybe<Scalars['String']>;
  readonly proposalId: Maybe<Scalars['Int']>;
  readonly transferReceipt: Maybe<Scalars['String']>;
  readonly valueForProfessional: Maybe<Scalars['Float']>;
};

export type JobsDemandChargeHistory = {
  readonly __typename?: 'JobsDemandChargeHistory';
  readonly alertLevel: Maybe<Scalars['String']>;
  readonly chargeHistoryId: Maybe<Scalars['Int']>;
  readonly chargeId: Maybe<Scalars['Int']>;
  readonly chargeStatus: Maybe<Scalars['String']>;
  readonly chargeStatusId: Maybe<Scalars['Int']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly ip: Maybe<Scalars['String']>;
  readonly modifiedAt: Maybe<Scalars['String']>;
};

export type JobsDemandContractor = {
  readonly __typename?: 'JobsDemandContractor';
  readonly accountId: Maybe<Scalars['Int']>;
  readonly accountType: Maybe<Scalars['String']>;
  readonly corporateName: Maybe<Scalars['String']>;
  readonly email: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly payments: Maybe<Scalars['Int']>;
  readonly paymentsDescription: Maybe<Scalars['String']>;
  readonly phoneNumber: Maybe<Scalars['String']>;
  readonly pid: Maybe<Scalars['Float']>;
};

export type JobsDemandDetail = {
  readonly __typename?: 'JobsDemandDetail';
  readonly label: Maybe<Scalars['String']>;
  readonly value: Maybe<Scalars['String']>;
};

export type JobsDemandFile = {
  readonly __typename?: 'JobsDemandFile';
  readonly fileName: Maybe<Scalars['String']>;
  readonly fileType: Maybe<Scalars['String']>;
};

export type JobsDemandFileMessage = {
  readonly __typename?: 'JobsDemandFileMessage';
  readonly contactId: Maybe<Scalars['Int']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly demandId: Maybe<Scalars['Int']>;
  readonly file: Maybe<JobsDemandFile>;
  readonly ip: Maybe<Scalars['String']>;
  readonly messageId: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly proposalId: Maybe<Scalars['Int']>;
  readonly type: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['String']>;
  readonly userId: Maybe<Scalars['Int']>;
};

export type JobsDemandFilter = {
  readonly __typename?: 'JobsDemandFilter';
  readonly filters: Maybe<ReadonlyArray<Maybe<JobsDemandFilterItem>>>;
  readonly tags: Maybe<ReadonlyArray<Maybe<JobsDemandFilterItem>>>;
};

export type JobsDemandFilterItem = {
  readonly __typename?: 'JobsDemandFilterItem';
  readonly label: Maybe<Scalars['String']>;
  readonly value: Maybe<Scalars['String']>;
};

export type JobsDemandInvoice = {
  readonly __typename?: 'JobsDemandInvoice';
  readonly url: Maybe<Scalars['String']>;
};

export type JobsDemandMessage = {
  readonly __typename?: 'JobsDemandMessage';
  readonly color: Maybe<Scalars['String']>;
  readonly contactId: Maybe<Scalars['Int']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly deadline: Maybe<Scalars['Int']>;
  readonly demandId: Maybe<Scalars['Int']>;
  readonly file: Maybe<JobsDemandMessageFile>;
  readonly ip: Maybe<Scalars['String']>;
  readonly message: Maybe<Scalars['String']>;
  readonly messageId: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly proposalId: Maybe<Scalars['Int']>;
  readonly read: Maybe<Scalars['Boolean']>;
  readonly readAt: Maybe<Scalars['String']>;
  readonly type: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['String']>;
  readonly userId: Maybe<Scalars['Int']>;
  readonly value: Maybe<Scalars['Float']>;
};

export type JobsDemandMessageFile = {
  readonly __typename?: 'JobsDemandMessageFile';
  readonly fileId: Maybe<Scalars['String']>;
  readonly fileName: Maybe<Scalars['String']>;
};

export type JobsDemandMessageFileInfo = {
  readonly __typename?: 'JobsDemandMessageFileInfo';
  readonly file: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
};

export type JobsDemandProposal = {
  readonly __typename?: 'JobsDemandProposal';
  readonly acceptanceEmailSent: Maybe<Scalars['Boolean']>;
  readonly automaticallyCanceled: Maybe<Scalars['Boolean']>;
  readonly cancelContestedByProfessional: Maybe<Scalars['Boolean']>;
  readonly cancelContestedByProfessionalAt: Maybe<Scalars['String']>;
  readonly cancelReason: Maybe<Scalars['String']>;
  readonly cancelRequested: Maybe<Scalars['Boolean']>;
  readonly cancelRequestedAt: Maybe<Scalars['String']>;
  readonly charge: Maybe<JobsDemandCharge>;
  readonly charges: Maybe<ReadonlyArray<Maybe<JobsDemandCharge>>>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly deadline: Maybe<Scalars['Int']>;
  readonly demandId: Maybe<Scalars['Int']>;
  readonly discarded: Maybe<Scalars['Boolean']>;
  readonly discardedAt: Maybe<Scalars['String']>;
  readonly done: Maybe<Scalars['Boolean']>;
  readonly doneAt: Maybe<Scalars['String']>;
  readonly hired: Maybe<Scalars['Boolean']>;
  readonly hiredAt: Maybe<Scalars['String']>;
  readonly invoice: Maybe<Scalars['String']>;
  readonly ip: Maybe<Scalars['String']>;
  readonly latitude: Maybe<Scalars['Float']>;
  readonly longitude: Maybe<Scalars['Float']>;
  readonly modifiedAt: Maybe<Scalars['String']>;
  readonly nimdaCancelObservation: Maybe<Scalars['String']>;
  readonly notificationForValueIncrease: Maybe<Scalars['Boolean']>;
  readonly pagTax: Maybe<Scalars['Float']>;
  readonly previousValue: Maybe<Scalars['Float']>;
  readonly professionalId: Maybe<Scalars['Int']>;
  readonly proposalId: Maybe<Scalars['Int']>;
  readonly proximity: Maybe<Scalars['Boolean']>;
  readonly refundValue: Maybe<Scalars['Float']>;
  readonly selected: Maybe<Scalars['Boolean']>;
  readonly selectedDate: Maybe<Scalars['String']>;
  readonly tax: Maybe<Scalars['Float']>;
  readonly totalValue: Maybe<Scalars['Float']>;
  readonly transferReceipt: Maybe<Scalars['String']>;
  readonly value: Maybe<Scalars['Float']>;
  readonly valueForProfessional: Maybe<Scalars['Float']>;
};


export type JobsDemandProposalChargeArgs = {
  chargeId: Scalars['Int'];
};

export type JobsDemandRefundRequest = {
  readonly __typename?: 'JobsDemandRefundRequest';
  readonly createdAt: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
  readonly fileName: Maybe<Scalars['String']>;
  readonly reason: Maybe<Scalars['String']>;
  readonly refundRequestId: Maybe<Scalars['Int']>;
  readonly status: Maybe<Scalars['String']>;
  readonly statusId: Maybe<Scalars['Int']>;
  readonly taxRefund: Maybe<Scalars['Float']>;
  readonly value: Maybe<Scalars['Float']>;
};

export type JobsDemandSendInvoiceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly demandId: Scalars['Int'];
  readonly fileKey: Scalars['String'];
};

export type JobsDemandSendInvoicePayload = {
  readonly __typename?: 'JobsDemandSendInvoicePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
};

export type JobsDemandSendRefundRequestInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly demandId: Scalars['Int'];
  readonly description: Scalars['String'];
  readonly fileKey: Scalars['String'];
  readonly value: Scalars['Float'];
};

export type JobsDemandSendRefundRequestPayload = {
  readonly __typename?: 'JobsDemandSendRefundRequestPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly refundRequest: Maybe<JobsDemandRefundRequest>;
};

export type JobsDemandState = {
  readonly __typename?: 'JobsDemandState';
  readonly alterProposal: Maybe<Scalars['Boolean']>;
  readonly archive: Maybe<Scalars['Boolean']>;
  readonly cancelReason: Maybe<Scalars['String']>;
  readonly chances: Maybe<Scalars['String']>;
  readonly conclude: Maybe<Scalars['Boolean']>;
  readonly demandStatus: Maybe<Scalars['String']>;
  readonly hasInvoice: Maybe<Scalars['Boolean']>;
  readonly hiringAlert: Maybe<Scalars['Boolean']>;
  readonly invoiceRequired: Maybe<Scalars['Boolean']>;
  readonly onlyLegalEntity: Maybe<Scalars['Boolean']>;
  readonly requestRefund: Maybe<Scalars['Boolean']>;
  readonly requestSignature: Maybe<Scalars['Boolean']>;
  readonly sendCharge: Maybe<Scalars['Boolean']>;
  readonly sendFile: Maybe<Scalars['Boolean']>;
  readonly sendInvoice: Maybe<Scalars['Boolean']>;
  readonly sendMessage: Maybe<Scalars['Boolean']>;
  readonly sendProposal: Maybe<Scalars['Boolean']>;
  readonly showCancelDialog: Maybe<Scalars['Boolean']>;
  readonly tabs: Maybe<JobsDemandTabsState>;
  readonly unarchive: Maybe<Scalars['Boolean']>;
};

export type JobsDemandTabsState = {
  readonly __typename?: 'JobsDemandTabsState';
  readonly chat: Maybe<Scalars['Boolean']>;
  readonly details: Maybe<Scalars['Boolean']>;
  readonly payments: Maybe<Scalars['Boolean']>;
};

export type JobsDemandsListConnection = {
  readonly __typename?: 'JobsDemandsListConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<JobsDemandsListEdge>>>;
  readonly pageInfo: PageInfo;
};

export type JobsDemandsListEdge = {
  readonly __typename?: 'JobsDemandsListEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<JobsDemand>;
};

export type JobsDisagreeWithDemandCancelInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly demandId: Scalars['Int'];
};

export type JobsDisagreeWithDemandCancelPayload = {
  readonly __typename?: 'JobsDisagreeWithDemandCancelPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly message: Maybe<Scalars['String']>;
};

export type JobsGraph = {
  readonly __typename?: 'JobsGraph';
  readonly hiredPercent: Maybe<Scalars['Float']>;
  readonly nonProporsalPercent: Maybe<Scalars['Float']>;
  readonly points: Maybe<ReadonlyArray<Maybe<JobsGraphPoints>>>;
  readonly proporsalPercent: Maybe<Scalars['Float']>;
};

export type JobsGraphPoints = {
  readonly __typename?: 'JobsGraphPoints';
  readonly demands: Maybe<Scalars['Int']>;
  readonly hired: Maybe<Scalars['Int']>;
  readonly label: Maybe<Scalars['String']>;
  readonly withProposal: Maybe<Scalars['Int']>;
};

export type JobsMetadata = {
  readonly __typename?: 'JobsMetadata';
  readonly availableExtensions: Maybe<ReadonlyArray<Maybe<JobsAvailableExtensions>>>;
};

export type JobsPayment = Node & {
  readonly __typename?: 'JobsPayment';
  readonly demand: Maybe<JobsDemand>;
  readonly id: Scalars['ID'];
  readonly paymentId: Maybe<Scalars['Int']>;
  readonly payments: Maybe<ReadonlyArray<Maybe<JobsPaymentItem>>>;
};

export type JobsPaymentAttachment = Node & {
  readonly __typename?: 'JobsPaymentAttachment';
  readonly id: Scalars['ID'];
  readonly items: Maybe<ReadonlyArray<Maybe<JobsPaymentAttachmentItem>>>;
  readonly paymentId: Maybe<Scalars['Int']>;
  readonly paymentOfficeId: Maybe<Scalars['Int']>;
  readonly paymentType: Maybe<Scalars['String']>;
  readonly transferReceipt: Maybe<JobsPaymentTransferReceipt>;
};

export type JobsPaymentAttachmentItem = {
  readonly __typename?: 'JobsPaymentAttachmentItem';
  readonly callback: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly fileType: Maybe<Scalars['String']>;
  readonly link: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
};

export type JobsPaymentBillingNote = Node & {
  readonly __typename?: 'JobsPaymentBillingNote';
  readonly id: Scalars['ID'];
  readonly items: Maybe<ReadonlyArray<Maybe<JobsPaymentBillingNoteItem>>>;
  readonly paymentId: Maybe<Scalars['Int']>;
};

export type JobsPaymentBillingNoteAttachment = Node & {
  readonly __typename?: 'JobsPaymentBillingNoteAttachment';
  readonly createdAt: Maybe<Scalars['String']>;
  readonly file: Maybe<JobsPaymentBillingNoteAttachmentSignedUrl>;
  readonly filePathS3: Maybe<Scalars['String']>;
  readonly fileType: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly paymentBillingNoteId: Maybe<Scalars['Int']>;
  readonly paymentId: Maybe<Scalars['Int']>;
  readonly title: Maybe<Scalars['String']>;
};

export type JobsPaymentBillingNoteAttachmentSignedUrl = {
  readonly __typename?: 'JobsPaymentBillingNoteAttachmentSignedUrl';
  readonly url: Maybe<Scalars['String']>;
};

export type JobsPaymentBillingNoteItem = {
  readonly __typename?: 'JobsPaymentBillingNoteItem';
  readonly attachment: Maybe<JobsPaymentBillingNoteAttachment>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
  readonly details: Maybe<Scalars['String']>;
  readonly paymentBillingNoteId: Maybe<Scalars['Int']>;
  readonly paymentId: Maybe<Scalars['Int']>;
};

export type JobsPaymentDetail = Node & {
  readonly __typename?: 'JobsPaymentDetail';
  readonly amount: Maybe<Scalars['Float']>;
  readonly amountFee: Maybe<Scalars['Float']>;
  readonly amountForProfessional: Maybe<Scalars['Float']>;
  readonly amountRefund: Maybe<Scalars['Float']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly demand: Maybe<JobsDemand>;
  readonly description: Maybe<Scalars['String']>;
  readonly hasCharging: Maybe<Scalars['Boolean']>;
  readonly hash: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly paymentDetailId: Maybe<Scalars['Int']>;
  readonly paymentType: Maybe<Scalars['String']>;
  readonly refId: Maybe<Scalars['Int']>;
  readonly status: Maybe<Scalars['String']>;
  readonly statusId: Maybe<Scalars['Int']>;
  readonly statusMessage: Maybe<Scalars['String']>;
  readonly timeline: Maybe<ReadonlyArray<Maybe<JobsPaymentTimeslice>>>;
  readonly totalAttachments: Maybe<Scalars['Int']>;
  readonly totalRefunds: Maybe<Scalars['Int']>;
};

export type JobsPaymentFilter = {
  readonly __typename?: 'JobsPaymentFilter';
  readonly date: Maybe<ReadonlyArray<Maybe<JobsPaymentFilterDate>>>;
  readonly demand: Maybe<ReadonlyArray<Maybe<JobsPaymentFilterDemand>>>;
  readonly status: Maybe<ReadonlyArray<Maybe<JobsPaymentFilterStatus>>>;
};

export type JobsPaymentFilterDate = {
  readonly __typename?: 'JobsPaymentFilterDate';
  readonly filterId: Maybe<Scalars['Int']>;
  readonly interval: Maybe<Scalars['String']>;
  readonly label: Maybe<Scalars['String']>;
};

export type JobsPaymentFilterDemand = {
  readonly __typename?: 'JobsPaymentFilterDemand';
  readonly filterId: Maybe<Scalars['Int']>;
  readonly label: Maybe<Scalars['String']>;
};

export type JobsPaymentFilterStatus = {
  readonly __typename?: 'JobsPaymentFilterStatus';
  readonly filterId: Maybe<Scalars['Int']>;
  readonly label: Maybe<Scalars['String']>;
};

export type JobsPaymentItem = {
  readonly __typename?: 'JobsPaymentItem';
  readonly amount: Maybe<Scalars['Float']>;
  readonly amountFee: Maybe<Scalars['Float']>;
  readonly amountForProfessional: Maybe<Scalars['Float']>;
  readonly amountRefund: Maybe<Scalars['Float']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
  readonly hash: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly statusMessage: Maybe<Scalars['String']>;
};

export type JobsPaymentRefund = Node & {
  readonly __typename?: 'JobsPaymentRefund';
  readonly id: Scalars['ID'];
  readonly items: Maybe<ReadonlyArray<Maybe<JobsPaymentRefundItem>>>;
  readonly paymentId: Maybe<Scalars['Int']>;
  readonly total: Maybe<Scalars['Int']>;
};

export type JobsPaymentRefundAttachment = Node & {
  readonly __typename?: 'JobsPaymentRefundAttachment';
  readonly createdAt: Maybe<Scalars['String']>;
  readonly file: Maybe<JobsPaymentRefundAttachmentSignedUrl>;
  readonly filePathS3: Maybe<Scalars['String']>;
  readonly fileType: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly paymentId: Maybe<Scalars['Int']>;
  readonly paymentRefundId: Maybe<Scalars['Int']>;
  readonly title: Maybe<Scalars['String']>;
};

export type JobsPaymentRefundAttachmentSignedUrl = {
  readonly __typename?: 'JobsPaymentRefundAttachmentSignedUrl';
  readonly url: Maybe<Scalars['String']>;
};

export type JobsPaymentRefundItem = {
  readonly __typename?: 'JobsPaymentRefundItem';
  readonly amount: Maybe<Scalars['Float']>;
  readonly attachment: Maybe<JobsPaymentRefundAttachment>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
  readonly filePathS3: Maybe<Scalars['String']>;
  readonly paymentId: Maybe<Scalars['Int']>;
  readonly paymentRefundId: Maybe<Scalars['Int']>;
  readonly status: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
};

export type JobsPaymentTimeslice = {
  readonly __typename?: 'JobsPaymentTimeslice';
  readonly createdAt: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly statusId: Maybe<Scalars['Int']>;
  readonly statusMessage: Maybe<Scalars['String']>;
};

export type JobsPaymentTransferReceipt = {
  readonly __typename?: 'JobsPaymentTransferReceipt';
  readonly fileUrl: Maybe<Scalars['String']>;
};

export type JobsPaymentsConnection = {
  readonly __typename?: 'JobsPaymentsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<JobsPaymentsEdge>>>;
  readonly pageInfo: PageInfo;
  readonly totalPaymentItems: Maybe<Scalars['Int']>;
  readonly totalPendingValue: Maybe<Scalars['Float']>;
  readonly totalReceivedValue: Maybe<Scalars['Float']>;
};

export type JobsPaymentsEdge = {
  readonly __typename?: 'JobsPaymentsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<JobsPayment>;
};

export type JobsReport = {
  readonly __typename?: 'JobsReport';
  readonly averageResponseTime: Maybe<Scalars['Int']>;
  readonly demands: Maybe<JobsReportRange>;
  readonly graph: Maybe<JobsGraph>;
  readonly hired: Maybe<JobsReportRange>;
  readonly hiredTax: Maybe<JobsReportPercentRange>;
  readonly proposals: Maybe<JobsReportRange>;
};

export type JobsReportPercentRange = {
  readonly __typename?: 'JobsReportPercentRange';
  readonly periodDiffPercent: Maybe<Scalars['Float']>;
  readonly value: Maybe<Scalars['Float']>;
};

export type JobsReportRange = {
  readonly __typename?: 'JobsReportRange';
  readonly periodDiffPercent: Maybe<Scalars['Float']>;
  readonly value: Maybe<Scalars['Int']>;
};

export type JobsSendUserSignatureInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly signatureFileS3: Scalars['String'];
  readonly userId: Scalars['Int'];
};

export type JobsSendUserSignaturePayload = {
  readonly __typename?: 'JobsSendUserSignaturePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly signatureFile: Maybe<Scalars['String']>;
};

export type JobsService = {
  readonly __typename?: 'JobsService';
  readonly active: Maybe<Scalars['Boolean']>;
  readonly id: Maybe<Scalars['String']>;
  readonly jcPag: Maybe<Scalars['Boolean']>;
  readonly name: Maybe<Scalars['String']>;
  readonly order: Maybe<Scalars['Int']>;
  readonly singular: Maybe<Scalars['String']>;
};

export type JobsUpdateUserActingCitiesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly mainTopicId: Scalars['Int'];
  readonly topicIds: ReadonlyArray<InputMaybe<Scalars['Int']>>;
};

export type JobsUpdateUserActingCitiesPayload = {
  readonly __typename?: 'JobsUpdateUserActingCitiesPayload';
  readonly actingCities: Maybe<JobsUserActingCities>;
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type JobsUpdateUserAddressInput = {
  readonly cityId?: InputMaybe<Scalars['Int']>;
  readonly cityTid?: InputMaybe<Scalars['Int']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly complement?: InputMaybe<Scalars['String']>;
  readonly district: Scalars['String'];
  readonly number: Scalars['String'];
  readonly streetName: Scalars['String'];
  readonly userId: Scalars['Int'];
  readonly userName: Scalars['String'];
  readonly zipCode: Scalars['String'];
};

export type JobsUpdateUserAddressPayload = {
  readonly __typename?: 'JobsUpdateUserAddressPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly jobsUser: Maybe<JobsUser>;
};

export type JobsUpdateUserBankDataInput = {
  readonly accountKind: Scalars['String'];
  readonly accountNumber: Scalars['String'];
  readonly accountNumberDigit: Scalars['String'];
  readonly agency: Scalars['String'];
  readonly bankId: Scalars['Int'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly operation?: InputMaybe<Scalars['String']>;
  readonly ownerCnpj?: InputMaybe<Scalars['String']>;
  readonly ownerCpf?: InputMaybe<Scalars['String']>;
  readonly ownerName: Scalars['String'];
};

export type JobsUpdateUserBankDataPayload = {
  readonly __typename?: 'JobsUpdateUserBankDataPayload';
  readonly bankData: Maybe<JobsUserBankData>;
  readonly clientMutationId: Maybe<Scalars['String']>;
};

export type JobsUser = Node & {
  readonly __typename?: 'JobsUser';
  readonly actingCities: Maybe<JobsUserActingCities>;
  readonly address: Maybe<JobsUserAddress>;
  readonly bankData: Maybe<JobsUserBankData>;
  readonly cnpj: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly lawServices: Maybe<ReadonlyArray<Maybe<JobsService>>>;
  readonly name: Maybe<Scalars['String']>;
  readonly pid: Maybe<Scalars['Int']>;
  readonly professionalReview: Maybe<JobsUserProfessionalReview>;
  readonly signature: Maybe<JobsUserSignature>;
  readonly signatureFilled: Maybe<Scalars['Boolean']>;
  readonly statistics: Maybe<JobsReport>;
  readonly taxData: Maybe<JobsUserTaxData>;
  readonly unreadDemandsCounter: Maybe<Scalars['Int']>;
  readonly userId: Maybe<Scalars['Int']>;
  readonly usesEO: Maybe<Scalars['Boolean']>;
};


export type JobsUserStatisticsArgs = {
  endDate: InputMaybe<Scalars['Float']>;
  startDate: InputMaybe<Scalars['Float']>;
};

export type JobsUserActingCities = {
  readonly __typename?: 'JobsUserActingCities';
  readonly cities: Maybe<ReadonlyArray<Maybe<Topic>>>;
  readonly limit: Maybe<Scalars['Int']>;
  readonly main: Maybe<Topic>;
};

export type JobsUserAddress = {
  readonly __typename?: 'JobsUserAddress';
  readonly city: Maybe<Topic>;
  readonly cityId: Maybe<Scalars['Int']>;
  readonly complement: Maybe<Scalars['String']>;
  readonly district: Maybe<Scalars['String']>;
  readonly number: Maybe<Scalars['String']>;
  readonly state: Maybe<Scalars['String']>;
  readonly streetName: Maybe<Scalars['String']>;
  readonly zipCode: Maybe<Scalars['String']>;
};

export type JobsUserBankData = {
  readonly __typename?: 'JobsUserBankData';
  readonly accountId: Maybe<Scalars['Int']>;
  readonly accountKind: Maybe<Scalars['String']>;
  readonly accountNumber: Maybe<Scalars['String']>;
  readonly accountNumberDigit: Maybe<Scalars['String']>;
  readonly agency: Maybe<Scalars['String']>;
  readonly bank: Maybe<Scalars['String']>;
  readonly bankId: Maybe<Scalars['Int']>;
  readonly iuguError: Maybe<Scalars['String']>;
  readonly operation: Maybe<Scalars['String']>;
  readonly ownerCnpj: Maybe<Scalars['String']>;
  readonly ownerCpf: Maybe<Scalars['String']>;
  readonly ownerName: Maybe<Scalars['String']>;
};

export type JobsUserCreateTaxDataInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cnpj?: InputMaybe<Scalars['String']>;
};

export type JobsUserCreateTaxDataPayload = {
  readonly __typename?: 'JobsUserCreateTaxDataPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly user: Maybe<JobsUser>;
};

export type JobsUserIntegration = {
  readonly __typename?: 'JobsUserIntegration';
  readonly isPremium: Maybe<Scalars['Boolean']>;
  readonly isRegistered: Maybe<Scalars['Boolean']>;
  readonly link: Maybe<Scalars['String']>;
  readonly userId: Maybe<Scalars['Float']>;
};

export type JobsUserProfessionalReview = {
  readonly __typename?: 'JobsUserProfessionalReview';
  readonly averageByService: Maybe<ReadonlyArray<Maybe<JobsUserServiceReview>>>;
  readonly generalAverage: Maybe<Scalars['Float']>;
  readonly totalOfDemands: Maybe<Scalars['Int']>;
};

export type JobsUserServiceReview = {
  readonly __typename?: 'JobsUserServiceReview';
  readonly average: Maybe<Scalars['Float']>;
  readonly quantity: Maybe<Scalars['Int']>;
  readonly service: Maybe<Scalars['String']>;
};

export type JobsUserSignature = {
  readonly __typename?: 'JobsUserSignature';
  readonly url: Maybe<Scalars['String']>;
};

export type JobsUserTaxData = {
  readonly __typename?: 'JobsUserTaxData';
  readonly cnpj: Maybe<Scalars['String']>;
  readonly corporateName: Maybe<Scalars['String']>;
};

export type JobsUserUpdateServicesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly professionalServices?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type JobsUserUpdateServicesPayload = {
  readonly __typename?: 'JobsUserUpdateServicesPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly jobsUser: Maybe<JobsUser>;
};

export type JoinCrmBetaInput = {
  readonly betaGroup?: InputMaybe<Scalars['String']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly grantRewards?: InputMaybe<Scalars['Boolean']>;
};

export type JoinCrmBetaPayload = {
  readonly __typename?: 'JoinCRMBetaPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly user: Maybe<User>;
};

export type JournalBlocksConnection = {
  readonly __typename?: 'JournalBlocksConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<JournalBlocksEdge>>>;
  readonly pageInfo: PageInfo;
};

export type JournalBlocksEdge = {
  readonly __typename?: 'JournalBlocksEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Document>;
};

export type JournalMetadata = {
  readonly __typename?: 'JournalMetadata';
  readonly addons: Maybe<SearchMetadataAddons>;
  readonly author: SearchMetadataAuthor;
  readonly body: Maybe<Scalars['String']>;
  readonly date: Maybe<Scalars['Float']>;
  readonly docId: Scalars['String'];
  readonly features: Maybe<SearchMetadataFeatures>;
  readonly highlight: Maybe<Scalars['String']>;
  readonly pageNumber: Scalars['Int'];
  readonly slug: Scalars['String'];
  readonly source: Scalars['String'];
  readonly title: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly url: Scalars['String'];
};


export type JournalMetadataBodyArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
  preferHighlight?: InputMaybe<Scalars['Boolean']>;
};

export type JournalSectionSummary = {
  readonly __typename?: 'JournalSectionSummary';
  readonly documentsAmount: Maybe<Scalars['Int']>;
  readonly firstDecimalPageNumber: Maybe<Scalars['Int']>;
  readonly firstPageNumber: Maybe<Scalars['Int']>;
  readonly lastDecimalPageNumber: Maybe<Scalars['Int']>;
  readonly pagesAmount: Maybe<Scalars['Int']>;
  readonly savedPagesAmount: Maybe<Scalars['Int']>;
};

export type JurisGuidanceSearchSnippent = {
  readonly __typename?: 'JurisGuidanceSearchSnippent';
  readonly statement: Maybe<Scalars['String']>;
  readonly statusLabel: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['Float']>;
};

export type JurisUnderstandingItem = {
  readonly __typename?: 'JurisUnderstandingItem';
  readonly context: Maybe<Scalars['String']>;
  readonly documents: Maybe<ReadonlyArray<Maybe<JurisUnderstandingItemDocument>>>;
  readonly documentsByCourt: Maybe<ReadonlyArray<Maybe<DocumentByCourt>>>;
  readonly documentsByType: Maybe<ReadonlyArray<Maybe<DocumentByType>>>;
  readonly keywords: Maybe<Scalars['String']>;
  readonly lawArea: Maybe<Scalars['String']>;
  readonly prompt: Maybe<Scalars['String']>;
  readonly thesis: Maybe<Scalars['String']>;
  readonly totalDocuments: Maybe<Scalars['Int']>;
  readonly yearsRange: Maybe<YearsRange>;
};

export type JurisUnderstandingItemDocument = {
  readonly __typename?: 'JurisUnderstandingItemDocument';
  readonly court: Maybe<Scalars['String']>;
  readonly date: Maybe<Scalars['String']>;
  readonly id: Maybe<Scalars['String']>;
  readonly slug: Maybe<Scalars['String']>;
  readonly snippet: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
  readonly type: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
};

export type JurisUnderstandings = {
  readonly __typename?: 'JurisUnderstandings';
  readonly id: Maybe<Scalars['String']>;
  readonly model: Maybe<Scalars['String']>;
  readonly query: Maybe<Scalars['String']>;
  readonly queryLimit: Maybe<Scalars['Int']>;
  readonly understandings: Maybe<ReadonlyArray<Maybe<JurisUnderstandingItem>>>;
  readonly updatedAt: Maybe<Scalars['String']>;
  readonly version: Maybe<Scalars['String']>;
};

export type JurisUnderstandingsThesis = {
  readonly __typename?: 'JurisUnderstandingsThesis';
  readonly items: Maybe<ReadonlyArray<Maybe<JurisUnderstandingsThesisItem>>>;
  readonly strategy: Maybe<Scalars['String']>;
};

export type JurisUnderstandingsThesisItem = {
  readonly __typename?: 'JurisUnderstandingsThesisItem';
  readonly _id: Maybe<Scalars['String']>;
  readonly highlight: Maybe<Highlight>;
  readonly ner: Ner;
  readonly thesis: Maybe<Thesis>;
};

export type JurisprudenceMetadata = {
  readonly __typename?: 'JurisprudenceMetadata';
  readonly addons: Maybe<SearchMetadataAddons>;
  readonly author: SearchMetadataAuthor;
  readonly authoritativeExcerpt: Scalars['String'];
  readonly body: Maybe<Scalars['String']>;
  readonly court: Scalars['String'];
  readonly date: Maybe<Scalars['Float']>;
  readonly degree: Scalars['String'];
  readonly docId: Scalars['String'];
  readonly documentCitations: ReadonlyArray<Scalars['String']>;
  readonly features: Maybe<SearchMetadataFeatures>;
  readonly highlight: Maybe<Scalars['String']>;
  readonly isDecisionAdmissibility: Scalars['Boolean'];
  readonly isDecisionMerit: Scalars['Boolean'];
  readonly isMandatoryPrecedent: Scalars['Boolean'];
  readonly judgingOrgan: Scalars['String'];
  readonly lawsuitNumber: Scalars['String'];
  readonly partyNames: ReadonlyArray<Scalars['String']>;
  readonly rapporteurName: Scalars['String'];
  readonly relatedJudges: ReadonlyArray<Scalars['String']>;
  readonly slug: Scalars['String'];
  readonly status: Maybe<Scalars['String']>;
  readonly theme: Scalars['String'];
  readonly themeNumber: Scalars['String'];
  readonly thesis: Scalars['String'];
  readonly thesisType: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly url: Scalars['String'];
  readonly wingmanDocumentGPTSnippetSummary: Maybe<WingmanDocumentGptSnippetSummary>;
};


export type JurisprudenceMetadataBodyArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
  preferHighlight?: InputMaybe<Scalars['Boolean']>;
};

export type JurisprudencesLikeThisConnection = {
  readonly __typename?: 'JurisprudencesLikeThisConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<JurisprudencesLikeThisEdge>>>;
  readonly pageInfo: PageInfo;
};

export type JurisprudencesLikeThisEdge = {
  readonly __typename?: 'JurisprudencesLikeThisEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Document>;
  readonly searchSnippet: Maybe<DocumentSearchSnippet>;
};

export type JusIaCreateThreadAndSaveMessagesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly context?: InputMaybe<Scalars['JSON']>;
  readonly promptId?: InputMaybe<Jus_Ia_Prompt_Id>;
  readonly resourceId: Scalars['String'];
  readonly source?: InputMaybe<Jus_Ia_Source>;
  readonly sourceRef?: InputMaybe<Scalars['String']>;
  readonly templateId?: InputMaybe<Jus_Ia_Template_Id>;
};

export type JusIaCreateThreadAndSaveMessagesPayload = {
  readonly __typename?: 'JusIaCreateThreadAndSaveMessagesPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly messages: Maybe<ReadonlyArray<Maybe<MessageOutputType>>>;
  readonly thread: Maybe<ThreadType>;
};

export type JusIaCreateThreadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly resourceId: Scalars['String'];
  readonly title?: InputMaybe<Scalars['String']>;
};

export type JusIaCreateThreadPayload = {
  readonly __typename?: 'JusIaCreateThreadPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly thread: Maybe<ThreadType>;
};

export type KeycloakAuthorization = {
  readonly __typename?: 'KeycloakAuthorization';
  readonly accessToken: Scalars['String'];
  readonly expiresIn: Maybe<Scalars['Int']>;
  readonly refreshToken: Maybe<Scalars['String']>;
  readonly tokenType: Maybe<Scalars['String']>;
};

export type LgpdMetadata = {
  readonly __typename?: 'LGPDMetadata';
  readonly addons: Maybe<SearchMetadataAddons>;
  readonly author: SearchMetadataAuthor;
  readonly authoritativeExcerpt: Scalars['String'];
  readonly body: Maybe<Scalars['String']>;
  readonly court: Scalars['String'];
  readonly date: Maybe<Scalars['Float']>;
  readonly degree: Scalars['String'];
  readonly docId: Scalars['String'];
  readonly documentCitations: ReadonlyArray<Scalars['String']>;
  readonly features: Maybe<SearchMetadataFeatures>;
  readonly highlight: Maybe<Scalars['String']>;
  readonly isDecisionAdmissibility: Scalars['Boolean'];
  readonly isDecisionMerit: Scalars['Boolean'];
  readonly isMandatoryPrecedent: Scalars['Boolean'];
  readonly judgingOrgan: Scalars['String'];
  readonly jurisprudenceCitations: Maybe<ReadonlyArray<Maybe<Document>>>;
  readonly lawCitations: Maybe<ReadonlyArray<Maybe<Topic>>>;
  readonly lawsuitNumber: Scalars['String'];
  readonly partyNames: ReadonlyArray<Scalars['String']>;
  readonly rapporteurName: Scalars['String'];
  readonly relatedJudges: ReadonlyArray<Scalars['String']>;
  readonly slug: Scalars['String'];
  readonly status: Maybe<Scalars['String']>;
  readonly theme: Scalars['String'];
  readonly themeNumber: Scalars['String'];
  readonly thesis: Scalars['String'];
  readonly thesisType: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly url: Scalars['String'];
  readonly wingmanDocumentGPTSnippetSummary: Maybe<WingmanDocumentGptSnippetSummary>;
};


export type LgpdMetadataBodyArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
};


export type LgpdMetadataJurisprudenceCitationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type LgpdMetadataLawCitationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type LpSegmentToggleOption = {
  readonly __typename?: 'LPSegmentToggleOption';
  readonly description: Scalars['String'];
  readonly label: Scalars['String'];
};

export type LpToggle = {
  readonly __typename?: 'LPToggle';
  readonly defaultOption: Scalars['String'];
  readonly description: LpToggleDescription;
  readonly options: ReadonlyArray<Scalars['String']>;
  readonly optionsBySegment: ReadonlyArray<LpSegmentToggleOption>;
};

export type LpToggleDescription = {
  readonly __typename?: 'LPToggleDescription';
  readonly benefit: Scalars['String'];
};

export type LandingPageButton = {
  readonly __typename?: 'LandingPageButton';
  readonly kind: Maybe<ButtonKindEnum>;
  readonly label: Scalars['String'];
};

export type LandingPageOffer = {
  readonly __typename?: 'LandingPageOffer';
  readonly currentPlanHelpText: Maybe<Scalars['String']>;
  readonly frequency: Maybe<Scalars['String']>;
  readonly frequencyPeriodText: Maybe<Scalars['String']>;
  readonly installmentsText: Maybe<Scalars['String']>;
  readonly isCurrentPlan: Maybe<Scalars['Boolean']>;
  readonly isJusAIOffer: Maybe<Scalars['Boolean']>;
  readonly isMigrateToAnnual: Maybe<Scalars['Boolean']>;
  readonly limitText: Maybe<Scalars['String']>;
  readonly presentationDescription: Maybe<Scalars['String']>;
  readonly presentationName: Scalars['String'];
  readonly priceAfterPromotionalPeriodText: Maybe<Scalars['String']>;
  readonly pricePerInstallments: Maybe<Scalars['String']>;
  readonly priceText: Maybe<Scalars['String']>;
  readonly priceTitle: Maybe<Scalars['String']>;
  readonly promotional: Maybe<Scalars['Boolean']>;
  readonly upgradeAdditionalPriceText: Maybe<Scalars['String']>;
};

export type LandingPageOfferCard = {
  readonly __typename?: 'LandingPageOfferCard';
  readonly benefitsList: ReadonlyArray<Scalars['String']>;
  readonly button: LandingPageButton;
  readonly offer: LandingPageOffer;
  readonly planId: Maybe<Scalars['Int']>;
  readonly planType: Maybe<PlanSubscriptionType>;
  readonly segment: Maybe<Scalars['String']>;
  readonly submitData: LandingPageSubmitData;
  readonly tags: ReadonlyArray<Scalars['String']>;
  readonly templateId: Maybe<Scalars['Int']>;
};

export type LandingPageOffers = {
  readonly __typename?: 'LandingPageOffers';
  readonly currentPlanId: Maybe<Scalars['Int']>;
  readonly experimentEnabled: Scalars['Boolean'];
  readonly isCurrentPlanYearly: Maybe<Scalars['Boolean']>;
  readonly landingPageCards: ReadonlyArray<LandingPageOfferCard>;
  readonly planGroupId: Maybe<Scalars['Int']>;
  readonly planSubscription: Maybe<PlanSubscriptionType>;
  readonly redirectUrl: Maybe<Scalars['String']>;
  readonly segmentToggle: LpToggle;
  readonly shouldShowAnnualOfferBanner: Maybe<Scalars['Boolean']>;
  readonly toggle: LpToggle;
};


export type LandingPageOffersExperimentEnabledArgs = {
  experimentName: InputMaybe<Scalars['String']>;
  variant: InputMaybe<Scalars['String']>;
};

export type LandingPageSubmitData = {
  readonly __typename?: 'LandingPageSubmitData';
  readonly hash: Scalars['String'];
  readonly jwt: Scalars['String'];
  readonly submitUrl: Scalars['String'];
};

export type LawItem = {
  readonly __typename?: 'LawItem';
  readonly codeInt64: Maybe<Scalars['Int64']>;
  readonly description: Maybe<Scalars['String']>;
  readonly lawTopic: Maybe<Topic>;
  readonly revoked: Maybe<Scalars['Boolean']>;
  readonly text: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly topicId: Maybe<Scalars['Int']>;
  readonly type: Maybe<Scalars['String']>;
};


export type LawItemDescriptionArgs = {
  stripTags: InputMaybe<Scalars['Boolean']>;
};

export type LawMetadata = {
  readonly __typename?: 'LawMetadata';
  readonly addons: Maybe<SearchMetadataAddons>;
  readonly articles: ReadonlyArray<LawMetadata>;
  readonly author: SearchMetadataAuthor;
  readonly body: Maybe<Scalars['String']>;
  readonly date: Maybe<Scalars['Float']>;
  readonly docId: Scalars['String'];
  readonly features: Maybe<SearchMetadataFeatures>;
  readonly highlight: Maybe<Scalars['String']>;
  readonly parent: SearchMetadataParent;
  readonly slug: Scalars['String'];
  readonly source: Scalars['String'];
  readonly state: Scalars['String'];
  readonly tags: ReadonlyArray<SearchMetadataTags>;
  readonly title: Maybe<Scalars['String']>;
  readonly titleWithNickname: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly url: Scalars['String'];
};


export type LawMetadataBodyArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
  preferHighlight?: InputMaybe<Scalars['Boolean']>;
};

export type Lawsuit = {
  readonly __typename?: 'Lawsuit';
  readonly cnjNumber: Maybe<CnjNumber>;
  readonly court: Maybe<Scalars['String']>;
  readonly distributionDate: Maybe<Scalars['Float']>;
  readonly entity: Maybe<TopicEntity>;
  readonly judgeName: Maybe<Scalars['String']>;
  readonly judicialPower: Maybe<Scalars['String']>;
  readonly lastUpdate: Maybe<Scalars['Float']>;
  readonly lawArea: Maybe<Scalars['String']>;
  readonly mainSubject: Maybe<CnjSubjects>;
  readonly number: Maybe<Scalars['String']>;
  readonly relatedPeople: ReadonlyArray<Maybe<MotionRelatedPeople>>;
  readonly subjects: ReadonlyArray<Maybe<Scalars['String']>>;
};

export type LawsuitActivityItemsConnection = {
  readonly __typename?: 'LawsuitActivityItemsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<LawsuitActivityItemsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type LawsuitActivityItemsEdge = {
  readonly __typename?: 'LawsuitActivityItemsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmLawsuitActivityItem>;
};

export type LawsuitApigee = {
  readonly __typename?: 'LawsuitApigee';
  readonly confidence: Maybe<LawsuitApigeeConfidence>;
  readonly county: Maybe<Scalars['String']>;
  readonly court: Maybe<Scalars['String']>;
  readonly distributionDate: Maybe<Scalars['String']>;
  readonly distributionYear: Maybe<Scalars['String']>;
  readonly isLetterRogatory: Maybe<Scalars['Boolean']>;
  readonly isPrimaryLawsuit: Maybe<Scalars['Boolean']>;
  readonly kind: Maybe<Scalars['String']>;
  readonly lastActivityDate: Maybe<Scalars['String']>;
  readonly lastProviderUpdate: Maybe<Scalars['String']>;
  readonly lawItems: Maybe<Scalars['JSON']>;
  readonly lawsuitId: Maybe<Scalars['String']>;
  readonly nature: Maybe<Scalars['String']>;
  readonly normalizedClass: Maybe<Scalars['String']>;
  readonly number: Maybe<Scalars['String']>;
  readonly paper: Maybe<Scalars['String']>;
  readonly passivePolo: Maybe<Scalars['Boolean']>;
  readonly rawSubject: Maybe<Scalars['String']>;
  readonly relatedLawsuits: Maybe<ReadonlyArray<Maybe<CproLawsuit>>>;
  readonly relatedPeople: Maybe<ReadonlyArray<Maybe<LawsuitApigeeRelatedPerson>>>;
  readonly situation: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly subject: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
  readonly uf: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
  readonly value: Maybe<Scalars['String']>;
};

export enum LawsuitApigeeConfidence {
  Alta = 'ALTA',
  Baixa = 'BAIXA',
  Media = 'MEDIA'
}

export type LawsuitApigeeRelatedPerson = {
  readonly __typename?: 'LawsuitApigeeRelatedPerson';
  readonly author: Maybe<Scalars['String']>;
  readonly canonicalIdentificationNumber: Maybe<Scalars['String']>;
  readonly defendant: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly poleA: Maybe<Scalars['Boolean']>;
  readonly poleB: Maybe<Scalars['Boolean']>;
  readonly status: Maybe<Scalars['String']>;
};

export type LawsuitAssistantMessage = {
  readonly __typename?: 'LawsuitAssistantMessage';
  readonly aiResponse: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly feedbackRating: Maybe<Scalars['JSON']>;
  readonly id: Maybe<Scalars['String']>;
  readonly lastActivityId: Maybe<Scalars['String']>;
  readonly lawsuitId: Maybe<Scalars['String']>;
  readonly messageType: Maybe<Scalars['String']>;
  readonly metadata: Maybe<Scalars['JSON']>;
  readonly pid: Maybe<Scalars['Int']>;
  readonly respondedAt: Maybe<Scalars['Float']>;
  readonly status: Maybe<Scalars['String']>;
  readonly userMessage: Maybe<Scalars['String']>;
};

export enum LawsuitAssistantMessageRating {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

export type LawsuitAssistantMessagesConnection = {
  readonly __typename?: 'LawsuitAssistantMessagesConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<LawsuitAssistantMessagesEdge>>>;
  readonly pageInfo: PageInfo;
};

export type LawsuitAssistantMessagesEdge = {
  readonly __typename?: 'LawsuitAssistantMessagesEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<LawsuitAssistantMessage>;
};

export type LawsuitAssistantQuestions = {
  readonly __typename?: 'LawsuitAssistantQuestions';
  /** @deprecated Use LawsuitAssistantSuggestions / lawsuitAssistantSuggestions instead. */
  readonly lawsuitId: Maybe<Scalars['String']>;
  /** @deprecated Use LawsuitAssistantSuggestions / lawsuitAssistantSuggestions instead. */
  readonly questions: Maybe<Scalars['JSON']>;
  /** @deprecated Use LawsuitAssistantSuggestions / lawsuitAssistantSuggestions instead. */
  readonly versionId: Maybe<Scalars['String']>;
};

export type LawsuitAssistantSuggestion = {
  readonly __typename?: 'LawsuitAssistantSuggestion';
  readonly consumedAt: Maybe<Scalars['Float']>;
  readonly suggestionId: Maybe<Scalars['String']>;
  readonly text: Maybe<Scalars['String']>;
};

export type LawsuitAssistantSuggestions = Node & {
  readonly __typename?: 'LawsuitAssistantSuggestions';
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly id: Scalars['ID'];
  readonly lawsuitId: Maybe<Scalars['String']>;
  readonly pid: Maybe<Scalars['Int']>;
  readonly suggestions: Maybe<ReadonlyArray<Maybe<LawsuitAssistantSuggestion>>>;
  readonly versionId: Maybe<Scalars['String']>;
};

export type LawsuitAttachmentsConnection = {
  readonly __typename?: 'LawsuitAttachmentsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<LawsuitAttachmentsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type LawsuitAttachmentsEdge = {
  readonly __typename?: 'LawsuitAttachmentsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmLawsuitAttachment>;
};

export type LawsuitCase = Node & {
  readonly __typename?: 'LawsuitCase';
  readonly caseId: Maybe<Scalars['String']>;
  readonly entityCount: Maybe<Scalars['Int']>;
  readonly entityId: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly lawsuitCount: Maybe<Scalars['Int']>;
  readonly lawsuits: Maybe<LawsuitCaseLawsuitsConnection>;
  readonly llmTitle: Maybe<CrmCaseLlmTitle>;
  readonly mostRecentDistributionDate: Maybe<Scalars['Float']>;
  readonly oldestDistributionDate: Maybe<Scalars['Float']>;
  readonly status: Maybe<Scalars['String']>;
  readonly summarization: Maybe<CrmCaseSummarization>;
  readonly updatedAt: Maybe<Scalars['Float']>;
};


export type LawsuitCaseLawsuitsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};

export type LawsuitCaseEntityRef = {
  readonly __typename?: 'LawsuitCaseEntityRef';
  readonly caseId: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly entityId: Maybe<Scalars['String']>;
  readonly lawsuitCase: Maybe<LawsuitCase>;
  readonly lawsuitCountForEntity: Maybe<Scalars['Int']>;
  readonly lawsuits: Maybe<ReadonlyArray<Maybe<LawsuitCaseEntityRefLawsuit>>>;
  readonly mostRecentLawsuitDate: Maybe<Scalars['Float']>;
  readonly oldestLawsuit: Maybe<CrmLawsuit>;
  readonly oldestLawsuitId: Maybe<Scalars['String']>;
  readonly oldestLawsuitPole: Maybe<Scalars['String']>;
  readonly predominantPole: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['Float']>;
};

export type LawsuitCaseEntityRefLawsuit = {
  readonly __typename?: 'LawsuitCaseEntityRefLawsuit';
  readonly addedAt: Maybe<Scalars['Float']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
  readonly lawsuitId: Maybe<Scalars['String']>;
};

export type LawsuitCaseLawsuitsConnection = {
  readonly __typename?: 'LawsuitCaseLawsuitsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<LawsuitCaseLawsuitsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type LawsuitCaseLawsuitsEdge = {
  readonly __typename?: 'LawsuitCaseLawsuitsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmLawsuit>;
};

export type LawsuitCasesByEntityConnection = {
  readonly __typename?: 'LawsuitCasesByEntityConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<LawsuitCasesByEntityEdge>>>;
  readonly pageInfo: PageInfo;
};

export type LawsuitCasesByEntityEdge = {
  readonly __typename?: 'LawsuitCasesByEntityEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<LawsuitCaseEntityRef>;
};

export type LawsuitDecision = {
  readonly __typename?: 'LawsuitDecision';
  readonly result: Maybe<Scalars['String']>;
  readonly text: Maybe<Scalars['String']>;
};

export type LawsuitDigesto = {
  readonly __typename?: 'LawsuitDigesto';
  readonly confidence: Maybe<LawsuitDigestoConfidence>;
  readonly county: Maybe<Scalars['String']>;
  readonly court: Maybe<Scalars['String']>;
  readonly distributionYear: Maybe<Scalars['String']>;
  readonly isLetterRogatory: Maybe<Scalars['Boolean']>;
  readonly isPrimaryLawsuit: Maybe<Scalars['Boolean']>;
  readonly kind: Maybe<Scalars['String']>;
  readonly lawItems: Maybe<Scalars['JSON']>;
  readonly nature: Maybe<Scalars['String']>;
  readonly number: Maybe<Scalars['String']>;
  readonly paper: Maybe<Scalars['String']>;
  readonly rawSubject: Maybe<Scalars['String']>;
  readonly relatedLawsuits: Maybe<ReadonlyArray<Maybe<CrmLawsuit>>>;
  readonly subject: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
};

export enum LawsuitDigestoConfidence {
  Alta = 'ALTA',
  Baixa = 'BAIXA',
  Media = 'MEDIA'
}

export type LawsuitGpt = {
  readonly __typename?: 'LawsuitGpt';
  readonly answers: Maybe<ReadonlyArray<Maybe<LawsuitGptAnswer>>>;
  readonly completion: Maybe<Scalars['String']>;
  readonly key: Maybe<Scalars['String']>;
};

export type LawsuitGptAnswer = {
  readonly __typename?: 'LawsuitGptAnswer';
  readonly answer: Maybe<Scalars['String']>;
  readonly questionId: Maybe<Scalars['String']>;
};

export type LawsuitGptCreateCompletionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId?: InputMaybe<Scalars['String']>;
  readonly promptId?: InputMaybe<Scalars['String']>;
  readonly term: Scalars['String'];
};

export type LawsuitGptCreateCompletionPayload = {
  readonly __typename?: 'LawsuitGptCreateCompletionPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuitGpt: Maybe<LawsuitGpt>;
};

export type LawsuitMetadata = {
  readonly __typename?: 'LawsuitMetadata';
  readonly amount: Maybe<Scalars['Float']>;
  readonly body: Maybe<Scalars['String']>;
  readonly cnjNumber: Maybe<CnjNumber>;
  readonly court: Scalars['String'];
  readonly courtInstance: Scalars['String'];
  readonly courtSection: Scalars['String'];
  readonly date: Maybe<Scalars['Float']>;
  readonly distributionDate: Maybe<Scalars['Float']>;
  readonly district: Scalars['String'];
  readonly docId: Scalars['String'];
  readonly firstActivityDate: Maybe<Scalars['Float']>;
  readonly highlight: Maybe<Scalars['String']>;
  readonly isJusticeSecret: Scalars['Boolean'];
  readonly judgeName: Scalars['String'];
  readonly kind: Scalars['String'];
  readonly lastActivityDate: Maybe<Scalars['Float']>;
  readonly lastActivityText: Scalars['String'];
  readonly lawsuitTitle: Maybe<Scalars['String']>;
  readonly nature: Scalars['String'];
  readonly number: Maybe<Scalars['String']>;
  readonly publicationPersons: ReadonlyArray<SearchMetadataPublicationPerson>;
  readonly relatedPeople: ReadonlyArray<SearchMetadataPerson>;
  readonly representedPersonLawyers: ReadonlyArray<SearchMetadataLawyer>;
  readonly subject: Scalars['String'];
  readonly title: Maybe<Scalars['String']>;
  readonly topicSourceId: Maybe<Scalars['Int']>;
  readonly topicSourceSlug: Maybe<Scalars['String']>;
  readonly url: Scalars['String'];
};


export type LawsuitMetadataBodyArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
  preferHighlight?: InputMaybe<Scalars['Boolean']>;
};

export type LawsuitNumberDetails = {
  readonly __typename?: 'LawsuitNumberDetails';
  readonly courtAcronym: Maybe<Scalars['String']>;
  readonly courtName: Maybe<Scalars['String']>;
  readonly courtSection: Maybe<Scalars['String']>;
  readonly district: Maybe<Scalars['String']>;
  readonly judicialBranch: Maybe<Scalars['String']>;
  readonly stateAcronym: Maybe<Scalars['String']>;
};

export type LawsuitPartyEntitiesFilterInput = {
  readonly ageRange?: InputMaybe<AgeRangeEnum>;
  readonly lawsuitStates?: InputMaybe<ReadonlyArray<InputMaybe<StateEnum>>>;
};

export type LawsuitPartyEntitiesRelationshipFilterInput = {
  readonly relationshipTypes?: InputMaybe<ReadonlyArray<InputMaybe<LawsuitPartyEntityRelationshipType>>>;
};

export type LawsuitPartyEntityMetadata = {
  readonly __typename?: 'LawsuitPartyEntityMetadata';
  readonly age: Maybe<Scalars['String']>;
  readonly aggregations: Maybe<EntityPersistedAggregations>;
  readonly alternativeName: Maybe<Scalars['String']>;
  readonly body: Maybe<Scalars['String']>;
  readonly candidacy: Maybe<SearchMetadataLawsuitPartyEntityCandidacy>;
  readonly date: Maybe<Scalars['Float']>;
  readonly displayName: Maybe<Scalars['String']>;
  readonly docId: Scalars['String'];
  readonly entityId: Maybe<Scalars['String']>;
  readonly highlight: Maybe<Scalars['String']>;
  readonly identificationName: Maybe<Scalars['String']>;
  readonly identificationNumber: Maybe<Scalars['String']>;
  readonly identificationType: Maybe<Scalars['String']>;
  readonly state: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
  readonly uf: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
};


export type LawsuitPartyEntityMetadataBodyArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
  preferHighlight?: InputMaybe<Scalars['Boolean']>;
};

export enum LawsuitPartyEntityRelationshipType {
  Holding = 'HOLDING',
  IndividualCompany = 'INDIVIDUAL_COMPANY',
  Mei = 'MEI',
  Partnership = 'PARTNERSHIP'
}

export type LawsuitPartyMetadata = {
  readonly __typename?: 'LawsuitPartyMetadata';
  readonly body: Maybe<Scalars['String']>;
  readonly canonicalEntityCount: Scalars['Int'];
  readonly contactLawsuitCount: Scalars['Int'];
  readonly courts: ReadonlyArray<SearchMetadataCourtCounter>;
  readonly date: Maybe<Scalars['Float']>;
  readonly degrees: ReadonlyArray<SearchMetadataDegreeCounter>;
  readonly docId: Scalars['String'];
  readonly highlight: Maybe<Scalars['String']>;
  readonly lawsuitCount: Scalars['Int'];
  readonly relatedPeople: ReadonlyArray<SearchMetadataRelatedPeopleCounter>;
  readonly sourceTopicId: Scalars['Int'];
  readonly states: ReadonlyArray<SearchMetadataStateCounter>;
  readonly title: Maybe<Scalars['String']>;
  readonly topicSlug: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly url: Scalars['String'];
};


export type LawsuitPartyMetadataBodyArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
  preferHighlight?: InputMaybe<Scalars['Boolean']>;
};

export type LawsuitQaEvaluator = {
  readonly __typename?: 'LawsuitQaEvaluator';
  readonly completed: Maybe<Scalars['Int']>;
  readonly config: Maybe<Scalars['JSON']>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly evaluationId: Maybe<Scalars['String']>;
  readonly failed: Maybe<Scalars['Int']>;
  readonly feature: Maybe<Scalars['String']>;
  readonly judgeOverrides: Maybe<Scalars['JSON']>;
  readonly results: Maybe<ReadonlyArray<Maybe<LawsuitQaEvaluatorItem>>>;
  readonly status: Maybe<Scalars['String']>;
  readonly total: Maybe<Scalars['Int']>;
  readonly updatedAt: Maybe<Scalars['Float']>;
  readonly userMessage: Maybe<Scalars['String']>;
};

export type LawsuitQaEvaluatorItem = {
  readonly __typename?: 'LawsuitQaEvaluatorItem';
  readonly caseKey: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly error: Maybe<Scalars['String']>;
  readonly evalResponse: Maybe<Scalars['String']>;
  readonly evaluationId: Maybe<Scalars['String']>;
  readonly flowName: Maybe<Scalars['String']>;
  readonly hadAttachments: Maybe<Scalars['Boolean']>;
  readonly id: Maybe<Scalars['String']>;
  readonly judgeError: Maybe<Scalars['String']>;
  readonly judgeRawResponse: Maybe<Scalars['JSON']>;
  readonly judgeResults: Maybe<Scalars['JSON']>;
  readonly lawsuitCNJ: Maybe<Scalars['String']>;
  readonly lawsuitId: Maybe<Scalars['String']>;
  readonly lawsuitStartDate: Maybe<Scalars['String']>;
  readonly metadata: Maybe<Scalars['JSON']>;
  readonly status: Maybe<Scalars['String']>;
  readonly systemPrompt: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['Float']>;
  readonly userPrompt: Maybe<Scalars['String']>;
  readonly userQuestion: Maybe<Scalars['String']>;
};

export enum LawsuitQaEvaluatorModel {
  Gemini_2_5Flash = 'GEMINI_2_5_FLASH',
  Gpt_4O = 'GPT_4O',
  Gpt_4OMini = 'GPT_4O_MINI',
  Sabiazinho_3 = 'SABIAZINHO_3',
  Sabiazinho_4 = 'SABIAZINHO_4',
  Sabia_3_1 = 'SABIA_3_1'
}

export type LawsuitRelevantEvent = {
  readonly __typename?: 'LawsuitRelevantEvent';
  readonly completeClassification: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly coverIds: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly eventId: Maybe<Scalars['String']>;
  readonly eventType: Maybe<Scalars['String']>;
  readonly source: Maybe<CrmTimelineItem>;
};

export enum LawsuitRelevantEventType {
  Acordao = 'ACORDAO',
  Audiencia = 'AUDIENCIA',
  Decisao = 'DECISAO',
  Execucao = 'EXECUCAO',
  Sentenca = 'SENTENCA'
}

export type LawsuitRestrictionInput = {
  readonly justiceSecret: Scalars['Boolean'];
  readonly sensitive: Scalars['Boolean'];
};

export type LawsuitRestrictions = {
  readonly __typename?: 'LawsuitRestrictions';
  readonly createdAt: Maybe<Scalars['String']>;
  readonly justiceSecretSignal: Maybe<LawsuitRestrictionsJusticeSecretSignal>;
  readonly sensitiveSignal: Maybe<LawsuitRestrictionsSensitiveSignal>;
  readonly updatedAt: Maybe<Scalars['String']>;
};

export type LawsuitRestrictionsJusticeSecretSignal = {
  readonly __typename?: 'LawsuitRestrictionsJusticeSecretSignal';
  readonly createdAt: Maybe<Scalars['String']>;
  readonly externalEntity: Maybe<Scalars['String']>;
  readonly externalId: Maybe<Scalars['String']>;
  readonly justiceSecretKind: Maybe<Scalars['String']>;
  readonly justiceSecretReason: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly method: Maybe<Scalars['String']>;
  readonly signalOrigin: Maybe<Scalars['String']>;
};

export type LawsuitRestrictionsSensitiveSignal = {
  readonly __typename?: 'LawsuitRestrictionsSensitiveSignal';
  readonly createdAt: Maybe<Scalars['String']>;
  readonly externalEntity: Maybe<Scalars['String']>;
  readonly externalId: Maybe<Scalars['String']>;
  readonly method: Maybe<Scalars['String']>;
  readonly sensitiveKind: Maybe<Scalars['String']>;
  readonly sensitiveReason: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly signalOrigin: Maybe<Scalars['String']>;
};

export type LawsuitSearch = {
  readonly __typename?: 'LawsuitSearch';
  readonly detectedQueryType: Scalars['String'];
  readonly result: Result;
  readonly rules: Maybe<ResultRules>;
  readonly searchStatus: Scalars['String'];
  readonly searchType: Scalars['String'];
};

export type LawsuitSearchSnippet = {
  readonly __typename?: 'LawsuitSearchSnippet';
  readonly cnjNumber: Maybe<CnjNumber>;
  readonly distributionDate: Maybe<Scalars['Float']>;
  readonly lawArea: Maybe<Scalars['String']>;
  readonly subjects: ReadonlyArray<Scalars['String']>;
};

export type LawsuitSearchTerm = {
  readonly __typename?: 'LawsuitSearchTerm';
  readonly term: Maybe<Scalars['String']>;
  readonly type: Maybe<Scalars['String']>;
};

export type LawsuitSeenInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
};

export type LawsuitSeenPayload = {
  readonly __typename?: 'LawsuitSeenPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
};

export type LawsuitSessionAssistantMessage = {
  readonly __typename?: 'LawsuitSessionAssistantMessage';
  readonly lawsuitId: Maybe<Scalars['String']>;
  readonly sessionId: Maybe<Scalars['String']>;
  readonly text: Maybe<Scalars['String']>;
  readonly type: Maybe<Scalars['String']>;
  readonly userId: Maybe<Scalars['String']>;
};

export type LawsuitUnlockInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
};

export type LawsuitUnlockPayload = {
  readonly __typename?: 'LawsuitUnlockPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
};

export type LawsuitUpdateRequestInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
  readonly lockedItemsCount?: InputMaybe<Scalars['Int']>;
};

export type LawsuitUpdateRequestPayload = {
  readonly __typename?: 'LawsuitUpdateRequestPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
};

export type LawsuitUserInteraction = Node & {
  readonly __typename?: 'LawsuitUserInteraction';
  readonly chatBlockSeenIds: Maybe<Scalars['String']>;
  readonly currentExplanationVersion: Maybe<Scalars['String']>;
  readonly explanationSeen: Maybe<Scalars['Boolean']>;
  readonly featureUsage: Maybe<Scalars['JSON']>;
  readonly firstUserRequestedUpdate: Maybe<Scalars['Float']>;
  readonly id: Scalars['ID'];
  readonly lastSeenActivityDate: Maybe<Scalars['Float']>;
  readonly lastSeenActivityDateBeforeUpdate: Maybe<Scalars['Float']>;
  readonly lastSeenActivityId: Maybe<Scalars['String']>;
  readonly lastSeenStep: Maybe<Scalars['String']>;
  readonly lastUserRequestedUpdate: Maybe<Scalars['Float']>;
  readonly lawsuitId: Maybe<Scalars['String']>;
  readonly lockedItemsCount: Maybe<Scalars['Int']>;
  readonly orgId: Maybe<Scalars['String']>;
  readonly requestedUpdateCount: Maybe<Scalars['Int']>;
};

export type LawsuitsApigee = {
  readonly __typename?: 'LawsuitsApigee';
  readonly document: Maybe<Scalars['String']>;
  readonly lawsuits: ReadonlyArray<LawsuitApigee>;
  readonly name: Maybe<Scalars['String']>;
};

export type LawsuitsDigestoByDocument = {
  readonly __typename?: 'LawsuitsDigestoByDocument';
  readonly document: Maybe<Scalars['String']>;
  readonly lawsuits: ReadonlyArray<LawsuitDigesto>;
  readonly name: Maybe<Scalars['String']>;
};

export type LawsuitsFilterInput = {
  readonly lawsuitStates?: InputMaybe<ReadonlyArray<InputMaybe<StateEnum>>>;
  readonly relatedPeopleNames?: InputMaybe<Scalars['String']>;
};

export type Lawyer = {
  readonly __typename?: 'Lawyer';
  readonly name: Maybe<Scalars['String']>;
  readonly oabNumber: Maybe<Scalars['String']>;
  readonly oabType: Maybe<Scalars['String']>;
  readonly oabUF: Maybe<Scalars['String']>;
};

export type LawyersLikeThisConnection = {
  readonly __typename?: 'LawyersLikeThisConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<LawyersLikeThisEdge>>>;
  readonly pageInfo: PageInfo;
};

export type LawyersLikeThisEdge = {
  readonly __typename?: 'LawyersLikeThisEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Profile>;
};

export enum LayoutVariantEnum {
  Default = 'DEFAULT'
}

export type LeanRelatedLawsuit = {
  readonly __typename?: 'LeanRelatedLawsuit';
  readonly lawsuit: Maybe<CrmLawsuit>;
  readonly lawsuitId: Maybe<Scalars['String']>;
  readonly number: Maybe<Scalars['String']>;
  readonly relationType: Maybe<Scalars['String']>;
};

export type LegacyLegalCase = Node & {
  readonly __typename?: 'LegacyLegalCase';
  readonly canAfford: Maybe<Scalars['Boolean']>;
  readonly hiringIntent: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly legalCaseId: Maybe<Scalars['Float']>;
  readonly sender: Maybe<Scalars['JSON']>;
  readonly senderName: Maybe<Scalars['String']>;
  readonly tags: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly text: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
  readonly type: Maybe<Scalars['String']>;
};

export type LegalCase = Node & {
  readonly __typename?: 'LegalCase';
  readonly body: Maybe<Scalars['JSON']>;
  readonly canAfford: Maybe<Scalars['Boolean']>;
  readonly contactOptions: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly conversation: Maybe<Conversation>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly customCampaign: Maybe<Scalars['String']>;
  readonly deletedAt: Maybe<Scalars['Float']>;
  readonly deletedBy: Maybe<Profile>;
  readonly experiments: Maybe<Scalars['JSON']>;
  readonly expertise: Maybe<Topic>;
  readonly expiresAfterHours: Maybe<Scalars['Int']>;
  readonly formAnswers: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly formVersion: Maybe<Scalars['String']>;
  readonly hasTag: Maybe<Scalars['Boolean']>;
  readonly hiringIntent: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly initialCost: Maybe<Scalars['Int']>;
  readonly isArchivedByViewer: Maybe<Scalars['Boolean']>;
  readonly isExclusiveToMe: Maybe<Scalars['Boolean']>;
  readonly isReadByViewer: Maybe<Scalars['Boolean']>;
  readonly isRespondedByViewer: Maybe<Scalars['Boolean']>;
  readonly isStructured: Maybe<Scalars['Boolean']>;
  readonly legalCaseId: Maybe<Scalars['Float']>;
  readonly location: Maybe<Topic>;
  readonly maxAnswers: Maybe<Scalars['Int']>;
  readonly migrationId: Maybe<Scalars['Float']>;
  readonly oabPrice: Maybe<OabPrice>;
  readonly obfuscatedEmail: Maybe<Scalars['String']>;
  readonly obfuscatedPhone: Maybe<Scalars['String']>;
  readonly originalCost: Maybe<Scalars['Int']>;
  readonly phone: Maybe<Scalars['String']>;
  readonly rawSenderMessage: Maybe<Scalars['String']>;
  readonly readBy: Maybe<LegalCaseReadedProfilesConnection>;
  readonly readByCount: Maybe<Scalars['Int']>;
  readonly referrer: Maybe<Scalars['String']>;
  readonly respondedBy: Maybe<LegalCaseRespondedProfilesConnection>;
  readonly respondedByCount: Maybe<Scalars['Int']>;
  readonly scheduleDealMailAt: Maybe<Scalars['Float']>;
  readonly score: Maybe<Scalars['Float']>;
  readonly scoreWeight: Maybe<Scalars['Float']>;
  readonly sender: Maybe<Profile>;
  readonly senderMessage: Maybe<Scalars['String']>;
  readonly smsStatus: Maybe<Scalars['String']>;
  readonly source: Maybe<Scalars['String']>;
  readonly stats: Maybe<LegalCaseStats>;
  readonly status: Maybe<Scalars['String']>;
  readonly subject: Maybe<Topic>;
  readonly subjectId: Maybe<Scalars['Float']>;
  readonly tags: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly unreadStats: Maybe<LegalCaseStats>;
  readonly updatedAt: Maybe<Scalars['Float']>;
};


export type LegalCaseHasTagArgs = {
  name: Scalars['String'];
};


export type LegalCaseReadByArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type LegalCaseRespondedByArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

export type LegalCaseFeed = {
  readonly __typename?: 'LegalCaseFeed';
  readonly legalCases: Maybe<ReadonlyArray<Maybe<LegalCase>>>;
};

export type LegalCaseProfileInfo = Node & {
  readonly __typename?: 'LegalCaseProfileInfo';
  readonly agreedCrmTermsIp: Maybe<Scalars['String']>;
  readonly agreedCrmTermsTime: Maybe<Scalars['Float']>;
  readonly agreedMigration: Maybe<Scalars['Boolean']>;
  readonly agreedMigrationIp: Maybe<Scalars['String']>;
  readonly agreedMigrationTime: Maybe<Scalars['Float']>;
  readonly agreedTermsIp: Maybe<Scalars['String']>;
  readonly agreedTermsTime: Maybe<Scalars['Float']>;
  readonly bids: Maybe<Scalars['Int']>;
  readonly calendar: Maybe<CrmCalendar>;
  readonly calendarAclCreatedAt: Maybe<Scalars['Float']>;
  readonly calendarId: Maybe<Scalars['String']>;
  readonly christmasLotteryStatus: Maybe<Scalars['String']>;
  readonly crmOnboardDisabledAt: Maybe<Scalars['Float']>;
  readonly didBuyConsumableLawsuitUpdate: Maybe<Scalars['Boolean']>;
  readonly enableEventRemindNotification: Maybe<Scalars['Boolean']>;
  readonly enableNewLawsuitProgressNotification: Maybe<Scalars['Boolean']>;
  readonly enableNewMessageNotification: Maybe<Scalars['Boolean']>;
  readonly enableNewPublicationDigestNotification: Maybe<Scalars['Boolean']>;
  readonly enableTaskAndEventDigestNotification: Maybe<Scalars['Boolean']>;
  readonly events: Maybe<ReadonlyArray<Maybe<CrmEvent>>>;
  readonly featureFlags: Maybe<Scalars['JSON']>;
  readonly hasAlertNotificationSinceRead: Maybe<Scalars['Boolean']>;
  readonly hasOpenApp: Maybe<Scalars['Boolean']>;
  readonly hasSharedEntity: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly isLockedByTime: Maybe<Scalars['Boolean']>;
  readonly isPhoneConfirmed: Maybe<Scalars['Boolean']>;
  readonly lastLoginOrganization: Maybe<Organization>;
  readonly lastPendingPushNotificationSentAt: Maybe<Scalars['Float']>;
  readonly lastReadUpdates: Maybe<Scalars['Float']>;
  readonly lastSeenDashboard: Maybe<Scalars['Float']>;
  readonly lastSeenOpportunities: Maybe<Scalars['Float']>;
  readonly lawsuitGptUsage: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly lockedUntil: Maybe<Scalars['Float']>;
  readonly migrated: Maybe<Scalars['Boolean']>;
  readonly migrationBonusReceived: Maybe<Scalars['Int']>;
  readonly organizationMembership: Maybe<ReadonlyArray<Maybe<OrganizationMember>>>;
  readonly profileId: Maybe<Scalars['Int']>;
  readonly sawAcademy: Maybe<Scalars['Boolean']>;
  readonly sawCrmInvitation: Maybe<Scalars['Boolean']>;
  readonly sawCrmOnboardInvitation: Maybe<Scalars['Boolean']>;
  readonly sawCrmOnboardMonitorOab: Maybe<Scalars['Boolean']>;
  readonly sawCrmOnboardOrganization: Maybe<Scalars['Boolean']>;
  readonly sawCrmTerms: Maybe<Scalars['Boolean']>;
  readonly sawOfficeContacts: Maybe<Scalars['Boolean']>;
  readonly sawOnboard: Maybe<Scalars['Boolean']>;
  readonly sawOrganizationOnboard: Maybe<Scalars['Boolean']>;
  readonly sawTerms: Maybe<Scalars['Boolean']>;
  readonly showViolationModal: Maybe<Scalars['Boolean']>;
};


export type LegalCaseProfileInfoEventsArgs = {
  contactId: InputMaybe<Scalars['String']>;
  eventType: InputMaybe<Scalars['String']>;
  lawsuitId: InputMaybe<Scalars['String']>;
  organizationId: InputMaybe<Scalars['Int']>;
  singleEvents: InputMaybe<Scalars['Boolean']>;
  timeMax: InputMaybe<Scalars['Float']>;
  timeMin: InputMaybe<Scalars['Float']>;
};

export type LegalCaseReadedProfilesConnection = {
  readonly __typename?: 'LegalCaseReadedProfilesConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<LegalCaseReadedProfilesEdge>>>;
  readonly pageInfo: PageInfo;
};

export type LegalCaseReadedProfilesEdge = {
  readonly __typename?: 'LegalCaseReadedProfilesEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Profile>;
};

export type LegalCaseRespondedProfilesConnection = {
  readonly __typename?: 'LegalCaseRespondedProfilesConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<LegalCaseRespondedProfilesEdge>>>;
  readonly pageInfo: PageInfo;
};

export type LegalCaseRespondedProfilesEdge = {
  readonly __typename?: 'LegalCaseRespondedProfilesEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Profile>;
};

export type LegalCaseStats = {
  readonly __typename?: 'LegalCaseStats';
  readonly conversationsAmount: Maybe<Scalars['Int']>;
  readonly legalCaseId: Maybe<Scalars['Float']>;
};


export type LegalCaseStatsConversationsAmountArgs = {
  status: InputMaybe<Scalars['String']>;
};

export type LegalThesis = {
  readonly __typename?: 'LegalThesis';
  readonly theme: Maybe<Scalars['String']>;
  readonly thesis: Maybe<Scalars['String']>;
};

export type LegalThesisClusterLabels = {
  readonly __typename?: 'LegalThesisClusterLabels';
  readonly clusterId: Maybe<Scalars['String']>;
  readonly clusterLabel: Maybe<Scalars['String']>;
};

export type LikeDocumentInput = {
  readonly artifact: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId?: InputMaybe<Scalars['NumericID']>;
  readonly id?: InputMaybe<Scalars['Int']>;
  readonly vote: Scalars['String'];
};

export type LikeDocumentPayload = {
  readonly __typename?: 'LikeDocumentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly document: Maybe<Document>;
  readonly profilesVoteEdge: Maybe<ProfilesVoteEdge>;
};

export type LinkCrmTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly entityId: Scalars['String'];
  readonly entityType: Scalars['String'];
  readonly tagId: Scalars['String'];
};

export type LinkCrmTagPayload = {
  readonly __typename?: 'LinkCRMTagPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly entity: Maybe<CrmTaggable>;
  readonly link: Maybe<CrmTagLink>;
  readonly linkEdge: Maybe<CrmEntityTagsEdge>;
};

export type LinkLayerConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly conversationId: Scalars['Int'];
  readonly layerId: Scalars['String'];
};

export type LinkLayerConversationPayload = {
  readonly __typename?: 'LinkLayerConversationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly conversation: Maybe<Conversation>;
};

export type LinkedLawsuitConnection = {
  readonly __typename?: 'LinkedLawsuitConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<LinkedLawsuitEdge>>>;
  readonly pageInfo: PageInfo;
};

export type LinkedLawsuitEdge = {
  readonly __typename?: 'LinkedLawsuitEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmLinkedLawsuit>;
};

export type ListPublicationAlertsConnection = {
  readonly __typename?: 'ListPublicationAlertsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ListPublicationAlertsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ListPublicationAlertsEdge = {
  readonly __typename?: 'ListPublicationAlertsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<PublicationAlert>;
};

export type LoginInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly password: Scalars['String'];
  readonly username: Scalars['String'];
};

export type LoginPayload = {
  readonly __typename?: 'LoginPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly cookie: Maybe<Scalars['String']>;
  readonly user: Maybe<User>;
};

export type MarkUserExcludedAsAdminInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly uid: Scalars['Int'];
};

export type MarkUserExcludedAsAdminPayload = {
  readonly __typename?: 'MarkUserExcludedAsAdminPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly user: Maybe<User>;
};

export type Match = {
  readonly __typename?: 'Match';
  readonly artifacts: Maybe<ReadonlyArray<Maybe<Artifact>>>;
  readonly isKeyValue: Scalars['Boolean'];
  readonly key: Scalars['String'];
};

export type MaterializeJusiaPlanInput = {
  readonly areaUuid: Scalars['String'];
  readonly bundleId?: InputMaybe<Scalars['String']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly moduleSlug?: InputMaybe<Scalars['String']>;
  readonly planName: Scalars['String'];
  readonly seats?: InputMaybe<Scalars['Int']>;
};

export type MaterializeJusiaPlanPayload = {
  readonly __typename?: 'MaterializeJusiaPlanPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
};

export type MergeContactsInput = {
  readonly children: ReadonlyArray<InputMaybe<Scalars['String']>>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly parent: Scalars['String'];
};

export type MergeContactsPayload = {
  readonly __typename?: 'MergeContactsPayload';
  readonly children: Maybe<ReadonlyArray<Maybe<Contact>>>;
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
  readonly parent: Maybe<Contact>;
};

export type MessageContentPartType = {
  readonly __typename?: 'MessageContentPartType';
  readonly text: Maybe<Scalars['String']>;
  readonly type: Maybe<Scalars['String']>;
};

export type MessageContentType = {
  readonly __typename?: 'MessageContentType';
  readonly content: Maybe<Scalars['String']>;
  readonly format: Maybe<Scalars['Int']>;
  readonly parts: Maybe<ReadonlyArray<Maybe<MessageContentPartType>>>;
};

export type MessageOutputType = {
  readonly __typename?: 'MessageOutputType';
  readonly content: Maybe<MessageContentType>;
  readonly id: Maybe<Scalars['String']>;
  readonly resourceId: Scalars['String'];
  readonly role: MessageRole;
  readonly threadId: Scalars['String'];
};

export enum MessageRole {
  Assistant = 'assistant',
  System = 'system',
  User = 'user'
}

export enum MessageStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sent = 'SENT'
}

export type MigrateLegalCaseInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly legalCaseMigrateId: Scalars['Int'];
};

export type MigrateLegalCasePayload = {
  readonly __typename?: 'MigrateLegalCasePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly conversation: Maybe<Conversation>;
};

export type ModelMetadata = {
  readonly __typename?: 'ModelMetadata';
  readonly addons: Maybe<SearchMetadataAddons>;
  readonly author: SearchMetadataAuthor;
  readonly body: Maybe<Scalars['String']>;
  readonly date: Maybe<Scalars['Float']>;
  readonly docId: Scalars['String'];
  readonly features: Maybe<SearchMetadataFeatures>;
  readonly highlight: Maybe<Scalars['String']>;
  readonly slug: Scalars['String'];
  readonly tags: ReadonlyArray<SearchMetadataTags>;
  readonly title: Maybe<Scalars['String']>;
  readonly url: Scalars['String'];
};


export type ModelMetadataBodyArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
  preferHighlight?: InputMaybe<Scalars['Boolean']>;
};

export type ModerationLogContent = {
  readonly __typename?: 'ModerationLogContent';
  readonly change: Maybe<Scalars['JSON']>;
  readonly command: Scalars['String'];
  readonly createdAt: Scalars['String'];
  readonly error: Scalars['String'];
  readonly moderationLogId: Scalars['String'];
  readonly moderator: Maybe<Scalars['String']>;
  readonly origin: Scalars['String'];
  readonly reportId: Scalars['String'];
  readonly status: Scalars['String'];
};

export type ModerationNoteContent = {
  readonly __typename?: 'ModerationNoteContent';
  readonly createdAt: Scalars['String'];
  readonly moderationNoteId: Scalars['String'];
  readonly moderator: Scalars['String'];
  readonly note: Scalars['String'];
  readonly reportId: Scalars['String'];
};

export type MonitorCrmLawsuitInput = {
  readonly activityMonitoringActive?: InputMaybe<Scalars['Boolean']>;
  readonly boxOptions?: InputMaybe<Scalars['JSON']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly hasUserRequestedLawsuitUpdate?: InputMaybe<Scalars['Boolean']>;
  readonly lawsuitId: Scalars['String'];
  readonly publicationMonitoringActive?: InputMaybe<Scalars['Boolean']>;
};

export type MonitorCrmLawsuitPayload = {
  readonly __typename?: 'MonitorCRMLawsuitPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
  readonly lawsuitEdge: Maybe<OrganizationLawsuitsEdge>;
  readonly organization: Maybe<Organization>;
};

export type MonitoringReasonSentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
  readonly monitoringReasonSent: Scalars['Boolean'];
};

export type MonitoringReasonSentPayload = {
  readonly __typename?: 'MonitoringReasonSentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
};

export type MotionMetadata = {
  readonly __typename?: 'MotionMetadata';
  readonly addons: Maybe<SearchMetadataAddons>;
  readonly author: SearchMetadataAuthor;
  readonly body: Maybe<Scalars['String']>;
  readonly cnjNumber: Maybe<CnjNumber>;
  readonly court: Scalars['String'];
  readonly courtPublishingDate: Maybe<Scalars['Float']>;
  readonly date: Maybe<Scalars['Float']>;
  readonly docId: Scalars['String'];
  readonly features: Maybe<SearchMetadataFeatures>;
  readonly highlight: Maybe<Scalars['String']>;
  readonly lawsuitDistributionDate: Maybe<Scalars['Float']>;
  readonly lawsuitNumber: Scalars['String'];
  readonly lawsuitTopicId: Maybe<Scalars['String']>;
  readonly slug: Scalars['String'];
  readonly tags: ReadonlyArray<SearchMetadataTags>;
  readonly title: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly url: Scalars['String'];
};


export type MotionMetadataBodyArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
  preferHighlight?: InputMaybe<Scalars['Boolean']>;
};

export type MotionRelatedPeople = {
  readonly __typename?: 'MotionRelatedPeople';
  readonly active: Maybe<Scalars['Boolean']>;
  readonly author: Maybe<Scalars['Boolean']>;
  readonly name: Maybe<Scalars['String']>;
  readonly role: Maybe<Scalars['String']>;
};

export type MrBigContract = {
  readonly __typename?: 'MrBigContract';
  readonly invites: Maybe<MrBigContractInvites>;
  readonly seats: Maybe<Scalars['Int']>;
  readonly supportEmail: Maybe<Scalars['String']>;
  readonly supportName: Maybe<Scalars['String']>;
};

export type MrBigContractInvites = {
  readonly __typename?: 'MrBigContractInvites';
  readonly activeInvitesCount: Maybe<Scalars['Int']>;
};

export type MrBigOrganization = {
  readonly __typename?: 'MrBigOrganization';
  readonly contract: Maybe<MrBigContract>;
  readonly name: Maybe<Scalars['String']>;
  readonly opCompanyId: Maybe<Scalars['Int']>;
  readonly organizationId: Maybe<Scalars['Int']>;
};

export type MultiSearchResponse = {
  readonly __typename?: 'MultiSearchResponse';
  readonly haystackResponse: Maybe<HaystackResponse>;
  readonly sortedKinds: ReadonlyArray<SearchKind>;
};


export type MultiSearchResponseHaystackResponseArgs = {
  facets?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  filters?: InputMaybe<ReadonlyArray<InputMaybe<FilterInput>>>;
  flags?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  highlights?: InputMaybe<ReadonlyArray<InputMaybe<HighlightInput>>>;
  kind: SearchKind;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sorts?: InputMaybe<ReadonlyArray<InputMaybe<SortInput>>>;
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly acceptBackgroundCheckTerms: Maybe<AcceptBackgroundCheckTermsPayload>;
  readonly acceptHubInvite: Maybe<AcceptHubInvitePayload>;
  readonly acceptInvite: Maybe<AcceptInvitePayload>;
  readonly acceptOrganizationInvite: Maybe<AcceptOrganizationInvitePayload>;
  readonly acceptShareEntity: Maybe<AcceptShareEntityPayload>;
  readonly activatePriceIncrease: Maybe<ActivatePriceIncreasePayload>;
  readonly activateStudentBenefit: Maybe<ActivateStudentBenefitPayload>;
  readonly addBlockedNotificationType: Maybe<AddBlockedNotificationTypePayload>;
  readonly addCollectionDocuments: Maybe<AddCollectionDocumentsPayload>;
  readonly addComment: Maybe<AddCommentDocumentPayload>;
  readonly addCrmComment: Maybe<AddCrmCommentPayload>;
  readonly addOnCitationQueues: Maybe<AddOnCitationQueuesPayload>;
  readonly addOnboardingReminders: Maybe<AddOnboardingReminderPayload>;
  readonly addOptOutForAllNotificationTypes: Maybe<AddOptOutForAllNotificationTypesPayload>;
  readonly addPipedrive4bizDeal: Maybe<AddPipedrive4bizDealPayload>;
  readonly addPipedriveDeal: Maybe<AddPipedriveDealPayload>;
  readonly addReplyDocumentComment: Maybe<AddReplyDocumentCommentPayload>;
  readonly addScoreDocument: Maybe<AddScoreDocumentPayload>;
  readonly addToWhatsappBlockList: Maybe<AddToWhatsappBlockListPayload>;
  readonly addTopicDocument: Maybe<AddTopicDocumentPayload>;
  readonly anonymizeLegalCase: Maybe<AnonymizeLegalCasePayload>;
  readonly answerAcademyQuestion: Maybe<AnswerAcademyQuestionPayload>;
  readonly appleLogin: Maybe<AppleLoginPayload>;
  readonly approveDocument: Maybe<ApproveDocumentPayload>;
  readonly approveFeatureTask: Maybe<ApproveFeatureTaskPayload>;
  readonly approveVirtualFeatureConfig: Maybe<ApproveVirtualFeatureConfigPayload>;
  readonly approvedLegalCaseMail: Maybe<ApprovedLegalCaseMailPayload>;
  readonly archiveHubUser: Maybe<ArchiveHubUserPayload>;
  readonly archiveLegalCase: Maybe<ArchiveLegalCasePayload>;
  readonly assignAdminRole: Maybe<AssignAdminRolePayload>;
  readonly assignHubFeature: Maybe<AssignHubFeaturePayload>;
  readonly assignHubFeaturesBatch: Maybe<AssignHubFeaturesBatchPayload>;
  readonly assignHubFeaturesByPlan: Maybe<AssignHubFeaturesByPlanPayload>;
  readonly authConfirmedAnonymousUser: Maybe<AuthConfirmedAnonymousUserPayload>;
  readonly batchInviteHubUsers: Maybe<BatchInviteHubUsersPayload>;
  readonly bidLegalCase: Maybe<BidLegalCasePayload>;
  readonly blockedSourcesPublicationMonitoring: Maybe<BlockedSourcesPublicationMonitoringPayload>;
  readonly botEvent: Maybe<BotEventPayload>;
  readonly boxParticipanteExperiment: Maybe<BoxParticipanteExperimentPayload>;
  readonly broadcastDel: Maybe<BroadcastDelMutationPayload>;
  readonly broadcastSet: Maybe<BroadcastSetMutationPayload>;
  readonly bulkUpdateContact: Maybe<BulkUpdateContactPayload>;
  readonly cancelFeatureTask: Maybe<CancelFeatureTaskPayload>;
  readonly cancelHubInvite: Maybe<CancelHubInvitePayload>;
  readonly cancelIAPSubscription: Maybe<CancelIapSubscriptionPayload>;
  readonly cancelPriceIncrease: Maybe<CancelPriceIncreasePayload>;
  readonly cancelStudentBenefitAsAdmin: Maybe<CancelStudentBenefitAsAdminPayload>;
  readonly cancelSubscription: Maybe<CancelSubscriptionPayload>;
  readonly changeCProUserAdminState: Maybe<ChangeCProUserAdminStatePayload>;
  readonly changeCpfAccount: Maybe<ChangeCpfAccountPayload>;
  readonly changeHubUserArea: Maybe<ChangeHubUserAreaPayload>;
  readonly changePassword: Maybe<ChangePasswordPayload>;
  readonly changePlan: Maybe<SubscriptionChangePlanPayload>;
  readonly changePublicationAlertItemStatus: Maybe<ChangePublicationAlertItemStatusPayload>;
  readonly checkMigratedLegalCase: Maybe<CheckMigratedLegalCasePayload>;
  readonly checkStudentBenefitEligibility: Maybe<CheckStudentBenefitEligibilityPayload>;
  readonly confirmAnonymousUser: Maybe<ConfirmAnonymousUserPayload>;
  readonly confirmConvertedCredits: Maybe<ConfirmConvertedCreditsPayload>;
  readonly confirmEmailChange: Maybe<ConfirmEmailChangePayload>;
  readonly confirmLawsuitValidatedProfile: Maybe<ConfirmLawsuitValidatedProfilePayload>;
  readonly confirmOabPartnershipByCertificate: Maybe<ConfirmOabPartnershipByCertificatePayload>;
  readonly confirmOabPartnershipInvitation: Maybe<ConfirmOabPartnershipInvitationPayload>;
  readonly consumeFreemiumAttachmentDownload: Maybe<ConsumeFreemiumAttachmentDownloadPayload>;
  readonly consumeLawsuitAssistantSuggestion: Maybe<ConsumeAssistantSuggestionPayload>;
  readonly contactSalesHubCompanyRequest: Maybe<ContactSalesHubCompanyRequestPayload>;
  readonly convertDocument: Maybe<ConvertDocumentPayload>;
  readonly convertExperiment: Maybe<ConvertExperimentPayload>;
  readonly copyFactsForReference: Maybe<CopyFactsForReferencePayload>;
  readonly createAnonymizationRequest: Maybe<CreateAnonymizationRequestPayload>;
  readonly createAudienceSegment: Maybe<CreateAudienceSegmentPayload>;
  readonly createB2BAreas: Maybe<CreateB2BAreasPayload>;
  readonly createB2BCompany: Maybe<CreateB2BCompanyPayload>;
  readonly createB2BDomain: Maybe<CreateB2BDomainPayload>;
  readonly createB2BSubscription: Maybe<CreateB2BSubscriptionPayload>;
  readonly createBiddedConversation: Maybe<CreateBiddedConversationPayload>;
  readonly createBounceUserActivity: Maybe<CreateBounceUserActivityPayload>;
  readonly createCPROOrganization: Maybe<CreateCproOrganizationPayload>;
  readonly createCPROOrganizationExtraValues: Maybe<CreateCproOrganizationExtraValuesPayload>;
  readonly createCPROOrganizationLimits: Maybe<CreateCProOrganizationLimitsPayload>;
  readonly createCRMActivityLog: Maybe<CreateCrmActivityLogPayload>;
  readonly createCRMBulkAction: Maybe<CreateCrmBulkActionPayload>;
  readonly createCRMCourtCredentialLawsuit: Maybe<CreateCrmCourtCredentialLawsuitPayload>;
  readonly createCRMDataExport: Maybe<CreateCrmDataExportPayload>;
  readonly createCRMDocuments: Maybe<CreateCrmDocumentsPayload>;
  readonly createCRMEvent: Maybe<CreateCrmEventPayload>;
  readonly createCRMLawsuitFollowUp: Maybe<CreateCrmLawsuitFollowUpPayload>;
  readonly createCRMLawsuitPerson: Maybe<CreateCrmLawsuitPersonPayload>;
  readonly createCRMLawsuitSearchUserInteraction: Maybe<CreateCrmLawsuitSearchUserInteractionPayload>;
  readonly createCRMLawsuitsHistory: Maybe<CreateCrmLawsuitsHistoryPayload>;
  readonly createCRMTag: Maybe<CreateCrmTagPayload>;
  readonly createCRMTask: Maybe<CreateCrmTaskPayload>;
  readonly createCamadaAuthToken: Maybe<CreateCamadaAuthTokenPayload>;
  readonly createCaseLLMTitle: Maybe<CreateCaseLlmTitlePayload>;
  readonly createCaseSummarization: Maybe<CreateCaseSummarizationPayload>;
  readonly createCollection: Maybe<CreateUserCollectionPayload>;
  readonly createCompletion: Maybe<LawsuitGptCreateCompletionPayload>;
  readonly createContact: Maybe<CreateContactPayload>;
  readonly createConversation: Maybe<CreateConversationPayload>;
  readonly createCurrentExplanation: Maybe<CreateCurrentExplanationPayload>;
  readonly createCustomPlan: Maybe<CreateCustomPlanPayload>;
  readonly createCustomPlanBasedFeatureTokenLimits: Maybe<CreateCustomPlanBasedFeatureTokenLimitsPayload>;
  readonly createDirectConversation: Maybe<CreateDirectConversationPayload>;
  readonly createDraft: Maybe<CreateDraftPayload>;
  readonly createEntityLawsuitCollectionRequest: Maybe<CreateEntityLawsuitCollectionRequestPayload>;
  readonly createEntityQueryView: Maybe<CreateEntityQueryViewPayload>;
  readonly createEntitySummarization: Maybe<CreateEntitySummarizationPayload>;
  readonly createFeatureTask: Maybe<CreateFeatureTaskPayload>;
  readonly createFreePublicationMonitoring: Maybe<CreateFreePublicationMonitoringPayload>;
  readonly createHubCompanyRequest: Maybe<CreateHubCompanyRequestPayload>;
  readonly createHubOrganization: Maybe<CreateHubOrganizationPayload>;
  readonly createHubSubscription: Maybe<CreateHubSubscriptionPayload>;
  /** @deprecated Use inviteHubUser instead. User will be created on accepting of invite */
  readonly createHubUser: Maybe<CreateHubUserPayload>;
  readonly createHubUsersBatch: Maybe<CreateHubUsersBatchPayload>;
  readonly createImportedLawsuit: Maybe<CreateCrmImportedLawsuitPayload>;
  readonly createInstitutionalProfile: Maybe<CreateInstitutionalProfilePayload>;
  readonly createJPVLastAccess: Maybe<CreateJpvLastAccessPayload>;
  readonly createLawsuitAssistantMessage: Maybe<CreateLawsuitAssistantMessagePayload>;
  /** @deprecated Use createLawsuitAssistantSuggestions instead. */
  readonly createLawsuitAssistantQuestions: Maybe<CreateAssistantQuestionsPayload>;
  readonly createLawsuitAssistantSuggestions: Maybe<CreateAssistantSuggestionsPayload>;
  readonly createLawsuitDeadlineForecast: Maybe<CreateLawsuitDeadlineForecastPayload>;
  readonly createLawsuitLLMTitle: Maybe<CreateLawsuitLlmTitlePayload>;
  readonly createLawsuitQaEvaluatorFeature: Maybe<CreateLawsuitQaEvaluatorFeaturePayload>;
  readonly createLawsuitQaEvaluatorJudge: Maybe<CreateLawsuitQaEvaluatorJudgePayload>;
  readonly createLawsuitResult: Maybe<CreateLawsuitResultPayload>;
  readonly createLawsuitService: Maybe<CreateLawsuitServicePayload>;
  readonly createLawsuitSummarization: Maybe<CreateLawsuitSummarizationPayload>;
  readonly createMagicLinkConfig: Maybe<CreateMagicLinkConfigPayload>;
  readonly createNameFollowUp: Maybe<CreateNameFollowUpPayload>;
  readonly createOrganization: Maybe<CreateOrganizationPayload>;
  readonly createOrganizationCalendar: Maybe<CreateOrganizationCalendarPayload>;
  readonly createPendingConversation: Maybe<CreatePendingConversationPayload>;
  readonly createPlan: Maybe<CreatePlanPayload>;
  readonly createPlanGroup: Maybe<CreatePlanGroupPayload>;
  readonly createPlanTemplate: Maybe<CreatePlanTemplatePayload>;
  readonly createPriceIncrease: Maybe<CreatePriceIncreasePayload>;
  readonly createProfileCalendar: Maybe<CreateProfileCalendarPayload>;
  readonly createProfileCalendarACLs: Maybe<CreateProfileCalendarAcLsPayload>;
  readonly createPublicationMonitoring: Maybe<CreatePublicationMonitoringPayload>;
  readonly createSmartLink: Maybe<CreateSmartLinkPayload>;
  readonly createStudentBenefit: Maybe<CreateStudentBenefitPayload>;
  readonly createSubscriptionOnPatinhas: Maybe<CreateSubscriptionOnPatinhasPayload>;
  readonly createSupportTicket: Maybe<CreateSupportTicketPayload>;
  readonly createTextDocument: Maybe<CreateTextDocumentPayload>;
  readonly createTopicDocument: Maybe<CreateTopicDocumentPayload>;
  readonly createTopicTipo: Maybe<CreateTopicTipoPayload>;
  readonly deactivateOrganization: Maybe<DeactivateOrganizationPayload>;
  readonly deactivateProfile: Maybe<DeactivateProfilePayload>;
  readonly decodeEmailAndAuthenticateUser: Maybe<DecodeEmailAndAuthenticateUserPayload>;
  readonly deleteB2BArea: Maybe<DeleteB2BAreaPayload>;
  readonly deleteCProUserFromOrganization: Maybe<DeleteCProUserFromOrganizationPayload>;
  readonly deleteCRMActivityLog: Maybe<DeleteCrmActivityLogPayload>;
  readonly deleteCRMDocument: Maybe<DeleteCrmDocumentPayload>;
  readonly deleteCRMEvent: Maybe<DeleteCrmEventPayload>;
  readonly deleteCRMLawsuitActivityItem: Maybe<DeleteCrmLawsuitActivityItemPayload>;
  readonly deleteCRMTag: Maybe<DeleteCrmTagPayload>;
  readonly deleteCRMTask: Maybe<DeleteCrmTaskPayload>;
  readonly deleteContact: Maybe<DeleteContactPayload>;
  readonly deleteDocument: Maybe<DeleteDocumentPayload>;
  readonly deleteForcedExperiment: Maybe<DeleteForcedExperimentPayload>;
  readonly deleteLatestExplanation: Maybe<DeleteLatestExplanationPayload>;
  readonly deleteLawsuitUserInteraction: Maybe<DeleteLawsuitUserInteractionPayload>;
  readonly deleteLegalCase: Maybe<DeleteLegalCasePayload>;
  readonly deleteMagicLinkConfig: Maybe<DeleteMagicLinkConfigPayload>;
  readonly deleteOrganization: Maybe<DeleteOrganizationPayload>;
  readonly deletePersonalData: Maybe<DeletePersonalDataPayload>;
  readonly deletePublicationMonitoring: Maybe<DeletePublicationMonitoringPayload>;
  readonly deleteRating: Maybe<DeleteRatingPayload>;
  readonly deleteSmartLink: Maybe<DeleteSmartLinkPayload>;
  readonly demoteHubUserAdmin: Maybe<DemoteHubUserAdminPayload>;
  readonly dismissHubUser: Maybe<DismissHubUserPayload>;
  readonly downloadPersonalData: Maybe<DownloadPersonalDataPayload>;
  readonly editCPROOrganization: Maybe<EditCproOrganizationPayload>;
  readonly editCRMActivityLog: Maybe<EditCrmActivityLogPayload>;
  readonly editCRMCourtCredential: Maybe<EditCrmCourtCredentialPayload>;
  readonly editCRMDocument: Maybe<EditCrmDocumentPayload>;
  readonly editCRMEvent: Maybe<EditCrmEventPayload>;
  readonly editCRMLawsuit: Maybe<EditCrmLawsuitPayload>;
  readonly editCRMLawsuitActivityItem: Maybe<EditCrmLawsuitActivityItemPayload>;
  readonly editCRMLawsuitInteraction: Maybe<EditCrmLawsuitInteractionPayload>;
  readonly editCRMLawsuitPerson: Maybe<EditCrmLawsuitPersonPayload>;
  readonly editCRMPublicationItem: Maybe<EditCrmPublicationItemPayload>;
  readonly editCRMTag: Maybe<EditCrmTagPayload>;
  readonly editCRMTask: Maybe<EditCrmTaskPayload>;
  readonly editCRMTimelineItem: Maybe<EditCrmTimelineItemPayload>;
  readonly editConversation: Maybe<EditConversationPayload>;
  readonly editCrmComment: Maybe<EditCrmCommentPayload>;
  readonly editLawsuitSearch: Maybe<EditLawsuitSearchPayload>;
  readonly editLawsuitService: Maybe<EditLawsuitServicePayload>;
  readonly editOrganization: Maybe<EditOrganizationPayload>;
  readonly editOrganizationMember: Maybe<EditOrganizationMemberPayload>;
  readonly editOrganizationProfile: Maybe<EditOrganizationProfilePayload>;
  readonly editProfile: Maybe<EditProfilePayload>;
  readonly editProfileAddress: Maybe<EditProfileAddressPayload>;
  readonly editProfileBooks: Maybe<EditProfileBooksPayload>;
  readonly editProfileInfo: Maybe<EditProfileInfoPayload>;
  readonly editProfilePhone: Maybe<EditProfilePhonePayload>;
  readonly editPublicationAlertItem: Maybe<EditPublicationAlertItemPayload>;
  readonly editPublicationMonitoring: Maybe<EditPublicationMonitoringPayload>;
  readonly editSmartLink: Maybe<EditSmartLinkPayload>;
  readonly editSubscription: Maybe<EditSubscriptionPayload>;
  readonly editTextDocument: Maybe<EditTextDocumentPayload>;
  readonly editTopic: Maybe<EditTopicPayload>;
  readonly editUser: Maybe<EditUserPayload>;
  readonly editUserAdminLevel: Maybe<EditUserAdminLevelPayload>;
  readonly endErpBeta: Maybe<EndErpBetaPayload>;
  readonly expireResourcesByParentId: Maybe<ExpireResourcesByParentIdPayload>;
  readonly extractCnj: Maybe<ExtractCnjPayload>;
  readonly facebookAccountAssociation: Maybe<FacebookAccountAssociationPayload>;
  readonly facebookLogin: Maybe<FacebookLoginPayload>;
  readonly favoriteCRMEntity: Maybe<FavoriteCrmEntityPayload>;
  readonly forceAcademicVerificationAsAdmin: Maybe<ForceAcademicVerificationAsAdminPayload>;
  readonly forceExperiment: Maybe<ForceExperimentPayload>;
  readonly forceIcpCertificateValidation: Maybe<ForceIcpCertificateValidationPayload>;
  readonly forceIdentityVerificationAsAdmin: Maybe<ForceIdentityVerificationAsAdminPayload>;
  readonly forceOabStateAsAdmin: Maybe<ForceOabStateAsAdminPayload>;
  readonly generateKeycloakImpersonationLink: Maybe<GenerateKeycloakImpersonationLinkPayload>;
  readonly generateUploadUrl: Maybe<GenerateUploadUrlPayload>;
  readonly getOrCreateCPRODocumentSummary: Maybe<GetOrCreateCproDocumentSummaryPayload>;
  readonly googleLogin: Maybe<GoogleLoginPayload>;
  readonly grantAreaPlans: Maybe<GrantAreaPlansPayload>;
  readonly grantBonus: Maybe<GrantBonusPayload>;
  readonly incrementCRMLawsuitSearchUserInteraction: Maybe<IncrementCrmLawsuitSearchUserInteractionPayload>;
  readonly incrementConciergeDailySalesCount: Maybe<IncrementConciergeDailySalesCountPayload>;
  readonly inviteHubUser: Maybe<InviteHubUserPayload>;
  readonly inviteToOrganization: Maybe<InviteToOrganizationPayload>;
  readonly inviteToShareEntity: Maybe<InviteToShareEntityPayload>;
  readonly jobsAgreeWithDemandCancel: Maybe<JobsAgreeWithDemandCancelPayload>;
  readonly jobsArchiveDemand: Maybe<JobsArchiveDemandPayload>;
  readonly jobsConcludeDemand: Maybe<JobsConcludeDemandPayload>;
  readonly jobsCreateDemandCharge: Maybe<JobsCreateDemandChargePayload>;
  readonly jobsCreateDemandProposal: Maybe<JobsCreateDemandProposalPayload>;
  readonly jobsDemandSendInvoice: Maybe<JobsDemandSendInvoicePayload>;
  readonly jobsDemandSendRefundRequest: Maybe<JobsDemandSendRefundRequestPayload>;
  readonly jobsDisagreeWithDemandCancel: Maybe<JobsDisagreeWithDemandCancelPayload>;
  readonly jobsSendUserSignature: Maybe<JobsSendUserSignaturePayload>;
  readonly jobsUpdateUserActingCities: Maybe<JobsUpdateUserActingCitiesPayload>;
  readonly jobsUpdateUserAddress: Maybe<JobsUpdateUserAddressPayload>;
  readonly jobsUpdateUserBankData: Maybe<JobsUpdateUserBankDataPayload>;
  readonly jobsUserCreateTaxData: Maybe<JobsUserCreateTaxDataPayload>;
  readonly jobsUserUpdateServices: Maybe<JobsUserUpdateServicesPayload>;
  readonly joinCRMBeta: Maybe<JoinCrmBetaPayload>;
  readonly jusIaCreateThread: Maybe<JusIaCreateThreadPayload>;
  readonly jusIaCreateThreadAndSaveMessages: Maybe<JusIaCreateThreadAndSaveMessagesPayload>;
  readonly lawsuitSeen: Maybe<LawsuitSeenPayload>;
  readonly lawsuitUnlock: Maybe<LawsuitUnlockPayload>;
  readonly lawsuitUpdateRequest: Maybe<LawsuitUpdateRequestPayload>;
  readonly likeDocument: Maybe<LikeDocumentPayload>;
  readonly linkCRMTag: Maybe<LinkCrmTagPayload>;
  readonly linkLayerConversation: Maybe<LinkLayerConversationPayload>;
  readonly login: Maybe<LoginPayload>;
  readonly markUserExcluded: Maybe<MarkUserExcludedAsAdminPayload>;
  readonly materializeJusiaPlan: Maybe<MaterializeJusiaPlanPayload>;
  readonly mergeContacts: Maybe<MergeContactsPayload>;
  readonly migrateLegalCase: Maybe<MigrateLegalCasePayload>;
  readonly monitorCRMLawsuit: Maybe<MonitorCrmLawsuitPayload>;
  readonly monitoringReasonSent: Maybe<MonitoringReasonSentPayload>;
  readonly newLegalCaseAnswer: Maybe<NewLegalCaseAnswerPayload>;
  readonly newOpportunity: Maybe<NewOpportunityPayload>;
  readonly notifySalesTeam: Maybe<NotifySalesTeamPayload>;
  readonly occultDocument: Maybe<OccultDocumentPayload>;
  readonly occupyHubSeat: Maybe<OccupyHubSeatPayload>;
  readonly oneClickBuy: Maybe<OneClickBuyPayload>;
  readonly oneClickChangePlan: Maybe<OneClickChangePlanPayload>;
  readonly patchAreaFeatures: Maybe<PatchAreaFeaturesPayload>;
  readonly patchAudienceSegment: Maybe<PatchAudienceSegmentPayload>;
  readonly patchPipaReport: Maybe<PatchReportPayload>;
  readonly patchSubscriptionFeatures: Maybe<PatchSubscriptionFeaturesPayload>;
  readonly pauseFeatureTask: Maybe<PauseFeatureTaskPayload>;
  readonly postModerationNoteContent: Maybe<PostModerationNotePayload>;
  readonly postPipaReport: Maybe<PostReportPayload>;
  readonly promoteHubUserAdmin: Maybe<PromoteHubUserAdminPayload>;
  readonly publishDraft: Maybe<PublishDraftPayload>;
  readonly putOnboardingStopStep: Maybe<PutOnboardingStopStepPayload>;
  readonly putPipaReport: Maybe<SaveReportPayload>;
  readonly reactivateOrganization: Maybe<ReactivateOrganizationPayload>;
  readonly reactivatePublicationMonitoring: Maybe<ReactivatePublicationMonitoringPayload>;
  readonly reactivateTopic: Maybe<ReactivateTopicPayload>;
  readonly readAllMessages: Maybe<ReadAllMessagesPayload>;
  readonly refreshCPROOrganizationCredential: Maybe<RefreshCproOrganizationCredentialPayload>;
  readonly refreshCRMLawsuit: Maybe<RefreshCrmLawsuitPayload>;
  readonly refreshNetworkLawsuit: Maybe<RefreshNetworkLawsuitPayload>;
  readonly refreshViewer: Maybe<RefreshViewerPayload>;
  readonly registerCRMTimelineItemAction: Maybe<RegisterCrmTimelineItemActionPayload>;
  readonly registerDeviceToken: Maybe<RegisterDeviceTokenPayload>;
  readonly rejectFeatureTask: Maybe<RejectFeatureTaskPayload>;
  readonly reloadSubscriptions: Maybe<ReloadSubscriptionsPayload>;
  readonly removeAdminRole: Maybe<RemoveAdminRolePayload>;
  readonly removeBlockedNotificationType: Maybe<RemoveBlockedNotificationTypePayload>;
  readonly removeCollection: Maybe<RemoveUserCollectionPayload>;
  readonly removeCollectionDocuments: Maybe<RemoveCollectionDocumentsPayload>;
  readonly removeCrmComment: Maybe<RemoveCrmCommentPayload>;
  readonly removeDeviceToken: Maybe<RemoveDeviceTokenPayload>;
  readonly removeExpertiseArea: Maybe<RemoveExpertiseAreaPayload>;
  readonly removeHubFeature: Maybe<RemoveHubFeaturePayload>;
  readonly removeNameFromLawsuit: Maybe<RemoveNameFromLawsuitPayload>;
  readonly removeOnboardingReminders: Maybe<RemoveOnboardingReminderPayload>;
  readonly removeOptOutForAllNotificationTypes: Maybe<RemoveOptOutForAllNotificationTypesPayload>;
  readonly removeOrganizationMember: Maybe<RemoveOrganizationMemberPayload>;
  readonly removeShareEntity: Maybe<RemoveShareEntityPayload>;
  readonly removeTopicDocument: Maybe<RemoveTopicDocumentPayload>;
  readonly removeTopicImage: Maybe<RemoveTopicImagePayload>;
  readonly replaceSession: Maybe<ReplaceSessionPayload>;
  readonly reportAbuse: Maybe<ReportAbusePayload>;
  readonly reportDocument: Maybe<ReportDocumentPayload>;
  readonly reportEntityCompany: Maybe<ReportEntityCompanyPayload>;
  readonly requestAttachmentLogs: Maybe<RequestAttachmentLogsPayload>;
  readonly requestCpfRemoval: Maybe<RequestCpfRemovalPayload>;
  readonly requestEmailChange: Maybe<RequestEmailChangePayload>;
  readonly resendHubInvite: Maybe<ResendHubInvitePayload>;
  readonly resetCPFValidation: Maybe<ResetCpfValidationPayload>;
  readonly resetLawsuitLockedItems: Maybe<ResetLawsuitLockedItemsPayload>;
  readonly resetOABValidation: Maybe<ResetOabValidationPayload>;
  readonly resetScoreTimeDocument: Maybe<ResetScoreTimeDocumentPayload>;
  readonly resolveSubscriptionInconsistency: Maybe<ResolveSubscriptionInconsistencyPayload>;
  readonly restartSoftBlockSession: Maybe<RestartSoftBlockSessionPayload>;
  readonly retryLawsuitAssistantMessage: Maybe<RetryLawsuitAssistantMessagePayload>;
  readonly retryLawsuitQaEvaluatorItem: Maybe<RetryLawsuitQaEvaluatorItemPayload>;
  readonly revertEdition: Maybe<RevertEditionPayload>;
  readonly saveAssistantMessageFeedback: Maybe<SaveAssistantMessageFeedbackPayload>;
  readonly saveCProUserOrganization: Maybe<SaveCProUserOrganizationPayload>;
  readonly saveChatBlockSeenIds: Maybe<SaveChatBlockSeenIdsPayload>;
  readonly saveCheckoutData: Maybe<SaveCheckoutDataPayload>;
  readonly saveExplanationSeen: Maybe<SaveExplanationSeenPayload>;
  readonly saveFeatureUsage: Maybe<SaveFeatureUsagePayload>;
  readonly saveLastRequestedUpdate: Maybe<SaveLastRequestedUpdatePayload>;
  readonly saveLastSeenStep: Maybe<SaveLawsuitLastSeenStepPayload>;
  readonly saveLawsuitLastAccess: Maybe<SaveLawsuitLastAccessPayload>;
  readonly saveNotificationPreference: Maybe<SaveNotificationPreferencePayload>;
  readonly saveRating: Maybe<SaveRatingPayload>;
  readonly saveTestimonial: Maybe<SaveTestimonialPayload>;
  readonly scheduleDealMail: Maybe<ScheduleDealMailPayload>;
  readonly searchLawsuit: Maybe<SearchLawsuitPayload>;
  readonly selectOrganization: Maybe<SelectOrganizationPayload>;
  readonly sendApprovedLegalCaseMail: Maybe<SendApprovedLegalCaseMailPayload>;
  readonly sendChangeDeviceNotAllowedEmail: Maybe<SendChangeDeviceNotAllowedEmailPayload>;
  readonly sendForgotPasswordMail: Maybe<SendForgotPasswordMailPayload>;
  readonly sendLastReplacementEmail: Maybe<SendLastReplacementEmailPayload>;
  readonly sendLawsuitMonitoringSetupWhatsappMessage: Maybe<SendLawsuitMonitoringSetupWhatsappMessagePayload>;
  readonly sendLawsuitPreviewLinkMail: Maybe<SendLawsuitPreviewLinkMailPayload>;
  readonly sendLawsuitsReport: Maybe<SendLawsuitsReportPayload>;
  readonly sendMessage: Maybe<SendMessagePayload>;
  readonly sendOabTransferringEmail: Maybe<SendOabTransferringEmailPayload>;
  readonly sendSignupEmail: Maybe<SendSignupEmailPayload>;
  readonly sendTimedCodeMail: Maybe<SendTimedCodeMailPayload>;
  readonly setBackgroundCheckUser: Maybe<SetBackgroundCheckUserPayload>;
  readonly setCRMEntityImportance: Maybe<SetCrmEntityImportancePayload>;
  readonly shortlistDel: Maybe<ShortlistDelMutationPayload>;
  readonly shortlistRename: Maybe<ShortlistRenameMutationPayload>;
  readonly shortlistSet: Maybe<ShortlistSetMutationPayload>;
  readonly signJournalPdf: Maybe<SignJournalPdfPayload>;
  readonly signJurisprudenceFile: Maybe<SignJurisprudenceFilePayload>;
  readonly signMotionFile: Maybe<SignMotionFilePayload>;
  readonly signRJBFile: Maybe<SignRjbFilePayload>;
  readonly signResearchLabTerms: Maybe<SignResearchLabTermsPayload>;
  /** @deprecated This mutation no longer creates accounts. Use one of the other signup mutations instead. It will be removed in a future release. */
  readonly signup: Maybe<SignupPayload>;
  readonly signupWithCpf: Maybe<SignupWithCpfPayload>;
  readonly signupWithCpfFromApple: Maybe<SignupWithCpfFromApplePayload>;
  readonly signupWithCpfFromGoogle: Maybe<SignupWithCpfFromGooglePayload>;
  readonly startLawsuitSearch: Maybe<StartLawsuitSearchPayload>;
  readonly startMonitoringCpf: Maybe<StartMonitoringCpfPayload>;
  readonly startNotificationFlow: Maybe<StartNotificationFlowPayload>;
  readonly stopMonitoringCRMLawsuit: Maybe<StopMonitoringCrmLawsuitPayload>;
  readonly stopMonitoringCpf: Maybe<StopMonitoringCpfPayload>;
  readonly submitStudentAcademicData: Maybe<SubmitStudentAcademicDataPayload>;
  readonly subscribeToCpfMonitoring: Maybe<SubscribeToCpfMonitoringPayload>;
  readonly suspendStudentBenefitAsAdmin: Maybe<SuspendStudentBenefitAsAdminPayload>;
  readonly takeOver: Maybe<TakeOverPayload>;
  readonly toggleFollowEntity: Maybe<ToggleFollowEntityPayload>;
  readonly toggleMonitoringCRMLawsuits: Maybe<ToggleMonitoringCrmLawsuitsPayload>;
  readonly toggleSaveDocument: Maybe<ToggleSaveDocumentPayload>;
  readonly transferHubUser: Maybe<TransferHubUserPayload>;
  readonly transferOab: Maybe<TransferOabPayload>;
  readonly transferRelatedCRMEvents: Maybe<TransferRelatedCrmEventsPayload>;
  readonly unImpersonate: Maybe<UnImpersonatePayload>;
  readonly unfavoriteCRMEntity: Maybe<UnfavoriteCrmEntityPayload>;
  readonly unlinkCRMTag: Maybe<UnlinkCrmTagPayload>;
  readonly unloggedValidateCPF: Maybe<UnloggedValidateCpfPayload>;
  readonly updateAcademyUserInfo: Maybe<UpdateAcademyUserInfoPayload>;
  readonly updateB2BArea: Maybe<UpdateB2BAreaPayload>;
  readonly updateB2BCompany: Maybe<UpdateB2BCompanyPayload>;
  readonly updateCProUserFeatures: Maybe<UpdateCproUserFeaturesPayload>;
  readonly updateCRMLawsuitPartyEntityHistory: Maybe<UpdateCrmLawsuitPartyEntityHistoryPayload>;
  readonly updateCollection: Maybe<UpdateUserCollectionPayload>;
  readonly updateCompanyQuota: Maybe<UpdateCompanyQuotaPayload>;
  readonly updateContact: Maybe<UpdateContactPayload>;
  readonly updateCpfValidationInfoAsAdmin: Maybe<UpdateCpfValidationInfoAsAdminPayload>;
  readonly updateDocumentIndexableStatus: Maybe<UpdateDocumentIndexableStatusPayload>;
  readonly updateExpertiseArea: Maybe<UpdateExpertiseAreaPayload>;
  readonly updateExpertises: Maybe<UpdateExpertisesPayload>;
  readonly updateFacebookConnection: Maybe<UpdateFacebookConnectionPayload>;
  readonly updateHubCompanyRequestPlan: Maybe<UpdateHubCompanyRequestPlanPayload>;
  readonly updateHubInviteArea: Maybe<UpdateHubInviteAreaPayload>;
  readonly updateHubInviteRole: Maybe<UpdateHubInviteRolePayload>;
  readonly updateHubOrganization: Maybe<UpdateHubOrganizationPayload>;
  readonly updateInstitutionalProfileAdmins: Maybe<UpdateInstitutionalProfileAdminsPayload>;
  readonly updateLawServiceLocation: Maybe<UpdateLawServiceLocationPayload>;
  readonly updateLawsuitSummary: Maybe<UpdateLawsuitSummaryPayload>;
  readonly updateLawsuitTitle: Maybe<UpdateLawsuitTitlePayload>;
  readonly updateMagicLinkConfig: Maybe<UpdateMagicLinkConfigPayload>;
  readonly updateNamesIndexableStatus: Maybe<UpdateNamesIndexableStatusPayload>;
  readonly updateOabValidationInfo: Maybe<UpdateOabValidationInfoPayload>;
  readonly updateProfileBadges: Maybe<UpdateProfileBadgesPayload>;
  readonly updateProfileLastSeenCasesDashboard: Maybe<UpdateProfileLastSeenCasesDashboardPayload>;
  readonly updateProfilePlan: Maybe<UpdateProfilePlanPayload>;
  readonly updatePublicationMonitoring: Maybe<UpdatePublicationMonitoringPayload>;
  readonly updateSessionItemsCookie: Maybe<UpdateSessionItemsCookiePayload>;
  readonly updateWorkLocations: Maybe<UpdateWorkLocationsPayload>;
  readonly uploadStudentEnrollmentDoc: Maybe<UploadStudentEnrollmentDocPayload>;
  readonly upsertBatchMetadata: Maybe<UpsertBatchMetadataPayload>;
  readonly upsertMetadata: Maybe<UpsertMetadataPayload>;
  readonly upsertVirtualFeatureConfig: Maybe<UpsertVirtualFeatureConfigPayload>;
  readonly useCRMLawsuitPartyEntityFeature: Maybe<UseCrmLawsuitPartyEntityFeaturePayload>;
  readonly useDocumentFeature: Maybe<UseDocumentFeaturePayload>;
  readonly useSearchFeature: Maybe<UseSearchFeaturePayload>;
  readonly useThirdPartySearchFeature: Maybe<UseThirdPartySearchFeaturePayload>;
  readonly useTopicFeature: Maybe<UseTopicFeaturePayload>;
  readonly userReportProblem: Maybe<UserReportProblemPayload>;
  readonly userRequestedUpdate: Maybe<UserRequestedUpdatePayload>;
  readonly validateAuthToken: Maybe<ValidateAuthTokenPayload>;
  readonly validateCPF: Maybe<ValidateCpfPayload>;
  readonly validateInviteCsv: Maybe<ValidateInviteCsvPayload>;
  readonly validateLawsuitProfile: Maybe<ValidateLawsuitProfilePayload>;
  readonly validateLawsuitRepresentedPerson: Maybe<ValidateLawsuitRepresentedPersonPayload>;
  readonly validateOab: Maybe<ValidateOabPayload>;
  readonly validateSignupToken: Maybe<ValidateSignupTokenPayload>;
  readonly validateSms: Maybe<ValidateSmsPayload>;
  readonly validateStudentEnrollmentDocument: Maybe<ValidateStudentEnrollmentDocumentPayload>;
  readonly validateTurnstileToken: Maybe<ValidateTurnstileTokenPayload>;
  readonly verifyEmailForERPMobileSignup: Maybe<VerifyEmailForErpMobileSignupPayload>;
  readonly verifyOTPCode: Maybe<VerifyOtpCodePayload>;
  readonly verifyOneTimePurchaseIAP: Maybe<IapVerifyOneTimePurchasePayload>;
  readonly verifyPurchaseIAP: Maybe<IapVerifyPurchaseSubscriptionPayload>;
  readonly voteDocumentComment: Maybe<VoteDocumentCommentPayload>;
  readonly wingmanUndoFeatureUsage: Maybe<WingmanUndoFeatureUsagePayload>;
  readonly wingmanUseFeature: Maybe<WingmanUseFeaturePayload>;
};


export type MutationAcceptBackgroundCheckTermsArgs = {
  input: AcceptBackgroundCheckTermsInput;
};


export type MutationAcceptHubInviteArgs = {
  input: AcceptHubInviteInput;
};


export type MutationAcceptInviteArgs = {
  input: AcceptInviteInput;
};


export type MutationAcceptOrganizationInviteArgs = {
  input: AcceptOrganizationInviteInput;
};


export type MutationAcceptShareEntityArgs = {
  input: AcceptShareEntityInput;
};


export type MutationActivatePriceIncreaseArgs = {
  input: ActivatePriceIncreaseInput;
};


export type MutationActivateStudentBenefitArgs = {
  input: ActivateStudentBenefitInput;
};


export type MutationAddBlockedNotificationTypeArgs = {
  input: AddBlockedNotificationTypeInput;
};


export type MutationAddCollectionDocumentsArgs = {
  input: AddCollectionDocumentsInput;
};


export type MutationAddCommentArgs = {
  input: AddCommentDocumentInput;
};


export type MutationAddCrmCommentArgs = {
  input: AddCrmCommentInput;
};


export type MutationAddOnCitationQueuesArgs = {
  input: AddOnCitationQueuesInput;
};


export type MutationAddOnboardingRemindersArgs = {
  input: AddOnboardingReminderInput;
};


export type MutationAddOptOutForAllNotificationTypesArgs = {
  input: AddOptOutForAllNotificationTypesInput;
};


export type MutationAddPipedrive4bizDealArgs = {
  input: AddPipedrive4bizDealInput;
};


export type MutationAddPipedriveDealArgs = {
  input: AddPipedriveDealInput;
};


export type MutationAddReplyDocumentCommentArgs = {
  input: AddReplyDocumentCommentInput;
};


export type MutationAddScoreDocumentArgs = {
  input: AddScoreDocumentInput;
};


export type MutationAddToWhatsappBlockListArgs = {
  input: AddToWhatsappBlockListInput;
};


export type MutationAddTopicDocumentArgs = {
  input: AddTopicDocumentInput;
};


export type MutationAnonymizeLegalCaseArgs = {
  input: AnonymizeLegalCaseInput;
};


export type MutationAnswerAcademyQuestionArgs = {
  input: AnswerAcademyQuestionInput;
};


export type MutationAppleLoginArgs = {
  input: AppleLoginInput;
};


export type MutationApproveDocumentArgs = {
  input: ApproveDocumentInput;
};


export type MutationApproveFeatureTaskArgs = {
  input: ApproveFeatureTaskInput;
};


export type MutationApproveVirtualFeatureConfigArgs = {
  input: ApproveVirtualFeatureConfigInput;
};


export type MutationApprovedLegalCaseMailArgs = {
  input: ApprovedLegalCaseMailInput;
};


export type MutationArchiveHubUserArgs = {
  input: ArchiveHubUserInput;
};


export type MutationArchiveLegalCaseArgs = {
  input: ArchiveLegalCaseInput;
};


export type MutationAssignAdminRoleArgs = {
  input: AssignAdminRoleInput;
};


export type MutationAssignHubFeatureArgs = {
  input: AssignHubFeatureInput;
};


export type MutationAssignHubFeaturesBatchArgs = {
  input: AssignHubFeaturesBatchInput;
};


export type MutationAssignHubFeaturesByPlanArgs = {
  input: AssignHubFeaturesByPlanInput;
};


export type MutationAuthConfirmedAnonymousUserArgs = {
  input: AuthConfirmedAnonymousUserInput;
};


export type MutationBatchInviteHubUsersArgs = {
  input: BatchInviteHubUsersInput;
};


export type MutationBidLegalCaseArgs = {
  input: BidLegalCaseInput;
};


export type MutationBlockedSourcesPublicationMonitoringArgs = {
  input: BlockedSourcesPublicationMonitoringInput;
};


export type MutationBotEventArgs = {
  input: BotEventInput;
};


export type MutationBoxParticipanteExperimentArgs = {
  input: BoxParticipanteExperimentInput;
};


export type MutationBroadcastDelArgs = {
  input: BroadcastDelMutationInput;
};


export type MutationBroadcastSetArgs = {
  input: BroadcastSetMutationInput;
};


export type MutationBulkUpdateContactArgs = {
  input: BulkUpdateContactInput;
};


export type MutationCancelFeatureTaskArgs = {
  input: CancelFeatureTaskInput;
};


export type MutationCancelHubInviteArgs = {
  input: CancelHubInviteInput;
};


export type MutationCancelIapSubscriptionArgs = {
  input: CancelIapSubscriptionInput;
};


export type MutationCancelPriceIncreaseArgs = {
  input: CancelPriceIncreaseInput;
};


export type MutationCancelStudentBenefitAsAdminArgs = {
  input: CancelStudentBenefitAsAdminInput;
};


export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type MutationChangeCProUserAdminStateArgs = {
  input: ChangeCProUserAdminStateInput;
};


export type MutationChangeCpfAccountArgs = {
  input: ChangeCpfAccountInput;
};


export type MutationChangeHubUserAreaArgs = {
  input: ChangeHubUserAreaInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationChangePlanArgs = {
  input: SubscriptionChangePlanInput;
};


export type MutationChangePublicationAlertItemStatusArgs = {
  input: ChangePublicationAlertItemStatusInput;
};


export type MutationCheckMigratedLegalCaseArgs = {
  input: CheckMigratedLegalCaseInput;
};


export type MutationCheckStudentBenefitEligibilityArgs = {
  input: CheckStudentBenefitEligibilityInput;
};


export type MutationConfirmAnonymousUserArgs = {
  input: ConfirmAnonymousUserInput;
};


export type MutationConfirmConvertedCreditsArgs = {
  input: ConfirmConvertedCreditsInput;
};


export type MutationConfirmEmailChangeArgs = {
  input: ConfirmEmailChangeInput;
};


export type MutationConfirmLawsuitValidatedProfileArgs = {
  input: ConfirmLawsuitValidatedProfileInput;
};


export type MutationConfirmOabPartnershipByCertificateArgs = {
  input: ConfirmOabPartnershipByCertificateInput;
};


export type MutationConfirmOabPartnershipInvitationArgs = {
  input: ConfirmOabPartnershipInvitationInput;
};


export type MutationConsumeFreemiumAttachmentDownloadArgs = {
  input: ConsumeFreemiumAttachmentDownloadInput;
};


export type MutationConsumeLawsuitAssistantSuggestionArgs = {
  input: ConsumeAssistantSuggestionInput;
};


export type MutationContactSalesHubCompanyRequestArgs = {
  input: ContactSalesHubCompanyRequestInput;
};


export type MutationConvertDocumentArgs = {
  input: ConvertDocumentInput;
};


export type MutationConvertExperimentArgs = {
  input: ConvertExperimentInput;
};


export type MutationCopyFactsForReferenceArgs = {
  input: CopyFactsForReferenceInput;
};


export type MutationCreateAnonymizationRequestArgs = {
  input: CreateAnonymizationRequestInput;
};


export type MutationCreateAudienceSegmentArgs = {
  input: CreateAudienceSegmentInput;
};


export type MutationCreateB2BAreasArgs = {
  input: CreateB2BAreasInput;
};


export type MutationCreateB2BCompanyArgs = {
  input: CreateB2BCompanyInput;
};


export type MutationCreateB2BDomainArgs = {
  input: CreateB2BDomainInput;
};


export type MutationCreateB2BSubscriptionArgs = {
  input: CreateB2BSubscriptionInput;
};


export type MutationCreateBiddedConversationArgs = {
  input: CreateBiddedConversationInput;
};


export type MutationCreateBounceUserActivityArgs = {
  input: CreateBounceUserActivityInput;
};


export type MutationCreateCproOrganizationArgs = {
  input: CreateCproOrganizationInput;
};


export type MutationCreateCproOrganizationExtraValuesArgs = {
  input: CreateCproOrganizationExtraValuesInput;
};


export type MutationCreateCproOrganizationLimitsArgs = {
  input: CreateCProOrganizationLimitsInput;
};


export type MutationCreateCrmActivityLogArgs = {
  input: CreateCrmActivityLogInput;
};


export type MutationCreateCrmBulkActionArgs = {
  input: CreateCrmBulkActionInput;
};


export type MutationCreateCrmCourtCredentialLawsuitArgs = {
  input: CreateCrmCourtCredentialLawsuitInput;
};


export type MutationCreateCrmDataExportArgs = {
  input: CreateCrmDataExportInput;
};


export type MutationCreateCrmDocumentsArgs = {
  input: CreateCrmDocumentsInput;
};


export type MutationCreateCrmEventArgs = {
  input: CreateCrmEventInput;
};


export type MutationCreateCrmLawsuitFollowUpArgs = {
  input: CreateCrmLawsuitFollowUpInput;
};


export type MutationCreateCrmLawsuitPersonArgs = {
  input: CreateCrmLawsuitPersonInput;
};


export type MutationCreateCrmLawsuitSearchUserInteractionArgs = {
  input: CreateCrmLawsuitSearchUserInteractionInput;
};


export type MutationCreateCrmLawsuitsHistoryArgs = {
  input: CreateCrmLawsuitsHistoryInput;
};


export type MutationCreateCrmTagArgs = {
  input: CreateCrmTagInput;
};


export type MutationCreateCrmTaskArgs = {
  input: CreateCrmTaskInput;
};


export type MutationCreateCamadaAuthTokenArgs = {
  input: CreateCamadaAuthTokenInput;
};


export type MutationCreateCaseLlmTitleArgs = {
  input: CreateCaseLlmTitleInput;
};


export type MutationCreateCaseSummarizationArgs = {
  input: CreateCaseSummarizationInput;
};


export type MutationCreateCollectionArgs = {
  input: CreateUserCollectionInput;
};


export type MutationCreateCompletionArgs = {
  input: LawsuitGptCreateCompletionInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateConversationArgs = {
  input: CreateConversationInput;
};


export type MutationCreateCurrentExplanationArgs = {
  input: CreateCurrentExplanationInput;
};


export type MutationCreateCustomPlanArgs = {
  input: CreateCustomPlanInput;
};


export type MutationCreateCustomPlanBasedFeatureTokenLimitsArgs = {
  input: CreateCustomPlanBasedFeatureTokenLimitsInput;
};


export type MutationCreateDirectConversationArgs = {
  input: CreateDirectConversationInput;
};


export type MutationCreateDraftArgs = {
  input: CreateDraftInput;
};


export type MutationCreateEntityLawsuitCollectionRequestArgs = {
  input: CreateEntityLawsuitCollectionRequestInput;
};


export type MutationCreateEntityQueryViewArgs = {
  input: CreateEntityQueryViewInput;
};


export type MutationCreateEntitySummarizationArgs = {
  input: CreateEntitySummarizationInput;
};


export type MutationCreateFeatureTaskArgs = {
  input: CreateFeatureTaskInput;
};


export type MutationCreateFreePublicationMonitoringArgs = {
  input: CreateFreePublicationMonitoringInput;
};


export type MutationCreateHubCompanyRequestArgs = {
  input: CreateHubCompanyRequestInput;
};


export type MutationCreateHubOrganizationArgs = {
  input: CreateHubOrganizationInput;
};


export type MutationCreateHubSubscriptionArgs = {
  input: CreateHubSubscriptionInput;
};


export type MutationCreateHubUserArgs = {
  input: CreateHubUserInput;
};


export type MutationCreateHubUsersBatchArgs = {
  input: CreateHubUsersBatchInput;
};


export type MutationCreateImportedLawsuitArgs = {
  input: CreateCrmImportedLawsuitInput;
};


export type MutationCreateInstitutionalProfileArgs = {
  input: CreateInstitutionalProfileInput;
};


export type MutationCreateJpvLastAccessArgs = {
  input: CreateJpvLastAccessInput;
};


export type MutationCreateLawsuitAssistantMessageArgs = {
  input: CreateLawsuitAssistantMessageInput;
};


export type MutationCreateLawsuitAssistantQuestionsArgs = {
  input: CreateAssistantQuestionsInput;
};


export type MutationCreateLawsuitAssistantSuggestionsArgs = {
  input: CreateAssistantSuggestionsInput;
};


export type MutationCreateLawsuitDeadlineForecastArgs = {
  input: CreateLawsuitDeadlineForecastInput;
};


export type MutationCreateLawsuitLlmTitleArgs = {
  input: CreateLawsuitLlmTitleInput;
};


export type MutationCreateLawsuitQaEvaluatorFeatureArgs = {
  input: CreateLawsuitQaEvaluatorFeatureInput;
};


export type MutationCreateLawsuitQaEvaluatorJudgeArgs = {
  input: CreateLawsuitQaEvaluatorJudgeInput;
};


export type MutationCreateLawsuitResultArgs = {
  input: CreateLawsuitResultInput;
};


export type MutationCreateLawsuitServiceArgs = {
  input: CreateLawsuitServiceInput;
};


export type MutationCreateLawsuitSummarizationArgs = {
  input: CreateLawsuitSummarizationInput;
};


export type MutationCreateMagicLinkConfigArgs = {
  input: CreateMagicLinkConfigInput;
};


export type MutationCreateNameFollowUpArgs = {
  input: CreateNameFollowUpInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateOrganizationCalendarArgs = {
  input: CreateOrganizationCalendarInput;
};


export type MutationCreatePendingConversationArgs = {
  input: CreatePendingConversationInput;
};


export type MutationCreatePlanArgs = {
  input: CreatePlanInput;
};


export type MutationCreatePlanGroupArgs = {
  input: CreatePlanGroupInput;
};


export type MutationCreatePlanTemplateArgs = {
  input: CreatePlanTemplateInput;
};


export type MutationCreatePriceIncreaseArgs = {
  input: CreatePriceIncreaseInput;
};


export type MutationCreateProfileCalendarArgs = {
  input: CreateProfileCalendarInput;
};


export type MutationCreateProfileCalendarAcLsArgs = {
  input: CreateProfileCalendarAcLsInput;
};


export type MutationCreatePublicationMonitoringArgs = {
  input: CreatePublicationMonitoringInput;
};


export type MutationCreateSmartLinkArgs = {
  input: CreateSmartLinkInput;
};


export type MutationCreateStudentBenefitArgs = {
  input: CreateStudentBenefitInput;
};


export type MutationCreateSubscriptionOnPatinhasArgs = {
  input: CreateSubscriptionOnPatinhasInput;
};


export type MutationCreateSupportTicketArgs = {
  input: CreateSupportTicketInput;
};


export type MutationCreateTextDocumentArgs = {
  input: CreateTextDocumentInput;
};


export type MutationCreateTopicDocumentArgs = {
  input: CreateTopicDocumentInput;
};


export type MutationCreateTopicTipoArgs = {
  input: CreateTopicTipoInput;
};


export type MutationDeactivateOrganizationArgs = {
  input: DeactivateOrganizationInput;
};


export type MutationDeactivateProfileArgs = {
  input: DeactivateProfileInput;
};


export type MutationDecodeEmailAndAuthenticateUserArgs = {
  input: DecodeEmailAndAuthenticateUserInput;
};


export type MutationDeleteB2BAreaArgs = {
  input: DeleteB2BAreaInput;
};


export type MutationDeleteCProUserFromOrganizationArgs = {
  input: DeleteCProUserFromOrganizationInput;
};


export type MutationDeleteCrmActivityLogArgs = {
  input: DeleteCrmActivityLogInput;
};


export type MutationDeleteCrmDocumentArgs = {
  input: DeleteCrmDocumentInput;
};


export type MutationDeleteCrmEventArgs = {
  input: DeleteCrmEventInput;
};


export type MutationDeleteCrmLawsuitActivityItemArgs = {
  input: DeleteCrmLawsuitActivityItemInput;
};


export type MutationDeleteCrmTagArgs = {
  input: DeleteCrmTagInput;
};


export type MutationDeleteCrmTaskArgs = {
  input: DeleteCrmTaskInput;
};


export type MutationDeleteContactArgs = {
  input: DeleteContactInput;
};


export type MutationDeleteDocumentArgs = {
  input: DeleteDocumentInput;
};


export type MutationDeleteForcedExperimentArgs = {
  input: DeleteForcedExperimentInput;
};


export type MutationDeleteLatestExplanationArgs = {
  input: DeleteLatestExplanationInput;
};


export type MutationDeleteLawsuitUserInteractionArgs = {
  input: DeleteLawsuitUserInteractionInput;
};


export type MutationDeleteLegalCaseArgs = {
  input: DeleteLegalCaseInput;
};


export type MutationDeleteMagicLinkConfigArgs = {
  input: DeleteMagicLinkConfigInput;
};


export type MutationDeleteOrganizationArgs = {
  input: DeleteOrganizationInput;
};


export type MutationDeletePersonalDataArgs = {
  input: DeletePersonalDataInput;
};


export type MutationDeletePublicationMonitoringArgs = {
  input: DeletePublicationMonitoringInput;
};


export type MutationDeleteRatingArgs = {
  input: DeleteRatingInput;
};


export type MutationDeleteSmartLinkArgs = {
  input: DeleteSmartLinkInput;
};


export type MutationDemoteHubUserAdminArgs = {
  input: DemoteHubUserAdminInput;
};


export type MutationDismissHubUserArgs = {
  input: DismissHubUserInput;
};


export type MutationDownloadPersonalDataArgs = {
  input: DownloadPersonalDataInput;
};


export type MutationEditCproOrganizationArgs = {
  input: EditCproOrganizationInput;
};


export type MutationEditCrmActivityLogArgs = {
  input: EditCrmActivityLogInput;
};


export type MutationEditCrmCourtCredentialArgs = {
  input: EditCrmCourtCredentialInput;
};


export type MutationEditCrmDocumentArgs = {
  input: EditCrmDocumentInput;
};


export type MutationEditCrmEventArgs = {
  input: EditCrmEventInput;
};


export type MutationEditCrmLawsuitArgs = {
  input: EditCrmLawsuitInput;
};


export type MutationEditCrmLawsuitActivityItemArgs = {
  input: EditCrmLawsuitActivityItemInput;
};


export type MutationEditCrmLawsuitInteractionArgs = {
  input: EditCrmLawsuitInteractionInput;
};


export type MutationEditCrmLawsuitPersonArgs = {
  input: EditCrmLawsuitPersonInput;
};


export type MutationEditCrmPublicationItemArgs = {
  input: EditCrmPublicationItemInput;
};


export type MutationEditCrmTagArgs = {
  input: EditCrmTagInput;
};


export type MutationEditCrmTaskArgs = {
  input: EditCrmTaskInput;
};


export type MutationEditCrmTimelineItemArgs = {
  input: EditCrmTimelineItemInput;
};


export type MutationEditConversationArgs = {
  input: EditConversationInput;
};


export type MutationEditCrmCommentArgs = {
  input: EditCrmCommentInput;
};


export type MutationEditLawsuitSearchArgs = {
  input: EditLawsuitSearchInput;
};


export type MutationEditLawsuitServiceArgs = {
  input: EditLawsuitServiceInput;
};


export type MutationEditOrganizationArgs = {
  input: EditOrganizationInput;
};


export type MutationEditOrganizationMemberArgs = {
  input: EditOrganizationMemberInput;
};


export type MutationEditOrganizationProfileArgs = {
  input: EditOrganizationProfileInput;
};


export type MutationEditProfileArgs = {
  input: EditProfileInput;
};


export type MutationEditProfileAddressArgs = {
  input: EditProfileAddressInput;
};


export type MutationEditProfileBooksArgs = {
  input: EditProfileBooksInput;
};


export type MutationEditProfileInfoArgs = {
  input: EditProfileInfoInput;
};


export type MutationEditProfilePhoneArgs = {
  input: EditProfilePhoneInput;
};


export type MutationEditPublicationAlertItemArgs = {
  input: EditPublicationAlertItemInput;
};


export type MutationEditPublicationMonitoringArgs = {
  input: EditPublicationMonitoringInput;
};


export type MutationEditSmartLinkArgs = {
  input: EditSmartLinkInput;
};


export type MutationEditSubscriptionArgs = {
  input: EditSubscriptionInput;
};


export type MutationEditTextDocumentArgs = {
  input: EditTextDocumentInput;
};


export type MutationEditTopicArgs = {
  input: EditTopicInput;
};


export type MutationEditUserArgs = {
  input: EditUserInput;
};


export type MutationEditUserAdminLevelArgs = {
  input: EditUserAdminLevelInput;
};


export type MutationEndErpBetaArgs = {
  input: EndErpBetaInput;
};


export type MutationExpireResourcesByParentIdArgs = {
  input: ExpireResourcesByParentIdInput;
};


export type MutationExtractCnjArgs = {
  input: ExtractCnjInput;
};


export type MutationFacebookAccountAssociationArgs = {
  input: FacebookAccountAssociationInput;
};


export type MutationFacebookLoginArgs = {
  input: FacebookLoginInput;
};


export type MutationFavoriteCrmEntityArgs = {
  input: FavoriteCrmEntityInput;
};


export type MutationForceAcademicVerificationAsAdminArgs = {
  input: ForceAcademicVerificationAsAdminInput;
};


export type MutationForceExperimentArgs = {
  input: ForceExperimentInput;
};


export type MutationForceIcpCertificateValidationArgs = {
  input: ForceIcpCertificateValidationInput;
};


export type MutationForceIdentityVerificationAsAdminArgs = {
  input: ForceIdentityVerificationAsAdminInput;
};


export type MutationForceOabStateAsAdminArgs = {
  input: ForceOabStateAsAdminInput;
};


export type MutationGenerateKeycloakImpersonationLinkArgs = {
  input: GenerateKeycloakImpersonationLinkInput;
};


export type MutationGenerateUploadUrlArgs = {
  input: GenerateUploadUrlInput;
};


export type MutationGetOrCreateCproDocumentSummaryArgs = {
  input: GetOrCreateCproDocumentSummaryInput;
};


export type MutationGoogleLoginArgs = {
  input: GoogleLoginInput;
};


export type MutationGrantAreaPlansArgs = {
  input: GrantAreaPlansInput;
};


export type MutationGrantBonusArgs = {
  input: GrantBonusInput;
};


export type MutationIncrementCrmLawsuitSearchUserInteractionArgs = {
  input: IncrementCrmLawsuitSearchUserInteractionInput;
};


export type MutationIncrementConciergeDailySalesCountArgs = {
  input: IncrementConciergeDailySalesCountInput;
};


export type MutationInviteHubUserArgs = {
  input: InviteHubUserInput;
};


export type MutationInviteToOrganizationArgs = {
  input: InviteToOrganizationInput;
};


export type MutationInviteToShareEntityArgs = {
  input: InviteToShareEntityInput;
};


export type MutationJobsAgreeWithDemandCancelArgs = {
  input: JobsAgreeWithDemandCancelInput;
};


export type MutationJobsArchiveDemandArgs = {
  input: JobsArchiveDemandInput;
};


export type MutationJobsConcludeDemandArgs = {
  input: JobsConcludeDemandInput;
};


export type MutationJobsCreateDemandChargeArgs = {
  input: JobsCreateDemandChargeInput;
};


export type MutationJobsCreateDemandProposalArgs = {
  input: JobsCreateDemandProposalInput;
};


export type MutationJobsDemandSendInvoiceArgs = {
  input: JobsDemandSendInvoiceInput;
};


export type MutationJobsDemandSendRefundRequestArgs = {
  input: JobsDemandSendRefundRequestInput;
};


export type MutationJobsDisagreeWithDemandCancelArgs = {
  input: JobsDisagreeWithDemandCancelInput;
};


export type MutationJobsSendUserSignatureArgs = {
  input: JobsSendUserSignatureInput;
};


export type MutationJobsUpdateUserActingCitiesArgs = {
  input: JobsUpdateUserActingCitiesInput;
};


export type MutationJobsUpdateUserAddressArgs = {
  input: JobsUpdateUserAddressInput;
};


export type MutationJobsUpdateUserBankDataArgs = {
  input: JobsUpdateUserBankDataInput;
};


export type MutationJobsUserCreateTaxDataArgs = {
  input: JobsUserCreateTaxDataInput;
};


export type MutationJobsUserUpdateServicesArgs = {
  input: JobsUserUpdateServicesInput;
};


export type MutationJoinCrmBetaArgs = {
  input: JoinCrmBetaInput;
};


export type MutationJusIaCreateThreadArgs = {
  input: JusIaCreateThreadInput;
};


export type MutationJusIaCreateThreadAndSaveMessagesArgs = {
  input: JusIaCreateThreadAndSaveMessagesInput;
};


export type MutationLawsuitSeenArgs = {
  input: LawsuitSeenInput;
};


export type MutationLawsuitUnlockArgs = {
  input: LawsuitUnlockInput;
};


export type MutationLawsuitUpdateRequestArgs = {
  input: LawsuitUpdateRequestInput;
};


export type MutationLikeDocumentArgs = {
  input: LikeDocumentInput;
};


export type MutationLinkCrmTagArgs = {
  input: LinkCrmTagInput;
};


export type MutationLinkLayerConversationArgs = {
  input: LinkLayerConversationInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationMarkUserExcludedArgs = {
  input: MarkUserExcludedAsAdminInput;
};


export type MutationMaterializeJusiaPlanArgs = {
  input: MaterializeJusiaPlanInput;
};


export type MutationMergeContactsArgs = {
  input: MergeContactsInput;
};


export type MutationMigrateLegalCaseArgs = {
  input: MigrateLegalCaseInput;
};


export type MutationMonitorCrmLawsuitArgs = {
  input: MonitorCrmLawsuitInput;
};


export type MutationMonitoringReasonSentArgs = {
  input: MonitoringReasonSentInput;
};


export type MutationNewLegalCaseAnswerArgs = {
  input: NewLegalCaseAnswerInput;
};


export type MutationNewOpportunityArgs = {
  input: NewOpportunityInput;
};


export type MutationNotifySalesTeamArgs = {
  input: NotifySalesTeamInput;
};


export type MutationOccultDocumentArgs = {
  input: OccultDocumentInput;
};


export type MutationOccupyHubSeatArgs = {
  input: OccupyHubSeatInput;
};


export type MutationOneClickBuyArgs = {
  input: OneClickBuyInput;
};


export type MutationOneClickChangePlanArgs = {
  input: OneClickChangePlanInput;
};


export type MutationPatchAreaFeaturesArgs = {
  input: PatchAreaFeaturesInput;
};


export type MutationPatchAudienceSegmentArgs = {
  input: PatchAudienceSegmentInput;
};


export type MutationPatchPipaReportArgs = {
  input: PatchReportInput;
};


export type MutationPatchSubscriptionFeaturesArgs = {
  input: PatchSubscriptionFeaturesInput;
};


export type MutationPauseFeatureTaskArgs = {
  input: PauseFeatureTaskInput;
};


export type MutationPostModerationNoteContentArgs = {
  input: PostModerationNoteInput;
};


export type MutationPostPipaReportArgs = {
  input: PostReportInput;
};


export type MutationPromoteHubUserAdminArgs = {
  input: PromoteHubUserAdminInput;
};


export type MutationPublishDraftArgs = {
  input: PublishDraftInput;
};


export type MutationPutOnboardingStopStepArgs = {
  input: PutOnboardingStopStepInput;
};


export type MutationPutPipaReportArgs = {
  input: SaveReportInput;
};


export type MutationReactivateOrganizationArgs = {
  input: ReactivateOrganizationInput;
};


export type MutationReactivatePublicationMonitoringArgs = {
  input: ReactivatePublicationMonitoringInput;
};


export type MutationReactivateTopicArgs = {
  input: ReactivateTopicInput;
};


export type MutationReadAllMessagesArgs = {
  input: ReadAllMessagesInput;
};


export type MutationRefreshCproOrganizationCredentialArgs = {
  input: RefreshCproOrganizationCredentialInput;
};


export type MutationRefreshCrmLawsuitArgs = {
  input: RefreshCrmLawsuitInput;
};


export type MutationRefreshNetworkLawsuitArgs = {
  input: RefreshNetworkLawsuitInput;
};


export type MutationRefreshViewerArgs = {
  input: RefreshViewerInput;
};


export type MutationRegisterCrmTimelineItemActionArgs = {
  input: RegisterCrmTimelineItemActionInput;
};


export type MutationRegisterDeviceTokenArgs = {
  input: RegisterDeviceTokenInput;
};


export type MutationRejectFeatureTaskArgs = {
  input: RejectFeatureTaskInput;
};


export type MutationReloadSubscriptionsArgs = {
  input: ReloadSubscriptionsInput;
};


export type MutationRemoveAdminRoleArgs = {
  input: RemoveAdminRoleInput;
};


export type MutationRemoveBlockedNotificationTypeArgs = {
  input: RemoveBlockedNotificationTypeInput;
};


export type MutationRemoveCollectionArgs = {
  input: RemoveUserCollectionInput;
};


export type MutationRemoveCollectionDocumentsArgs = {
  input: RemoveCollectionDocumentsInput;
};


export type MutationRemoveCrmCommentArgs = {
  input: RemoveCrmCommentInput;
};


export type MutationRemoveDeviceTokenArgs = {
  input: RemoveDeviceTokenInput;
};


export type MutationRemoveExpertiseAreaArgs = {
  input: RemoveExpertiseAreaInput;
};


export type MutationRemoveHubFeatureArgs = {
  input: RemoveHubFeatureInput;
};


export type MutationRemoveNameFromLawsuitArgs = {
  input: RemoveNameFromLawsuitInput;
};


export type MutationRemoveOnboardingRemindersArgs = {
  input: RemoveOnboardingReminderInput;
};


export type MutationRemoveOptOutForAllNotificationTypesArgs = {
  input: RemoveOptOutForAllNotificationTypesInput;
};


export type MutationRemoveOrganizationMemberArgs = {
  input: RemoveOrganizationMemberInput;
};


export type MutationRemoveShareEntityArgs = {
  input: RemoveShareEntityInput;
};


export type MutationRemoveTopicDocumentArgs = {
  input: RemoveTopicDocumentInput;
};


export type MutationRemoveTopicImageArgs = {
  input: RemoveTopicImageInput;
};


export type MutationReplaceSessionArgs = {
  input: ReplaceSessionInput;
};


export type MutationReportAbuseArgs = {
  input: ReportAbuseInput;
};


export type MutationReportDocumentArgs = {
  input: ReportDocumentInput;
};


export type MutationReportEntityCompanyArgs = {
  input: ReportEntityCompanyInput;
};


export type MutationRequestAttachmentLogsArgs = {
  input: RequestAttachmentLogsInput;
};


export type MutationRequestCpfRemovalArgs = {
  input: RequestCpfRemovalInput;
};


export type MutationRequestEmailChangeArgs = {
  input: RequestEmailChangeInput;
};


export type MutationResendHubInviteArgs = {
  input: ResendHubInviteInput;
};


export type MutationResetCpfValidationArgs = {
  input: ResetCpfValidationInput;
};


export type MutationResetLawsuitLockedItemsArgs = {
  input: ResetLawsuitLockedItemsInput;
};


export type MutationResetOabValidationArgs = {
  input: ResetOabValidationInput;
};


export type MutationResetScoreTimeDocumentArgs = {
  input: ResetScoreTimeDocumentInput;
};


export type MutationResolveSubscriptionInconsistencyArgs = {
  input: ResolveSubscriptionInconsistencyInput;
};


export type MutationRestartSoftBlockSessionArgs = {
  input: RestartSoftBlockSessionInput;
};


export type MutationRetryLawsuitAssistantMessageArgs = {
  input: RetryLawsuitAssistantMessageInput;
};


export type MutationRetryLawsuitQaEvaluatorItemArgs = {
  input: RetryLawsuitQaEvaluatorItemInput;
};


export type MutationRevertEditionArgs = {
  input: RevertEditionInput;
};


export type MutationSaveAssistantMessageFeedbackArgs = {
  input: SaveAssistantMessageFeedbackInput;
};


export type MutationSaveCProUserOrganizationArgs = {
  input: SaveCProUserOrganizationInput;
};


export type MutationSaveChatBlockSeenIdsArgs = {
  input: SaveChatBlockSeenIdsInput;
};


export type MutationSaveCheckoutDataArgs = {
  input: SaveCheckoutDataInput;
};


export type MutationSaveExplanationSeenArgs = {
  input: SaveExplanationSeenInput;
};


export type MutationSaveFeatureUsageArgs = {
  input: SaveFeatureUsageInput;
};


export type MutationSaveLastRequestedUpdateArgs = {
  input: SaveLastRequestedUpdateInput;
};


export type MutationSaveLastSeenStepArgs = {
  input: SaveLawsuitLastSeenStepInput;
};


export type MutationSaveLawsuitLastAccessArgs = {
  input: SaveLawsuitLastAccessInput;
};


export type MutationSaveNotificationPreferenceArgs = {
  input: SaveNotificationPreferenceInput;
};


export type MutationSaveRatingArgs = {
  input: SaveRatingInput;
};


export type MutationSaveTestimonialArgs = {
  input: SaveTestimonialInput;
};


export type MutationScheduleDealMailArgs = {
  input: ScheduleDealMailInput;
};


export type MutationSearchLawsuitArgs = {
  input: SearchLawsuitInput;
};


export type MutationSelectOrganizationArgs = {
  input: SelectOrganizationInput;
};


export type MutationSendApprovedLegalCaseMailArgs = {
  input: SendApprovedLegalCaseMailInput;
};


export type MutationSendChangeDeviceNotAllowedEmailArgs = {
  input: SendChangeDeviceNotAllowedEmailInput;
};


export type MutationSendForgotPasswordMailArgs = {
  input: SendForgotPasswordMailInput;
};


export type MutationSendLastReplacementEmailArgs = {
  input: SendLastReplacementEmailInput;
};


export type MutationSendLawsuitMonitoringSetupWhatsappMessageArgs = {
  input: SendLawsuitMonitoringSetupWhatsappMessageInput;
};


export type MutationSendLawsuitPreviewLinkMailArgs = {
  input: SendLawsuitPreviewLinkMailInput;
};


export type MutationSendLawsuitsReportArgs = {
  input: SendLawsuitsReportInput;
};


export type MutationSendMessageArgs = {
  input: SendMessageInput;
};


export type MutationSendOabTransferringEmailArgs = {
  input: SendOabTransferringEmailInput;
};


export type MutationSendSignupEmailArgs = {
  input: SendSignupEmailInput;
};


export type MutationSendTimedCodeMailArgs = {
  input: SendTimedCodeMailInput;
};


export type MutationSetBackgroundCheckUserArgs = {
  input: SetBackgroundCheckUserInput;
};


export type MutationSetCrmEntityImportanceArgs = {
  input: SetCrmEntityImportanceInput;
};


export type MutationShortlistDelArgs = {
  input: ShortlistDelMutationInput;
};


export type MutationShortlistRenameArgs = {
  input: ShortlistRenameMutationInput;
};


export type MutationShortlistSetArgs = {
  input: ShortlistSetMutationInput;
};


export type MutationSignJournalPdfArgs = {
  input: SignJournalPdfInput;
};


export type MutationSignJurisprudenceFileArgs = {
  input: SignJurisprudenceFileInput;
};


export type MutationSignMotionFileArgs = {
  input: SignMotionFileInput;
};


export type MutationSignRjbFileArgs = {
  input: SignRjbFileInput;
};


export type MutationSignResearchLabTermsArgs = {
  input: SignResearchLabTermsInput;
};


export type MutationSignupArgs = {
  input: SignupInput;
};


export type MutationSignupWithCpfArgs = {
  input: SignupWithCpfInput;
};


export type MutationSignupWithCpfFromAppleArgs = {
  input: SignupWithCpfFromAppleInput;
};


export type MutationSignupWithCpfFromGoogleArgs = {
  input: SignupWithCpfFromGoogleInput;
};


export type MutationStartLawsuitSearchArgs = {
  input: StartLawsuitSearchInput;
};


export type MutationStartMonitoringCpfArgs = {
  input: StartMonitoringCpfInput;
};


export type MutationStartNotificationFlowArgs = {
  input: StartNotificationFlowInput;
};


export type MutationStopMonitoringCrmLawsuitArgs = {
  input: StopMonitoringCrmLawsuitInput;
};


export type MutationStopMonitoringCpfArgs = {
  input: StopMonitoringCpfInput;
};


export type MutationSubmitStudentAcademicDataArgs = {
  input: SubmitStudentAcademicDataInput;
};


export type MutationSubscribeToCpfMonitoringArgs = {
  input: SubscribeToCpfMonitoringInput;
};


export type MutationSuspendStudentBenefitAsAdminArgs = {
  input: SuspendStudentBenefitAsAdminInput;
};


export type MutationTakeOverArgs = {
  input: TakeOverInput;
};


export type MutationToggleFollowEntityArgs = {
  input: ToggleFollowEntityInput;
};


export type MutationToggleMonitoringCrmLawsuitsArgs = {
  input: ToggleMonitoringCrmLawsuitsInput;
};


export type MutationToggleSaveDocumentArgs = {
  input: ToggleSaveDocumentInput;
};


export type MutationTransferHubUserArgs = {
  input: TransferHubUserInput;
};


export type MutationTransferOabArgs = {
  input: TransferOabInput;
};


export type MutationTransferRelatedCrmEventsArgs = {
  input: TransferRelatedCrmEventsInput;
};


export type MutationUnImpersonateArgs = {
  input: UnImpersonateInput;
};


export type MutationUnfavoriteCrmEntityArgs = {
  input: UnfavoriteCrmEntityInput;
};


export type MutationUnlinkCrmTagArgs = {
  input: UnlinkCrmTagInput;
};


export type MutationUnloggedValidateCpfArgs = {
  input: UnloggedValidateCpfInput;
};


export type MutationUpdateAcademyUserInfoArgs = {
  input: UpdateAcademyUserInfoInput;
};


export type MutationUpdateB2BAreaArgs = {
  input: UpdateB2BAreaInput;
};


export type MutationUpdateB2BCompanyArgs = {
  input: UpdateB2BCompanyInput;
};


export type MutationUpdateCProUserFeaturesArgs = {
  input: UpdateCproUserFeaturesInput;
};


export type MutationUpdateCrmLawsuitPartyEntityHistoryArgs = {
  input: UpdateCrmLawsuitPartyEntityHistoryInput;
};


export type MutationUpdateCollectionArgs = {
  input: UpdateUserCollectionInput;
};


export type MutationUpdateCompanyQuotaArgs = {
  input: UpdateCompanyQuotaInput;
};


export type MutationUpdateContactArgs = {
  input: UpdateContactInput;
};


export type MutationUpdateCpfValidationInfoAsAdminArgs = {
  input: UpdateCpfValidationInfoAsAdminInput;
};


export type MutationUpdateDocumentIndexableStatusArgs = {
  input: UpdateDocumentIndexableStatusInput;
};


export type MutationUpdateExpertiseAreaArgs = {
  input: UpdateExpertiseAreaInput;
};


export type MutationUpdateExpertisesArgs = {
  input: UpdateExpertisesInput;
};


export type MutationUpdateFacebookConnectionArgs = {
  input: UpdateFacebookConnectionInput;
};


export type MutationUpdateHubCompanyRequestPlanArgs = {
  input: UpdateHubCompanyRequestPlanInput;
};


export type MutationUpdateHubInviteAreaArgs = {
  input: UpdateHubInviteAreaInput;
};


export type MutationUpdateHubInviteRoleArgs = {
  input: UpdateHubInviteRoleInput;
};


export type MutationUpdateHubOrganizationArgs = {
  input: UpdateHubOrganizationInput;
};


export type MutationUpdateInstitutionalProfileAdminsArgs = {
  input: UpdateInstitutionalProfileAdminsInput;
};


export type MutationUpdateLawServiceLocationArgs = {
  input: UpdateLawServiceLocationInput;
};


export type MutationUpdateLawsuitSummaryArgs = {
  input: UpdateLawsuitSummaryInput;
};


export type MutationUpdateLawsuitTitleArgs = {
  input: UpdateLawsuitTitleInput;
};


export type MutationUpdateMagicLinkConfigArgs = {
  input: UpdateMagicLinkConfigInput;
};


export type MutationUpdateNamesIndexableStatusArgs = {
  input: UpdateNamesIndexableStatusInput;
};


export type MutationUpdateOabValidationInfoArgs = {
  input: UpdateOabValidationInfoInput;
};


export type MutationUpdateProfileBadgesArgs = {
  input: UpdateProfileBadgesInput;
};


export type MutationUpdateProfileLastSeenCasesDashboardArgs = {
  input: UpdateProfileLastSeenCasesDashboardInput;
};


export type MutationUpdateProfilePlanArgs = {
  input: UpdateProfilePlanInput;
};


export type MutationUpdatePublicationMonitoringArgs = {
  input: UpdatePublicationMonitoringInput;
};


export type MutationUpdateSessionItemsCookieArgs = {
  input: UpdateSessionItemsCookieInput;
};


export type MutationUpdateWorkLocationsArgs = {
  input: UpdateWorkLocationsInput;
};


export type MutationUploadStudentEnrollmentDocArgs = {
  input: UploadStudentEnrollmentDocInput;
};


export type MutationUpsertBatchMetadataArgs = {
  input: UpsertBatchMetadataInput;
};


export type MutationUpsertMetadataArgs = {
  input: UpsertMetadataInput;
};


export type MutationUpsertVirtualFeatureConfigArgs = {
  input: UpsertVirtualFeatureConfigInput;
};


export type MutationUseCrmLawsuitPartyEntityFeatureArgs = {
  input: UseCrmLawsuitPartyEntityFeatureInput;
};


export type MutationUseDocumentFeatureArgs = {
  input: UseDocumentFeatureInput;
};


export type MutationUseSearchFeatureArgs = {
  input: UseSearchFeatureInput;
};


export type MutationUseThirdPartySearchFeatureArgs = {
  input: UseThirdPartySearchFeatureInput;
};


export type MutationUseTopicFeatureArgs = {
  input: UseTopicFeatureInput;
};


export type MutationUserReportProblemArgs = {
  input: UserReportProblemInput;
};


export type MutationUserRequestedUpdateArgs = {
  input: UserRequestedUpdateInput;
};


export type MutationValidateAuthTokenArgs = {
  input: ValidateAuthTokenInput;
};


export type MutationValidateCpfArgs = {
  input: ValidateCpfInput;
};


export type MutationValidateInviteCsvArgs = {
  input: ValidateInviteCsvInput;
};


export type MutationValidateLawsuitProfileArgs = {
  input: ValidateLawsuitProfileInput;
};


export type MutationValidateLawsuitRepresentedPersonArgs = {
  input: ValidateLawsuitRepresentedPersonInput;
};


export type MutationValidateOabArgs = {
  input: ValidateOabInput;
};


export type MutationValidateSignupTokenArgs = {
  input: ValidateSignupTokenInput;
};


export type MutationValidateSmsArgs = {
  input: ValidateSmsInput;
};


export type MutationValidateStudentEnrollmentDocumentArgs = {
  input: ValidateStudentEnrollmentDocumentInput;
};


export type MutationValidateTurnstileTokenArgs = {
  input: ValidateTurnstileTokenInput;
};


export type MutationVerifyEmailForErpMobileSignupArgs = {
  input: VerifyEmailForErpMobileSignupInput;
};


export type MutationVerifyOtpCodeArgs = {
  input: VerifyOtpCodeInput;
};


export type MutationVerifyOneTimePurchaseIapArgs = {
  input: IapVerifyOneTimePurchaseInput;
};


export type MutationVerifyPurchaseIapArgs = {
  input: IapVerifyPurchaseSubscriptionInput;
};


export type MutationVoteDocumentCommentArgs = {
  input: VoteDocumentCommentInput;
};


export type MutationWingmanUndoFeatureUsageArgs = {
  input: WingmanUndoFeatureUsageInput;
};


export type MutationWingmanUseFeatureArgs = {
  input: WingmanUseFeatureInput;
};

export type NameBatchInput = {
  readonly indexable: Scalars['Boolean'];
  readonly nameId: Scalars['NumericID'];
};

export type NearbyCitiesConnection = {
  readonly __typename?: 'NearbyCitiesConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<NearbyCitiesEdge>>>;
  readonly pageInfo: PageInfo;
};

export type NearbyCitiesEdge = {
  readonly __typename?: 'NearbyCitiesEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Topic>;
};

export type Ner = {
  readonly __typename?: 'Ner';
  readonly normative_act: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly precedent: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly theme: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
};

export type NewLegalCaseAnswerInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly conversationId: Scalars['Int'];
};

export type NewLegalCaseAnswerPayload = {
  readonly __typename?: 'NewLegalCaseAnswerPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly conversation: Maybe<Conversation>;
  readonly conversationsEdge: Maybe<ProfileLegalCasesConversationsEdge>;
  readonly legalCase: Maybe<LegalCase>;
  readonly viewer: Maybe<Profile>;
};

export type NewOpportunityInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly legalCaseId: Scalars['Int'];
};

export type NewOpportunityPayload = {
  readonly __typename?: 'NewOpportunityPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly legalCase: Maybe<LegalCase>;
  readonly legalCasesEdge: Maybe<ProfileLegalCasesDashboardEdge>;
  readonly viewer: Maybe<Profile>;
};

export type NewsMetadata = {
  readonly __typename?: 'NewsMetadata';
  readonly addons: Maybe<SearchMetadataAddons>;
  readonly author: SearchMetadataAuthor;
  readonly body: Maybe<Scalars['String']>;
  readonly date: Maybe<Scalars['Float']>;
  readonly docId: Scalars['String'];
  readonly features: Maybe<SearchMetadataFeatures>;
  readonly highlight: Maybe<Scalars['String']>;
  readonly slug: Scalars['String'];
  readonly tags: ReadonlyArray<SearchMetadataTags>;
  readonly title: Maybe<Scalars['String']>;
  readonly url: Scalars['String'];
};


export type NewsMetadataBodyArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
  preferHighlight?: InputMaybe<Scalars['Boolean']>;
};

export type Node = {
  readonly id: Scalars['ID'];
};

export enum NotificationChannelEnum {
  AllEmailNotifications = 'all_email_notifications',
  AllNotifications = 'all_notifications'
}

export type NotificationInfo = {
  readonly __typename?: 'NotificationInfo';
  readonly configName: Maybe<Scalars['String']>;
  readonly notificationName: Maybe<Scalars['String']>;
  readonly template: Maybe<Scalars['String']>;
  readonly variables: Maybe<Scalars['JSON']>;
};

export type NotificationInfoType = {
  readonly configName?: InputMaybe<Scalars['String']>;
  readonly notificationName?: InputMaybe<Scalars['String']>;
  readonly template?: InputMaybe<Scalars['String']>;
  readonly variables?: InputMaybe<Scalars['JSON']>;
};

export type NotificationPreference = {
  readonly __typename?: 'NotificationPreference';
  readonly availableEmailNotificationTypes: ReadonlyArray<EmailNotificationTypeInfo>;
  readonly availableNotificationTypes: ReadonlyArray<NotificationTypeInfo>;
  readonly blockedNotificationTypes: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
};

export enum NotificationPreferenceType {
  CourtHearing = 'court_hearing',
  LawsuitDecisions = 'lawsuit_decisions',
  NewLawsuitForCpf = 'new_lawsuit_for_cpf'
}

export type NotificationTypeInfo = {
  readonly __typename?: 'NotificationTypeInfo';
  readonly description: Scalars['String'];
  readonly enabled: Maybe<Scalars['Boolean']>;
  readonly title: Scalars['String'];
  readonly type: Maybe<NotificationPreferenceType>;
};

export type NotifySalesTeamInput = {
  readonly about?: InputMaybe<Scalars['String']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly company?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly phone?: InputMaybe<Scalars['String']>;
  readonly term?: InputMaybe<Scalars['String']>;
};

export type NotifySalesTeamPayload = {
  readonly __typename?: 'NotifySalesTeamPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly user: Maybe<User>;
};

export type OabPrice = {
  readonly __typename?: 'OABPrice';
  readonly description: Maybe<Scalars['String']>;
  readonly locationId: Maybe<Scalars['Int']>;
  readonly subjectId: Maybe<Scalars['Int']>;
  readonly url: Maybe<Scalars['String']>;
};

export enum OabPartnershipStatusType {
  Logged = 'LOGGED',
  NonMember = 'NON_MEMBER',
  Unlogged = 'UNLOGGED',
  Upgrade = 'UPGRADE'
}

export type OabTransferring = {
  readonly __typename?: 'OabTransferring';
  readonly birthDate: Scalars['Int64'];
  readonly cpf: Scalars['String'];
  readonly oab: Scalars['String'];
  readonly oabType: Scalars['String'];
  readonly oabUf: Scalars['NumericID'];
  readonly oabUfLabel: Scalars['String'];
  readonly origin: Maybe<Scalars['String']>;
};

export type OabTransferringFormFieldsInput = {
  readonly birthDate: Scalars['Int64'];
  readonly cpf: Scalars['String'];
  readonly oab: Scalars['String'];
  readonly oabType: Scalars['String'];
  readonly oabUf: Scalars['NumericID'];
  readonly oabUfLabel: Scalars['String'];
  readonly origin?: InputMaybe<Scalars['String']>;
};

export type OccultDocumentInput = {
  readonly artifact: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId: Scalars['NumericID'];
  readonly message: Scalars['String'];
  readonly notify: Scalars['Boolean'];
};

export type OccultDocumentPayload = {
  readonly __typename?: 'OccultDocumentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly document: Maybe<Document>;
};

export enum OccupationType {
  Bachelor = 'BACHELOR',
  Lawyer = 'LAWYER',
  Other = 'OTHER',
  Undergraduate = 'UNDERGRADUATE'
}

export type OccupyHubSeatInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type OccupyHubSeatPayload = {
  readonly __typename?: 'OccupyHubSeatPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly errorCode: Maybe<Scalars['String']>;
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type Offer = Node & {
  readonly __typename?: 'Offer';
  readonly expirationDate: Maybe<Scalars['String']>;
  readonly expiredOffer: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly offerId: Maybe<Scalars['Int']>;
  readonly plan: Maybe<Plan>;
  readonly planId: Maybe<Scalars['Int']>;
  readonly shouldShowToastNotification: Maybe<Scalars['Boolean']>;
  readonly toastNotificationStartAt: Maybe<Scalars['String']>;
  readonly user: Maybe<Scalars['String']>;
};

export type OfferInfo = {
  readonly __typename?: 'OfferInfo';
  readonly benefits: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly description: Maybe<Scalars['String']>;
  readonly legalCaption: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly tags: Maybe<ReadonlyArray<Scalars['String']>>;
};

export type OfferInfoType = {
  readonly benefits?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly description?: InputMaybe<Scalars['String']>;
  readonly legalCaption?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly tags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type OfferLockBanner = {
  readonly __typename?: 'OfferLockBanner';
  readonly description: Scalars['String'];
  readonly icon: OfferLockIcon;
  readonly title: Scalars['String'];
  readonly type: Maybe<BannerTypeEnum>;
};

export type OfferLockBenefit = {
  readonly __typename?: 'OfferLockBenefit';
  readonly icon: OfferLockIcon;
  readonly iconType: Maybe<BenefitIconTypeEnum>;
  readonly isHighlighted: Scalars['Boolean'];
  readonly name: Scalars['String'];
};

export type OfferLockBody = {
  readonly __typename?: 'OfferLockBody';
  readonly cards: ReadonlyArray<OfferLockCard>;
};

export type OfferLockBottomLinks = {
  readonly __typename?: 'OfferLockBottomLinks';
  readonly label: Scalars['String'];
  readonly url: Scalars['String'];
};

export type OfferLockButton = {
  readonly __typename?: 'OfferLockButton';
  readonly kind: Maybe<ButtonKindEnum>;
  readonly label: Scalars['String'];
  readonly labelOnError: Scalars['String'];
  readonly url: Scalars['String'];
};

export type OfferLockCard = {
  readonly __typename?: 'OfferLockCard';
  readonly banner: Maybe<OfferLockBanner>;
  readonly benefitsList: ReadonlyArray<OfferLockBenefit>;
  readonly bottomLinks: ReadonlyArray<OfferLockBottomLinks>;
  readonly button: OfferLockButton;
  readonly buttons: ReadonlyArray<OfferLockButton>;
  readonly checkoutFallbackVariant: Maybe<Scalars['String']>;
  readonly chip: OfferLockChip;
  readonly creditCard: Maybe<CreditCard>;
  readonly descriptions: ReadonlyArray<Scalars['String']>;
  readonly forceCheckout: Scalars['Boolean'];
  readonly icon: OfferLockIcon;
  readonly image: OfferLockImage;
  readonly infoChip: Maybe<OfferLockChip>;
  readonly link: OfferLockLink;
  readonly lockEventProperties: OfferLockEventProperties;
  readonly offer: OfferLockOffer;
  readonly submitData: OfferLockSubmitData;
  readonly subtitle: Scalars['String'];
  readonly title: Scalars['String'];
  readonly titlePlansSection: Maybe<Scalars['String']>;
};

export type OfferLockChip = {
  readonly __typename?: 'OfferLockChip';
  readonly description: Maybe<Scalars['String']>;
  readonly kind: Maybe<ChipKindEnum>;
  readonly label: Scalars['String'];
};

export type OfferLockData = {
  readonly __typename?: 'OfferLockData';
  readonly body: OfferLockBody;
  readonly footer: OfferLockFooter;
  readonly header: OfferLockHeader;
};

export type OfferLockEventProperties = {
  readonly __typename?: 'OfferLockEventProperties';
  readonly app_id: Maybe<Scalars['String']>;
  readonly current_plan: Maybe<Scalars['NumericID']>;
  readonly experiment_id: Maybe<Scalars['String']>;
  readonly feature: Scalars['String'];
  readonly from_component: Maybe<Scalars['String']>;
  readonly is_one_click: Maybe<Scalars['Boolean']>;
  readonly is_upgrade: Maybe<Scalars['Boolean']>;
  readonly modal_type: Maybe<BoxLockVariationType>;
  readonly next_plan: Maybe<Scalars['NumericID']>;
  readonly parent_resource_id: Maybe<Scalars['String']>;
  readonly pid: Maybe<Scalars['Int']>;
  readonly plan_price: Maybe<Scalars['Float']>;
  readonly resource_id: Maybe<Scalars['String']>;
};

export type OfferLockFooter = {
  readonly __typename?: 'OfferLockFooter';
  readonly banner: Maybe<OfferLockBanner>;
  readonly links: ReadonlyArray<OfferLockLink>;
  readonly text: Scalars['String'];
};

export type OfferLockHeader = {
  readonly __typename?: 'OfferLockHeader';
  readonly icon: OfferLockIcon;
  readonly secondStepTitle: Maybe<Scalars['String']>;
  readonly subtitle: Scalars['String'];
  readonly title: Scalars['String'];
  readonly toggle: Toggle;
};

export type OfferLockIcon = {
  readonly __typename?: 'OfferLockIcon';
  readonly color: Scalars['String'];
  readonly iconType: Maybe<IconTypeEnum>;
};

export type OfferLockImage = {
  readonly __typename?: 'OfferLockImage';
  readonly alt: Scalars['String'];
  readonly src: Scalars['String'];
};

export type OfferLockLink = {
  readonly __typename?: 'OfferLockLink';
  readonly label: Scalars['String'];
  readonly url: Scalars['String'];
};

export type OfferLockOffer = {
  readonly __typename?: 'OfferLockOffer';
  readonly currentPlanPriceText: Maybe<Scalars['String']>;
  readonly discountPercentage: Maybe<Scalars['Int']>;
  readonly discountText: Maybe<Scalars['String']>;
  readonly frequency: Maybe<Scalars['String']>;
  readonly frequencyInDays: Maybe<Scalars['Int']>;
  readonly frequencyPeriodText: Maybe<Scalars['String']>;
  readonly installmentsText: Maybe<Scalars['String']>;
  readonly isJusAIOffer: Maybe<Scalars['Boolean']>;
  readonly isRecommendedOffer: Maybe<Scalars['Boolean']>;
  readonly presentationName: Maybe<Scalars['String']>;
  readonly priceAfterPromotionalPeriodText: Maybe<Scalars['String']>;
  readonly priceText: Maybe<Scalars['String']>;
  readonly priceTitle: Scalars['String'];
  readonly priceTitlePlansSection: Maybe<Scalars['String']>;
};

export type OfferLockSubmitData = {
  readonly __typename?: 'OfferLockSubmitData';
  readonly jwt: Scalars['String'];
  readonly submitUrl: Scalars['String'];
};

export type Onboarding = Node & {
  readonly __typename?: 'Onboarding';
  readonly id: Scalars['ID'];
  readonly stopStep: Scalars['Int'];
  readonly userId: Maybe<Scalars['Int']>;
};


export type OnboardingStopStepArgs = {
  onboardingName: Scalars['String'];
};

export type OneClickBuyInput = {
  readonly ccToken: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly submitData: Scalars['JSON'];
};

export type OneClickBuyPayload = {
  readonly __typename?: 'OneClickBuyPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly orderCode: Scalars['String'];
  readonly success: Scalars['Boolean'];
};

export type OneClickChangePlanInput = {
  readonly boxHash: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly jwt: Scalars['String'];
};

export type OneClickChangePlanPayload = {
  readonly __typename?: 'OneClickChangePlanPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
};

export type OneTimeFeeSubscription = {
  readonly __typename?: 'OneTimeFeeSubscription';
  readonly name: Scalars['String'];
  readonly planId: Maybe<Scalars['Int']>;
  readonly priceText: Scalars['String'];
  readonly subscriptionHelpText: Scalars['String'];
  readonly supportLink: Scalars['String'];
};

export type OptionsType = {
  readonly limit?: InputMaybe<Scalars['Int']>;
  readonly price?: InputMaybe<Scalars['Float']>;
};

export type Organization = CrmEntity & CrmTimelineProvider & Node & {
  readonly __typename?: 'Organization';
  readonly autocomplete: Maybe<OrganizationCrmAutocompleteConnection>;
  readonly avatar: Maybe<Scalars['String']>;
  readonly bulkActions: Maybe<ReadonlyArray<Maybe<CrmBulkAction>>>;
  readonly calendar: Maybe<CrmCalendar>;
  readonly calendarId: Maybe<Scalars['String']>;
  readonly contactCount: Maybe<Scalars['JSON']>;
  readonly contactCountByType: Maybe<Scalars['JSON']>;
  readonly contacts: Maybe<OrganizationContactsConnection>;
  readonly dashboard: Maybe<OrganizationDashboard>;
  readonly documentCount: Maybe<Scalars['JSON']>;
  readonly documentCountByEntityType: Maybe<Scalars['JSON']>;
  readonly documentCountByLawsuitAttachment: Maybe<Scalars['JSON']>;
  readonly documentCountByOwner: Maybe<Scalars['JSON']>;
  readonly documents: Maybe<CrmEntityDocumentConnection>;
  readonly enabledIdoxIntegration: Maybe<Scalars['Boolean']>;
  readonly enterprise: Maybe<Scalars['Boolean']>;
  readonly entityRefId: Maybe<Scalars['String']>;
  readonly entityRefName: Maybe<Scalars['String']>;
  readonly entityRefType: Maybe<Scalars['String']>;
  readonly entityRefTypeRaw: Maybe<Scalars['String']>;
  readonly events: Maybe<ReadonlyArray<Maybe<CrmEvent>>>;
  readonly eventsConnection: Maybe<CrmEntityEventsConnection>;
  readonly favorited: Maybe<Scalars['Boolean']>;
  readonly featureTokens: Maybe<FeatureTokens>;
  readonly hasPendingPayment: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly idoxIntegrationAuth: Maybe<Scalars['String']>;
  readonly isMyJusbrasil: Maybe<Scalars['Boolean']>;
  readonly isOwner: Maybe<Scalars['Boolean']>;
  readonly isProOnlineOffice: Maybe<Scalars['Boolean']>;
  readonly isShared: Maybe<Scalars['Boolean']>;
  readonly isVerified: Maybe<Scalars['Boolean']>;
  readonly lawsuitCount: Maybe<Scalars['JSON']>;
  readonly lawsuitCountByStatus: Maybe<Scalars['JSON']>;
  readonly lawsuitRawCount: Maybe<Scalars['JSON']>;
  readonly lawsuitSearches: Maybe<ReadonlyArray<Maybe<CrmLawsuitSearch>>>;
  readonly lawsuits: Maybe<OrganizationLawsuitsConnection>;
  readonly legalCaseProfileInfo: Maybe<LegalCaseProfileInfo>;
  readonly listPublicationAlerts: Maybe<ListPublicationAlertsConnection>;
  readonly members: Maybe<ReadonlyArray<Maybe<OrganizationMember>>>;
  readonly migratedToOnlineOffice: Maybe<Scalars['Boolean']>;
  readonly monitoringLawsuitCount: Maybe<Scalars['Int']>;
  readonly monitoringLawsuits: Maybe<OrganizationMonitoringLawsuitCountConnection>;
  readonly monthStatement: Maybe<BoxTokenStatement>;
  readonly name: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
  readonly organizationId: Maybe<Scalars['Int']>;
  readonly organizationType: Maybe<Scalars['String']>;
  readonly owner: Maybe<Profile>;
  readonly ownerId: Maybe<Scalars['Int']>;
  readonly publicationAlertItems: Maybe<PublicationAlertItemsConnection>;
  readonly publicationAlertMonitored: Maybe<PublicationAlert>;
  readonly publicationAlerts: Maybe<PublicationAlertsConnection>;
  readonly publicationAlertsByKind: Maybe<ReadonlyArray<Maybe<PublicationAlert>>>;
  readonly readOnly: Maybe<Scalars['Boolean']>;
  readonly search: Maybe<OrganizationCrmSearchItemConnection>;
  readonly sectionsVisibility: Maybe<SectionsVisibility>;
  readonly status: Maybe<Scalars['String']>;
  readonly subscriptions: Maybe<ReadonlyArray<Maybe<BoxSubscription>>>;
  readonly tagList: Maybe<OrganizationCrmTagsConnection>;
  readonly tagsOverriding: Maybe<Scalars['JSON']>;
  readonly tasks: Maybe<ReadonlyArray<Maybe<CrmTask>>>;
  readonly tasksConnection: Maybe<CrmEntityTasksConnection>;
  readonly thumborAvatar: Maybe<ThumborImage>;
  readonly timeline: Maybe<CrmEntityTimelineConnection>;
  readonly timelineItem: Maybe<CrmTimelineItem>;
  readonly timelineSources: Maybe<ReadonlyArray<Maybe<CrmTimelineItemSource>>>;
  readonly visible: Maybe<Scalars['Boolean']>;
};


export type OrganizationAutocompleteArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
};


export type OrganizationBulkActionsArgs = {
  status: InputMaybe<Scalars['String']>;
};


export type OrganizationContactCountArgs = {
  aggSize: InputMaybe<Scalars['Int']>;
  category: Scalars['String'];
  favorited: InputMaybe<Scalars['Boolean']>;
  firstLetter: InputMaybe<Scalars['String']>;
  query: InputMaybe<Scalars['String']>;
  status: InputMaybe<Scalars['String']>;
};


export type OrganizationContactCountByTypeArgs = {
  aggSize: InputMaybe<Scalars['Int']>;
  favorited: InputMaybe<Scalars['Boolean']>;
  firstLetter: InputMaybe<Scalars['String']>;
  query: InputMaybe<Scalars['String']>;
  status: InputMaybe<Scalars['String']>;
};


export type OrganizationContactsArgs = {
  after: InputMaybe<Scalars['String']>;
  autocomplete: InputMaybe<Scalars['String']>;
  contactTypes: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  email: InputMaybe<Scalars['String']>;
  entitiesTags: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  favorited: InputMaybe<Scalars['Boolean']>;
  first: InputMaybe<Scalars['Int']>;
  firstLetter: InputMaybe<Scalars['String']>;
  ownerId: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
  sortProperties: InputMaybe<Scalars['JSON']>;
  status: InputMaybe<Scalars['String']>;
};


export type OrganizationDashboardArgs = {
  autocomplete: InputMaybe<Scalars['String']>;
  endDate: Scalars['Float'];
  histogramType: InputMaybe<Scalars['String']>;
  numItems: InputMaybe<Scalars['Int']>;
  number: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderByField: InputMaybe<Scalars['String']>;
  ownerId: InputMaybe<Scalars['Int']>;
  pid: InputMaybe<Scalars['Int']>;
  startDate: Scalars['Float'];
  status: InputMaybe<Scalars['String']>;
};


export type OrganizationDocumentCountArgs = {
  aggSize: InputMaybe<Scalars['Int']>;
  category: Scalars['String'];
  query: InputMaybe<Scalars['String']>;
  status: InputMaybe<Scalars['String']>;
  updatedAtRange: InputMaybe<Scalars['JSON']>;
};


export type OrganizationDocumentCountByEntityTypeArgs = {
  aggSize: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
  status: InputMaybe<Scalars['String']>;
  updatedAtRange: InputMaybe<Scalars['JSON']>;
};


export type OrganizationDocumentCountByLawsuitAttachmentArgs = {
  aggSize: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
  status: InputMaybe<Scalars['String']>;
  updatedAtRange: InputMaybe<Scalars['JSON']>;
};


export type OrganizationDocumentCountByOwnerArgs = {
  aggSize: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
  status: InputMaybe<Scalars['String']>;
  updatedAtRange: InputMaybe<Scalars['JSON']>;
};


export type OrganizationDocumentsArgs = {
  after: InputMaybe<Scalars['String']>;
  autocomplete: InputMaybe<Scalars['String']>;
  entityType: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  lawsuitAttachment: InputMaybe<Scalars['Boolean']>;
  orderBy: InputMaybe<Scalars['JSON']>;
  ownerId: InputMaybe<Scalars['Int']>;
  status: InputMaybe<Scalars['String']>;
  visibilityType: InputMaybe<Scalars['String']>;
};


export type OrganizationEventsArgs = {
  contactId: InputMaybe<Scalars['String']>;
  eventType: InputMaybe<Scalars['String']>;
  lawsuitId: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  ownerId: InputMaybe<Scalars['Int']>;
  singleEvents: InputMaybe<Scalars['Boolean']>;
  timeMax: InputMaybe<Scalars['Float']>;
  timeMin: InputMaybe<Scalars['Float']>;
};


export type OrganizationEventsConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  contactId: InputMaybe<Scalars['String']>;
  eventFilter: InputMaybe<EventFilterType>;
  eventType: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  lawsuitId: InputMaybe<Scalars['String']>;
  ownerId: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
  singleEvents: InputMaybe<Scalars['Boolean']>;
  timeMax: InputMaybe<Scalars['Float']>;
  timeMin: InputMaybe<Scalars['Float']>;
};


export type OrganizationFeatureTokensArgs = {
  featureCode: Scalars['String'];
  type: InputMaybe<Scalars['String']>;
};


export type OrganizationLawsuitCountArgs = {
  aggSize: InputMaybe<Scalars['Int']>;
  category: Scalars['String'];
  entitiesTags: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  favorited: InputMaybe<Scalars['Boolean']>;
  lawsuitType: InputMaybe<Scalars['String']>;
  monitoringIntentionActive: InputMaybe<Scalars['Boolean']>;
  monitoringStatus: InputMaybe<Scalars['String']>;
  number: InputMaybe<Scalars['String']>;
  ownerId: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
  relatedPersonId: InputMaybe<Scalars['String']>;
  status: InputMaybe<Scalars['String']>;
  updatedAtRange: InputMaybe<Scalars['JSON']>;
};


export type OrganizationLawsuitCountByStatusArgs = {
  aggSize: InputMaybe<Scalars['Int']>;
  number: InputMaybe<Scalars['String']>;
  ownerId: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
  relatedPersonId: InputMaybe<Scalars['String']>;
  status: InputMaybe<Scalars['String']>;
  updatedAtRange: InputMaybe<Scalars['JSON']>;
};


export type OrganizationLawsuitRawCountArgs = {
  entitiesTags: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  favorited: InputMaybe<Scalars['Boolean']>;
  lawsuitType: InputMaybe<Scalars['String']>;
  monitoringIntentionActive: InputMaybe<Scalars['Boolean']>;
  monitoringStatus: InputMaybe<Scalars['String']>;
  number: InputMaybe<Scalars['String']>;
  ownerId: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
  relatedPersonId: InputMaybe<Scalars['String']>;
  status: InputMaybe<Scalars['String']>;
  updatedAtRange: InputMaybe<Scalars['JSON']>;
};


export type OrganizationLawsuitSearchesArgs = {
  executionStatus: InputMaybe<Scalars['String']>;
  status: InputMaybe<Scalars['String']>;
};


export type OrganizationLawsuitsArgs = {
  after: InputMaybe<Scalars['String']>;
  autocomplete: InputMaybe<Scalars['String']>;
  entitiesTags: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  favorited: InputMaybe<Scalars['Boolean']>;
  first: InputMaybe<Scalars['Int']>;
  ignoreShared: InputMaybe<Scalars['Boolean']>;
  lawsuitType: InputMaybe<Scalars['String']>;
  monitoringIntentionActive: InputMaybe<Scalars['Boolean']>;
  monitoringStatus: InputMaybe<Scalars['String']>;
  number: InputMaybe<Scalars['String']>;
  orderBy: InputMaybe<Scalars['JSON']>;
  ownerId: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
  relatedPersonId: InputMaybe<Scalars['String']>;
  status: InputMaybe<Scalars['String']>;
  updateStatus: InputMaybe<Scalars['String']>;
  updatedAtRange: InputMaybe<Scalars['JSON']>;
  visibilityType: InputMaybe<Scalars['String']>;
};


export type OrganizationListPublicationAlertsArgs = {
  after: InputMaybe<Scalars['String']>;
  countUnread: InputMaybe<Scalars['Boolean']>;
  filter: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  fromExternalSource: InputMaybe<Scalars['Boolean']>;
  mandatoryLabelsToExclude: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  previousItemId: InputMaybe<Scalars['String']>;
  sourceExternalReferenceId: InputMaybe<Scalars['String']>;
  status: InputMaybe<Scalars['String']>;
};


export type OrganizationMembersArgs = {
  includePending: InputMaybe<Scalars['Boolean']>;
};


export type OrganizationMonitoringLawsuitsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type OrganizationMonthStatementArgs = {
  featureCode: Scalars['String'];
  month: Scalars['Int'];
  year: Scalars['Int'];
};


export type OrganizationPublicationAlertItemsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  fromExternalSource: InputMaybe<Scalars['Boolean']>;
  idAlert: InputMaybe<Scalars['String']>;
  idSource: InputMaybe<Scalars['String']>;
  lastTimestamp: InputMaybe<Scalars['Float']>;
  read: InputMaybe<Scalars['Boolean']>;
  status: InputMaybe<Scalars['String']>;
};


export type OrganizationPublicationAlertMonitoredArgs = {
  filterOabNumber: InputMaybe<Scalars['Int']>;
  filterOabUF: InputMaybe<Scalars['String']>;
  term: InputMaybe<Scalars['String']>;
};


export type OrganizationPublicationAlertsArgs = {
  after: InputMaybe<Scalars['String']>;
  exceptFromMetaSourceTypes: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  first: InputMaybe<Scalars['Int']>;
  fromExternalSource: InputMaybe<Scalars['Boolean']>;
  query: InputMaybe<Scalars['String']>;
  statuses: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type OrganizationPublicationAlertsByKindArgs = {
  kind: Scalars['String'];
  mandatoryLabelsToExclude: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type OrganizationSearchArgs = {
  after: InputMaybe<Scalars['String']>;
  entitiesName: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  entityName: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
};


export type OrganizationTagListArgs = {
  after: InputMaybe<Scalars['String']>;
  autocomplete: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  overrideWithUserCustom: InputMaybe<Scalars['Boolean']>;
  status: InputMaybe<Scalars['String']>;
  targetTypes: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type OrganizationTasksArgs = {
  dateRange: InputMaybe<Scalars['JSON']>;
  finished: InputMaybe<Scalars['Boolean']>;
  limit: InputMaybe<Scalars['Int']>;
  ownerId: InputMaybe<Scalars['Int']>;
  visibilityType: InputMaybe<Scalars['String']>;
};


export type OrganizationTasksConnectionArgs = {
  after: InputMaybe<Scalars['String']>;
  dateRange: InputMaybe<Scalars['JSON']>;
  finished: InputMaybe<Scalars['Boolean']>;
  first: InputMaybe<Scalars['Int']>;
  ownerId: InputMaybe<Scalars['Int']>;
};


export type OrganizationTimelineArgs = {
  actions: InputMaybe<Scalars['JSON']>;
  after: InputMaybe<Scalars['String']>;
  createdAtRange: InputMaybe<Scalars['JSON']>;
  eventType: InputMaybe<Scalars['String']>;
  eventTypes: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  excludeStatus: InputMaybe<SuitsStatusType>;
  first: InputMaybe<Scalars['Int']>;
  important: InputMaybe<Scalars['Boolean']>;
  loadFromDB: InputMaybe<Scalars['Boolean']>;
  objectType: InputMaybe<Scalars['String']>;
  ownerId: InputMaybe<Scalars['Int']>;
  read: InputMaybe<Scalars['Boolean']>;
  sortProperties: InputMaybe<Scalars['JSON']>;
  source: InputMaybe<Scalars['JSON']>;
  status: InputMaybe<Scalars['String']>;
  visibilityType: InputMaybe<Scalars['String']>;
};


export type OrganizationTimelineItemArgs = {
  timelineItemId: InputMaybe<Scalars['String']>;
};


export type OrganizationTimelineSourcesArgs = {
  eventType: InputMaybe<Scalars['String']>;
  monitoredEntity: InputMaybe<Scalars['Boolean']>;
  objectType: InputMaybe<Scalars['String']>;
  read: InputMaybe<Scalars['Boolean']>;
  source: InputMaybe<Scalars['JSON']>;
  sourceType: InputMaybe<Scalars['String']>;
  status: InputMaybe<Scalars['String']>;
};

export type OrganizationCrmAutocompleteConnection = {
  readonly __typename?: 'OrganizationCRMAutocompleteConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<OrganizationCrmAutocompleteEdge>>>;
  readonly numHits: Maybe<Scalars['Int']>;
  readonly pageInfo: PageInfo;
};

export type OrganizationCrmAutocompleteEdge = {
  readonly __typename?: 'OrganizationCRMAutocompleteEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmSearchItem>;
};

export type OrganizationCrmSearchItemConnection = {
  readonly __typename?: 'OrganizationCRMSearchItemConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<OrganizationCrmSearchItemEdge>>>;
  readonly entityNameCounters: Maybe<Scalars['JSON']>;
  readonly numHits: Maybe<Scalars['Int']>;
  readonly pageInfo: PageInfo;
};

export type OrganizationCrmSearchItemEdge = {
  readonly __typename?: 'OrganizationCRMSearchItemEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmSearchItem>;
};

export type OrganizationCrmTagsConnection = {
  readonly __typename?: 'OrganizationCRMTagsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<OrganizationCrmTagsEdge>>>;
  readonly numHits: Maybe<Scalars['Int']>;
  readonly pageInfo: PageInfo;
};

export type OrganizationCrmTagsEdge = {
  readonly __typename?: 'OrganizationCRMTagsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmTag>;
};

export type OrganizationContactsConnection = {
  readonly __typename?: 'OrganizationContactsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<OrganizationContactsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type OrganizationContactsEdge = {
  readonly __typename?: 'OrganizationContactsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Contact>;
};

export type OrganizationDashboard = {
  readonly __typename?: 'OrganizationDashboard';
  readonly lawsuitDistribuition: Maybe<Scalars['JSON']>;
  readonly lawsuitDistribuitionPeriod: Maybe<Scalars['JSON']>;
  readonly lawsuitStats: Maybe<Scalars['JSON']>;
  readonly openedConversations: Maybe<Scalars['JSON']>;
  readonly profileStats: Maybe<Scalars['JSON']>;
  readonly recentContacts: Maybe<Scalars['JSON']>;
  readonly recentConversations: Maybe<Scalars['JSON']>;
  readonly recentConversationsByExpertise: Maybe<Scalars['JSON']>;
  readonly recentLawsuits: Maybe<Scalars['JSON']>;
  readonly recentLawsuitsByKind: Maybe<Scalars['JSON']>;
  readonly recentLawsuitsByOwner: Maybe<Scalars['JSON']>;
};


export type OrganizationDashboardRecentContactsArgs = {
  numItems: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type OrganizationDashboardRecentConversationsArgs = {
  numItems: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type OrganizationDashboardRecentConversationsByExpertiseArgs = {
  numItems: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type OrganizationDashboardRecentLawsuitsArgs = {
  numItems: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type OrganizationDashboardRecentLawsuitsByKindArgs = {
  numItems: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type OrganizationDashboardRecentLawsuitsByOwnerArgs = {
  numItems: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};

export type OrganizationLawsuitsConnection = {
  readonly __typename?: 'OrganizationLawsuitsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<OrganizationLawsuitsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type OrganizationLawsuitsEdge = {
  readonly __typename?: 'OrganizationLawsuitsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmLawsuit>;
};

export type OrganizationMember = Node & {
  readonly __typename?: 'OrganizationMember';
  readonly accessProFeatures: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly inviteEmail: Maybe<Scalars['String']>;
  readonly isCurrent: Maybe<Scalars['Boolean']>;
  readonly isOwner: Maybe<Scalars['Boolean']>;
  readonly joinDate: Maybe<Scalars['Float']>;
  readonly memberId: Maybe<Scalars['Int']>;
  readonly organization: Maybe<Organization>;
  readonly organizationId: Maybe<Scalars['Int']>;
  readonly organizationType: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
  readonly profileId: Maybe<Scalars['Int']>;
  readonly role: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
};

export type OrganizationMonitoringLawsuitCountConnection = {
  readonly __typename?: 'OrganizationMonitoringLawsuitCountConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<OrganizationMonitoringLawsuitCountEdge>>>;
  readonly pageInfo: PageInfo;
};

export type OrganizationMonitoringLawsuitCountEdge = {
  readonly __typename?: 'OrganizationMonitoringLawsuitCountEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmLawsuit>;
};

export type PageInfo = {
  readonly __typename?: 'PageInfo';
  readonly endCursor: Maybe<Scalars['String']>;
  readonly hasNextPage: Scalars['Boolean'];
  readonly hasPreviousPage: Scalars['Boolean'];
  readonly startCursor: Maybe<Scalars['String']>;
};

export type PageMetadataInput = {
  readonly personName?: InputMaybe<Scalars['String']>;
};

export type ParentTopicsConnection = {
  readonly __typename?: 'ParentTopicsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ParentTopicsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ParentTopicsEdge = {
  readonly __typename?: 'ParentTopicsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Topic>;
};

export type ParticipantsConversationProfileConnection = {
  readonly __typename?: 'ParticipantsConversationProfileConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ParticipantsConversationProfileEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ParticipantsConversationProfileEdge = {
  readonly __typename?: 'ParticipantsConversationProfileEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Profile>;
};

export type PatchAreaFeaturesInput = {
  readonly areaUuid: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly features: ReadonlyArray<B2BAreaPatchFeatureInput>;
};

export type PatchAreaFeaturesPayload = {
  readonly __typename?: 'PatchAreaFeaturesPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly errorCode: Maybe<Scalars['String']>;
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
};

export type PatchAudienceSegmentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly description?: InputMaybe<Scalars['String']>;
  readonly jsonRule?: InputMaybe<Scalars['JSON']>;
  readonly segmentId: Scalars['String'];
  readonly segmentName?: InputMaybe<Scalars['String']>;
};

export type PatchAudienceSegmentPayload = {
  readonly __typename?: 'PatchAudienceSegmentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
  readonly jsonRule: Maybe<Scalars['JSON']>;
  readonly segmentName: Maybe<Scalars['String']>;
};

export type PatchReport = {
  readonly artifactId?: InputMaybe<Scalars['String']>;
  readonly artifactSource?: InputMaybe<Scalars['String']>;
  readonly cnj?: InputMaybe<Scalars['String']>;
  readonly createdAt?: InputMaybe<Scalars['String']>;
  readonly emailResponseSentAt?: InputMaybe<Scalars['String']>;
  readonly lawsuitId?: InputMaybe<Scalars['String']>;
  readonly pid?: InputMaybe<Scalars['String']>;
  readonly reportData?: InputMaybe<Scalars['JSON']>;
  readonly reportType?: InputMaybe<Scalars['String']>;
  readonly status?: InputMaybe<Scalars['String']>;
  readonly updatedAt?: InputMaybe<Scalars['String']>;
};

export type PatchReportInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly input?: InputMaybe<PatchReport>;
  readonly moderationUserEmail: Scalars['String'];
  readonly reportId: Scalars['String'];
};

export type PatchReportPayload = {
  readonly __typename?: 'PatchReportPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
};

export type PatchSubscriptionFeaturesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly companyUuid: Scalars['String'];
  readonly features: ReadonlyArray<B2BPatchFeatureInput>;
  readonly subscriptionUuid: Scalars['String'];
};

export type PatchSubscriptionFeaturesPayload = {
  readonly __typename?: 'PatchSubscriptionFeaturesPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly errorCode: Maybe<Scalars['String']>;
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
};

export type PatinhasSubscription = {
  readonly __typename?: 'PatinhasSubscription';
  readonly creditCard: Maybe<PatinhasSubscriptionCreditCard>;
  readonly cycle: Maybe<Scalars['Int']>;
  readonly gateway: Maybe<Scalars['String']>;
  readonly gatewayRef: Maybe<Scalars['String']>;
  readonly nextBillingDate: Maybe<Scalars['String']>;
  readonly orderCode: Maybe<Scalars['String']>;
  readonly plan: Maybe<PatinhasSubscriptionPlan>;
  readonly promotionalData: Maybe<Scalars['JSON']>;
  readonly status: Maybe<Scalars['String']>;
  readonly subscriptionStatus: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['String']>;
};

export type PatinhasSubscriptionCreditCard = {
  readonly __typename?: 'PatinhasSubscriptionCreditCard';
  readonly brandName: Maybe<Scalars['String']>;
  readonly expMonth: Maybe<Scalars['String']>;
  readonly expYear: Maybe<Scalars['String']>;
  readonly lastDigits: Maybe<Scalars['String']>;
};

export type PatinhasSubscriptionPlan = {
  readonly __typename?: 'PatinhasSubscriptionPlan';
  readonly id: Maybe<Scalars['Int']>;
  readonly name: Maybe<Scalars['String']>;
  readonly price: Maybe<Scalars['Float']>;
  readonly refPlanId: Maybe<Scalars['Int']>;
};

export type PauseFeatureTaskInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly id: Scalars['String'];
};

export type PauseFeatureTaskPayload = {
  readonly __typename?: 'PauseFeatureTaskPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly featureTask: FeatureTask;
};

export type PaymentInfo = {
  readonly __typename?: 'PaymentInfo';
  readonly currency: Maybe<Scalars['String']>;
  readonly frequency: Maybe<PlanFrequency>;
  readonly price: Maybe<Scalars['String']>;
  readonly pricePerInstallments: Maybe<Scalars['String']>;
};

export type PaymentReceipts = {
  readonly __typename?: 'PaymentReceipts';
  readonly amount: Maybe<Scalars['Float']>;
  readonly boxSubscription: Maybe<BoxSubscription>;
  readonly currentStatus: Maybe<Scalars['String']>;
  readonly eventName: Maybe<Scalars['String']>;
  readonly orderCode: Maybe<Scalars['String']>;
  readonly paymentReceiptsId: Maybe<Scalars['Int']>;
  readonly plan: Maybe<Plan>;
  readonly profile: Maybe<Profile>;
  readonly receivedAt: Maybe<Scalars['Float']>;
};

export type PaywallData = {
  readonly __typename?: 'PaywallData';
  readonly cta: Maybe<PaywallDataCta>;
  readonly highlightedText: Maybe<Scalars['String']>;
  readonly opensModal: Scalars['Boolean'];
  readonly subtitle: Maybe<Scalars['String']>;
  readonly title: Scalars['String'];
};

export type PaywallDataCta = {
  readonly __typename?: 'PaywallDataCta';
  readonly label: Scalars['String'];
  readonly url: Maybe<Scalars['String']>;
};

export type PdmModalContent = {
  readonly __typename?: 'PdmModalContent';
  readonly affectedProfiles: Maybe<PdmModalContentAffectedProfiles>;
  readonly banner: Maybe<PdmModalContentBanner>;
  readonly blockingReason: Maybe<PdmModalContentBlockingReason>;
  readonly canRequest: Scalars['Boolean'];
  readonly confirmation: Maybe<PdmModalContentConfirmation>;
  readonly paragraphs: ReadonlyArray<PdmModalContentRichParagraph>;
  readonly primaryAction: PdmModalContentAction;
  readonly scheduledFor: Maybe<Scalars['Float']>;
  readonly secondaryAction: Maybe<PdmModalContentAction>;
  readonly title: Scalars['String'];
  readonly variant: Maybe<PdmModalContentVariant>;
};

export type PdmModalContentAction = {
  readonly __typename?: 'PdmModalContentAction';
  readonly enabled: Scalars['Boolean'];
  readonly intent: Maybe<PdmModalContentActionIntent>;
  readonly kind: Maybe<ButtonKindEnum>;
  readonly label: Scalars['String'];
};

export enum PdmModalContentActionIntent {
  ConfirmDelete = 'CONFIRM_DELETE',
  Deactivate = 'DEACTIVATE',
  Dismiss = 'DISMISS',
  DownloadPersonalData = 'DOWNLOAD_PERSONAL_DATA',
  ExecuteDelete = 'EXECUTE_DELETE'
}

export type PdmModalContentAffectedProfile = {
  readonly __typename?: 'PdmModalContentAffectedProfile';
  readonly image: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly pid: Scalars['Int'];
};

export type PdmModalContentAffectedProfiles = {
  readonly __typename?: 'PdmModalContentAffectedProfiles';
  readonly description: Scalars['String'];
  readonly profiles: ReadonlyArray<PdmModalContentAffectedProfile>;
  readonly title: Scalars['String'];
};

export type PdmModalContentBanner = {
  readonly __typename?: 'PdmModalContentBanner';
  readonly description: Scalars['String'];
  readonly icon: Maybe<IconTypeEnum>;
  readonly title: Maybe<Scalars['String']>;
  readonly type: Maybe<BannerTypeEnum>;
};

export enum PdmModalContentBlockingReason {
  ActiveSubscription = 'ACTIVE_SUBSCRIPTION',
  ScheduledDeletion = 'SCHEDULED_DELETION'
}

export type PdmModalContentConfirmation = {
  readonly __typename?: 'PdmModalContentConfirmation';
  readonly paragraphs: ReadonlyArray<PdmModalContentRichParagraph>;
  readonly primaryAction: PdmModalContentAction;
  readonly secondaryAction: PdmModalContentAction;
  readonly title: Scalars['String'];
};

export type PdmModalContentRichParagraph = {
  readonly __typename?: 'PdmModalContentRichParagraph';
  readonly text: Scalars['String'];
};

export enum PdmModalContentVariant {
  AccountDeactivation = 'ACCOUNT_DEACTIVATION',
  DownloadPersonalData = 'DOWNLOAD_PERSONAL_DATA',
  PermanentDeletion = 'PERMANENT_DELETION'
}

export type PersistentAlertBanner = {
  readonly __typename?: 'PersistentAlertBanner';
  readonly description: Scalars['String'];
  readonly icon: Maybe<PersistentAlertBannerIcon>;
  readonly link: Maybe<PersistentAlertBannerLink>;
  readonly text: Scalars['String'];
  readonly type: Maybe<PersistentAlertBannerType>;
};

export type PersistentAlertBannerIcon = {
  readonly __typename?: 'PersistentAlertBannerIcon';
  readonly type: Maybe<IconTypeEnum>;
};

export type PersistentAlertBannerLink = {
  readonly __typename?: 'PersistentAlertBannerLink';
  readonly label: Scalars['String'];
  readonly url: Scalars['String'];
};

export enum PersistentAlertBannerType {
  JusIa = 'JUS_IA',
  OverdueSubscription = 'OVERDUE_SUBSCRIPTION',
  StudentsBenefit = 'STUDENTS_BENEFIT'
}

export enum PersonIdPoleType {
  NoPole = 'NO_POLE',
  PoleA = 'POLE_A',
  PoleB = 'POLE_B'
}

export type Phone = {
  readonly __typename?: 'Phone';
  readonly area: Maybe<Scalars['String']>;
  readonly brFormat: Maybe<Scalars['String']>;
  readonly countryCode: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['Int64']>;
  readonly origin: Maybe<Scalars['String']>;
  readonly phone: Maybe<Scalars['String']>;
  readonly phoneId: Maybe<Scalars['Int']>;
  readonly valid: Maybe<Scalars['Boolean']>;
};

export type Plan = Node & {
  readonly __typename?: 'Plan';
  readonly appliedDiscount: Maybe<Scalars['Float']>;
  readonly coupon: Maybe<PlanCoupon>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly customPlan: Maybe<Scalars['Boolean']>;
  readonly description: Maybe<Scalars['String']>;
  readonly expiresAt: Maybe<Scalars['Float']>;
  readonly featurePrice: Maybe<FeaturePrice>;
  readonly features: Maybe<ReadonlyArray<Feature>>;
  readonly featuresPrice: Maybe<Scalars['JSON']>;
  readonly frequency: Maybe<PlanFrequencyType>;
  readonly gateway: Maybe<PlanGatewayType>;
  readonly gatewayPlanId: Maybe<Scalars['Int']>;
  readonly hasBundle: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly installments: Maybe<Scalars['Int']>;
  readonly isAnnualPlan: Maybe<Scalars['Boolean']>;
  readonly isInitialIapPlan: Maybe<Scalars['Boolean']>;
  readonly limit: Maybe<Scalars['Int']>;
  readonly name: Maybe<Scalars['String']>;
  readonly notificationInfo: Maybe<NotificationInfo>;
  readonly offerInfo: Maybe<OfferInfo>;
  readonly oneClickToUpgradePlan: Maybe<Plan>;
  readonly origin: Maybe<PlanOriginType>;
  readonly paymentInfo: Maybe<PaymentInfo>;
  readonly planGroupId: Maybe<Scalars['Int']>;
  readonly planId: Maybe<Scalars['Int']>;
  readonly planToUpgrade: Maybe<Plan>;
  readonly presentationAppliedDiscount: Maybe<Scalars['String']>;
  readonly presentationDataBonusPerceivedDiscountText: Maybe<Scalars['String']>;
  readonly presentationDataIsHiddenOnSettings: Maybe<Scalars['Boolean']>;
  readonly presentationDataSupportLink: Maybe<Scalars['String']>;
  readonly presentationName: Maybe<Scalars['String']>;
  readonly presentationPrice: Maybe<Scalars['String']>;
  readonly price: Maybe<Scalars['Float']>;
  readonly pricingPlans: Maybe<ReadonlyArray<Maybe<PricingPlan>>>;
  readonly product: Maybe<PlanProduct>;
  readonly promotional: Maybe<Scalars['Boolean']>;
  readonly promotionalPriceMonths: Maybe<Scalars['Int']>;
  readonly promotionalPriceText: Maybe<Scalars['String']>;
  readonly recommendedTemplate: Maybe<PlanTemplate>;
  readonly status: Maybe<Scalars['String']>;
  readonly submitData: Maybe<Scalars['JSON']>;
  readonly submitURL: Maybe<Scalars['String']>;
  readonly template: Maybe<PlanTemplate>;
  readonly trialDays: Maybe<Scalars['Int']>;
  readonly type: Maybe<Scalars['String']>;
  readonly version: Maybe<PlanVersionType>;
  readonly visibility: Maybe<Scalars['String']>;
};


export type PlanFeaturePriceArgs = {
  featureCode: Scalars['String'];
};


export type PlanHasBundleArgs = {
  featureCode: Scalars['String'];
};


export type PlanLimitArgs = {
  featureCode: Scalars['String'];
};


export type PlanPricingPlansArgs = {
  boxContext: InputMaybe<Scalars['JSON']>;
};


export type PlanSubmitDataArgs = {
  boxContext: InputMaybe<Scalars['JSON']>;
};


export type PlanSubmitUrlArgs = {
  boxContext: InputMaybe<Scalars['JSON']>;
};

export type PlanCoupon = {
  readonly __typename?: 'PlanCoupon';
  readonly couponId: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
  readonly discountType: Maybe<Scalars['String']>;
  readonly discountValue: Maybe<Scalars['Float']>;
  readonly freeFeatures: Maybe<Scalars['JSON']>;
  readonly minFeatures: Maybe<Scalars['JSON']>;
  readonly name: Maybe<Scalars['String']>;
  readonly valid: Maybe<Scalars['Boolean']>;
};

export type PlanFrequency = {
  readonly __typename?: 'PlanFrequency';
  readonly periodicityLabel: Maybe<Scalars['String']>;
  readonly unitLabel: Maybe<Scalars['String']>;
};

export enum PlanFrequencyType {
  Biennial = 'BIENNIAL',
  Bimonthly = 'BIMONTHLY',
  Infinitely = 'INFINITELY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Semiannual = 'SEMIANNUAL',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export enum PlanGatewayType {
  Iapi = 'IAPI',
  Patinhas = 'PATINHAS'
}

export type PlanGroup = {
  readonly __typename?: 'PlanGroup';
  readonly defaultPlanTemplateId: Maybe<Scalars['Int']>;
  readonly multiPlanPosition: Maybe<Scalars['Int']>;
  readonly name: Scalars['String'];
  readonly planGroupId: Scalars['Int'];
  readonly planTemplateDetail: Maybe<PlanTemplate>;
  readonly plans: ReadonlyArray<Maybe<PlanGroupItem>>;
  readonly slug: Scalars['String'];
};

export type PlanGroupItem = {
  readonly __typename?: 'PlanGroupItem';
  readonly associatedAt: Maybe<Scalars['String']>;
  readonly percentageOfUsersVisibleTo: Maybe<Scalars['Float']>;
  readonly planDetail: Maybe<Plan>;
  readonly planId: Maybe<Scalars['Int']>;
  readonly position: Maybe<Scalars['Int']>;
};

export enum PlanOriginType {
  AppleStore = 'APPLE_STORE',
  FreePlan = 'FREE_PLAN',
  GooglePlay = 'GOOGLE_PLAY',
  Web = 'WEB'
}

export type PlanProduct = {
  readonly __typename?: 'PlanProduct';
  readonly name: Maybe<Scalars['String']>;
  readonly productId: Maybe<Scalars['String']>;
};

export type PlanSubscription = {
  readonly __typename?: 'PlanSubscription';
  readonly bundles: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly planSubscription: Maybe<PlanSubscriptionType>;
};

export enum PlanSubscriptionType {
  AdvancedResearchPlan = 'ADVANCED_RESEARCH_PLAN',
  BasicResearchPlan = 'BASIC_RESEARCH_PLAN',
  BgCheckPlan = 'BG_CHECK_PLAN',
  JusAiPlan = 'JUS_AI_PLAN',
  LawsuitAndBgCheckPlan = 'LAWSUIT_AND_BG_CHECK_PLAN',
  LawsuitPlan = 'LAWSUIT_PLAN',
  LoggedPlan = 'LOGGED_PLAN',
  Unlogged = 'UNLOGGED'
}

export type PlanTemplate = {
  readonly __typename?: 'PlanTemplate';
  readonly allowedFrequencies: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly basePrice: Maybe<Scalars['Float']>;
  readonly bonusFeatures: Maybe<ReadonlyArray<Maybe<Scalars['JSON']>>>;
  readonly description: Maybe<Scalars['String']>;
  readonly discount: Maybe<Scalars['Float']>;
  readonly editableFeatures: Maybe<ReadonlyArray<Maybe<Scalars['JSON']>>>;
  readonly fixedFeatures: Maybe<ReadonlyArray<Maybe<Scalars['JSON']>>>;
  readonly groupName: Maybe<Scalars['String']>;
  readonly installments: Maybe<Scalars['Int']>;
  readonly name: Maybe<Scalars['String']>;
  readonly notificationInfo: Maybe<Scalars['JSON']>;
  readonly offerInfo: Maybe<Scalars['JSON']>;
  readonly presentationNameTemplate: Maybe<Scalars['String']>;
  readonly productId: Maybe<Scalars['Int']>;
  readonly slug: Maybe<Scalars['String']>;
  readonly templateId: Maybe<Scalars['Int']>;
  readonly version: Maybe<PlanTemplateVersionType>;
};

export enum PlanTemplateVersionType {
  V1 = 'V1',
  V2 = 'V2'
}

export enum PlanType {
  Bonus = 'BONUS',
  OneTimeFee = 'ONE_TIME_FEE',
  Subscription = 'SUBSCRIPTION'
}

export enum PlanVersionType {
  V1 = 'V1',
  V2 = 'V2'
}

export type PostModerationNoteInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly input?: InputMaybe<PostModerationNoteInputNew>;
};

export type PostModerationNoteInputNew = {
  readonly moderator: Scalars['String'];
  readonly note: Scalars['String'];
  readonly reportId: Scalars['String'];
};

export type PostModerationNotePayload = {
  readonly __typename?: 'PostModerationNotePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly moderationNote: Maybe<ModerationNoteContent>;
};

export type PostReportInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly input?: InputMaybe<PostReportInputNew>;
};

export type PostReportInputNew = {
  readonly artifactId?: InputMaybe<Scalars['String']>;
  readonly artifactSource: Scalars['String'];
  readonly lawsuitId: Scalars['String'];
  readonly pid: Scalars['Int'];
  readonly reportData: Scalars['JSON'];
  readonly reportType: Scalars['String'];
};

export type PostReportPayload = {
  readonly __typename?: 'PostReportPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly report: Maybe<ReportContent>;
};

export type PriceIncrease = Node & {
  readonly __typename?: 'PriceIncrease';
  readonly createdAt: Maybe<Scalars['String']>;
  readonly emailTemplateId: Maybe<Scalars['String']>;
  readonly fromPlanId: Maybe<Scalars['Int']>;
  readonly id: Scalars['ID'];
  readonly priceIncreaseId: Maybe<Scalars['String']>;
  readonly status: Maybe<PriceIncreaseStatusType>;
  readonly subscriptionRulesType: Maybe<PriceIncreaseTypeEnum>;
  readonly toPlanGroupId: Maybe<Scalars['Int']>;
  readonly toPlanId: Maybe<Scalars['Int']>;
  readonly updatedAt: Maybe<Scalars['String']>;
};

export enum PriceIncreaseStatusType {
  Canceled = 'CANCELED',
  Created = 'CREATED',
  Done = 'DONE',
  Running = 'RUNNING'
}

export enum PriceIncreaseTypeEnum {
  SubscriptionsFrom_6Months = 'SUBSCRIPTIONS_FROM_6_MONTHS'
}

export type PricingPlan = {
  readonly __typename?: 'PricingPlan';
  readonly experimentConfig: Maybe<PricingPlanExperimenteConfig>;
  readonly featuresPrice: Maybe<Scalars['JSON']>;
  readonly frequency: Maybe<Scalars['String']>;
  readonly gateway: Maybe<Scalars['String']>;
  readonly gatewayPlanId: Maybe<Scalars['Int']>;
  readonly installments: Maybe<Scalars['Int']>;
  readonly paymentInfo: Maybe<PricingPlanPaymentInfo>;
  readonly planType: Maybe<Scalars['String']>;
  readonly presentationName: Maybe<Scalars['String']>;
  readonly price: Maybe<Scalars['Float']>;
  readonly priceAttributionByProduct: Maybe<Scalars['JSON']>;
  readonly promotional: Maybe<Scalars['Boolean']>;
  readonly promotionalPriceMonths: Maybe<Scalars['Int']>;
  readonly slug: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly submitData: Maybe<Scalars['JSON']>;
  readonly trialDays: Maybe<Scalars['Int']>;
  readonly type: Maybe<Scalars['String']>;
};

export type PricingPlanExperimenteConfig = {
  readonly __typename?: 'PricingPlanExperimenteConfig';
  readonly name: Maybe<Scalars['String']>;
  readonly variant: Maybe<Scalars['String']>;
};

export type PricingPlanPaymentInfo = {
  readonly __typename?: 'PricingPlanPaymentInfo';
  readonly currency: Maybe<Scalars['String']>;
  readonly frequency: Maybe<PlanFrequency>;
  readonly price: Maybe<Scalars['String']>;
  readonly pricePerInstallments: Maybe<Scalars['String']>;
};

export type PrivacyContext = {
  readonly __typename?: 'PrivacyContext';
  readonly anonymizedData: Maybe<AnonymizedData>;
  readonly restrictions: Maybe<PrivacyRestrictions>;
};

export type PrivacyRestrictionReason = {
  readonly __typename?: 'PrivacyRestrictionReason';
  readonly category: Maybe<Scalars['String']>;
  readonly reason: Maybe<Scalars['String']>;
  readonly restrictionTypes: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
};

export type PrivacyRestrictions = {
  readonly __typename?: 'PrivacyRestrictions';
  readonly reasons: Maybe<ReadonlyArray<Maybe<PrivacyRestrictionReason>>>;
  readonly restrictionId: Maybe<Scalars['String']>;
};

export enum ProcessStatus {
  Adiado = 'ADIADO',
  Erro = 'ERRO',
  ExceededDocLimit = 'EXCEEDED_DOC_LIMIT',
  NaoEncontrado = 'NAO_ENCONTRADO',
  None = 'NONE',
  Pendente = 'PENDENTE',
  Processado = 'PROCESSADO',
  Processando = 'PROCESSANDO'
}

export type Profile = FollowableEntity & Node & {
  readonly __typename?: 'Profile';
  readonly academicCourse: Maybe<Scalars['String']>;
  readonly academicInstitution: Maybe<Scalars['String']>;
  readonly academyInfo: Maybe<AcademyUserInfo>;
  readonly academyStats: Maybe<AcademyStats>;
  readonly acronym: Maybe<Scalars['String']>;
  readonly activePatinhasSubscriptions: Maybe<ReadonlyArray<Maybe<PatinhasSubscription>>>;
  readonly addresses: Maybe<ReadonlyArray<Maybe<Address>>>;
  readonly alertProfileConfig: Maybe<AlertProfileConfig>;
  readonly alertasEnabled: Maybe<Scalars['Boolean']>;
  readonly allowContact: Maybe<Scalars['Boolean']>;
  readonly allowSearchIndex: Maybe<Scalars['Boolean']>;
  readonly allowsEcpfCertificateOnly: Maybe<Scalars['Boolean']>;
  readonly archetype: Maybe<Scalars['String']>;
  readonly archetypeUpdatedAt: Maybe<Scalars['Float']>;
  readonly availablePlans: Maybe<ReadonlyArray<Plan>>;
  readonly avatar: Maybe<Scalars['String']>;
  readonly badges: Maybe<ProfileBadgesConnection>;
  readonly bio: Maybe<Scalars['String']>;
  readonly birthDate: Maybe<Scalars['Float']>;
  readonly books: Maybe<ProfileBooksConnection>;
  readonly booksAmount: Maybe<Scalars['Int']>;
  readonly boxProfileInfo: Maybe<BoxProfileInfo>;
  readonly camadaConversations: Maybe<ProfileCamadaConversationsConnection>;
  readonly camadaUserId: Maybe<Scalars['String']>;
  readonly canBypassMonitorLawsuit: Maybe<Scalars['Boolean']>;
  readonly canUnlockCnjNumber: Maybe<Scalars['Boolean']>;
  readonly canUseBatchFeatures: ReadonlyArray<CanUseFeatureResult>;
  readonly canUseFeature: Maybe<Scalars['Boolean']>;
  readonly coverImage: Maybe<Scalars['String']>;
  readonly cpf: Maybe<Scalars['String']>;
  readonly cpfEntrySource: Maybe<Scalars['String']>;
  readonly cpfName: Maybe<Scalars['String']>;
  readonly cpfUpdatedAt: Maybe<Scalars['Int64']>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly crmFeatureFlag: Maybe<Scalars['Boolean']>;
  readonly currentAvailablePlans: AvailablePlans;
  readonly currentEnrollmentPeriod: Maybe<Scalars['String']>;
  readonly currentOrganization: Maybe<Organization>;
  readonly currentOrganizationMembership: Maybe<OrganizationMember>;
  readonly currentPlan: CurrentPlan;
  readonly currentPlanSubscription: Maybe<PlanSubscription>;
  readonly defaultCreditCard: Maybe<CreditCard>;
  readonly disabledComponents: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly documentsPublishedAmount: Maybe<Scalars['Int']>;
  readonly documentsPublishedAmountMap: Maybe<Scalars['JSON']>;
  readonly editUrl: Maybe<Scalars['String']>;
  readonly editionsAmount: Maybe<Scalars['Int']>;
  readonly editionsHistory: Maybe<ProfileEditHistoryConnection>;
  readonly effectivePlanPresentationName: Scalars['String'];
  readonly enabledToUpgradeMonthlyToAnnual: Maybe<Scalars['Boolean']>;
  readonly enrollmentStartedAt: Maybe<Scalars['Float']>;
  readonly entityId: Maybe<Scalars['NumericID']>;
  readonly entityType: Maybe<Scalars['String']>;
  readonly evaluatedLegalCaseAnswerAmount: Maybe<Scalars['Int']>;
  readonly expertises: Maybe<ProfileExpertisesConnection>;
  readonly expertisesInfo: Maybe<ReadonlyArray<Maybe<ExpertiseInfo>>>;
  readonly featureTokens: Maybe<FeatureTokens>;
  readonly feed: Maybe<ProfileFeedConnection>;
  readonly firebaseToken: Maybe<Scalars['String']>;
  readonly followedProfiles: Maybe<FollowedProfilesConnection>;
  readonly followedTopics: Maybe<FollowedTopicsConnection>;
  readonly followers: Maybe<EntityFollowersConnection>;
  readonly followersAmount: Maybe<Scalars['Int']>;
  readonly followingAmount: Maybe<Scalars['Int']>;
  readonly followingTopicsAmount: Maybe<Scalars['Int']>;
  readonly fullname: Maybe<Scalars['String']>;
  readonly generateKeycloakAuthLink: Maybe<Scalars['String']>;
  readonly generateKeycloakLogoutUrl: Maybe<Scalars['String']>;
  readonly graduationYear: Maybe<Scalars['Int']>;
  readonly growthbookExperiments: ReadonlyArray<GrowthBookExperiment>;
  readonly hadAccessTo4Pro: Maybe<Scalars['Boolean']>;
  readonly hadBundleAccess: Maybe<Scalars['Boolean']>;
  readonly hasAcceptedBackgroundCheckTerms: Maybe<Scalars['Boolean']>;
  readonly hasAccessToSomeBundle: Maybe<Scalars['Boolean']>;
  readonly hasActiveCpfMonitoring: Maybe<Scalars['Boolean']>;
  readonly hasBigAccountContract: Maybe<Scalars['Boolean']>;
  readonly hasBigAccountContractOrInvitedBy: Maybe<Scalars['Boolean']>;
  readonly hasBilling: Maybe<Scalars['Boolean']>;
  readonly hasCaseTracking: Maybe<Scalars['Boolean']>;
  readonly hasDeclaredOccupation: Maybe<Scalars['Boolean']>;
  readonly hasDoctrine: Maybe<Scalars['Boolean']>;
  readonly hasExpertise: Maybe<Scalars['Boolean']>;
  readonly hasFeed: Maybe<Scalars['Boolean']>;
  readonly hasFirebaseToken: Maybe<Scalars['Boolean']>;
  readonly hasHighTouchBadge: Maybe<Scalars['Boolean']>;
  readonly hasJusIA: Maybe<Scalars['Boolean']>;
  readonly hasJusIAFeatures: Maybe<Scalars['Boolean']>;
  readonly hasLegalResearch: Maybe<Scalars['Boolean']>;
  readonly hasOabAccount: Maybe<Scalars['Boolean']>;
  readonly hasOnlineOffice: Maybe<Scalars['Boolean']>;
  readonly hasPaidPlan: Maybe<Scalars['Boolean']>;
  /** @deprecated This field is deprecated and kept for backward compatibility only. Use box subscription overdue instead */
  readonly hasPendingPayment: Maybe<Scalars['Boolean']>;
  readonly hasPendingPersonalInfo: Maybe<Scalars['Boolean']>;
  readonly hasPermission: Maybe<Scalars['Boolean']>;
  readonly hasProBadge: Maybe<Scalars['Boolean']>;
  readonly hasSubscriptionInconsistency: Maybe<Scalars['Boolean']>;
  readonly hasUnlockedCaseLawInformation: Maybe<Scalars['Boolean']>;
  readonly homeLocation: Maybe<Topic>;
  readonly hubCompany: Maybe<HubOrganization>;
  readonly icpCertificateExpirationDate: Maybe<Scalars['Float']>;
  readonly icpCertificateType: Maybe<Scalars['String']>;
  readonly icpCertificateValidatedAt: Maybe<Scalars['Float']>;
  readonly id: Scalars['ID'];
  readonly idsLawServicesLocation: Maybe<ReadonlyArray<Maybe<Scalars['Float']>>>;
  readonly image: Maybe<Scalars['String']>;
  readonly impersonation: Maybe<ImpersonationState>;
  readonly intentions: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly intentionsUpdatedAt: Maybe<Scalars['Float']>;
  readonly introduction: Maybe<Scalars['String']>;
  readonly isAcademicDataVerified: Maybe<Scalars['Boolean']>;
  readonly isActive: Maybe<Scalars['Boolean']>;
  readonly isB2BSelfService: Maybe<Scalars['Boolean']>;
  readonly isBachelorInLaw: Maybe<Scalars['Boolean']>;
  readonly isBackgroundCheckUser: Maybe<Scalars['Boolean']>;
  readonly isBlockedFeature: Maybe<Scalars['Boolean']>;
  readonly isCorrespondent: Maybe<Scalars['Boolean']>;
  readonly isCpfValid: Maybe<Scalars['Boolean']>;
  readonly isEligibleToFreePublication: Maybe<Scalars['Boolean']>;
  readonly isFollowedByViewer: Maybe<Scalars['Boolean']>;
  /** @deprecated This field is deprecated and kept for backward compatibility only. Use isICPCertificateValid instead */
  readonly isICPCertificateRequiredToCreateConversation: Maybe<Scalars['Boolean']>;
  readonly isICPCertificateValid: Maybe<Scalars['Boolean']>;
  readonly isIdentityVerified: Maybe<Scalars['Boolean']>;
  readonly isInstitutional: Maybe<Scalars['Boolean']>;
  readonly isJobsAvailable: Maybe<Scalars['Boolean']>;
  readonly isJusbrasilMonitoringEnvironment: Maybe<Scalars['Boolean']>;
  readonly isLawOperator: Maybe<Scalars['Boolean']>;
  readonly isLawStudent: Maybe<Scalars['Boolean']>;
  readonly isLawyer: Maybe<Scalars['Boolean']>;
  readonly isLawyerMissingIcpCertificate: Scalars['Boolean'];
  readonly isLawyerWithValidIcpCertificate: Scalars['Boolean'];
  readonly isOabOutdated: Maybe<Scalars['Boolean']>;
  readonly isOabValid: Maybe<Scalars['Boolean']>;
  readonly isOnShortlist: Scalars['Boolean'];
  readonly isOnlineOfficeParticipant: Maybe<Scalars['Boolean']>;
  /** @deprecated Please use `hasPaidPlan` instead. */
  readonly isPro: Maybe<Scalars['Boolean']>;
  readonly isProOnlineOffice: Maybe<Scalars['Boolean']>;
  readonly isRecurrentSubscriber: Maybe<Scalars['Boolean']>;
  readonly isSubscriber: Maybe<Scalars['Boolean']>;
  readonly isTakingOver: Maybe<Scalars['Boolean']>;
  readonly isUserInMrBigCNJIntegration: Maybe<Scalars['Boolean']>;
  readonly isVerified: Maybe<Scalars['Boolean']>;
  readonly isViewer: Maybe<Scalars['Boolean']>;
  readonly jobsProfessionalReview: Maybe<JobsUserProfessionalReview>;
  readonly jobsUser: Maybe<JobsUser>;
  readonly joinedLawyerDirectory: Maybe<Scalars['Boolean']>;
  readonly journalBooks: Maybe<Scalars['JSON']>;
  readonly jusiaFirstThreadAt: Maybe<Scalars['Float']>;
  readonly lastDayFreeConversationCount: Maybe<Scalars['Int']>;
  readonly lastDocuments: Maybe<ProfileDocumentsConnection>;
  readonly lastSubscriptions: Maybe<ReadonlyArray<Maybe<BoxSubscription>>>;
  readonly lastname: Maybe<Scalars['String']>;
  readonly lawServices: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly lawyerSince: Maybe<Scalars['Float']>;
  readonly lawyerWorkType: Maybe<Scalars['String']>;
  readonly lawyersLikeThis: Maybe<LawyersLikeThisConnection>;
  readonly legalCaseAnswerAmount: Maybe<Scalars['Int']>;
  readonly legalCaseFeed: Maybe<LegalCaseFeed>;
  readonly legalCaseProfileInfo: Maybe<LegalCaseProfileInfo>;
  readonly legalCasesConversations: Maybe<ProfileLegalCasesConversationsConnection>;
  readonly legalCasesDashboard: Maybe<ProfileLegalCasesDashboardConnection>;
  readonly legalRating: Maybe<Rating>;
  readonly legalRatingByTopic: Maybe<ReadonlyArray<Maybe<TopicRating>>>;
  readonly mainPhone: Maybe<Phone>;
  readonly meta: Maybe<Scalars['JSON']>;
  readonly monitoringEnvironment: Maybe<Scalars['String']>;
  readonly monthStatement: Maybe<BoxTokenStatement>;
  readonly mrBigOrganization: Maybe<MrBigOrganization>;
  readonly name: Maybe<Scalars['String']>;
  readonly newestPhone: Maybe<Phone>;
  readonly nextPlanModal: Maybe<Scalars['JSON']>;
  readonly notificationPreference: Maybe<NotificationPreference>;
  readonly notifications: Maybe<ProfileNotifications>;
  readonly notifyLeadsByMail: Maybe<Scalars['Boolean']>;
  readonly oab: Maybe<Scalars['String']>;
  readonly oabOccurrences: Maybe<Scalars['Int']>;
  readonly oabOccurrencesYear: Maybe<Scalars['Int']>;
  readonly oabRegisteredAt: Maybe<Scalars['Float']>;
  readonly oabType: Maybe<Scalars['String']>;
  readonly oabTypeCna: Maybe<Scalars['String']>;
  readonly oabUf: Maybe<Topic>;
  readonly oabValidatedAt: Maybe<Scalars['Float']>;
  readonly occupation: Maybe<Topic>;
  readonly occupationUpdatedAt: Maybe<Scalars['Float']>;
  readonly onboarding: Maybe<Onboarding>;
  readonly participatesInBeta: Maybe<Scalars['Boolean']>;
  readonly patinhasSubscription: Maybe<PatinhasSubscription>;
  readonly paymentReceipts: Maybe<ProfilePaymentReceiptsConnection>;
  readonly pdmModalContent: PdmModalContent;
  readonly phones: Maybe<ReadonlyArray<Maybe<Phone>>>;
  readonly pid: Scalars['Int'];
  readonly plans: Maybe<ReadonlyArray<Maybe<Plan>>>;
  readonly proSince: Maybe<Scalars['Float']>;
  readonly profileLikeThis: Maybe<ProfileLikeThisConnection>;
  readonly profileType: Maybe<Scalars['String']>;
  readonly profileVisibility: Maybe<Scalars['String']>;
  readonly publishedDocViewStat: Maybe<Stat>;
  readonly readLegalCaseAnswerAmount: Maybe<Scalars['Int']>;
  readonly receiveLeadsDigest: Maybe<Scalars['Boolean']>;
  readonly receivedQuestionsAmount: Maybe<Scalars['Int']>;
  readonly recommendedDocuments: Maybe<ProfileRecommendedDocumentsConnection>;
  readonly recommendedDocumentsAmount: Maybe<Scalars['Float']>;
  readonly retentionAskLawsuitExperiment: Maybe<Scalars['JSON']>;
  readonly savedDocuments: Maybe<ProfileSavedDocumentsConnection>;
  readonly sentLegalCasesDashboard: Maybe<SentProfileLegalCasesDashboardConnection>;
  readonly showCrmInterviewModal: Maybe<Scalars['Boolean']>;
  readonly showLawyersDataRequestCheatModal: Maybe<Scalars['Boolean']>;
  readonly skipOABValidation: Maybe<Scalars['Boolean']>;
  readonly socialConnections: Maybe<SocialConnectionsConnection>;
  readonly sponsoredTopicsId: Maybe<ReadonlyArray<Maybe<Scalars['Float']>>>;
  readonly subscribeLink: Maybe<SubscribeLink>;
  readonly subscriptions: Maybe<ReadonlyArray<Maybe<BoxSubscription>>>;
  readonly temporaryOfferBanner: Maybe<TemporaryOfferBanner>;
  readonly temporaryOffers: Maybe<ReadonlyArray<Maybe<TemporaryOffer>>>;
  readonly thirdPartySearchList: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly thumborAvatar: Maybe<ThumborImage>;
  readonly thumborCoverImage: Maybe<ThumborImage>;
  readonly thumborImage: Maybe<ThumborImage>;
  readonly unreadCamadaConversation: Maybe<Scalars['Int']>;
  readonly unreadGroupedNotifications: Maybe<Scalars['Int']>;
  readonly unreadReceivedExclusiveLegalCasesAmount: Maybe<Scalars['Int']>;
  readonly unreadReceivedLegalCasesAmount: Maybe<Scalars['Int']>;
  readonly unreadSentLegalCasesAmount: Maybe<Scalars['Int']>;
  readonly url: Maybe<Scalars['String']>;
  readonly usedResources: Maybe<ProfileUsedResourcesConnection>;
  readonly usedResourcesByFeatureCode: Maybe<ReadonlyArray<Maybe<UsedResource>>>;
  readonly user: Maybe<User>;
  readonly userId: Maybe<Scalars['Int']>;
  readonly username: Maybe<Scalars['String']>;
  readonly users: Maybe<InstitutionalProfileAdminsConnection>;
  readonly validCards: ReadonlyArray<CreditCard>;
  readonly viewStat: Maybe<Stat>;
  readonly website: Maybe<Scalars['String']>;
  readonly wingmanJusiaWrappedJSONStats: Maybe<Scalars['JSON']>;
  readonly workLocations: Maybe<ProfileWorkLocationsConnection>;
  readonly workLocationsReached: Maybe<ProfileWorkLocationsReachedConnection>;
};


export type ProfileAcademyStatsArgs = {
  context: InputMaybe<Scalars['JSON']>;
  product: Scalars['String'];
};


export type ProfileBadgesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type ProfileBooksArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type ProfileCamadaConversationsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  kind: InputMaybe<Scalars['String']>;
};


export type ProfileCanUseBatchFeaturesArgs = {
  featureCodes: ReadonlyArray<Scalars['String']>;
};


export type ProfileCanUseFeatureArgs = {
  featureCode: Scalars['String'];
};


export type ProfileCrmFeatureFlagArgs = {
  flag: Scalars['String'];
};


export type ProfileDocumentsPublishedAmountArgs = {
  artifacts: ReadonlyArray<InputMaybe<Scalars['String']>>;
};


export type ProfileEditUrlArgs = {
  section: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type ProfileEditionsHistoryArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type ProfileExpertisesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type ProfileFeatureTokensArgs = {
  featureCode: Scalars['String'];
  type: InputMaybe<Scalars['String']>;
};


export type ProfileFeedArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type ProfileFirebaseTokenArgs = {
  clientApp: InputMaybe<FirebaseClientName>;
};


export type ProfileFollowedProfilesArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type ProfileFollowedTopicsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type ProfileFollowersArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type ProfileGenerateKeycloakAuthLinkArgs = {
  returnTo: InputMaybe<Scalars['String']>;
};


export type ProfileGenerateKeycloakLogoutUrlArgs = {
  redirectUri: Scalars['String'];
};


export type ProfileHadAccessTo4ProArgs = {
  monthsBack: Scalars['Int'];
};


export type ProfileHadBundleAccessArgs = {
  monthsBack: Scalars['Int'];
};


export type ProfileHasExpertiseArgs = {
  directoryUrl: Scalars['String'];
};


export type ProfileHasPermissionArgs = {
  permission: Scalars['String'];
};


export type ProfileIsBlockedFeatureArgs = {
  featureCode: Scalars['String'];
};


export type ProfileIsOnShortlistArgs = {
  key: Scalars['String'];
};


export type ProfileLastDocumentsArgs = {
  after: InputMaybe<Scalars['String']>;
  artifact: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type ProfileLastSubscriptionsArgs = {
  limit: Scalars['Int'];
};


export type ProfileLawyersLikeThisArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type ProfileLegalCaseFeedArgs = {
  limit: InputMaybe<Scalars['Int']>;
};


export type ProfileLegalCasesConversationsArgs = {
  after: InputMaybe<Scalars['String']>;
  filterByOrganization: InputMaybe<Scalars['Boolean']>;
  first: InputMaybe<Scalars['Int']>;
  legalCaseId: InputMaybe<Scalars['Int']>;
  legalCaseOutcome: InputMaybe<Scalars['String']>;
  profileId: InputMaybe<Scalars['Int']>;
  transactionStatus: InputMaybe<Scalars['String']>;
  unreadPids: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']>>>;
};


export type ProfileLegalCasesDashboardArgs = {
  after: InputMaybe<Scalars['String']>;
  answeredByMe: InputMaybe<Scalars['Boolean']>;
  archivedByMe: InputMaybe<Scalars['Boolean']>;
  endDate: InputMaybe<Scalars['Float']>;
  exclusiveToMe: InputMaybe<Scalars['Boolean']>;
  first: InputMaybe<Scalars['Int']>;
  fromExpertiseIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']>>>;
  fromLocationIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']>>>;
  fromSubjectIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']>>>;
  highInterest: InputMaybe<Scalars['Int']>;
  lowInterest: InputMaybe<Scalars['Int']>;
  myLocations: InputMaybe<Scalars['Boolean']>;
  noAnswers: InputMaybe<Scalars['Boolean']>;
  notArchivedByMe: InputMaybe<Scalars['Boolean']>;
  query: InputMaybe<Scalars['String']>;
  readByMe: InputMaybe<Scalars['Boolean']>;
  startDate: InputMaybe<Scalars['Float']>;
  tags: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  unreadByMe: InputMaybe<Scalars['Boolean']>;
};


export type ProfileMonthStatementArgs = {
  featureCode: Scalars['String'];
  month: Scalars['Int'];
  year: Scalars['Int'];
};


export type ProfileMrBigOrganizationArgs = {
  includeInvites: InputMaybe<Scalars['Boolean']>;
};


export type ProfileNextPlanModalArgs = {
  addAllFeatures: InputMaybe<Scalars['Boolean']>;
  addPricingPlans: InputMaybe<Scalars['Boolean']>;
  appId: InputMaybe<Scalars['String']>;
  boxOptions: InputMaybe<Scalars['JSON']>;
  featureCode: Scalars['String'];
  fromComponent: InputMaybe<Scalars['String']>;
  loadPlanToUpgrade: InputMaybe<Scalars['Boolean']>;
};


export type ProfileParticipatesInBetaArgs = {
  name: Scalars['String'];
};


export type ProfilePatinhasSubscriptionArgs = {
  orderCode: Scalars['String'];
};


export type ProfilePaymentReceiptsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type ProfilePdmModalContentArgs = {
  variant: PdmModalContentVariant;
};


export type ProfileProfileLikeThisArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type ProfileRecommendedDocumentsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type ProfileRetentionAskLawsuitExperimentArgs = {
  subscriberCutDate: InputMaybe<Scalars['Int64']>;
};


export type ProfileSavedDocumentsArgs = {
  after: InputMaybe<Scalars['String']>;
  artifact: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type ProfileSentLegalCasesDashboardArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type ProfileSocialConnectionsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type ProfileTemporaryOfferBannerArgs = {
  offerType: InputMaybe<TemporaryOfferType>;
};


export type ProfileUnreadReceivedExclusiveLegalCasesAmountArgs = {
  expertiseIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  locationIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type ProfileUnreadReceivedLegalCasesAmountArgs = {
  exclusiveToMe: InputMaybe<Scalars['Boolean']>;
  expertiseIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  locationIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  transactionStatus: InputMaybe<Scalars['String']>;
};


export type ProfileUsedResourcesArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type ProfileUsedResourcesByFeatureCodeArgs = {
  featureCode: Scalars['String'];
  limit: InputMaybe<Scalars['Int']>;
};


export type ProfileUsersArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type ProfileWingmanJusiaWrappedJsonStatsArgs = {
  key: Scalars['String'];
};


export type ProfileWorkLocationsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type ProfileWorkLocationsReachedArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

export type ProfileBadge = {
  readonly __typename?: 'ProfileBadge';
  readonly associatedAt: Maybe<Scalars['Float']>;
  readonly bid: Maybe<Scalars['Int']>;
};

export type ProfileBadgesConnection = {
  readonly __typename?: 'ProfileBadgesConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ProfileBadgesEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ProfileBadgesEdge = {
  readonly __typename?: 'ProfileBadgesEdge';
  readonly cursor: Scalars['String'];
  readonly edgeInfo: Maybe<ProfileBadge>;
  readonly node: Maybe<Badge>;
};

export type ProfileBooksConnection = {
  readonly __typename?: 'ProfileBooksConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ProfileBooksEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ProfileBooksEdge = {
  readonly __typename?: 'ProfileBooksEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Book>;
};

export type ProfileCamadaConversationsConnection = {
  readonly __typename?: 'ProfileCamadaConversationsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ProfileCamadaConversationsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ProfileCamadaConversationsEdge = {
  readonly __typename?: 'ProfileCamadaConversationsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CamadaConversation>;
};

export type ProfileDocumentsConnection = {
  readonly __typename?: 'ProfileDocumentsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ProfileDocumentsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ProfileDocumentsEdge = {
  readonly __typename?: 'ProfileDocumentsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Document>;
};

export type ProfileEditHistoryConnection = {
  readonly __typename?: 'ProfileEditHistoryConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ProfileEditHistoryEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ProfileEditHistoryEdge = {
  readonly __typename?: 'ProfileEditHistoryEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<EditHistory>;
};

export type ProfileExpertisesConnection = {
  readonly __typename?: 'ProfileExpertisesConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ProfileExpertisesEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ProfileExpertisesEdge = {
  readonly __typename?: 'ProfileExpertisesEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Topic>;
};

export type ProfileFeedConnection = {
  readonly __typename?: 'ProfileFeedConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ProfileFeedEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ProfileFeedEdge = {
  readonly __typename?: 'ProfileFeedEdge';
  readonly cursor: Scalars['String'];
  readonly feedSources: Maybe<FeedSource>;
  readonly node: Maybe<Document>;
};

export type ProfileGroup = Node & {
  readonly __typename?: 'ProfileGroup';
  readonly booksAmount: Maybe<Scalars['Int']>;
  readonly contributionsAmount: Maybe<Scalars['Int']>;
  readonly documentsPublishedAmount: Maybe<Scalars['Int']>;
  readonly documentsPublishedAmountMap: Maybe<Scalars['JSON']>;
  readonly editionsAmount: Maybe<Scalars['Int']>;
  readonly followersAmount: Maybe<Scalars['Int']>;
  readonly followingAmount: Maybe<Scalars['Int']>;
  readonly followingTopicsAmount: Maybe<Scalars['Int']>;
  readonly id: Scalars['ID'];
  readonly pid: Maybe<Scalars['Int']>;
};


export type ProfileGroupDocumentsPublishedAmountArgs = {
  artifacts: ReadonlyArray<InputMaybe<Scalars['String']>>;
};

export type ProfileLegalCasesConversationsConnection = {
  readonly __typename?: 'ProfileLegalCasesConversationsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ProfileLegalCasesConversationsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ProfileLegalCasesConversationsEdge = {
  readonly __typename?: 'ProfileLegalCasesConversationsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Conversation>;
};

export type ProfileLegalCasesDashboardConnection = {
  readonly __typename?: 'ProfileLegalCasesDashboardConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ProfileLegalCasesDashboardEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ProfileLegalCasesDashboardEdge = {
  readonly __typename?: 'ProfileLegalCasesDashboardEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<LegalCase>;
};

export type ProfileLikeThisConnection = {
  readonly __typename?: 'ProfileLikeThisConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ProfileLikeThisEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ProfileLikeThisEdge = {
  readonly __typename?: 'ProfileLikeThisEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Profile>;
};

export type ProfileMetadata = {
  readonly __typename?: 'ProfileMetadata';
  readonly avatar: Scalars['String'];
  readonly body: Maybe<Scalars['String']>;
  readonly cnaValidatedAt: Maybe<Scalars['Float']>;
  readonly date: Maybe<Scalars['Float']>;
  readonly docId: Scalars['String'];
  readonly followersCount: Scalars['Int'];
  readonly hasFirebaseToken: Maybe<Scalars['Boolean']>;
  readonly highlight: Maybe<Scalars['String']>;
  readonly isAdmin: Scalars['Boolean'];
  readonly isCnaValid: Maybe<Scalars['Boolean']>;
  readonly isMarketplaceEnabled: Scalars['Boolean'];
  readonly isSubscriber: Scalars['Boolean'];
  readonly lawyerSince: Maybe<Scalars['Float']>;
  readonly legalCaseProfileInfo: Maybe<LegalCaseProfileInfo>;
  readonly oab: Maybe<Scalars['String']>;
  readonly oabState: Maybe<Scalars['String']>;
  readonly occupationTitle: Maybe<Scalars['String']>;
  readonly pid: Scalars['String'];
  readonly ratingScore: Maybe<Scalars['Float']>;
  readonly ratingTotal: Maybe<Scalars['Int']>;
  readonly tags: ReadonlyArray<SearchMetadataTags>;
  readonly title: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly url: Scalars['String'];
  readonly username: Scalars['String'];
};


export type ProfileMetadataAvatarArgs = {
  height: Scalars['Int'];
  width: Scalars['Int'];
};


export type ProfileMetadataBodyArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
  preferHighlight?: InputMaybe<Scalars['Boolean']>;
};

export type ProfileNotifications = Node & {
  readonly __typename?: 'ProfileNotifications';
  readonly id: Scalars['ID'];
  readonly networkGlobalPreview: Maybe<Scalars['JSON']>;
  readonly networkGlobalUnseen: Maybe<Scalars['Int']>;
  readonly networkMessagesPreview: Maybe<Scalars['JSON']>;
  readonly networkMessagesUnseen: Maybe<Scalars['Int']>;
  readonly onlineOfficeAlertsUnseen: Maybe<Scalars['Int']>;
  readonly onlineOfficeConversationUnread: Maybe<Scalars['Int']>;
  readonly onlineOfficeExclusiveOpportunitiesUnread: Maybe<Scalars['Int']>;
  readonly onlineOfficeOpportunitiesUnread: Maybe<Scalars['Int']>;
  readonly onlineOfficeSentOpportunitiesUnread: Maybe<Scalars['Int']>;
  readonly pid: Maybe<Scalars['Int']>;
};


export type ProfileNotificationsOnlineOfficeExclusiveOpportunitiesUnreadArgs = {
  expertiseIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  locationIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type ProfileNotificationsOnlineOfficeOpportunitiesUnreadArgs = {
  exclusiveToMe: InputMaybe<Scalars['Boolean']>;
  expertiseIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  locationIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  transactionStatus: InputMaybe<Scalars['String']>;
};

export type ProfilePaymentReceiptsConnection = {
  readonly __typename?: 'ProfilePaymentReceiptsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ProfilePaymentReceiptsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ProfilePaymentReceiptsEdge = {
  readonly __typename?: 'ProfilePaymentReceiptsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<PaymentReceipts>;
};

export type ProfileRecommendedDocumentsConnection = {
  readonly __typename?: 'ProfileRecommendedDocumentsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ProfileRecommendedDocumentsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ProfileRecommendedDocumentsEdge = {
  readonly __typename?: 'ProfileRecommendedDocumentsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Document>;
};

export type ProfileSavedDocumentsConnection = {
  readonly __typename?: 'ProfileSavedDocumentsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ProfileSavedDocumentsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ProfileSavedDocumentsEdge = {
  readonly __typename?: 'ProfileSavedDocumentsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Document>;
};

export type ProfileUsedResourcesConnection = {
  readonly __typename?: 'ProfileUsedResourcesConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ProfileUsedResourcesEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ProfileUsedResourcesEdge = {
  readonly __typename?: 'ProfileUsedResourcesEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<UsedResource>;
};

export type ProfileWorkLocationsConnection = {
  readonly __typename?: 'ProfileWorkLocationsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ProfileWorkLocationsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ProfileWorkLocationsEdge = {
  readonly __typename?: 'ProfileWorkLocationsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Topic>;
};

export type ProfileWorkLocationsReachedConnection = {
  readonly __typename?: 'ProfileWorkLocationsReachedConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ProfileWorkLocationsReachedEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ProfileWorkLocationsReachedEdge = {
  readonly __typename?: 'ProfileWorkLocationsReachedEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Topic>;
};

export type ProfilesNegativeVoteConnection = {
  readonly __typename?: 'ProfilesNegativeVoteConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ProfilesNegativeVoteEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ProfilesNegativeVoteEdge = {
  readonly __typename?: 'ProfilesNegativeVoteEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Profile>;
};

export type ProfilesVoteConnection = {
  readonly __typename?: 'ProfilesVoteConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ProfilesVoteEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ProfilesVoteEdge = {
  readonly __typename?: 'ProfilesVoteEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Profile>;
};

export type PromoteHubUserAdminInput = {
  readonly actorUuid: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly companyUuid: Scalars['String'];
  readonly userUuid: Scalars['String'];
};

export type PromoteHubUserAdminPayload = {
  readonly __typename?: 'PromoteHubUserAdminPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly errorCode: Maybe<Scalars['String']>;
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
  readonly userUuid: Maybe<Scalars['String']>;
};

export enum PromotionalBannerType {
  MonthlyPromotionalStartsSoon = 'MONTHLY_PROMOTIONAL_STARTS_SOON',
  MultiplePromotionalPriceMonths = 'MULTIPLE_PROMOTIONAL_PRICE_MONTHS'
}

export type PublicationAlert = Node & {
  readonly __typename?: 'PublicationAlert';
  readonly alertId: Maybe<Scalars['String']>;
  readonly blacklisted: Maybe<Scalars['Boolean']>;
  readonly blockedSources: Maybe<ReadonlyArray<Maybe<PublicationAlertSource>>>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly createdByJusbrasil: Maybe<Scalars['Boolean']>;
  readonly excludedArtifacts: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly externalSource: Maybe<CrmEntity>;
  readonly externalSourceId: Maybe<Scalars['String']>;
  readonly externalSourceType: Maybe<Scalars['String']>;
  readonly frequencyNotifications: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly isFree: Maybe<Scalars['Boolean']>;
  readonly kind: Maybe<Scalars['String']>;
  readonly lastUpdate: Maybe<Scalars['Float']>;
  readonly lawsuitSearch: Maybe<CrmLawsuitSearch>;
  readonly metaAlertSource: Maybe<PublicationMetaAlertSource>;
  readonly metaId: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly publicationCount: Scalars['Int'];
  readonly slug: Maybe<Scalars['String']>;
  readonly sources: Maybe<ReadonlyArray<Maybe<PublicationAlertSource>>>;
  readonly status: Maybe<Scalars['String']>;
  readonly tags: Maybe<ReadonlyArray<Maybe<Tag>>>;
  readonly unread: Maybe<Scalars['Float']>;
};


export type PublicationAlertPublicationCountArgs = {
  since: Scalars['Float'];
};

export type PublicationAlertItem = Node & {
  readonly __typename?: 'PublicationAlertItem';
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly dateDocument: Maybe<Scalars['Float']>;
  readonly document: Maybe<Document>;
  readonly documentArtifact: Maybe<Scalars['String']>;
  readonly documentId: Maybe<Scalars['Int']>;
  readonly emailSent: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly lawsuit: Maybe<CrmLawsuit>;
  readonly mobileNotificationSent: Maybe<Scalars['Boolean']>;
  readonly pushNotificationSent: Maybe<Scalars['Boolean']>;
  readonly read: Maybe<Scalars['Boolean']>;
  readonly received: Maybe<Scalars['Float']>;
};

export type PublicationAlertItemsConnection = {
  readonly __typename?: 'PublicationAlertItemsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<PublicationAlertItemsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type PublicationAlertItemsEdge = {
  readonly __typename?: 'PublicationAlertItemsEdge';
  readonly alerts: Maybe<ReadonlyArray<Maybe<PublicationAlert>>>;
  readonly cursor: Scalars['String'];
  readonly node: Maybe<PublicationAlertItem>;
  readonly sources: Maybe<ReadonlyArray<Maybe<PublicationAlertSource>>>;
};

export type PublicationAlertSource = Node & {
  readonly __typename?: 'PublicationAlertSource';
  readonly alertSourceId: Maybe<Scalars['String']>;
  readonly blocked: Maybe<Scalars['Boolean']>;
  readonly filter: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly lastUpdate: Maybe<Scalars['Float']>;
  readonly mandatory: Maybe<Scalars['Boolean']>;
  readonly processingStatus: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
  readonly topic: Maybe<Topic>;
  readonly unread: Maybe<Scalars['Float']>;
};

export type PublicationAlertsConnection = {
  readonly __typename?: 'PublicationAlertsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<PublicationAlertsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type PublicationAlertsEdge = {
  readonly __typename?: 'PublicationAlertsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<PublicationAlert>;
  readonly sources: Maybe<ReadonlyArray<Maybe<PublicationAlertSource>>>;
};

export type PublicationMetaAlertSource = {
  readonly __typename?: 'PublicationMetaAlertSource';
  readonly creationDate: Maybe<Scalars['Float']>;
  readonly lawyerName: Maybe<Scalars['String']>;
  readonly lawyerOabNumber: Maybe<Scalars['String']>;
  readonly lawyerOabType: Maybe<Scalars['String']>;
  readonly lawyerOabUF: Maybe<Scalars['String']>;
  readonly metaAlertSourceId: Maybe<Scalars['String']>;
  readonly sourceType: Maybe<Scalars['String']>;
  readonly value: Maybe<Scalars['String']>;
};

export type PublicationSegmentation = {
  readonly __typename?: 'PublicationSegmentation';
  readonly ctaText: Scalars['String'];
  readonly ctaUrl: Scalars['String'];
  readonly mainTheme: Maybe<Scalars['String']>;
  readonly typeSegmentation: Scalars['String'];
};

export type PublishDraftInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId: Scalars['NumericID'];
};

export type PublishDraftPayload = {
  readonly __typename?: 'PublishDraftPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly document: Maybe<Document>;
};

export type PutOnboardingStopStepInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly isNewLawsuitForCPFOptOut?: InputMaybe<Scalars['Boolean']>;
  readonly onboardingName: Scalars['String'];
  readonly recordOptOutHistory?: InputMaybe<Scalars['Boolean']>;
  readonly stopStep: Scalars['Int'];
};

export type PutOnboardingStopStepPayload = {
  readonly __typename?: 'PutOnboardingStopStepPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly onboarding: Maybe<Onboarding>;
  readonly user: Maybe<User>;
};

export type Query = {
  readonly __typename?: 'Query';
  readonly node: Maybe<Node>;
  readonly root: RootApi;
  readonly rootB2B: RootApi;
};


export type QueryNodeArgs = {
  id: Scalars['ID'];
};


export type QueryRootArgs = {
  auth: InputMaybe<Scalars['String']>;
  organizationToken: InputMaybe<Scalars['String']>;
  sessionToken: InputMaybe<Scalars['String']>;
};


export type QueryRootB2BArgs = {
  auth: InputMaybe<Scalars['String']>;
  organizationToken: InputMaybe<Scalars['String']>;
  sessionToken: InputMaybe<Scalars['String']>;
};

export type RapporteurSearch = {
  readonly __typename?: 'RapporteurSearch';
  readonly rapporteurs: ReadonlyArray<Scalars['String']>;
};

export type Rating = {
  readonly __typename?: 'Rating';
  readonly maxScore: Maybe<Scalars['Int']>;
  readonly score: Maybe<Scalars['Float']>;
  readonly total: Maybe<Scalars['Int']>;
};

export type ReactivateOrganizationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly id: Scalars['String'];
};

export type ReactivateOrganizationPayload = {
  readonly __typename?: 'ReactivateOrganizationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly hubOrganization: Maybe<HubOrganization>;
};

export type ReactivatePublicationMonitoringInput = {
  readonly alertId: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ReactivatePublicationMonitoringPayload = {
  readonly __typename?: 'ReactivatePublicationMonitoringPayload';
  readonly alert: Maybe<PublicationAlert>;
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
};

export type ReactivateTopicInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly tid: Scalars['Int'];
};

export type ReactivateTopicPayload = {
  readonly __typename?: 'ReactivateTopicPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly topic: Maybe<Topic>;
};

export type ReadAllMessagesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ReadAllMessagesPayload = {
  readonly __typename?: 'ReadAllMessagesPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type Recommendation = {
  readonly __typename?: 'Recommendation';
  readonly artifact: Maybe<Scalars['String']>;
  readonly artifactBooster: Maybe<Scalars['String']>;
  readonly docId: Maybe<Scalars['String']>;
  readonly document: Maybe<Document>;
  readonly explanation: Maybe<Scalars['String']>;
  readonly score: Maybe<Scalars['Float']>;
  readonly scoreDetails: Maybe<ReadonlyArray<Maybe<ScoreDetails>>>;
};

export type Redirect = {
  readonly __typename?: 'Redirect';
  readonly artifact: Scalars['String'];
  readonly date: Maybe<Scalars['Float']>;
  readonly destinyId: Scalars['Int'];
  readonly originId: Scalars['Int'];
};

export type Reference = {
  readonly __typename?: 'Reference';
  readonly documents: Maybe<ReadonlyArray<Maybe<Document>>>;
  readonly topics: Maybe<ReadonlyArray<Maybe<Topic>>>;
};

export type RefreshCproOrganizationCredentialInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly environmentType: Scalars['String'];
  readonly organizationId: Scalars['String'];
};

export type RefreshCproOrganizationCredentialPayload = {
  readonly __typename?: 'RefreshCPROOrganizationCredentialPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly credential: Scalars['String'];
};

export type RefreshCrmLawsuitInput = {
  readonly boxOptions?: InputMaybe<Scalars['JSON']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
};

export type RefreshCrmLawsuitPayload = {
  readonly __typename?: 'RefreshCRMLawsuitPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
};

export type RefreshNetworkLawsuitInput = {
  readonly appKind?: InputMaybe<FcmTokenAppKindType>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly deviceId?: InputMaybe<Scalars['String']>;
  readonly entityId?: InputMaybe<Scalars['String']>;
  readonly getAttachments?: InputMaybe<Scalars['Boolean']>;
  readonly lawsuitId: Scalars['String'];
  readonly origin?: InputMaybe<Scalars['String']>;
  readonly platform?: InputMaybe<FcmTokenPlatformType>;
  readonly searchErrorThresholdInMinutes?: InputMaybe<Scalars['Int']>;
  readonly token?: InputMaybe<Scalars['String']>;
  readonly version?: InputMaybe<Scalars['String']>;
};

export type RefreshNetworkLawsuitPayload = {
  readonly __typename?: 'RefreshNetworkLawsuitPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly itHasRefreshed: Maybe<Scalars['Boolean']>;
};

export type RefreshViewerInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type RefreshViewerPayload = {
  readonly __typename?: 'RefreshViewerPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly viewer: Maybe<Profile>;
};

export type RegisterCrmTimelineItemActionInput = {
  readonly action: Scalars['JSON'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly itemId: Scalars['String'];
};

export type RegisterCrmTimelineItemActionPayload = {
  readonly __typename?: 'RegisterCRMTimelineItemActionPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly item: Maybe<CrmTimelineItem>;
  readonly organization: Maybe<Organization>;
};

export type RegisterDeviceTokenInput = {
  readonly appKind: FcmTokenAppKindType;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly platform: FcmTokenPlatformType;
  readonly token: Scalars['String'];
  readonly version?: InputMaybe<Scalars['String']>;
};

export type RegisterDeviceTokenPayload = {
  readonly __typename?: 'RegisterDeviceTokenPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly isRegistered: Maybe<Scalars['Boolean']>;
};

export type RejectFeatureTaskInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly rejectionReason: Scalars['String'];
};

export type RejectFeatureTaskPayload = {
  readonly __typename?: 'RejectFeatureTaskPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly featureTask: FeatureTask;
};

export type RelatedCrmLawsuitPartyEntitiesConnection = {
  readonly __typename?: 'RelatedCRMLawsuitPartyEntitiesConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<RelatedCrmLawsuitPartyEntitiesEdge>>>;
  readonly pageInfo: PageInfo;
};

export type RelatedCrmLawsuitPartyEntitiesEdge = {
  readonly __typename?: 'RelatedCRMLawsuitPartyEntitiesEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmLawsuitPartyEntity>;
};

export type RelatedCompaniesConnection = {
  readonly __typename?: 'RelatedCompaniesConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<RelatedCompaniesEdge>>>;
  readonly pageInfo: PageInfo;
};

export type RelatedCompaniesEdge = {
  readonly __typename?: 'RelatedCompaniesEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<EntityCompany>;
};

export type RelatedDocumentAtoNormativo = {
  readonly __typename?: 'RelatedDocumentAtoNormativo';
  readonly artifact: Scalars['String'];
  readonly docId: Scalars['NumericID'];
  readonly perfilUsername: Scalars['String'];
  readonly title: Scalars['String'];
  readonly url: Scalars['String'];
};

export type RelatedLawsuit = {
  readonly __typename?: 'RelatedLawsuit';
  readonly lawsuit: Maybe<CrmLawsuit>;
  readonly number: Maybe<Scalars['String']>;
};

export enum RelatedLawsuitPersonType {
  Author = 'AUTHOR',
  Defendant = 'DEFENDANT',
  Other = 'OTHER'
}

export type RelatedLegisItem = {
  readonly __typename?: 'RelatedLegisItem';
  readonly id: Maybe<Scalars['Int']>;
  readonly prepositionForReference: Maybe<Scalars['String']>;
  readonly relatedLegisTitle: Maybe<Scalars['String']>;
  readonly subject: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
};

export type RelatedSearch = {
  readonly __typename?: 'RelatedSearch';
  readonly alternative: Maybe<Scalars['String']>;
  readonly suggestions: Maybe<ReadonlyArray<SuggestionItem>>;
};

export type RelatedTopicsConnection = {
  readonly __typename?: 'RelatedTopicsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<RelatedTopicsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type RelatedTopicsEdge = {
  readonly __typename?: 'RelatedTopicsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Topic>;
};

export type RelevantEventAttachment = {
  readonly __typename?: 'RelevantEventAttachment';
  readonly attachment: Maybe<CrmLawsuitAttachment>;
  readonly completeClassification: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly eventId: Maybe<Scalars['String']>;
  readonly eventType: Maybe<Scalars['String']>;
  readonly sourceDate: Maybe<Scalars['Float']>;
};

export type ReloadSubscriptionsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ReloadSubscriptionsPayload = {
  readonly __typename?: 'ReloadSubscriptionsPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
};

export enum RemovalReason {
  NomeMenor = 'NOME_MENOR',
  NomeTestemunha = 'NOME_TESTEMUNHA',
  NomeVitima = 'NOME_VITIMA',
  Outro = 'OUTRO',
  SegredoJustica = 'SEGREDO_JUSTICA',
  Trabalhista = 'TRABALHISTA'
}

export type RemovalRequest = {
  readonly __typename?: 'RemovalRequest';
  readonly answer: Maybe<Answer>;
  readonly answerEmailSent: Maybe<Scalars['Boolean']>;
  readonly attachment: Maybe<Scalars['String']>;
  readonly attachmentsUrl: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly deniedReason: Maybe<DeniedReason>;
  readonly entityId: Maybe<Scalars['String']>;
  readonly entityType: Maybe<EntityType>;
  readonly fingerHash: Maybe<Scalars['Float']>;
  readonly fingerSize: Maybe<Scalars['Int']>;
  readonly forceCompleteRemoval: Maybe<Scalars['Boolean']>;
  readonly indexed: Maybe<Scalars['String']>;
  readonly informationVisibility: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly ipAddress: Maybe<Scalars['String']>;
  readonly moderatedAt: Maybe<Scalars['Float']>;
  readonly moderatorPid: Maybe<Scalars['Float']>;
  readonly parentRequestId: Maybe<Scalars['Float']>;
  readonly pid: Maybe<Scalars['Float']>;
  readonly priority: Maybe<Scalars['Int']>;
  readonly removalName: Maybe<Scalars['String']>;
  readonly removalReason: Maybe<RemovalReason>;
  readonly removeOptions: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly requestId: Maybe<Scalars['Float']>;
  readonly requesterEmail: Maybe<Scalars['String']>;
  readonly requesterName: Maybe<Scalars['String']>;
  readonly requesterPhone: Maybe<Scalars['String']>;
  readonly status: Maybe<ProcessStatus>;
  readonly uid: Maybe<Scalars['Float']>;
  readonly url: Maybe<Scalars['String']>;
};

export type RemoveAdminRoleInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly profileId: Scalars['Int'];
};

export type RemoveAdminRolePayload = {
  readonly __typename?: 'RemoveAdminRolePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type RemoveBlockedNotificationTypeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly tipoNotificacaoBloqueada: Scalars['String'];
};

export type RemoveBlockedNotificationTypePayload = {
  readonly __typename?: 'RemoveBlockedNotificationTypePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly message: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type RemoveCrmCommentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly commentId: Scalars['String'];
};

export type RemoveCrmCommentPayload = {
  readonly __typename?: 'RemoveCRMCommentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly comment: Maybe<CrmComment>;
  readonly commentEdge: Maybe<CrmEntityCommentsEdge>;
  readonly commentableEntity: Maybe<CrmCommentable>;
};

export type RemoveCollectionDocumentsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly collectionId: Scalars['String'];
  readonly documents: ReadonlyArray<InputMaybe<Scalars['JSON']>>;
};

export type RemoveCollectionDocumentsPayload = {
  readonly __typename?: 'RemoveCollectionDocumentsPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly collectionId: Maybe<Scalars['String']>;
  readonly documents: Maybe<ReadonlyArray<Maybe<UserCollectionDocument>>>;
};

export type RemoveDeviceTokenInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly token: Scalars['String'];
};

export type RemoveDeviceTokenPayload = {
  readonly __typename?: 'RemoveDeviceTokenPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly isRemoved: Maybe<Scalars['Boolean']>;
};

export type RemoveExpertiseAreaInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly expertiseId: Scalars['Float'];
};

export type RemoveExpertiseAreaPayload = {
  readonly __typename?: 'RemoveExpertiseAreaPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type RemoveHubFeatureInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly featureCode: Scalars['String'];
  readonly profileId: Scalars['Int'];
};

export type RemoveHubFeaturePayload = {
  readonly __typename?: 'RemoveHubFeaturePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type RemoveNameFromLawsuitInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
  readonly lawsuitPartyType?: InputMaybe<Scalars['String']>;
  readonly lawsuitTopicId: Scalars['Int'];
  readonly nameTopicId: Scalars['Int'];
  readonly partyName?: InputMaybe<Scalars['String']>;
  readonly reportId: Scalars['String'];
  readonly url?: InputMaybe<Scalars['String']>;
};

export type RemoveNameFromLawsuitPayload = {
  readonly __typename?: 'RemoveNameFromLawsuitPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly removalRequestId: Maybe<Scalars['Int']>;
};

export type RemoveOnboardingReminderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly reminders?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type RemoveOnboardingReminderPayload = {
  readonly __typename?: 'RemoveOnboardingReminderPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly user: Maybe<User>;
};

export type RemoveOptOutForAllNotificationTypesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly notificationChannel?: InputMaybe<NotificationChannelEnum>;
};

export type RemoveOptOutForAllNotificationTypesPayload = {
  readonly __typename?: 'RemoveOptOutForAllNotificationTypesPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly message: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type RemoveOrganizationMemberInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly memberId: Scalars['Int'];
  readonly organizationId: Scalars['Int'];
};

export type RemoveOrganizationMemberPayload = {
  readonly __typename?: 'RemoveOrganizationMemberPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly member: Maybe<OrganizationMember>;
  readonly organization: Maybe<Organization>;
};

export type RemoveShareEntityInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly shareId: Scalars['String'];
};

export type RemoveShareEntityPayload = {
  readonly __typename?: 'RemoveShareEntityPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly entity: Maybe<CrmEntity>;
  readonly organization: Maybe<Organization>;
  readonly share: Maybe<CrmEntityShare>;
};

export type RemoveTopicDocumentInput = {
  readonly artifact: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId: Scalars['NumericID'];
  readonly tid: Scalars['Int'];
};

export type RemoveTopicDocumentPayload = {
  readonly __typename?: 'RemoveTopicDocumentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly document: Maybe<Document>;
  readonly topic: Maybe<Topic>;
};

export type RemoveTopicImageInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly tid: Scalars['Int'];
};

export type RemoveTopicImagePayload = {
  readonly __typename?: 'RemoveTopicImagePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly topic: Maybe<Topic>;
};

export type RemoveUserCollectionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly collectionId: Scalars['String'];
};

export type RemoveUserCollectionPayload = {
  readonly __typename?: 'RemoveUserCollectionPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly collectionId: Maybe<Scalars['String']>;
};

export type ReplaceSessionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly selectedJdid: Scalars['String'];
  readonly timedEmailCode: Scalars['String'];
};

export type ReplaceSessionPayload = {
  readonly __typename?: 'ReplaceSessionPayload';
  readonly checked: Scalars['Boolean'];
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly message: Maybe<Scalars['String']>;
  readonly replaced: Scalars['Boolean'];
  readonly success: Scalars['Boolean'];
};

export type ReportAbuseInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly comment?: InputMaybe<Scalars['String']>;
  readonly profileId: Scalars['Int'];
  readonly report?: InputMaybe<Scalars['String']>;
};

export type ReportAbusePayload = {
  readonly __typename?: 'ReportAbusePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type ReportContent = {
  readonly __typename?: 'ReportContent';
  readonly artifactId: Maybe<Scalars['String']>;
  readonly artifactSource: Scalars['String'];
  readonly cnj: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['String'];
  readonly emailResponseSentAt: Scalars['String'];
  readonly exposedContents: Maybe<ReadonlyArray<Maybe<ExposedContent>>>;
  readonly history: Maybe<ReportHistory>;
  readonly lawsuit: Maybe<CrmLawsuit>;
  readonly lawsuitId: Maybe<Scalars['String']>;
  readonly moderationLogContents: Maybe<ReadonlyArray<Maybe<ModerationLogContent>>>;
  readonly pid: Scalars['String'];
  readonly profile: Maybe<Profile>;
  readonly reanalysisCount: Maybe<Scalars['Int']>;
  readonly reportData: Maybe<Scalars['JSON']>;
  readonly reportId: Scalars['String'];
  readonly reportType: Scalars['String'];
  readonly status: Scalars['String'];
  readonly updatedAt: Scalars['String'];
};

export type ReportContentFromUserPaginationConnection = {
  readonly __typename?: 'ReportContentFromUserPaginationConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ReportContentFromUserPaginationEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ReportContentFromUserPaginationEdge = {
  readonly __typename?: 'ReportContentFromUserPaginationEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<ReportContent>;
};

export type ReportContentPaginationConnection = {
  readonly __typename?: 'ReportContentPaginationConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<ReportContentPaginationEdge>>>;
  readonly pageInfo: PageInfo;
};

export type ReportContentPaginationEdge = {
  readonly __typename?: 'ReportContentPaginationEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<ReportContent>;
};

export type ReportContentSearch = {
  readonly __typename?: 'ReportContentSearch';
  readonly reports: Maybe<ReportContentPaginationConnection>;
};


export type ReportContentSearchReportsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};

export type ReportContentSearchFromUser = {
  readonly __typename?: 'ReportContentSearchFromUser';
  readonly reports: Maybe<ReportContentFromUserPaginationConnection>;
};


export type ReportContentSearchFromUserReportsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};

export enum ReportContentStatusType {
  Aberto = 'ABERTO',
  AnaliseConteudoExposto = 'ANALISE_CONTEUDO_EXPOSTO',
  Aprovado = 'APROVADO',
  EmAnalise = 'EM_ANALISE',
  EmColeta = 'EM_COLETA',
  FilaAtendimento = 'FILA_ATENDIMENTO',
  FilaAutomacao = 'FILA_AUTOMACAO',
  Reanalise = 'REANALISE',
  Reprovado = 'REPROVADO'
}

export type ReportDocumentInput = {
  readonly artifact: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId: Scalars['NumericID'];
  readonly reason: Scalars['String'];
  readonly type: Scalars['String'];
};

export type ReportDocumentPayload = {
  readonly __typename?: 'ReportDocumentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly document: Maybe<Document>;
};

export type ReportEntityCompanyInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly entityId: Scalars['String'];
  readonly sendPipaReport: Scalars['Boolean'];
};

export type ReportEntityCompanyPayload = {
  readonly __typename?: 'ReportEntityCompanyPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly report: Maybe<ReportContent>;
};

export type ReportHistory = {
  readonly __typename?: 'ReportHistory';
  readonly entries: Maybe<ReadonlyArray<Maybe<ReportHistoryEntry>>>;
  readonly reportId: Scalars['String'];
};

export type ReportHistoryEntry = {
  readonly __typename?: 'ReportHistoryEntry';
  readonly createdAt: Scalars['String'];
  readonly status: Scalars['String'];
};

export enum ReportType {
  ContentError = 'CONTENT_ERROR',
  ContentRestriction = 'CONTENT_RESTRICTION',
  PartyError = 'PARTY_ERROR',
  PersonalInformationExposed = 'PERSONAL_INFORMATION_EXPOSED'
}

export type RequestAttachmentLogsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
};

export type RequestAttachmentLogsPayload = {
  readonly __typename?: 'RequestAttachmentLogsPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly ticketId: Scalars['String'];
};

export type RequestCpfRemovalInput = {
  readonly backTo: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cpf: Scalars['String'];
  readonly oldPid: Scalars['Int'];
  readonly role?: InputMaybe<Scalars['String']>;
  readonly template?: InputMaybe<Scalars['String']>;
};

export type RequestCpfRemovalPayload = {
  readonly __typename?: 'RequestCPFRemovalPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type RequestEmailChangeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly newEmail: Scalars['String'];
};

export type RequestEmailChangePayload = {
  readonly __typename?: 'RequestEmailChangePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly newEmail: Scalars['String'];
};

export type RequirementsType = {
  readonly featureCode?: InputMaybe<Scalars['String']>;
  readonly requiredAmount?: InputMaybe<Scalars['Int']>;
};

export type ResendHubInviteInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly username: Scalars['String'];
  readonly uuid: Scalars['String'];
};

export type ResendHubInvitePayload = {
  readonly __typename?: 'ResendHubInvitePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly errorCode: Maybe<Scalars['String']>;
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type ResetCpfValidationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly pid?: InputMaybe<Scalars['Int']>;
};

export type ResetCpfValidationPayload = {
  readonly __typename?: 'ResetCPFValidationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type ResetLawsuitLockedItemsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
};

export type ResetLawsuitLockedItemsPayload = {
  readonly __typename?: 'ResetLawsuitLockedItemsPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
};

export type ResetOabValidationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly pid?: InputMaybe<Scalars['Int']>;
};

export type ResetOabValidationPayload = {
  readonly __typename?: 'ResetOABValidationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type ResetScoreTimeDocumentInput = {
  readonly artifact: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId: Scalars['NumericID'];
};

export type ResetScoreTimeDocumentPayload = {
  readonly __typename?: 'ResetScoreTimeDocumentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly document: Maybe<Document>;
};

export type ResolveSubscriptionInconsistencyInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly resolvedBy: Scalars['String'];
};

export type ResolveSubscriptionInconsistencyPayload = {
  readonly __typename?: 'ResolveSubscriptionInconsistencyPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly inconsistency: Maybe<SubscriptionInconsistency>;
};

export type ResourceAccess = {
  readonly __typename?: 'ResourceAccess';
  readonly activities: ReadonlyArray<ResourceAccessLevel>;
  readonly attachments: ReadonlyArray<ResourceAccessLevel>;
  readonly monitoring: ReadonlyArray<ResourceAccessLevel>;
  readonly parties: ReadonlyArray<ResourceAccessLevel>;
  readonly title: ReadonlyArray<ResourceAccessLevel>;
};

export enum ResourceAccessLevel {
  Default = 'DEFAULT'
}

export type ResourceAccessRule = {
  readonly __typename?: 'ResourceAccessRule';
  readonly activities: ReadonlyArray<ResourceAccessLevel>;
  readonly attachments: ReadonlyArray<ResourceAccessLevel>;
  readonly isICPValidatedLawyer: Scalars['Boolean'];
  readonly isVerifiedLawsuitParty: Scalars['Boolean'];
  readonly justiceSecret: Maybe<Scalars['Boolean']>;
  readonly monitoring: ReadonlyArray<ResourceAccessLevel>;
  readonly parties: ReadonlyArray<ResourceAccessLevel>;
  readonly sensitive: Maybe<Scalars['Boolean']>;
  readonly sensitiveOrJS: Maybe<Scalars['Boolean']>;
  readonly title: ReadonlyArray<ResourceAccessLevel>;
};

export type RestartSoftBlockSessionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type RestartSoftBlockSessionPayload = {
  readonly __typename?: 'RestartSoftBlockSessionPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
};

export type RestrictionDetail = {
  readonly __typename?: 'RestrictionDetail';
  readonly createdAt: Maybe<Scalars['String']>;
  readonly restrictionId: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['String']>;
};

export enum RestrictionIdentifierType {
  Cnj = 'CNJ',
  IdDocumento = 'ID_DOCUMENTO',
  IdProcesso = 'ID_PROCESSO'
}

export type RestrictionLevel = {
  readonly __typename?: 'RestrictionLevel';
  readonly description: Scalars['String'];
  readonly identifier: Scalars['String'];
  readonly level: Scalars['Int'];
  readonly levelName: RestrictionLevelName;
};

export enum RestrictionLevelName {
  Aberto = 'ABERTO',
  AdvogadoValidado = 'ADVOGADO_VALIDADO',
  ParteValidada = 'PARTE_VALIDADA',
  SegredoJustica = 'SEGREDO_JUSTICA',
  Sensivel = 'SENSIVEL'
}

export type RestrictionReasonDetail = {
  readonly __typename?: 'RestrictionReasonDetail';
  readonly createdAt: Maybe<Scalars['String']>;
  readonly kind: Maybe<Scalars['String']>;
  readonly lastDetectedAt: Maybe<Scalars['String']>;
  readonly origin: Maybe<Scalars['String']>;
  readonly reason: Maybe<Scalars['String']>;
  readonly restrictionId: Maybe<Scalars['String']>;
  readonly restrictionTypes: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly updatedAt: Maybe<Scalars['String']>;
};

export type RestrictionSignalDetail = {
  readonly __typename?: 'RestrictionSignalDetail';
  readonly artifactId: Maybe<Scalars['String']>;
  readonly artifactType: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly firstDetectedAt: Maybe<Scalars['String']>;
  readonly ingressId: Maybe<Scalars['String']>;
  readonly ingressType: Maybe<Scalars['String']>;
  readonly kind: Maybe<Scalars['String']>;
  readonly lastDetectedAt: Maybe<Scalars['String']>;
  readonly method: Maybe<Scalars['String']>;
  readonly origin: Maybe<Scalars['String']>;
  readonly patchTargetSignalId: Maybe<Scalars['String']>;
  readonly patchedBySignalId: Maybe<Scalars['String']>;
  readonly reasons: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly restrictionType: Maybe<Scalars['String']>;
  readonly rootId: Scalars['String'];
  readonly rootType: Scalars['String'];
  readonly signalId: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['String']>;
};

export type RestrictionSignalResult = {
  readonly __typename?: 'RestrictionSignalResult';
  readonly restriction: Maybe<RestrictionDetail>;
  readonly restrictionId: Maybe<Scalars['String']>;
  readonly restrictionReasons: Maybe<ReadonlyArray<RestrictionReasonDetail>>;
  readonly signals: Maybe<ReadonlyArray<RestrictionSignalDetail>>;
};

export type Result = {
  readonly __typename?: 'Result';
  readonly data: ReadonlyArray<Maybe<ResultData>>;
  readonly metadata: ResultMetadata;
  readonly status: Scalars['String'];
};

export type ResultData = {
  readonly __typename?: 'ResultData';
  readonly fieldsRaw: Maybe<Scalars['JSON']>;
  readonly title: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly url: Maybe<Scalars['String']>;
};

export type ResultMetadata = {
  readonly __typename?: 'ResultMetadata';
  readonly hasCorrection: Maybe<Scalars['Boolean']>;
  readonly hits: Scalars['Int'];
  readonly query: Maybe<Scalars['String']>;
  readonly queryCorrection: Maybe<Scalars['String']>;
};

export type ResultRules = {
  readonly __typename?: 'ResultRules';
  readonly redirectUrl: Maybe<Scalars['String']>;
  readonly shouldRedirect: Scalars['Boolean'];
};

export type RetentionPlan = {
  readonly __typename?: 'RetentionPlan';
  readonly averagePricePerMonthText: Maybe<Scalars['String']>;
  readonly frequency: Maybe<Scalars['String']>;
  readonly fullPrice: Maybe<Scalars['Float']>;
  readonly fullPriceText: Maybe<Scalars['String']>;
  readonly percentageDiscountInfo: Maybe<Scalars['Float']>;
  readonly percentageDiscountText: Maybe<Scalars['String']>;
  readonly planId: Maybe<Scalars['Int']>;
  readonly presentationName: Maybe<Scalars['String']>;
  readonly price: Maybe<Scalars['Float']>;
  readonly priceText: Maybe<Scalars['String']>;
  readonly promotionalPriceMonths: Maybe<Scalars['Int']>;
  readonly submitData: Maybe<SubmitData>;
  readonly totalFullPriceText: Maybe<Scalars['String']>;
};

export type RetryLawsuitAssistantMessageInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly messageId: Scalars['String'];
};

export type RetryLawsuitAssistantMessagePayload = {
  readonly __typename?: 'RetryLawsuitAssistantMessagePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuitAssistantMessage: Maybe<LawsuitAssistantMessage>;
};

export type RetryLawsuitQaEvaluatorItemInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly evaluationId: Scalars['String'];
  readonly lawsuitId: Scalars['String'];
};

export type RetryLawsuitQaEvaluatorItemPayload = {
  readonly __typename?: 'RetryLawsuitQaEvaluatorItemPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuitQaEvaluatorItem: Maybe<LawsuitQaEvaluatorItem>;
};

export type RevertEditionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly comment?: InputMaybe<Scalars['String']>;
  readonly historyId: Scalars['String'];
};

export type RevertEditionPayload = {
  readonly __typename?: 'RevertEditionPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly historyReverser: Maybe<EditHistory>;
  readonly profileEditHistoryEdge: Maybe<ProfileEditHistoryEdge>;
  readonly revertedHistory: Maybe<EditHistory>;
};

export type Review = {
  readonly __typename?: 'Review';
  readonly comment: Maybe<Scalars['String']>;
  readonly date: Maybe<Scalars['Float']>;
  readonly profile: Maybe<Profile>;
};

export type RootApi = {
  readonly __typename?: 'RootApi';
  readonly CRMBnmp: Maybe<ReadonlyArray<Maybe<CrmBnmp>>>;
  readonly PlanByIdOrSlug: Maybe<Plan>;
  readonly PlanBySlug: Maybe<Plan>;
  readonly academy: Maybe<Academy>;
  readonly adminStudentBenefits: StudentBenefitList;
  readonly aiOverview: Maybe<AiOverview>;
  readonly aiRelatedQuestions: Maybe<AiRelatedQuestions>;
  readonly allPlanTemplates: Maybe<ReadonlyArray<Maybe<PlanTemplate>>>;
  readonly assistantAskLawsuitUsage: Maybe<AssistantAskLawsuitUsage>;
  readonly audienceSegment: ReadonlyArray<AudienceSegment>;
  readonly audienceSegmentAvailableFields: ReadonlyArray<UserFeature>;
  readonly audienceSegmentById: Maybe<AudienceSegment>;
  readonly authIdoxIntegration: Maybe<IdoxIntegration>;
  readonly badge: Maybe<Badge>;
  readonly badges: Maybe<ReadonlyArray<Maybe<Badge>>>;
  readonly boxCompanyClaims: BoxCompanyClaims;
  readonly boxLockViewer: Maybe<BoxLock>;
  readonly boxLockViewerVariationTypes: ReadonlyArray<VariationTypes>;
  readonly boxUserClaims: BoxUserClaims;
  readonly broadcast: Maybe<Broadcast>;
  readonly camadaConversation: Maybe<CamadaConversation>;
  readonly checkInviteByEmail: Maybe<CheckInviteByEmailResult>;
  readonly checkoutData: Maybe<CheckoutDataResult>;
  readonly citySearch: Maybe<ReadonlyArray<Maybe<CitySearch>>>;
  readonly civilLawsuitsByProvider: Maybe<LawsuitsDigestoByDocument>;
  readonly classifyQuery: ReadonlyArray<Classification>;
  readonly cnjNumber: Maybe<CnjNumber>;
  readonly collection: Maybe<UserCollectionDetail>;
  readonly contact: Maybe<Contact>;
  readonly conversation: Maybe<Conversation>;
  readonly conversationByCamadaId: Maybe<Conversation>;
  readonly cproBnmp: Maybe<CproBnmp>;
  readonly cproDocumentSummary: Maybe<CproDocumentSummary>;
  readonly cproInternalLawsuitsByDocument: Maybe<CproInternalLawsuitsByDocument>;
  readonly cproLawsuit: Maybe<CproLawsuit>;
  readonly cproLawsuitAttachment: Maybe<CproLawsuitAttachment>;
  readonly cproLawsuitByNumber: Maybe<CproLawsuit>;
  readonly cproLawsuitsByNameWithoutConfidence: Maybe<CproLawsuitsByNameWithoutConfidenceConnection>;
  readonly cproLawsuitsByPersonId: Maybe<CproLawsuitsByPersonIdConnection>;
  readonly cproMp: Maybe<CproMp>;
  readonly crmActivityLog: Maybe<CrmActivityLog>;
  readonly crmBulkAction: Maybe<CrmBulkAction>;
  readonly crmCourtCredential: Maybe<CrmCourtCredential>;
  readonly crmDataExport: Maybe<CrmDataExport>;
  readonly crmDocument: Maybe<CrmDocument>;
  readonly crmEmpregadorIrregular: Maybe<ReadonlyArray<Maybe<CrmEmpregadorIrregular>>>;
  readonly crmLawsuit: Maybe<CrmLawsuit>;
  readonly crmLawsuitAttachment: Maybe<CrmLawsuitAttachment>;
  readonly crmLawsuitAttachments: ReadonlyArray<Maybe<CrmLawsuitAttachment>>;
  readonly crmLawsuitByNumber: Maybe<CrmLawsuit>;
  readonly crmLawsuitByNumbers: ReadonlyArray<Maybe<CrmLawsuit>>;
  readonly crmLawsuitPartyEntity: Maybe<CrmLawsuitPartyEntity>;
  readonly crmLawsuitPartyEntityHistory: Maybe<ReadonlyArray<CrmLawsuitPartyEntity>>;
  readonly crmLawsuitSearch: Maybe<CrmLawsuitSearch>;
  readonly crmLawsuitSearchUserInteraction: Maybe<CrmLawsuitSearchUserInteraction>;
  readonly crmLawsuitSearchUserQueriesList: Maybe<ReadonlyArray<Maybe<CrmLawsuitSearchUserInteraction>>>;
  readonly crmLawsuitsByIds: ReadonlyArray<CrmLawsuit>;
  readonly crmLawsuitsByNameWithoutConfidence: Maybe<CrmLawsuitsByNameWithoutConfidenceConnection>;
  readonly crmLawsuitsByPersonId: Maybe<CrmLawsuitsByPersonIdConnection>;
  readonly crmLawsuitsHistory: Maybe<ReadonlyArray<CrmLawsuit>>;
  readonly crmMp: Maybe<ReadonlyArray<Maybe<CrmMp>>>;
  readonly crmTag: Maybe<CrmTag>;
  readonly crmTask: Maybe<CrmTask>;
  readonly crmTimelineItem: Maybe<CrmTimelineItem>;
  readonly crmTimelineItems: ReadonlyArray<Maybe<CrmTimelineItem>>;
  readonly currentOrganization: Maybe<Organization>;
  readonly currentOrganizationMembership: Maybe<OrganizationMember>;
  readonly currentUser: Maybe<User>;
  readonly defaultPlanGroup: Maybe<PlanGroup>;
  readonly didYouMean: Maybe<Scalars['String']>;
  /** @deprecated "docId: Int!" fails for recent ids beyond the internal GraphQL limit, and this endpoint will be retired, use documentByNumericID instead */
  readonly document: Maybe<Document>;
  readonly documentByNumericID: Maybe<Document>;
  readonly documentRedirect: Maybe<Redirect>;
  readonly documents: Maybe<ReadonlyArray<Maybe<Document>>>;
  /** @deprecated "docId: Int!" fails for recent ids beyond the internal GraphQL limit, and this endpoint will be retired, use documentsByNumericIDs instead */
  readonly documentsById: Maybe<ReadonlyArray<Maybe<Document>>>;
  readonly documentsByNumericIDs: Maybe<ReadonlyArray<Maybe<Document>>>;
  readonly enrichedContents: Maybe<ReadonlyArray<Maybe<EnrichedContents>>>;
  readonly entityCandidacyAutocomplete: Maybe<EntityCandidacyAutocomplete>;
  readonly entityCompany: Maybe<EntityCompany>;
  readonly entityGraphRelationships: Maybe<EntityGraphRelationships>;
  readonly entityPerson: Maybe<EntityPerson>;
  readonly entityQueryView: Maybe<EntityQueryView>;
  readonly event: Maybe<CrmEvent>;
  readonly events: Maybe<ReadonlyArray<Maybe<CrmEvent>>>;
  readonly exposedContents: Maybe<ReadonlyArray<ExposedContent>>;
  readonly featureByCode: Maybe<BoxFeature>;
  readonly featureTask: Maybe<FeatureTask>;
  readonly featureTasks: FeatureTaskList;
  readonly featuredLegalCase: Maybe<LegalCase>;
  readonly feed: Maybe<Feed>;
  readonly findRepresentedClientByMe: Maybe<FindRepresentedClientByMeResult>;
  readonly flashtag: Flashtag;
  readonly forcedExperiment: Maybe<ForcedExperiment>;
  readonly generalLawsuitsApigeeByDocument: Maybe<LawsuitsApigee>;
  readonly generalLawsuitsApigeeWithoutConfidenceByDocument: Maybe<LawsuitsApigee>;
  readonly getCProCompanyMetadata: Maybe<CproCompanyMetadata>;
  readonly getCProFeatures: Maybe<ReadonlyArray<Maybe<CproFeature>>>;
  readonly getCProOrganization: Maybe<CproOrganization>;
  readonly getCProOrganizationCredential: Maybe<Scalars['String']>;
  readonly getCProOrganizationItems: Maybe<CproPricingItem>;
  readonly getCProOrganizations: Maybe<CproOrganizationList>;
  readonly getCProOrganizationsMetadata: Maybe<CproOrganizationMetadata>;
  readonly getChiquinhaTransactionById: Maybe<ChiquinhaTransaction>;
  readonly getCproOrganizationExtraValues: Maybe<ReadonlyArray<Maybe<CproExtraValues>>>;
  readonly getCproOrganizationUsers: Maybe<ReadonlyArray<Maybe<CproUser>>>;
  readonly getCproUserByEmail: Maybe<CproUser>;
  readonly getCproUserByUid: Maybe<CproUser>;
  readonly getFullAddressByCep: Maybe<FullAddress>;
  readonly getJobsReport: Maybe<JobsReport>;
  readonly getOrCreateLawsuit: Maybe<CrmLawsuit>;
  readonly getSubscriptionById: Maybe<BoxSubscription>;
  readonly hasPasswordChanged: Maybe<Scalars['Boolean']>;
  readonly history: Maybe<EditHistory>;
  readonly hubAreaCompanyPlanFeatures: Maybe<AreaCompanyPlanFeaturesResult>;
  readonly hubAreaPlanGrants: Maybe<AreaPlanGrantsResult>;
  readonly hubB2BAreas: Maybe<HubB2BAreaListResult>;
  readonly hubB2BCatalogModules: Maybe<ReadonlyArray<Maybe<HubB2BCatalogModule>>>;
  readonly hubB2BCatalogPlanFeatures: Maybe<ReadonlyArray<Maybe<HubB2BCatalogPlanFeature>>>;
  readonly hubB2BCatalogPlans: Maybe<ReadonlyArray<Maybe<HubB2BCatalogPlan>>>;
  readonly hubCompanyByCnpj: Maybe<HubWhoIsCompanyResult>;
  readonly hubCompanySubscriptions: Maybe<HubCompanySubscriptionsResult>;
  readonly hubInvite: Maybe<HubInvite>;
  readonly hubInviteCounts: Maybe<HubInviteCounts>;
  readonly hubInvites: Maybe<HubInvitesResult>;
  readonly hubInvoiceDetails: Maybe<HubInvoiceDetailsResult>;
  readonly hubInvoiceEvents: Maybe<HubInvoiceEventsResult>;
  readonly hubInvoices: Maybe<HubInvoicesResult>;
  readonly hubJusiaPlanPreview: Maybe<HubJusiaPlanPreview>;
  readonly hubMyActiveCompanyRequest: ReadonlyArray<HubCompanyRequest>;
  readonly hubMyOrganization: Maybe<HubOrganization>;
  readonly hubOrganizations: Maybe<HubOrganizationList>;
  readonly hubSelfCheckoutPlans: HubSelfCheckoutPlans;
  readonly hubUseCases: Maybe<ReadonlyArray<Maybe<HubUseCase>>>;
  readonly hubUsers: Maybe<HubUsersResult>;
  readonly iapPlanByType: Maybe<Plan>;
  readonly idoxIntegration: Maybe<IdoxIntegration>;
  readonly inAppPurchaseProduct: Maybe<InAppPurchaseProduct>;
  readonly intentionSortedSearch: IntentionSortedSearch;
  readonly isEmailAvailable: Maybe<Scalars['Boolean']>;
  readonly isEmailVerifiedForERPMobileSignup: Maybe<Scalars['Boolean']>;
  readonly isJurisUnderstandingsPresent: Scalars['Boolean'];
  readonly isUnderMaintenance: Maybe<Scalars['Boolean']>;
  readonly jobsBankList: Maybe<ReadonlyArray<Maybe<JobsBank>>>;
  readonly jobsCepData: Maybe<JobsCepData>;
  readonly jobsConfigurations: Maybe<JobsConfigurations>;
  readonly jobsCountUnreadDemands: Maybe<Scalars['Int']>;
  readonly jobsDemand: Maybe<JobsDemand>;
  readonly jobsDemandFilters: Maybe<JobsDemandFilter>;
  readonly jobsDemandMessageFile: Maybe<JobsDemandMessageFileInfo>;
  readonly jobsDemands: Maybe<JobsDemandsListConnection>;
  readonly jobsMetadata: Maybe<JobsMetadata>;
  readonly jobsPaymentAttachments: Maybe<JobsPaymentAttachment>;
  readonly jobsPaymentBillingNoteAttachment: Maybe<JobsPaymentBillingNoteAttachment>;
  readonly jobsPaymentBillingNotes: Maybe<JobsPaymentBillingNote>;
  readonly jobsPaymentDetail: Maybe<JobsPaymentDetail>;
  readonly jobsPaymentFilters: Maybe<JobsPaymentFilter>;
  readonly jobsPaymentRefundAttachment: Maybe<JobsPaymentRefundAttachment>;
  readonly jobsPaymentRefunds: Maybe<JobsPaymentRefund>;
  readonly jobsPayments: Maybe<JobsPaymentsConnection>;
  readonly jobsServices: Maybe<ReadonlyArray<Maybe<JobsService>>>;
  readonly jobsUser: Maybe<JobsUser>;
  readonly jobsUserIntegration: Maybe<JobsUserIntegration>;
  readonly journalPage: Maybe<Document>;
  readonly jurisUnderstandings: Maybe<JurisUnderstandings>;
  readonly jurisUnderstandingsAvailable: Scalars['Boolean'];
  readonly jurisUnderstandingsThesis: Maybe<JurisUnderstandingsThesis>;
  readonly landingPageOffersViewer: LandingPageOffers;
  readonly lawsuitAssistantMessage: Maybe<LawsuitAssistantMessage>;
  readonly lawsuitAssistantMessages: Maybe<LawsuitAssistantMessagesConnection>;
  /** @deprecated Use LawsuitAssistantSuggestions / lawsuitAssistantSuggestions instead. */
  readonly lawsuitAssistantQuestions: Maybe<LawsuitAssistantQuestions>;
  readonly lawsuitAssistantSuggestions: Maybe<LawsuitAssistantSuggestions>;
  readonly lawsuitCase: Maybe<LawsuitCase>;
  readonly lawsuitQaEvaluator: Maybe<LawsuitQaEvaluator>;
  readonly lawsuitQaEvaluatorFeatures: Maybe<Scalars['JSON']>;
  readonly lawsuitQaEvaluators: Maybe<Scalars['JSON']>;
  readonly lawsuitSearch: Maybe<LawsuitSearch>;
  readonly lawsuitUserInteraction: Maybe<LawsuitUserInteraction>;
  readonly lawsuitValidatedProfile: Maybe<CrmLawsuitValidatedProfile>;
  readonly lawsuitValidatedProfilesByLawsuit: ReadonlyArray<CrmLawsuitValidatedProfile>;
  readonly lawsuitsApigeeByDocument: Maybe<LawsuitsApigee>;
  readonly lawsuitsByProvider: Maybe<LawsuitsDigestoByDocument>;
  readonly lawsuitsDigestoByDocument: Maybe<LawsuitsDigestoByDocument>;
  readonly lawyersFromOAB: Maybe<ReadonlyArray<Maybe<Lawyer>>>;
  readonly legalCase: Maybe<LegalCase>;
  readonly legalCaseByMigrationId: Maybe<LegalCase>;
  readonly legalThesis: ReadonlyArray<LegalThesis>;
  readonly legalThesisClusterLabels: ReadonlyArray<LegalThesisClusterLabels>;
  readonly listMagicLinkConfigs: ReadonlyArray<Maybe<HubMagicLinkConfig>>;
  readonly me: Maybe<Profile>;
  readonly meB2B: Maybe<Profile>;
  readonly moderationLogContent: Maybe<ReadonlyArray<ModerationLogContent>>;
  readonly moderationNoteContents: Maybe<ReadonlyArray<ModerationNoteContent>>;
  readonly multiSerp: MultiSearchResponse;
  readonly nearbyCities: ReadonlyArray<Topic>;
  readonly node: Maybe<Node>;
  readonly oabPrice: Maybe<OabPrice>;
  readonly oabTransferringDecrypt: Maybe<OabTransferring>;
  readonly organization: Maybe<Organization>;
  readonly organizationMember: Maybe<OrganizationMember>;
  readonly participateExperiment: Maybe<Experiment>;
  readonly partyEntityUrl: Maybe<Scalars['String']>;
  readonly persistentAlertBannerViewer: Maybe<PersistentAlertBanner>;
  readonly plan: Maybe<Plan>;
  readonly planCoupon: Maybe<PlanCoupon>;
  readonly planGroup: Maybe<PlanGroup>;
  readonly planTemplate: Maybe<PlanTemplate>;
  readonly planTemplateById: Maybe<PlanTemplate>;
  readonly plans: Maybe<ReadonlyArray<Maybe<Plan>>>;
  readonly priceIncrease: Maybe<PriceIncrease>;
  readonly priceIncreases: Maybe<ReadonlyArray<PriceIncrease>>;
  readonly profile: Maybe<Profile>;
  readonly profileByUsername: Maybe<Profile>;
  readonly profileByValidatedCpf: Maybe<Profile>;
  readonly profileGroup: Maybe<ProfileGroup>;
  readonly profilesByCpfOab: Maybe<ReadonlyArray<Maybe<Profile>>>;
  readonly profilesByEmail: Maybe<ReadonlyArray<Maybe<Profile>>>;
  readonly profilesByEmailOrPid: Maybe<ReadonlyArray<Maybe<Profile>>>;
  readonly profilesByIds: Maybe<ReadonlyArray<Maybe<Profile>>>;
  readonly publicationAlert: Maybe<PublicationAlert>;
  readonly querySectionRecommendation: Maybe<HaystackResponse>;
  readonly rapporteurSearch: Maybe<RapporteurSearch>;
  readonly recentLawyers: Maybe<ReadonlyArray<Maybe<Profile>>>;
  readonly relatedSearch: Maybe<RelatedSearch>;
  readonly remainingSearch: IntentionSortedSearch;
  readonly reportContent: ReportContent;
  readonly reportContentSearch: Maybe<ReportContentSearch>;
  readonly reportContentSearchFromUser: Maybe<ReportContentSearchFromUser>;
  readonly reportContents: ReadonlyArray<ReportContent>;
  readonly reportHistoryContent: Maybe<ReadonlyArray<ReportHistory>>;
  readonly resourceAccess: Maybe<ResourceAccess>;
  readonly resourceAccessRules: ReadonlyArray<ResourceAccessRule>;
  readonly restrictionLevel: Maybe<RestrictionLevel>;
  readonly restrictionSignals: Maybe<RestrictionSignalResult>;
  readonly retentionPlan: Maybe<RetentionPlan>;
  readonly root: RootApi;
  readonly salesRecommendation: Maybe<ReadonlyArray<Maybe<Plan>>>;
  readonly search: Maybe<Search>;
  readonly searchByEnrichedContents: Maybe<ReadonlyArray<Maybe<EnrichedContents>>>;
  readonly searchByEnrichedContentsV2: Maybe<SearchEnrichedContent>;
  readonly searchDirectLegis: Maybe<Search>;
  readonly searchDocumentsPaged: Maybe<SearchDocumentsPagedConnection>;
  readonly searchEmecLawInstitutions: ReadonlyArray<EmecLawInstitution>;
  readonly searchFeaturedJurisGuidance: Maybe<DocumentSearchSnippet>;
  readonly searchFeaturedLawsuit: Maybe<Search>;
  readonly searchFeaturedProfile: Maybe<DocumentSearchSnippet>;
  readonly searchFeaturedSummaryPrecedent: Maybe<DocumentSearchSnippet>;
  readonly searchFeaturedTopic: Maybe<DocumentSearchSnippet>;
  readonly searchHaystack: Maybe<HaystackResponse>;
  readonly searchHaystackSerp: HaystackSerpResponse;
  readonly searchHaystackSerpDeferred: Maybe<HaystackSerpDeferredResponse>;
  readonly searchLawsuitPartyEntities: Maybe<CrmSearchLawsuitPartyEntitiesConnection>;
  readonly searchLawyers: Maybe<Search>;
  readonly searchRemovalRequest: Maybe<ReadonlyArray<Maybe<RemovalRequest>>>;
  readonly senderByLead: Maybe<Profile>;
  readonly serpSEOMetadata: Maybe<SerpSeoMetadata>;
  readonly session: Maybe<Session>;
  readonly smartSearchSimilarDocuments: Maybe<SmartSearchSimilarDocumentsResult>;
  readonly smartlinks: Maybe<SmartLinksList>;
  readonly subscribeAnnualLpViewer: SubscribeAnnualLp;
  readonly subscribeDoctrineLpViewer: SubscribeDoctrineLp;
  readonly subscribeOABPartnershipLpViewer: SubscribeOabPartnershipLp;
  readonly subscribeProLpViewer: SubscribeProLp;
  readonly subscriptionInconsistencies: Maybe<ReadonlyArray<Maybe<SubscriptionInconsistency>>>;
  readonly subscriptionInconsistenciesStats: Maybe<Scalars['JSON']>;
  readonly subscriptionInconsistency: Maybe<SubscriptionInconsistency>;
  readonly tag: Maybe<Tag>;
  readonly testAccountAllowlist: ReadonlyArray<Scalars['String']>;
  readonly topic: Maybe<Topic>;
  readonly topicByDirectoryUrl: Maybe<Topic>;
  readonly topicByQuery: Maybe<Topic>;
  readonly topicBySlugAbout: Maybe<Topic>;
  readonly topicEntity: Maybe<TopicEntity>;
  readonly topicEntityFromLawsuit: Maybe<TopicEntity>;
  readonly topicsByIds: ReadonlyArray<Topic>;
  readonly topicsByLabel: ReadonlyArray<Topic>;
  readonly topicsByUrls: ReadonlyArray<Topic>;
  readonly user: Maybe<User>;
  readonly userByEmail: Maybe<User>;
  readonly userCanApproveVirtualFeatureConfig: Maybe<Scalars['Boolean']>;
  readonly userCollections: Maybe<ReadonlyArray<Maybe<UserCollection>>>;
  readonly validateHubInvite: Maybe<HubInvite>;
  readonly validatePublicationMonitoring: Maybe<Scalars['Boolean']>;
  readonly virtualFeatureConfig: Maybe<VirtualFeatureConfig>;
  readonly virtualFeatureConfigs: Maybe<ReadonlyArray<Maybe<VirtualFeatureConfig>>>;
  readonly visionEntityByRefId: Maybe<VisionEntity>;
  readonly wingmanAvailability: WingmanAvailability;
  readonly wingmanAvailable: Scalars['Boolean'];
  readonly wingmanCanUseFeature: Scalars['Boolean'];
  readonly wingmanFlagsAvailability: Scalars['JSON'];
};


export type RootApiCrmBnmpArgs = {
  identificationNumber: InputMaybe<Scalars['String']>;
  kind: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
};


export type RootApiPlanByIdOrSlugArgs = {
  idOrSlug: Scalars['String'];
};


export type RootApiPlanBySlugArgs = {
  name: Scalars['String'];
};


export type RootApiAcademyArgs = {
  context: InputMaybe<Scalars['JSON']>;
  product: Scalars['String'];
};


export type RootApiAdminStudentBenefitsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  profileQuery: InputMaybe<Scalars['String']>;
  status: InputMaybe<StudentBenefitStatusEnum>;
};


export type RootApiAiOverviewArgs = {
  query: Scalars['String'];
  variants: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


export type RootApiAiRelatedQuestionsArgs = {
  dataset: InputMaybe<ReadonlyArray<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type RootApiAssistantAskLawsuitUsageArgs = {
  lawsuitId: Scalars['String'];
  pid: Scalars['Int'];
};


export type RootApiAudienceSegmentArgs = {
  lastId: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  page: InputMaybe<Scalars['Int']>;
  pageSize: InputMaybe<Scalars['Int']>;
};


export type RootApiAudienceSegmentByIdArgs = {
  segmentId: Scalars['String'];
};


export type RootApiAuthIdoxIntegrationArgs = {
  auth: Scalars['String'];
};


export type RootApiBadgeArgs = {
  bid: Scalars['Int'];
};


export type RootApiBoxCompanyClaimsArgs = {
  pid: Scalars['Int'];
};


export type RootApiBoxLockViewerArgs = {
  adminOptions: InputMaybe<AdminOptionsInput>;
  appId: InputMaybe<Scalars['String']>;
  boxOptions: InputMaybe<BoxOptionsInput>;
  featureCode: Scalars['String'];
  fromComponent: InputMaybe<Scalars['String']>;
  pageMetadata: InputMaybe<PageMetadataInput>;
  product: InputMaybe<Scalars['String']>;
};


export type RootApiBoxUserClaimsArgs = {
  pid: Scalars['Int'];
};


export type RootApiBroadcastArgs = {
  target: Scalars['String'];
};


export type RootApiCamadaConversationArgs = {
  conversationId: Scalars['String'];
  kind: InputMaybe<Scalars['String']>;
};


export type RootApiCheckInviteByEmailArgs = {
  email: Scalars['String'];
};


export type RootApiCheckoutDataArgs = {
  planId: Scalars['Int'];
};


export type RootApiCitySearchArgs = {
  query: Scalars['String'];
};


export type RootApiCivilLawsuitsByProviderArgs = {
  document: Scalars['String'];
  email: Scalars['String'];
};


export type RootApiClassifyQueryArgs = {
  filter: InputMaybe<Scalars['String']>;
  query: InputMaybe<Scalars['String']>;
};


export type RootApiCnjNumberArgs = {
  number: Scalars['String'];
};


export type RootApiCollectionArgs = {
  collectionId: Scalars['String'];
};


export type RootApiContactArgs = {
  contactId: Scalars['String'];
};


export type RootApiConversationArgs = {
  conversationId: Scalars['Float'];
};


export type RootApiConversationByCamadaIdArgs = {
  layerConversationId: Scalars['String'];
};


export type RootApiCproBnmpArgs = {
  documentNumber: Scalars['String'];
  kind: InputMaybe<Scalars['String']>;
};


export type RootApiCproDocumentSummaryArgs = {
  documentNumber: Scalars['String'];
  model: InputMaybe<Scalars['String']>;
};


export type RootApiCproInternalLawsuitsByDocumentArgs = {
  cursor: InputMaybe<Scalars['String']>;
  document: Scalars['String'];
  ignoreCache: InputMaybe<Scalars['Boolean']>;
  limit: InputMaybe<Scalars['Int']>;
  useFallback: InputMaybe<Scalars['Boolean']>;
};


export type RootApiCproLawsuitArgs = {
  lawsuitId: Scalars['String'];
};


export type RootApiCproLawsuitAttachmentArgs = {
  attachmentId: Scalars['String'];
};


export type RootApiCproLawsuitByNumberArgs = {
  number: Scalars['String'];
  usePublicLawsuit: InputMaybe<Scalars['Boolean']>;
};


export type RootApiCproLawsuitsByNameWithoutConfidenceArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  identificationNumber: Scalars['String'];
  identificationType: InputMaybe<Scalars['String']>;
  kind: InputMaybe<Scalars['String']>;
  kinds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  noCourts: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  noKinds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type RootApiCproLawsuitsByPersonIdArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  identificationNumber: Scalars['String'];
  identificationType: InputMaybe<Scalars['String']>;
  kind: InputMaybe<Scalars['String']>;
  kinds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  noCourts: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  noKinds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  usingHaystack: InputMaybe<Scalars['Boolean']>;
};


export type RootApiCproMpArgs = {
  documentNumber: Scalars['String'];
  kind: InputMaybe<Scalars['String']>;
};


export type RootApiCrmActivityLogArgs = {
  activityId: Scalars['String'];
};


export type RootApiCrmBulkActionArgs = {
  bulkActionId: InputMaybe<Scalars['String']>;
};


export type RootApiCrmCourtCredentialArgs = {
  credentialId: Scalars['String'];
};


export type RootApiCrmDataExportArgs = {
  dataExportId: Scalars['String'];
};


export type RootApiCrmDocumentArgs = {
  documentId: Scalars['String'];
};


export type RootApiCrmEmpregadorIrregularArgs = {
  identificationNumber: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
};


export type RootApiCrmLawsuitArgs = {
  lawsuitId: Scalars['String'];
};


export type RootApiCrmLawsuitAttachmentArgs = {
  attachmentId: Scalars['String'];
};


export type RootApiCrmLawsuitAttachmentsArgs = {
  attachmentIds: ReadonlyArray<Scalars['String']>;
};


export type RootApiCrmLawsuitByNumberArgs = {
  number: Scalars['String'];
  usePublicLawsuit: InputMaybe<Scalars['Boolean']>;
};


export type RootApiCrmLawsuitByNumbersArgs = {
  numbers: ReadonlyArray<InputMaybe<Scalars['String']>>;
  usePublicLawsuit: InputMaybe<Scalars['Boolean']>;
};


export type RootApiCrmLawsuitPartyEntityArgs = {
  entityId: Scalars['String'];
  fromComponent?: InputMaybe<Scalars['String']>;
};


export type RootApiCrmLawsuitSearchArgs = {
  lawsuitSearchId: Scalars['String'];
};


export type RootApiCrmLawsuitSearchUserInteractionArgs = {
  queryId: Scalars['String'];
};


export type RootApiCrmLawsuitSearchUserQueriesListArgs = {
  excludeUnknown: InputMaybe<Scalars['Boolean']>;
  limit: InputMaybe<Scalars['Int']>;
};


export type RootApiCrmLawsuitsByIdsArgs = {
  lawsuitIds: ReadonlyArray<InputMaybe<Scalars['String']>>;
};


export type RootApiCrmLawsuitsByNameWithoutConfidenceArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  identificationName: Scalars['String'];
  kind: InputMaybe<Scalars['String']>;
  kinds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  noCourts: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  noKinds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type RootApiCrmLawsuitsByPersonIdArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  identificationNumber: Scalars['String'];
  identificationType: InputMaybe<Scalars['String']>;
  kind: InputMaybe<Scalars['String']>;
  kinds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  noCourts: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  noKinds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  onlyWithPole: InputMaybe<Scalars['Boolean']>;
  pole: InputMaybe<PersonIdPoleType>;
  poles: InputMaybe<ReadonlyArray<InputMaybe<PersonIdPoleType>>>;
  usingHaystack: InputMaybe<Scalars['Boolean']>;
};


export type RootApiCrmMpArgs = {
  identificationNumber: InputMaybe<Scalars['String']>;
  kind: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
};


export type RootApiCrmTagArgs = {
  tagId: Scalars['String'];
};


export type RootApiCrmTaskArgs = {
  taskId: Scalars['String'];
};


export type RootApiCrmTimelineItemArgs = {
  itemId: Scalars['String'];
};


export type RootApiCrmTimelineItemsArgs = {
  itemIds: ReadonlyArray<Scalars['String']>;
};


export type RootApiDidYouMeanArgs = {
  query: InputMaybe<Scalars['String']>;
};


export type RootApiDocumentArgs = {
  artifact: Scalars['String'];
  docId: Scalars['Int'];
};


export type RootApiDocumentByNumericIdArgs = {
  artifact: Scalars['String'];
  docId: Scalars['NumericID'];
};


export type RootApiDocumentRedirectArgs = {
  artifact: Scalars['String'];
  docId: Scalars['NumericID'];
};


export type RootApiDocumentsArgs = {
  identifiers: ReadonlyArray<DocumentIdentifier>;
};


export type RootApiDocumentsByIdArgs = {
  artifact: Scalars['String'];
  ids: ReadonlyArray<Scalars['Int']>;
};


export type RootApiDocumentsByNumericIDsArgs = {
  artifact: Scalars['String'];
  ids: ReadonlyArray<Scalars['NumericID']>;
};


export type RootApiEnrichedContentsArgs = {
  artifact: Scalars['String'];
  ids: ReadonlyArray<InputMaybe<Scalars['Int']>>;
  keys: ReadonlyArray<InputMaybe<Scalars['String']>>;
};


export type RootApiEntityCandidacyAutocompleteArgs = {
  candidacyType: InputMaybe<ReadonlyArray<InputMaybe<CandidacyTypeEnum>>>;
  electoralDistrictUf: InputMaybe<ReadonlyArray<InputMaybe<StateEnum>>>;
  limit?: InputMaybe<Scalars['Int']>;
  partyInitials: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query: InputMaybe<Scalars['String']>;
};


export type RootApiEntityCompanyArgs = {
  entityId: Scalars['String'];
};


export type RootApiEntityGraphRelationshipsArgs = {
  id: Scalars['String'];
  relations: InputMaybe<ReadonlyArray<InputMaybe<EntityRelationshipType>>>;
  sourceType: InputMaybe<Scalars['String']>;
};


export type RootApiEntityPersonArgs = {
  entityId: Scalars['String'];
};


export type RootApiEntityQueryViewArgs = {
  entityId: Scalars['String'];
  queryBase64: Scalars['String'];
};


export type RootApiEventArgs = {
  calendarId: Scalars['String'];
  eventId: Scalars['String'];
};


export type RootApiEventsArgs = {
  calendarId: Scalars['String'];
  contactId: InputMaybe<Scalars['String']>;
  lawsuitId: InputMaybe<Scalars['String']>;
  singleEvents: InputMaybe<Scalars['Boolean']>;
  timeMax: InputMaybe<Scalars['Float']>;
  timeMin: InputMaybe<Scalars['Float']>;
};


export type RootApiExposedContentsArgs = {
  reportId: Scalars['String'];
};


export type RootApiFeatureByCodeArgs = {
  code: Scalars['String'];
};


export type RootApiFeatureTaskArgs = {
  id: Scalars['String'];
};


export type RootApiFeatureTasksArgs = {
  featureCode: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  operation: InputMaybe<FeatureTaskOperation>;
  owner: InputMaybe<Scalars['String']>;
  status: InputMaybe<FeatureTaskStatus>;
};


export type RootApiFeaturedLegalCaseArgs = {
  legalCaseId: Scalars['Float'];
};


export type RootApiFeedArgs = {
  artifact: InputMaybe<Scalars['String']>;
};


export type RootApiFindRepresentedClientByMeArgs = {
  cnj: Scalars['String'];
};


export type RootApiFlashtagArgs = {
  name: Scalars['String'];
};


export type RootApiGeneralLawsuitsApigeeByDocumentArgs = {
  document: Scalars['String'];
};


export type RootApiGeneralLawsuitsApigeeWithoutConfidenceByDocumentArgs = {
  document: Scalars['String'];
};


export type RootApiGetCProCompanyMetadataArgs = {
  organizationId: Scalars['String'];
  organizationSlug: Scalars['String'];
};


export type RootApiGetCProOrganizationArgs = {
  organizationId: Scalars['String'];
};


export type RootApiGetCProOrganizationCredentialArgs = {
  email: Scalars['String'];
  environmentType: Scalars['String'];
  organizationId: Scalars['String'];
};


export type RootApiGetCProOrganizationItemsArgs = {
  featureId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type RootApiGetCProOrganizationsArgs = {
  active: InputMaybe<Scalars['Boolean']>;
  limit: InputMaybe<Scalars['Int']>;
  name: InputMaybe<Scalars['String']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type RootApiGetChiquinhaTransactionByIdArgs = {
  transactionId: Scalars['String'];
};


export type RootApiGetCproOrganizationExtraValuesArgs = {
  organizationId: Scalars['String'];
};


export type RootApiGetCproOrganizationUsersArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['String'];
};


export type RootApiGetCproUserByEmailArgs = {
  email: Scalars['String'];
  organizationId: Scalars['String'];
};


export type RootApiGetCproUserByUidArgs = {
  uid: Scalars['String'];
};


export type RootApiGetFullAddressByCepArgs = {
  cep: Scalars['String'];
};


export type RootApiGetJobsReportArgs = {
  endDate: InputMaybe<Scalars['Float']>;
  startDate: InputMaybe<Scalars['Float']>;
};


export type RootApiGetOrCreateLawsuitArgs = {
  cnjNumber: Scalars['String'];
};


export type RootApiGetSubscriptionByIdArgs = {
  subscriptionId: Scalars['String'];
};


export type RootApiHistoryArgs = {
  historyId: Scalars['String'];
};


export type RootApiHubAreaCompanyPlanFeaturesArgs = {
  areaUuid: Scalars['String'];
};


export type RootApiHubAreaPlanGrantsArgs = {
  areaUuid: Scalars['String'];
};


export type RootApiHubB2BAreasArgs = {
  companyUuid: Scalars['String'];
  limit: InputMaybe<Scalars['Int']>;
  name: InputMaybe<Scalars['String']>;
  offset: InputMaybe<Scalars['Int']>;
  status: InputMaybe<Scalars['String']>;
};


export type RootApiHubB2BCatalogPlanFeaturesArgs = {
  moduleSlug: Scalars['String'];
  planName: Scalars['String'];
};


export type RootApiHubB2BCatalogPlansArgs = {
  isSelfService: InputMaybe<Scalars['Boolean']>;
  moduleSlug: Scalars['String'];
};


export type RootApiHubCompanyByCnpjArgs = {
  cnpj: Scalars['String'];
};


export type RootApiHubCompanySubscriptionsArgs = {
  companyUuid: Scalars['String'];
};


export type RootApiHubInviteArgs = {
  uuid: Scalars['String'];
};


export type RootApiHubInviteCountsArgs = {
  companyUuid: Scalars['String'];
};


export type RootApiHubInvitesArgs = {
  companyUuid: Scalars['String'];
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  search: InputMaybe<Scalars['String']>;
  status: InputMaybe<Scalars['String']>;
};


export type RootApiHubInvoiceDetailsArgs = {
  invoiceUuid: Scalars['String'];
};


export type RootApiHubInvoiceEventsArgs = {
  areaUuid: InputMaybe<Scalars['String']>;
  eventNameSearch: InputMaybe<Scalars['String']>;
  invoiceUuid: Scalars['String'];
  moduleName: InputMaybe<Scalars['String']>;
};


export type RootApiHubInvoicesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  page: InputMaybe<Scalars['Int']>;
};


export type RootApiHubJusiaPlanPreviewArgs = {
  planName: Scalars['String'];
};


export type RootApiHubMyActiveCompanyRequestArgs = {
  pid: InputMaybe<Scalars['Int']>;
  statuses: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


export type RootApiHubOrganizationsArgs = {
  brandName: InputMaybe<Scalars['String']>;
  legalNumber: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type RootApiHubUsersArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  roles: InputMaybe<Scalars['String']>;
  search: InputMaybe<Scalars['String']>;
  status: InputMaybe<Scalars['String']>;
  userCompanyId: InputMaybe<Scalars['Int']>;
};


export type RootApiIapPlanByTypeArgs = {
  type: InputMaybe<IapPlanType>;
};


export type RootApiIdoxIntegrationArgs = {
  organizationId: InputMaybe<Scalars['Int']>;
  pid: InputMaybe<Scalars['Int']>;
};


export type RootApiInAppPurchaseProductArgs = {
  productId: InputMaybe<Scalars['String']>;
};


export type RootApiIntentionSortedSearchArgs = {
  flags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  intentionFilter: Scalars['String'];
  kinds: ReadonlyArray<HaystackKind>;
  maxKinds: Scalars['Int'];
  query: Scalars['String'];
};


export type RootApiIsEmailAvailableArgs = {
  email: Scalars['String'];
};


export type RootApiIsEmailVerifiedForErpMobileSignupArgs = {
  email: Scalars['String'];
};


export type RootApiIsJurisUnderstandingsPresentArgs = {
  courts?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query: Scalars['String'];
};


export type RootApiIsUnderMaintenanceArgs = {
  apiName: Scalars['String'];
};


export type RootApiJobsCepDataArgs = {
  cep: InputMaybe<Scalars['String']>;
};


export type RootApiJobsDemandArgs = {
  demandId: Scalars['Int'];
};


export type RootApiJobsDemandMessageFileArgs = {
  demandId: Scalars['Int'];
  messageId: Scalars['String'];
};


export type RootApiJobsDemandsArgs = {
  after: InputMaybe<Scalars['String']>;
  cacheBust: InputMaybe<Scalars['Float']>;
  filters: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  first: InputMaybe<Scalars['Int']>;
  isArchived: InputMaybe<Scalars['Boolean']>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
};


export type RootApiJobsPaymentAttachmentsArgs = {
  paymentId: Scalars['Int'];
  paymentType: Scalars['String'];
};


export type RootApiJobsPaymentBillingNoteAttachmentArgs = {
  paymentBillingNoteId: Scalars['Int'];
  paymentId: Scalars['Int'];
};


export type RootApiJobsPaymentBillingNotesArgs = {
  paymentId: Scalars['Int'];
};


export type RootApiJobsPaymentDetailArgs = {
  hash: InputMaybe<Scalars['String']>;
  paymentDetailId: Scalars['Int'];
};


export type RootApiJobsPaymentRefundAttachmentArgs = {
  paymentId: Scalars['Int'];
  paymentRefundId: Scalars['Int'];
};


export type RootApiJobsPaymentRefundsArgs = {
  paymentId: Scalars['Int'];
};


export type RootApiJobsPaymentsArgs = {
  after: InputMaybe<Scalars['String']>;
  cacheBurst: InputMaybe<Scalars['Float']>;
  filterDateFinal: InputMaybe<Scalars['String']>;
  filterDateInitial: InputMaybe<Scalars['String']>;
  filterDateInterval: InputMaybe<Scalars['Int']>;
  filterDemand: InputMaybe<Scalars['String']>;
  filterStatus: InputMaybe<Scalars['Int']>;
  first: InputMaybe<Scalars['Int']>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type RootApiJobsUserArgs = {
  id: InputMaybe<Scalars['Int']>;
  pid: InputMaybe<Scalars['Int']>;
};


export type RootApiJobsUserIntegrationArgs = {
  pid: Scalars['Float'];
};


export type RootApiJournalPageArgs = {
  date: Scalars['Float'];
  page: Scalars['String'];
  pid: Scalars['Int'];
  section: Scalars['String'];
};


export type RootApiJurisUnderstandingsArgs = {
  courts?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  forceCache?: InputMaybe<Scalars['Boolean']>;
  query: Scalars['String'];
};


export type RootApiJurisUnderstandingsAvailableArgs = {
  version: InputMaybe<Scalars['String']>;
};


export type RootApiJurisUnderstandingsThesisArgs = {
  comment_search?: InputMaybe<Scalars['Boolean']>;
  court: InputMaybe<Scalars['String']>;
  filterByClassifier?: InputMaybe<Scalars['Boolean']>;
  filter_author?: InputMaybe<Scalars['String']>;
  filter_doc_ids: InputMaybe<ReadonlyArray<Scalars['Int']>>;
  filters?: InputMaybe<ThesisFilterInput>;
  min_similarity?: InputMaybe<Scalars['Float']>;
  ner_filtering?: InputMaybe<Scalars['Boolean']>;
  query: Scalars['String'];
  segmentation_by_user_location?: InputMaybe<SegmentationMode>;
  semantic_cache_only?: InputMaybe<Scalars['Boolean']>;
  semantic_search?: InputMaybe<Scalars['Boolean']>;
  semantic_text_filtering?: InputMaybe<Scalars['Boolean']>;
  static_search?: InputMaybe<Scalars['Boolean']>;
  strict_search?: InputMaybe<Scalars['Boolean']>;
  text_search?: InputMaybe<Scalars['Boolean']>;
  text_search_msm?: InputMaybe<Scalars['Boolean']>;
};


export type RootApiLandingPageOffersViewerArgs = {
  planGroupSlug: InputMaybe<Scalars['String']>;
};


export type RootApiLawsuitAssistantMessageArgs = {
  messageId: Scalars['String'];
};


export type RootApiLawsuitAssistantMessagesArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  lastActivityId: Scalars['String'];
  type: InputMaybe<MessageType>;
};


export type RootApiLawsuitAssistantQuestionsArgs = {
  lawsuitId: Scalars['String'];
  versionId: Scalars['String'];
};


export type RootApiLawsuitAssistantSuggestionsArgs = {
  lawsuitId: Scalars['String'];
  versionId: Scalars['String'];
};


export type RootApiLawsuitCaseArgs = {
  caseId: Scalars['String'];
};


export type RootApiLawsuitQaEvaluatorArgs = {
  evaluationId: Scalars['String'];
};


export type RootApiLawsuitQaEvaluatorsArgs = {
  cursor: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
};


export type RootApiLawsuitSearchArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type RootApiLawsuitUserInteractionArgs = {
  lawsuitId: Scalars['String'];
};


export type RootApiLawsuitValidatedProfileArgs = {
  lawsuitId: Scalars['String'];
};


export type RootApiLawsuitValidatedProfilesByLawsuitArgs = {
  lawsuitId: Scalars['String'];
};


export type RootApiLawsuitsApigeeByDocumentArgs = {
  document: Scalars['String'];
  kind: Scalars['String'];
};


export type RootApiLawsuitsByProviderArgs = {
  document: Scalars['String'];
  kind: Scalars['String'];
};


export type RootApiLawsuitsDigestoByDocumentArgs = {
  document: Scalars['String'];
  kind: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


export type RootApiLawyersFromOabArgs = {
  collectIfMissing?: InputMaybe<Scalars['Boolean']>;
  lawyerName: InputMaybe<Scalars['String']>;
  oabNumber: InputMaybe<Scalars['String']>;
  oabType: InputMaybe<Scalars['String']>;
  oabUf: InputMaybe<Scalars['String']>;
};


export type RootApiLegalCaseArgs = {
  legalCaseId: Scalars['Float'];
};


export type RootApiLegalCaseByMigrationIdArgs = {
  migrationId: Scalars['Float'];
};


export type RootApiListMagicLinkConfigsArgs = {
  companyUuid: Scalars['String'];
};


export type RootApiModerationLogContentArgs = {
  reportId: Scalars['String'];
};


export type RootApiModerationNoteContentsArgs = {
  reportId: Scalars['String'];
};


export type RootApiMultiSerpArgs = {
  flags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  kinds: ReadonlyArray<SearchKind>;
  maxKinds: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  queryIntentionFilter?: InputMaybe<Scalars['String']>;
  sortByQueryIntention?: InputMaybe<Scalars['Boolean']>;
};


export type RootApiNearbyCitiesArgs = {
  latitude: Scalars['String'];
  longitude: Scalars['String'];
  radius: InputMaybe<Scalars['Int']>;
};


export type RootApiNodeArgs = {
  id: Scalars['ID'];
};


export type RootApiOabPriceArgs = {
  locationId: Scalars['Int'];
  subjectId: Scalars['Int'];
};


export type RootApiOabTransferringDecryptArgs = {
  jwt: InputMaybe<Scalars['String']>;
};


export type RootApiOrganizationArgs = {
  organizationId: Scalars['Int'];
};


export type RootApiOrganizationMemberArgs = {
  memberId: Scalars['Int'];
  organizationId: Scalars['Int'];
};


export type RootApiParticipateExperimentArgs = {
  alternatives: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  experimentGroup: Scalars['String'];
  experimentName: Scalars['String'];
  forceAlternative: InputMaybe<Scalars['String']>;
  onlySignedIn?: InputMaybe<Scalars['Boolean']>;
  onlySubscribers?: InputMaybe<Scalars['Boolean']>;
  simulate?: InputMaybe<Scalars['Boolean']>;
};


export type RootApiPartyEntityUrlArgs = {
  identificationNumber: Scalars['String'];
  identificationType: Scalars['String'];
};


export type RootApiPersistentAlertBannerViewerArgs = {
  appId?: InputMaybe<Scalars['String']>;
  appPageId?: InputMaybe<Scalars['String']>;
};


export type RootApiPlanArgs = {
  planId: Scalars['Int'];
};


export type RootApiPlanCouponArgs = {
  couponId: Scalars['String'];
};


export type RootApiPlanGroupArgs = {
  slugOrId: Scalars['String'];
};


export type RootApiPlanTemplateArgs = {
  slug: Scalars['String'];
};


export type RootApiPlanTemplateByIdArgs = {
  id: Scalars['Int'];
};


export type RootApiPlansArgs = {
  limit: InputMaybe<Scalars['Int']>;
};


export type RootApiPriceIncreaseArgs = {
  id: Scalars['String'];
};


export type RootApiPriceIncreasesArgs = {
  fromPlanId: InputMaybe<Scalars['Int']>;
  status: InputMaybe<PriceIncreaseStatusType>;
  subscriptionRulesType: InputMaybe<PriceIncreaseTypeEnum>;
  toPlanId: InputMaybe<Scalars['Int']>;
};


export type RootApiProfileArgs = {
  pid: Scalars['Int'];
};


export type RootApiProfileByUsernameArgs = {
  username: Scalars['String'];
};


export type RootApiProfileByValidatedCpfArgs = {
  cpf: Scalars['String'];
};


export type RootApiProfileGroupArgs = {
  pid: Scalars['Int'];
};


export type RootApiProfilesByCpfOabArgs = {
  cpf: Scalars['String'];
  oab: Scalars['String'];
  oabUf: Scalars['Int'];
};


export type RootApiProfilesByEmailArgs = {
  email: Scalars['String'];
};


export type RootApiProfilesByEmailOrPidArgs = {
  emailOrPid: Scalars['String'];
};


export type RootApiProfilesByIdsArgs = {
  pidList: InputMaybe<ReadonlyArray<Scalars['Int']>>;
};


export type RootApiPublicationAlertArgs = {
  alertId: InputMaybe<Scalars['String']>;
};


export type RootApiQuerySectionRecommendationArgs = {
  currentKind: SearchKind;
  flags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  highlights?: InputMaybe<ReadonlyArray<InputMaybe<HighlightInput>>>;
  query: Scalars['String'];
  queryIntentionFilter?: InputMaybe<Scalars['String']>;
};


export type RootApiRapporteurSearchArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type RootApiRecentLawyersArgs = {
  isPro: InputMaybe<Scalars['Boolean']>;
  maxRegisters: Scalars['Int'];
};


export type RootApiRelatedSearchArgs = {
  alternatives: InputMaybe<ReadonlyArray<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type RootApiRemainingSearchArgs = {
  query: Scalars['String'];
  remainingKinds: ReadonlyArray<HaystackKind>;
};


export type RootApiReportContentArgs = {
  reportId: InputMaybe<Scalars['String']>;
};


export type RootApiReportContentSearchArgs = {
  orderBy: InputMaybe<Scalars['String']>;
  orderDir: InputMaybe<Scalars['String']>;
  pid: InputMaybe<Scalars['String']>;
  reportType: InputMaybe<ReportType>;
  status: InputMaybe<ReportContentStatusType>;
};


export type RootApiReportContentSearchFromUserArgs = {
  orderBy: InputMaybe<Scalars['String']>;
  orderDir: InputMaybe<Scalars['String']>;
  reportType: InputMaybe<ReportType>;
  status: InputMaybe<ReportContentStatusType>;
};


export type RootApiReportHistoryContentArgs = {
  reportIds: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


export type RootApiResourceAccessArgs = {
  identifier: Scalars['String'];
  lawsuit: LawsuitRestrictionInput;
  viewer: ViewerRestrictionInput;
};


export type RootApiRestrictionLevelArgs = {
  identifier: Scalars['String'];
  lawsuit: LawsuitRestrictionInput;
  viewer: ViewerRestrictionInput;
};


export type RootApiRestrictionSignalsArgs = {
  type: RestrictionIdentifierType;
  value: Scalars['String'];
};


export type RootApiRetentionPlanArgs = {
  appId: InputMaybe<Scalars['String']>;
  backTo: InputMaybe<Scalars['String']>;
  experimentId: InputMaybe<Scalars['String']>;
  fromComponent: InputMaybe<Scalars['String']>;
  organizationUsers: InputMaybe<Scalars['Int']>;
  planBasePrice: InputMaybe<Scalars['Float']>;
  planPrice: InputMaybe<Scalars['Float']>;
  referrer: InputMaybe<Scalars['String']>;
  resourceId: InputMaybe<Scalars['String']>;
  source: InputMaybe<Scalars['String']>;
};


export type RootApiSalesRecommendationArgs = {
  filter: InputMaybe<SalesRecommendationFilter>;
};


export type RootApiSearchArgs = {
  admissibilityDecision: InputMaybe<Scalars['Boolean']>;
  articleId: InputMaybe<Scalars['Int']>;
  artifact: InputMaybe<Scalars['String']>;
  court: InputMaybe<Scalars['String']>;
  dateFrom: InputMaybe<Scalars['String']>;
  dateTo: InputMaybe<Scalars['String']>;
  degree: InputMaybe<Scalars['String']>;
  doctrineId: InputMaybe<Scalars['Int']>;
  enableDirectLegis: InputMaybe<Scalars['Boolean']>;
  enableDoctrineAggregation: InputMaybe<Scalars['Boolean']>;
  enableFacets: InputMaybe<Scalars['Boolean']>;
  enableIntentionArtifactSwap: InputMaybe<Scalars['Boolean']>;
  enableLawPhrasalTerms: InputMaybe<Scalars['Boolean']>;
  enableMotionOnGeneralSearch: InputMaybe<Scalars['Boolean']>;
  enablePhrasalTerms: InputMaybe<Scalars['Boolean']>;
  entityTypes: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  filterProfileType: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  filterTopicType: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  first: InputMaybe<Scalars['Int']>;
  followerBoost: InputMaybe<Scalars['Boolean']>;
  hasDecisionFacts: InputMaybe<Scalars['Boolean']>;
  includeSynonym: InputMaybe<Scalars['Boolean']>;
  journalTypeProfiles: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  journalUfProfiles: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  jurisTypes: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  keywords: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  kinds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  lawAreas: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  lawType: InputMaybe<Scalars['String']>;
  legalSearch: InputMaybe<Scalars['Boolean']>;
  mandatoryPrecedent: InputMaybe<Scalars['Boolean']>;
  matchAllWordsTerm: InputMaybe<Scalars['String']>;
  matchAnyWordTerm: InputMaybe<Scalars['String']>;
  matchExactTerm: InputMaybe<Scalars['String']>;
  maxLoadUnique: InputMaybe<Scalars['Int']>;
  meritDecision: InputMaybe<Scalars['Boolean']>;
  notContainingTerm: InputMaybe<Scalars['String']>;
  offset: InputMaybe<Scalars['Int']>;
  order: InputMaybe<Scalars['String']>;
  popularPrecedent: InputMaybe<Scalars['Boolean']>;
  profileType: InputMaybe<Scalars['String']>;
  publishedYears: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query: InputMaybe<Scalars['String']>;
  relator: InputMaybe<Scalars['String']>;
  requestUserAgent: InputMaybe<Scalars['String']>;
  subjects: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  supremeCourtBoostRangeOption: InputMaybe<Scalars['Int']>;
  topicIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  uniqueField: InputMaybe<Scalars['String']>;
  useAutocomplete: InputMaybe<Scalars['Boolean']>;
};


export type RootApiSearchByEnrichedContentsArgs = {
  courts: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  fromUniqueClusters: InputMaybe<Scalars['Boolean']>;
  keys: InputMaybe<ReadonlyArray<Scalars['String']>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  searchType: InputMaybe<Scalars['String']>;
};


export type RootApiSearchByEnrichedContentsV2Args = {
  courts: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  fromUniqueClusters: InputMaybe<Scalars['Boolean']>;
  keys: InputMaybe<ReadonlyArray<Scalars['String']>>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  searchType: InputMaybe<Scalars['String']>;
};


export type RootApiSearchDirectLegisArgs = {
  query: InputMaybe<Scalars['String']>;
};


export type RootApiSearchDocumentsPagedArgs = {
  after: InputMaybe<Scalars['String']>;
  artifact: InputMaybe<Scalars['String']>;
  dateFrom: InputMaybe<Scalars['String']>;
  dateTo: InputMaybe<Scalars['String']>;
  degree: InputMaybe<Scalars['String']>;
  enableDirectLegis: InputMaybe<Scalars['Boolean']>;
  enableFacets: InputMaybe<Scalars['Boolean']>;
  entityTypes: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  first: InputMaybe<Scalars['Int']>;
  hasDecisionFacts: InputMaybe<Scalars['Boolean']>;
  legalSearch: InputMaybe<Scalars['Boolean']>;
  order: InputMaybe<Scalars['String']>;
  query: InputMaybe<Scalars['String']>;
  topicIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  uniqueField: InputMaybe<Scalars['String']>;
  useAutocomplete: InputMaybe<Scalars['Boolean']>;
};


export type RootApiSearchEmecLawInstitutionsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type RootApiSearchFeaturedJurisGuidanceArgs = {
  query: InputMaybe<Scalars['String']>;
  topicIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type RootApiSearchFeaturedLawsuitArgs = {
  first: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
};


export type RootApiSearchFeaturedProfileArgs = {
  query: InputMaybe<Scalars['String']>;
};


export type RootApiSearchFeaturedSummaryPrecedentArgs = {
  query: InputMaybe<Scalars['String']>;
  topicIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type RootApiSearchFeaturedTopicArgs = {
  filterTopicType: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  query: InputMaybe<Scalars['String']>;
};


export type RootApiSearchHaystackArgs = {
  facets?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  filters?: InputMaybe<ReadonlyArray<InputMaybe<FilterInput>>>;
  flags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  highlights?: InputMaybe<ReadonlyArray<InputMaybe<HighlightInput>>>;
  kinds: InputMaybe<ReadonlyArray<InputMaybe<SearchKind>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  sorts?: InputMaybe<ReadonlyArray<InputMaybe<SortInput>>>;
};


export type RootApiSearchHaystackSerpArgs = {
  filters?: InputMaybe<ReadonlyArray<FilterInput>>;
  flags?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  serp: HaystackSerpKind;
  sorts?: InputMaybe<ReadonlyArray<SortInput>>;
};


export type RootApiSearchHaystackSerpDeferredArgs = {
  id: Scalars['String'];
};


export type RootApiSearchLawsuitPartyEntitiesArgs = {
  after: InputMaybe<Scalars['String']>;
  filters: InputMaybe<LawsuitPartyEntitiesFilterInput>;
  first: InputMaybe<Scalars['Int']>;
  identificationName: InputMaybe<Scalars['String']>;
  partyId: InputMaybe<Scalars['String']>;
  withLawsuits?: InputMaybe<Scalars['Boolean']>;
};


export type RootApiSearchLawyersArgs = {
  byRating: InputMaybe<Scalars['Boolean']>;
  cityId: InputMaybe<Scalars['Int']>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  randomSeed: InputMaybe<Scalars['Int']>;
  searchIssueId: InputMaybe<Scalars['Int']>;
};


export type RootApiSearchRemovalRequestArgs = {
  answer: InputMaybe<Answer>;
  entityId: Scalars['String'];
  entityType: EntityType;
};


export type RootApiSenderByLeadArgs = {
  email: Scalars['String'];
  legalCaseId: InputMaybe<Scalars['Int']>;
  migrationId: InputMaybe<Scalars['Int']>;
};


export type RootApiSerpSeoMetadataArgs = {
  artifact: InputMaybe<SerpSeoMetadataArtifacts>;
  query: Scalars['String'];
};


export type RootApiSmartSearchSimilarDocumentsArgs = {
  artifact?: InputMaybe<Scalars['String']>;
  docId: InputMaybe<Scalars['String']>;
  query: InputMaybe<Scalars['String']>;
  searchConfig: InputMaybe<Scalars['JSON']>;
};


export type RootApiSmartlinksArgs = {
  page: InputMaybe<Scalars['Int']>;
  pageSize: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
  sortBy: InputMaybe<SmartLinkSortBy>;
  sortOrder: InputMaybe<SmartLinkSortOrder>;
};


export type RootApiSubscriptionInconsistenciesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  page: InputMaybe<Scalars['Int']>;
  pid: InputMaybe<Scalars['Int']>;
  status: InputMaybe<Scalars['String']>;
};


export type RootApiSubscriptionInconsistenciesStatsArgs = {
  status: InputMaybe<Scalars['String']>;
};


export type RootApiSubscriptionInconsistencyArgs = {
  id: Scalars['String'];
};


export type RootApiTagArgs = {
  identifier: Scalars['String'];
};


export type RootApiTopicArgs = {
  tid: Scalars['Int'];
};


export type RootApiTopicByDirectoryUrlArgs = {
  directoryUrl: Scalars['String'];
};


export type RootApiTopicByQueryArgs = {
  q: Scalars['String'];
};


export type RootApiTopicBySlugAboutArgs = {
  slugAbout: Scalars['String'];
};


export type RootApiTopicEntityArgs = {
  entityValue: Scalars['String'];
};


export type RootApiTopicEntityFromLawsuitArgs = {
  lawsuitNumber: Scalars['String'];
};


export type RootApiTopicsByIdsArgs = {
  tidList: ReadonlyArray<InputMaybe<Scalars['Int']>>;
};


export type RootApiTopicsByLabelArgs = {
  label: Scalars['String'];
};


export type RootApiTopicsByUrlsArgs = {
  urls: ReadonlyArray<InputMaybe<Scalars['String']>>;
};


export type RootApiUserArgs = {
  uid: Scalars['Int'];
};


export type RootApiUserByEmailArgs = {
  email: Scalars['String'];
};


export type RootApiUserCollectionsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  page: InputMaybe<Scalars['Int']>;
  userProfileId: Scalars['Int'];
};


export type RootApiValidateHubInviteArgs = {
  uuid: Scalars['String'];
};


export type RootApiValidatePublicationMonitoringArgs = {
  payload: Scalars['JSON'];
  shouldFailWhenOabMonitoredAlreadyExists: InputMaybe<Scalars['Boolean']>;
  variations: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  verifyCanUse: InputMaybe<Scalars['Boolean']>;
};


export type RootApiVirtualFeatureConfigArgs = {
  featureCode: Scalars['String'];
};


export type RootApiVirtualFeatureConfigsArgs = {
  limit: InputMaybe<Scalars['Int']>;
};


export type RootApiVisionEntityByRefIdArgs = {
  externalReferenceId: Scalars['Int'];
};


export type RootApiWingmanAvailabilityArgs = {
  parentContext: Scalars['JSON'];
};


export type RootApiWingmanAvailableArgs = {
  parentContext: InputMaybe<Scalars['JSON']>;
};


export type RootApiWingmanCanUseFeatureArgs = {
  conversationId: InputMaybe<Scalars['String']>;
  featureCode: Scalars['String'];
  itemId: InputMaybe<Scalars['String']>;
};


export type RootApiWingmanFlagsAvailabilityArgs = {
  flags: ReadonlyArray<Scalars['String']>;
};

export type SalesRecommendationFilter = {
  readonly filterUpgradePlansForPromotional?: InputMaybe<Scalars['Boolean']>;
  readonly includeCurrentPlan?: InputMaybe<Scalars['Boolean']>;
  readonly planGroupSlug?: InputMaybe<Scalars['String']>;
  readonly tag?: InputMaybe<Scalars['String']>;
};

export type SaveAssistantMessageFeedbackInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly feedbackRating: LawsuitAssistantMessageRating;
  readonly messageId: Scalars['String'];
};

export type SaveAssistantMessageFeedbackPayload = {
  readonly __typename?: 'SaveAssistantMessageFeedbackPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuitAssistantMessage: Maybe<LawsuitAssistantMessage>;
};

export type SaveCProUserOrganizationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly isAdmin?: InputMaybe<Scalars['Boolean']>;
  readonly name: Scalars['String'];
  readonly organizationId: Scalars['String'];
};

export type SaveCProUserOrganizationPayload = {
  readonly __typename?: 'SaveCProUserOrganizationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly message: Maybe<Scalars['String']>;
  readonly saved: Maybe<Scalars['Boolean']>;
};

export type SaveChatBlockSeenIdsInput = {
  readonly chatBlockSeenIds: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
};

export type SaveChatBlockSeenIdsPayload = {
  readonly __typename?: 'SaveChatBlockSeenIdsPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
};

export type SaveCheckoutDataInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly jwt: Scalars['String'];
  readonly planId: Scalars['Int'];
};

export type SaveCheckoutDataPayload = {
  readonly __typename?: 'SaveCheckoutDataPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type SaveExplanationSeenInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly explanationSeen: Scalars['Boolean'];
  readonly lastSeenActivityId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
};

export type SaveExplanationSeenPayload = {
  readonly __typename?: 'SaveExplanationSeenPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuitUserInteraction: Maybe<LawsuitUserInteraction>;
};

export type SaveFeatureUsageInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly featureName?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
};

export type SaveFeatureUsagePayload = {
  readonly __typename?: 'SaveFeatureUsagePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuitUserInteraction: Maybe<LawsuitUserInteraction>;
};

export type SaveLastRequestedUpdateInput = {
  readonly chatBlockSeenIds?: InputMaybe<Scalars['String']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly explanationSeen?: InputMaybe<Scalars['Boolean']>;
  readonly lastSeenActivityDate: Scalars['Float'];
  readonly lastSeenActivityDateBeforeUpdate?: InputMaybe<Scalars['Float']>;
  readonly lastSeenActivityId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
  readonly lockedItemsCount?: InputMaybe<Scalars['Int']>;
  readonly requestedUpdateCount?: InputMaybe<Scalars['Int']>;
};

export type SaveLastRequestedUpdatePayload = {
  readonly __typename?: 'SaveLastRequestedUpdatePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
};

export type SaveLawsuitLastAccessInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
};

export type SaveLawsuitLastAccessPayload = {
  readonly __typename?: 'SaveLawsuitLastAccessPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type SaveLawsuitLastSeenStepInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lastSeenStep: Scalars['String'];
  readonly lawsuitId: Scalars['String'];
};

export type SaveLawsuitLastSeenStepPayload = {
  readonly __typename?: 'SaveLawsuitLastSeenStepPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
};

export type SaveNotificationPreferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly preferenciaNotificacao: Scalars['JSON'];
};

export type SaveNotificationPreferencePayload = {
  readonly __typename?: 'SaveNotificationPreferencePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly message: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type SaveRatingInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly conversationId: Scalars['Int'];
  readonly legalCaseId: Scalars['Int'];
  readonly ratedId: Scalars['Int'];
  readonly rating: Scalars['String'];
};

export type SaveRatingPayload = {
  readonly __typename?: 'SaveRatingPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly conversation: Maybe<Conversation>;
};

export type SaveReportInput = {
  readonly artifactId: Scalars['String'];
  readonly artifactSource: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cnj: Scalars['String'];
  readonly createdAt: Scalars['String'];
  readonly emailResponseSentAt: Scalars['String'];
  readonly lawsuitId: Scalars['String'];
  readonly pid: Scalars['String'];
  readonly reportData: Scalars['JSON'];
  readonly reportId: Scalars['String'];
  readonly reportType: Scalars['String'];
  readonly status: Scalars['String'];
  readonly updatedAt: Scalars['String'];
};

export type SaveReportPayload = {
  readonly __typename?: 'SaveReportPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
};

export type SaveTestimonialInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly conversationId: Scalars['Int'];
  readonly description: Scalars['String'];
  readonly ratedId: Scalars['Int'];
};

export type SaveTestimonialPayload = {
  readonly __typename?: 'SaveTestimonialPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly conversation: Maybe<Conversation>;
};

export type ScheduleDealMailInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly legalCaseId: Scalars['Float'];
  readonly scheduleDealMailAt: Scalars['Float'];
};

export type ScheduleDealMailPayload = {
  readonly __typename?: 'ScheduleDealMailPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly legalCase: Maybe<LegalCase>;
  readonly profile: Maybe<Profile>;
};

export type ScoreDetails = {
  readonly __typename?: 'ScoreDetails';
  readonly algorithmDescription: Maybe<Scalars['String']>;
  readonly algorithmName: Maybe<Scalars['String']>;
  readonly algorithmScore: Maybe<Scalars['Float']>;
  readonly algorithmWeight: Maybe<Scalars['Float']>;
};

export type Search = {
  readonly __typename?: 'Search';
  readonly artifactFacets: Maybe<Scalars['JSON']>;
  readonly directLegis: ReadonlyArray<DirectLegislation>;
  readonly directLegisTopic: ReadonlyArray<Topic>;
  readonly featuredProfile: Maybe<DocumentSearchSnippet>;
  readonly featuredSummaryPrecedent: Maybe<DocumentSearchSnippet>;
  readonly featuredTopic: Maybe<DocumentSearchSnippet>;
  readonly jurisFacets: Maybe<Scalars['JSON']>;
  readonly numResults: Scalars['Int'];
  readonly searchDocuments: ReadonlyArray<DocumentSearchSnippet>;
  readonly searchMetadata: Maybe<Scalars['JSON']>;
  readonly topicsFacets: ReadonlyArray<Topic>;
  readonly viewerCanUseFeature: Maybe<Scalars['Boolean']>;
};


export type SearchFeaturedProfileArgs = {
  query: InputMaybe<Scalars['String']>;
};


export type SearchFeaturedSummaryPrecedentArgs = {
  query: InputMaybe<Scalars['String']>;
};


export type SearchFeaturedTopicArgs = {
  query: InputMaybe<Scalars['String']>;
};


export type SearchTopicsFacetsArgs = {
  limit: InputMaybe<Scalars['Int']>;
};


export type SearchViewerCanUseFeatureArgs = {
  featureCode: InputMaybe<Scalars['String']>;
};

export type SearchDocumentsPagedConnection = {
  readonly __typename?: 'SearchDocumentsPagedConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<SearchDocumentsPagedEdge>>>;
  readonly pageInfo: PageInfo;
};

export type SearchDocumentsPagedEdge = {
  readonly __typename?: 'SearchDocumentsPagedEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<DocumentSearchSnippet>;
};

export type SearchEnrichedContent = {
  readonly __typename?: 'SearchEnrichedContent';
  readonly hits: Scalars['Int'];
  readonly items: ReadonlyArray<SearchEnrichedContentItem>;
};

export type SearchEnrichedContentItem = {
  readonly __typename?: 'SearchEnrichedContentItem';
  readonly document: Scalars['JSON'];
  readonly highlight: Maybe<Scalars['JSON']>;
};

export enum SearchKind {
  All = 'ALL',
  Article = 'ARTICLE',
  CommentedPrecedent = 'COMMENTED_PRECEDENT',
  Doctrine = 'DOCTRINE',
  General = 'GENERAL',
  Generic = 'GENERIC',
  Journal = 'JOURNAL',
  Jurisprudence = 'JURISPRUDENCE',
  Law = 'LAW',
  Lawsuit = 'LAWSUIT',
  LawsuitParty = 'LAWSUIT_PARTY',
  LawsuitPartyEntity = 'LAWSUIT_PARTY_ENTITY',
  Lgpd = 'LGPD',
  Model = 'MODEL',
  Motion = 'MOTION',
  News = 'NEWS',
  Precedent = 'PRECEDENT',
  Profile = 'PROFILE',
  SemanticPrecedent = 'SEMANTIC_PRECEDENT',
  Snippet = 'SNIPPET'
}

export type SearchLawsuitInput = {
  readonly appKind?: InputMaybe<FcmTokenAppKindType>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cnjNumber: Scalars['String'];
  readonly deviceId?: InputMaybe<Scalars['String']>;
  readonly entityId?: InputMaybe<Scalars['String']>;
  readonly platform?: InputMaybe<FcmTokenPlatformType>;
  readonly searchErrorThresholdInMinutes?: InputMaybe<Scalars['Int']>;
  readonly token?: InputMaybe<Scalars['String']>;
  readonly version?: InputMaybe<Scalars['String']>;
};

export type SearchLawsuitPayload = {
  readonly __typename?: 'SearchLawsuitPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuitHasCover: Scalars['Boolean'];
  readonly lawsuitId: Scalars['String'];
  readonly lawsuitNumber: Scalars['String'];
  readonly lawsuitUrl: Maybe<Scalars['String']>;
  readonly tid: Maybe<Scalars['Int']>;
};

export type SearchMetadata = ArticleMetadata | DoctrineMetadata | GenericMetadata | JournalMetadata | JurisprudenceMetadata | LgpdMetadata | LawMetadata | LawsuitMetadata | LawsuitPartyEntityMetadata | LawsuitPartyMetadata | ModelMetadata | MotionMetadata | NewsMetadata | ProfileMetadata | SnippetMetadata;

export type SearchMetadataAddons = {
  readonly __typename?: 'SearchMetadataAddons';
  readonly curatedHighlight: Maybe<Scalars['String']>;
  readonly legalThesis: ReadonlyArray<LegalThesis>;
  readonly legalThesisClusterLabels: ReadonlyArray<LegalThesisClusterLabels>;
  readonly plainFacts: Maybe<Scalars['String']>;
};

export type SearchMetadataAuthor = {
  readonly __typename?: 'SearchMetadataAuthor';
  readonly avatar: Scalars['String'];
  readonly name: Scalars['String'];
  readonly url: Scalars['String'];
  readonly userId: Scalars['String'];
  readonly username: Scalars['String'];
};


export type SearchMetadataAuthorAvatarArgs = {
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type SearchMetadataCourt = {
  readonly __typename?: 'SearchMetadataCourt';
  readonly acronym: Maybe<Scalars['String']>;
  readonly degree: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly states: Maybe<ReadonlyArray<Maybe<SearchMetadataState>>>;
  readonly type: Maybe<Scalars['String']>;
};

export type SearchMetadataCourtCounter = {
  readonly __typename?: 'SearchMetadataCourtCounter';
  readonly count: Scalars['Int'];
  readonly court: Scalars['String'];
  readonly courtMetadata: Maybe<SearchMetadataCourt>;
};

export type SearchMetadataDegreeCounter = {
  readonly __typename?: 'SearchMetadataDegreeCounter';
  readonly count: Scalars['Int'];
  readonly degree: Scalars['String'];
};

export type SearchMetadataFeatures = {
  readonly __typename?: 'SearchMetadataFeatures';
  readonly clickContext: Maybe<Scalars['String']>;
  readonly copyContext: Maybe<Scalars['String']>;
  readonly expandedCopyContext: Maybe<Scalars['String']>;
};

export type SearchMetadataLawsuitPartyEntityCandidacy = {
  readonly __typename?: 'SearchMetadataLawsuitPartyEntityCandidacy';
  readonly ballotName: Maybe<Scalars['String']>;
  readonly ballotNumber: Maybe<Scalars['String']>;
  readonly candidacyType: Maybe<Scalars['String']>;
  readonly electionYear: Maybe<Scalars['Int']>;
  readonly electoralDistrictName: Maybe<Scalars['String']>;
  readonly electoralDistrictUf: Maybe<Scalars['String']>;
  readonly entityId: Maybe<Scalars['String']>;
  readonly partyInitials: Maybe<Scalars['String']>;
  readonly partyName: Maybe<Scalars['String']>;
  readonly partyNumber: Maybe<Scalars['String']>;
  readonly tseId: Maybe<Scalars['String']>;
};

export type SearchMetadataLawyer = {
  readonly __typename?: 'SearchMetadataLawyer';
  readonly isAnonymized: Scalars['Boolean'];
  readonly lawyerId: Scalars['String'];
  readonly name: Scalars['String'];
  readonly oab: Maybe<Scalars['String']>;
  readonly topicId: Scalars['Int'];
};

export type SearchMetadataParent = {
  readonly __typename?: 'SearchMetadataParent';
  readonly body: Scalars['String'];
  readonly docId: Scalars['String'];
  readonly title: Scalars['String'];
  readonly url: Scalars['String'];
};

export type SearchMetadataPerson = {
  readonly __typename?: 'SearchMetadataPerson';
  readonly isAnonymized: Scalars['Boolean'];
  readonly isDeceased: Scalars['Boolean'];
  readonly name: Scalars['String'];
  readonly personId: Scalars['String'];
  readonly pole: Scalars['String'];
  readonly role: Scalars['String'];
  readonly topicId: Scalars['Int'];
  readonly type: Scalars['String'];
};

export type SearchMetadataPublicationPerson = {
  readonly __typename?: 'SearchMetadataPublicationPerson';
  readonly name: Scalars['String'];
  readonly publicationPersonId: Scalars['String'];
};

export type SearchMetadataRelatedPeopleCounter = {
  readonly __typename?: 'SearchMetadataRelatedPeopleCounter';
  readonly count: Scalars['Int'];
  readonly name: Scalars['String'];
};

export type SearchMetadataState = {
  readonly __typename?: 'SearchMetadataState';
  readonly acronym: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
};

export type SearchMetadataStateCounter = {
  readonly __typename?: 'SearchMetadataStateCounter';
  readonly count: Scalars['Int'];
  readonly state: Scalars['String'];
};

export type SearchMetadataTags = {
  readonly __typename?: 'SearchMetadataTags';
  readonly name: Scalars['String'];
  readonly tid: Scalars['String'];
  readonly type: Scalars['String'];
  readonly url: Maybe<Scalars['String']>;
};

export type SectionsVisibility = {
  readonly __typename?: 'SectionsVisibility';
  readonly academia: Maybe<Scalars['Boolean']>;
  readonly agenda: Maybe<Scalars['Boolean']>;
  readonly contacts: Maybe<Scalars['Boolean']>;
  readonly dealingOpportunities: Maybe<Scalars['Boolean']>;
  readonly documents: Maybe<Scalars['Boolean']>;
  readonly idox: Maybe<Scalars['Boolean']>;
  readonly lawsuits: Maybe<Scalars['Boolean']>;
  readonly metricsDashboard: Maybe<Scalars['Boolean']>;
  readonly myRequests: Maybe<Scalars['Boolean']>;
  readonly newOpportunities: Maybe<Scalars['Boolean']>;
  readonly notificationCenter: Maybe<Scalars['Boolean']>;
};

export enum SegmentationMode {
  Boost = 'BOOST',
  Disabled = 'DISABLED',
  Filter = 'FILTER'
}

export type SelectOrganizationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly organizationId: Scalars['Int'];
  readonly organizationType?: InputMaybe<Scalars['String']>;
};

export type SelectOrganizationPayload = {
  readonly __typename?: 'SelectOrganizationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly cookie: Maybe<Scalars['String']>;
  readonly expires: Maybe<Scalars['Float']>;
};

export type SendApprovedLegalCaseMailInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly legalCaseId: Scalars['Float'];
  readonly shouldChangeEmail: Scalars['Boolean'];
};

export type SendApprovedLegalCaseMailPayload = {
  readonly __typename?: 'SendApprovedLegalCaseMailPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly sent: Maybe<Scalars['Boolean']>;
  readonly user: Maybe<User>;
};

export type SendChangeDeviceNotAllowedEmailInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type SendChangeDeviceNotAllowedEmailPayload = {
  readonly __typename?: 'SendChangeDeviceNotAllowedEmailPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly email: Maybe<Scalars['String']>;
  readonly ip: Maybe<Scalars['String']>;
  readonly lastReplacementDate: Maybe<Scalars['String']>;
  readonly message: Maybe<Scalars['String']>;
  readonly nextAllowedReplacementDate: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
  readonly userAgent: Maybe<Scalars['String']>;
};

export type SendLastReplacementEmailInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type SendLastReplacementEmailPayload = {
  readonly __typename?: 'SendLastReplacementEmailPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly email: Maybe<Scalars['String']>;
  readonly ip: Maybe<Scalars['String']>;
  readonly lastReplacementDate: Maybe<Scalars['String']>;
  readonly message: Maybe<Scalars['String']>;
  readonly nextAllowedReplacementDate: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
  readonly userAgent: Maybe<Scalars['String']>;
};

export type SendLawsuitMonitoringSetupWhatsappMessageInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type SendLawsuitMonitoringSetupWhatsappMessagePayload = {
  readonly __typename?: 'SendLawsuitMonitoringSetupWhatsappMessagePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly message: Maybe<WhatsappMessage>;
};

export type SendLawsuitsReportInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly companyId: Scalars['Int'];
  readonly token: Scalars['String'];
};

export type SendLawsuitsReportPayload = {
  readonly __typename?: 'SendLawsuitsReportPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly sent: Maybe<Scalars['Boolean']>;
};

export type SendMessageInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly message: Scalars['String'];
  readonly receiverPid: Scalars['Float'];
};

export type SendMessagePayload = {
  readonly __typename?: 'SendMessagePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type SendOabTransferringEmailInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly currentUrl: Scalars['String'];
  readonly formFields: OabTransferringFormFieldsInput;
};

export type SendOabTransferringEmailPayload = {
  readonly __typename?: 'SendOabTransferringEmailPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
};

export type SendSignupEmailInput = {
  readonly app: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly email: Scalars['String'];
};

export type SendSignupEmailPayload = {
  readonly __typename?: 'SendSignupEmailPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type SendTimedCodeMailInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type SendTimedCodeMailPayload = {
  readonly __typename?: 'SendTimedCodeMailPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly email: Maybe<Scalars['String']>;
  readonly fallbackTimedEmailCode: Maybe<Scalars['String']>;
  readonly ip: Maybe<Scalars['String']>;
  readonly message: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
  readonly userAgent: Maybe<Scalars['String']>;
};

export type SentProfileLegalCasesDashboardConnection = {
  readonly __typename?: 'SentProfileLegalCasesDashboardConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<SentProfileLegalCasesDashboardEdge>>>;
  readonly pageInfo: PageInfo;
};

export type SentProfileLegalCasesDashboardEdge = {
  readonly __typename?: 'SentProfileLegalCasesDashboardEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<LegalCase>;
};

export type SentenceDevice = {
  readonly __typename?: 'SentenceDevice';
  readonly sentenceEntities: Maybe<ReadonlyArray<Maybe<SentenceEntities>>>;
  readonly text: Maybe<Scalars['String']>;
};

export type SentenceEntities = {
  readonly __typename?: 'SentenceEntities';
  readonly content: Maybe<Scalars['String']>;
  readonly end: Maybe<Scalars['Int']>;
  readonly start: Maybe<Scalars['Int']>;
  readonly tagName: Maybe<Scalars['String']>;
};

export type SerpSeoMetadata = {
  readonly __typename?: 'SerpSEOMetadata';
  readonly advertisable: Maybe<Scalars['Boolean']>;
  readonly artifact: Scalars['String'];
  readonly canonical_url: Maybe<Scalars['String']>;
  readonly indexable: Maybe<Scalars['Boolean']>;
  readonly query_id: Scalars['String'];
  readonly query_metadata_id: Scalars['String'];
  readonly redirectTo: Maybe<Scalars['String']>;
  readonly source: Maybe<Scalars['String']>;
};

export enum SerpSeoMetadataArtifacts {
  Artigos = 'ARTIGOS',
  ArtigosNoticias = 'ARTIGOS_NOTICIAS',
  Diarios = 'DIARIOS',
  Doutrina = 'DOUTRINA',
  General = 'GENERAL',
  Jurisprudencia = 'JURISPRUDENCIA',
  ModelosPecas = 'MODELOS_PECAS',
  Noticias = 'NOTICIAS',
  Pecas = 'PECAS'
}

export type SerpSeoMetadataBatchInput = {
  readonly artifact: Scalars['String'];
  readonly indexable: Scalars['Boolean'];
  readonly queryText: Scalars['String'];
  readonly redirectTo?: InputMaybe<Scalars['String']>;
};

export type SerpSummaryResult = {
  readonly __typename?: 'SerpSummaryResult';
  readonly authorUsername: Scalars['String'];
  readonly court: Scalars['String'];
  readonly date: Maybe<Scalars['String']>;
  readonly documentId: Scalars['String'];
  readonly isMandatoryPrecedent: Maybe<Scalars['Boolean']>;
  readonly rank: Maybe<Scalars['Int']>;
  readonly score: Maybe<Scalars['Float']>;
  readonly slug: Scalars['String'];
  readonly snippets: ReadonlyArray<Scalars['String']>;
  readonly title: Scalars['String'];
  readonly topThemes: ReadonlyArray<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly url: Scalars['String'];
};


export type SerpSummaryResultSnippetsArgs = {
  limit: InputMaybe<Scalars['Int']>;
};


export type SerpSummaryResultTopThemesArgs = {
  limit: InputMaybe<Scalars['Int']>;
};

export type Session = {
  readonly __typename?: 'Session';
  readonly activeSessions: ReadonlyArray<SessionData>;
  readonly check: Maybe<SessionCheckData>;
  readonly currentSession: SessionData;
  readonly isSoftBlocked: Maybe<Scalars['Boolean']>;
  readonly isTakingOver: Scalars['Boolean'];
  readonly lastReplacementDate: Scalars['String'];
  readonly nextAllowedReplacementDate: Scalars['String'];
  readonly orderCode: Scalars['String'];
  readonly pid: Scalars['Int'];
  readonly planId: Maybe<Scalars['Int']>;
};

export type SessionCheckData = {
  readonly __typename?: 'SessionCheckData';
  readonly lastReplacementDate: Scalars['String'];
  readonly message: Scalars['String'];
  readonly mustRedirectTo: Scalars['String'];
  readonly nextAllowedReplacementDate: Scalars['String'];
};

export type SessionData = {
  readonly __typename?: 'SessionData';
  readonly browser: Scalars['String'];
  readonly jdid: Scalars['String'];
  readonly lastActive: Scalars['String'];
  readonly mobile: Scalars['Boolean'];
  readonly os: Scalars['String'];
};

export type SetBackgroundCheckUserInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type SetBackgroundCheckUserPayload = {
  readonly __typename?: 'SetBackgroundCheckUserPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type SetCrmEntityImportanceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly entityId: Scalars['String'];
  readonly entityType: Scalars['String'];
  readonly importance: Scalars['String'];
  readonly profileId: Scalars['Int'];
};

export type SetCrmEntityImportancePayload = {
  readonly __typename?: 'SetCRMEntityImportancePayload';
  readonly CRMEntityImportance: Maybe<CrmEntityImportance>;
  readonly clientMutationId: Maybe<Scalars['String']>;
};

export type ShareableEntity = {
  readonly entityId: Maybe<Scalars['NumericID']>;
  readonly entityRefId: Maybe<Scalars['String']>;
  readonly entityRefType: Maybe<Scalars['String']>;
  readonly entityType: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly title: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
};

export type ShortlistDelMutationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly pid?: InputMaybe<Scalars['Int']>;
  readonly prefix: Scalars['String'];
  readonly username?: InputMaybe<Scalars['String']>;
};

export type ShortlistDelMutationPayload = {
  readonly __typename?: 'ShortlistDelMutationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly output: Maybe<Scalars['String']>;
};

export type ShortlistRenameMutationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly newPrefix: Scalars['String'];
  readonly oldPrefix: Scalars['String'];
};

export type ShortlistRenameMutationPayload = {
  readonly __typename?: 'ShortlistRenameMutationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly output: Maybe<Scalars['String']>;
};

export type ShortlistSetMutationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly pid?: InputMaybe<Scalars['Int']>;
  readonly prefix: Scalars['String'];
  readonly ttlSeconds: Scalars['Int'];
  readonly username?: InputMaybe<Scalars['String']>;
};

export type ShortlistSetMutationPayload = {
  readonly __typename?: 'ShortlistSetMutationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly output: Maybe<Scalars['String']>;
};

export type SignJournalPdfInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId: Scalars['Float'];
  readonly fromComponent?: InputMaybe<Scalars['String']>;
};

export type SignJournalPdfPayload = {
  readonly __typename?: 'SignJournalPdfPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly journalPdfPath: Maybe<Scalars['String']>;
};

export type SignJurisprudenceFileInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly fileInfo: Scalars['JSON'];
  readonly fromComponent?: InputMaybe<Scalars['String']>;
};

export type SignJurisprudenceFilePayload = {
  readonly __typename?: 'SignJurisprudenceFilePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly signedUrl: Maybe<Scalars['String']>;
};

export type SignMotionFileInput = {
  readonly bucket: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId: Scalars['String'];
  readonly fromComponent: Scalars['String'];
  readonly key: Scalars['String'];
  readonly storage: Scalars['String'];
};

export type SignMotionFilePayload = {
  readonly __typename?: 'SignMotionFilePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly signedUrl: Maybe<Scalars['String']>;
};

export type SignRjbFileInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly filename: Scalars['String'];
};

export type SignRjbFilePayload = {
  readonly __typename?: 'SignRJBFilePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly signedUrl: Maybe<Scalars['String']>;
};

export type SignResearchLabTermsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type SignResearchLabTermsPayload = {
  readonly __typename?: 'SignResearchLabTermsPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly signedUrl: Maybe<Scalars['String']>;
};

export type SignupInput = {
  readonly clientApp?: InputMaybe<GoogleAuthClients>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly firstname: Scalars['String'];
  readonly lastname: Scalars['String'];
  readonly nonce?: InputMaybe<Scalars['String']>;
  readonly occupationId?: InputMaybe<Scalars['Int']>;
  readonly password: Scalars['String'];
  readonly socialNetworkToken?: InputMaybe<Scalars['String']>;
  readonly socialNetworkType?: InputMaybe<SocialNetworkType>;
  readonly username: Scalars['String'];
};

export type SignupPayload = {
  readonly __typename?: 'SignupPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly cookie: Maybe<Scalars['String']>;
  readonly user: Maybe<User>;
};

export type SignupWithCpfFromAppleInput = {
  readonly app: Scalars['String'];
  readonly appleToken: Scalars['String'];
  readonly birthDate: Scalars['Int64'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cpf: Scalars['String'];
  readonly name: Scalars['String'];
  readonly nonce: Scalars['String'];
  readonly occupation: OccupationType;
  readonly phone?: InputMaybe<Scalars['String']>;
  readonly whatsAppOptIn?: InputMaybe<Scalars['Boolean']>;
};

export type SignupWithCpfFromApplePayload = {
  readonly __typename?: 'SignupWithCpfFromApplePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly cookie: Maybe<Scalars['String']>;
  readonly user: Maybe<User>;
};

export type SignupWithCpfFromGoogleInput = {
  readonly app: Scalars['String'];
  readonly birthDate: Scalars['Int64'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cpf: Scalars['String'];
  readonly googleToken: Scalars['String'];
  readonly name?: InputMaybe<Scalars['String']>;
  readonly occupation: OccupationType;
  readonly phone?: InputMaybe<Scalars['String']>;
  readonly whatsAppOptIn?: InputMaybe<Scalars['Boolean']>;
};

export type SignupWithCpfFromGooglePayload = {
  readonly __typename?: 'SignupWithCpfFromGooglePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly cookie: Maybe<Scalars['String']>;
  readonly user: Maybe<User>;
};

export type SignupWithCpfInput = {
  readonly app: Scalars['String'];
  readonly birthDate: Scalars['Int64'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cpf: Scalars['String'];
  readonly googleToken?: InputMaybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly occupation?: InputMaybe<OccupationType>;
  readonly password: Scalars['String'];
  readonly phone?: InputMaybe<Scalars['String']>;
  readonly token: Scalars['String'];
  readonly whatsAppOptIn?: InputMaybe<Scalars['Boolean']>;
};

export type SignupWithCpfPayload = {
  readonly __typename?: 'SignupWithCpfPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly cookie: Maybe<Scalars['String']>;
  readonly user: Maybe<User>;
};

export enum SkuStateType {
  Attachment = 'ATTACHMENT',
  Data = 'DATA',
  DisabledSku = 'DISABLED_SKU',
  Error = 'ERROR',
  None = 'NONE',
  NotFound = 'NOT_FOUND'
}

export type SmartLink = {
  readonly __typename?: 'SmartLink';
  readonly campaign: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly id: Maybe<Scalars['String']>;
  readonly keyName: Maybe<Scalars['String']>;
  readonly linkURL: Maybe<Scalars['String']>;
  readonly pid: Maybe<Scalars['Int']>;
  readonly status: Maybe<SmartLinkStatus>;
  readonly updatedAt: Maybe<Scalars['String']>;
};

export type SmartLinkEditInput = {
  readonly campaign?: InputMaybe<Scalars['String']>;
  readonly keyName?: InputMaybe<Scalars['String']>;
  readonly linkURL?: InputMaybe<Scalars['String']>;
  readonly status?: InputMaybe<SmartLinkStatus>;
};

export enum SmartLinkSortBy {
  Campaign = 'campaign',
  CreatedAt = 'createdAt',
  KeyName = 'keyName',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export enum SmartLinkSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SmartLinkStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type SmartLinksList = {
  readonly __typename?: 'SmartLinksList';
  readonly items: ReadonlyArray<SmartLink>;
  readonly page: Maybe<Scalars['Int']>;
  readonly pageSize: Maybe<Scalars['Int']>;
};

export type SmartSearchSimilarDocumentsResult = {
  readonly __typename?: 'SmartSearchSimilarDocumentsResult';
  readonly query: Maybe<Scalars['String']>;
  readonly searchResults: Maybe<Scalars['JSON']>;
};

export type SnippetMetadata = {
  readonly __typename?: 'SnippetMetadata';
  readonly author: SearchMetadataAuthor;
  readonly body: Maybe<Scalars['String']>;
  readonly date: Maybe<Scalars['Float']>;
  readonly docId: Scalars['String'];
  readonly highlight: Maybe<Scalars['String']>;
  readonly slug: Scalars['String'];
  readonly title: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly url: Scalars['String'];
};


export type SnippetMetadataBodyArgs = {
  maxLength: InputMaybe<Scalars['Int']>;
  preferHighlight?: InputMaybe<Scalars['Boolean']>;
};

export type SocialConnection = {
  readonly __typename?: 'SocialConnection';
  readonly network: Maybe<Scalars['String']>;
  readonly networkId: Maybe<Scalars['String']>;
  readonly pid: Maybe<Scalars['Float']>;
  readonly user: Maybe<User>;
};

export type SocialConnectionsConnection = {
  readonly __typename?: 'SocialConnectionsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<SocialConnectionsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type SocialConnectionsEdge = {
  readonly __typename?: 'SocialConnectionsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<SocialConnection>;
};

export enum SocialNetworkType {
  Apple = 'APPLE',
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE',
  Linkedin = 'LINKEDIN'
}

export type SortInput = {
  readonly field: Scalars['String'];
  readonly order?: InputMaybe<SortOrder>;
};

export type SortOptionsType = {
  readonly ascending?: InputMaybe<Scalars['Boolean']>;
  readonly field?: InputMaybe<Scalars['String']>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc',
  Random = 'random'
}

export type SourceDocumentsConnection = {
  readonly __typename?: 'SourceDocumentsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<SourceDocumentsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type SourceDocumentsEdge = {
  readonly __typename?: 'SourceDocumentsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Document>;
};

export type StartLawsuitSearchInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly filterOabNumber?: InputMaybe<Scalars['Int']>;
  readonly filterOabUF?: InputMaybe<Scalars['String']>;
  readonly monitoringIntentionActive?: InputMaybe<Scalars['Boolean']>;
  readonly searchType?: InputMaybe<Scalars['String']>;
  readonly terms: Scalars['JSON'];
};

export type StartLawsuitSearchPayload = {
  readonly __typename?: 'StartLawsuitSearchPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly existingOabMonitored: Maybe<PublicationAlert>;
  readonly lawsuitSearch: Maybe<CrmLawsuitSearch>;
  readonly organization: Maybe<Organization>;
};

export type StartMonitoringCpfInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly entityId: Scalars['String'];
};

export type StartMonitoringCpfPayload = {
  readonly __typename?: 'StartMonitoringCpfPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
};

export type StartNotificationFlowInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly flowType: Scalars['String'];
  readonly notificationData?: InputMaybe<Scalars['JSON']>;
  readonly originData: Scalars['JSON'];
  readonly profileId: Scalars['Int'];
};

export type StartNotificationFlowPayload = {
  readonly __typename?: 'StartNotificationFlowPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly flows: Maybe<ReadonlyArray<Maybe<Scalars['JSON']>>>;
};

export type StartingPrice = {
  readonly __typename?: 'StartingPrice';
  readonly text: Scalars['String'];
  readonly title: Scalars['String'];
};

export type Stat = {
  readonly __typename?: 'Stat';
  readonly count: Maybe<Scalars['Float']>;
  readonly events: Maybe<ReadonlyArray<Maybe<Event>>>;
  readonly histogram: Maybe<Scalars['JSON']>;
};


export type StatCountArgs = {
  from: InputMaybe<Scalars['JSON']>;
  to: InputMaybe<Scalars['JSON']>;
};


export type StatEventsArgs = {
  limit: Scalars['Int'];
};


export type StatHistogramArgs = {
  from: InputMaybe<Scalars['JSON']>;
  resolution: InputMaybe<Scalars['String']>;
  to: InputMaybe<Scalars['JSON']>;
};

export enum StateEnum {
  Ac = 'AC',
  Al = 'AL',
  Am = 'AM',
  Ap = 'AP',
  Ba = 'BA',
  Ce = 'CE',
  Df = 'DF',
  Es = 'ES',
  Go = 'GO',
  Ma = 'MA',
  Mg = 'MG',
  Ms = 'MS',
  Mt = 'MT',
  Pa = 'PA',
  Pb = 'PB',
  Pe = 'PE',
  Pi = 'PI',
  Pr = 'PR',
  Rj = 'RJ',
  Rn = 'RN',
  Ro = 'RO',
  Rr = 'RR',
  Rs = 'RS',
  Sc = 'SC',
  Se = 'SE',
  Sp = 'SP',
  To = 'TO'
}

export type StaticSerp = {
  readonly __typename?: 'StaticSerp';
  readonly relatedQueries: ReadonlyArray<Scalars['String']>;
  readonly results: ReadonlyArray<Maybe<SerpSummaryResult>>;
};


export type StaticSerpResultsArgs = {
  limit: InputMaybe<Scalars['Int']>;
};

export type StaticSerpGroup = {
  readonly __typename?: 'StaticSerpGroup';
  readonly artifact: Scalars['String'];
  readonly data: Maybe<StaticSerp>;
};

export type StaticSerpRelatedQuestions = {
  readonly __typename?: 'StaticSerpRelatedQuestions';
  readonly answer: Scalars['String'];
  readonly question: Scalars['String'];
  readonly source: StaticSerpSource;
};

export type StaticSerpSource = {
  readonly __typename?: 'StaticSerpSource';
  readonly artifactType: Scalars['String'];
  readonly court: Maybe<Scalars['String']>;
  readonly documentArtifact: Maybe<Scalars['String']>;
  readonly documentId: Scalars['String'];
  readonly publicationDate: Maybe<Scalars['Float']>;
  readonly tags: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly title: Scalars['String'];
  readonly url: Scalars['String'];
};

export type StaticSerpSummary = {
  readonly __typename?: 'StaticSerpSummary';
  readonly sources: ReadonlyArray<StaticSerpSource>;
  readonly text: Scalars['String'];
};

export type StopMonitoringCrmLawsuitInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
};

export type StopMonitoringCrmLawsuitPayload = {
  readonly __typename?: 'StopMonitoringCRMLawsuitPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
  readonly lawsuitEdge: Maybe<OrganizationLawsuitsEdge>;
  readonly organization: Maybe<Organization>;
};

export type StopMonitoringCpfInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly entityId: Scalars['String'];
};

export type StopMonitoringCpfPayload = {
  readonly __typename?: 'StopMonitoringCpfPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
};

export type StudentBenefit = {
  readonly __typename?: 'StudentBenefit';
  readonly benefitExpiresAt: Maybe<Scalars['Float']>;
  readonly benefitGrantedAt: Maybe<Scalars['Float']>;
  readonly course: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly effectiveStatus: Maybe<StudentBenefitStatusEnum>;
  readonly enrollmentPeriod: Maybe<Scalars['String']>;
  readonly experimentVariant: Maybe<Scalars['String']>;
  readonly id: Maybe<Scalars['Int']>;
  readonly institution: Maybe<Scalars['String']>;
  readonly pid: Maybe<Scalars['Int']>;
  readonly profile: Maybe<Profile>;
  readonly rejectionReason: Maybe<Scalars['String']>;
  readonly retryCountEnrollment: Maybe<Scalars['Int']>;
  readonly status: Maybe<StudentBenefitStatusEnum>;
};

export type StudentBenefitList = {
  readonly __typename?: 'StudentBenefitList';
  readonly data: ReadonlyArray<StudentBenefit>;
  readonly limit: Scalars['Int'];
  readonly offset: Scalars['Int'];
  readonly total: Scalars['Int'];
};

export enum StudentBenefitStatusEnum {
  BenefitActivated = 'benefit_activated',
  Cancelled = 'cancelled',
  CpfOtherAccount = 'cpf_other_account',
  Eligible = 'eligible',
  EnrollmentVerified = 'enrollment_verified',
  Expired = 'expired',
  IdentityVerified = 'identity_verified',
  Pending = 'pending',
  Rejected = 'rejected',
  Waitlisted = 'waitlisted'
}

export enum StudentEnrollmentRejectionReasonEnum {
  DocumentUnreadable = 'DOCUMENT_UNREADABLE',
  EnrollmentNotActive = 'ENROLLMENT_NOT_ACTIVE',
  InstitutionNotAllowed = 'INSTITUTION_NOT_ALLOWED',
  InstitutionNotIdentified = 'INSTITUTION_NOT_IDENTIFIED',
  LowConfidenceContent = 'LOW_CONFIDENCE_CONTENT',
  NameMismatch = 'NAME_MISMATCH',
  NotEnrollmentProof = 'NOT_ENROLLMENT_PROOF',
  NotLawUndergraduate = 'NOT_LAW_UNDERGRADUATE'
}

export type SubmitData = {
  readonly __typename?: 'SubmitData';
  readonly hash: Scalars['String'];
  readonly jwt: Scalars['String'];
  readonly submitUrl: Scalars['String'];
};

export type SubmitDataType = {
  readonly __typename?: 'SubmitDataType';
  readonly jwt: Maybe<Scalars['String']>;
  readonly submitUrl: Maybe<Scalars['String']>;
};

export type SubmitStudentAcademicDataInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly course: Scalars['String'];
  readonly enrollmentPeriod: Scalars['String'];
  readonly institution: Scalars['String'];
};

export type SubmitStudentAcademicDataPayload = {
  readonly __typename?: 'SubmitStudentAcademicDataPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly status: Maybe<StudentBenefitStatusEnum>;
};

export type SubscribeAnnualLp = {
  readonly __typename?: 'SubscribeAnnualLP';
  readonly comparePlans: Maybe<SubscribeProLpComparePlans>;
  readonly currentPlanId: Maybe<Scalars['Int']>;
  readonly faq: SubscribeAnnualLpfaq;
  readonly features: SubscribeAnnualLpFeatures;
  readonly footer: SubscribeAnnualLpFooter;
  readonly hero: SubscribeAnnualLpHero;
  readonly jusiaSection: SubscribeAnnualLpJusIaSection;
  readonly landingPageCards: ReadonlyArray<SubscribeAnnualLpCard>;
  readonly planSubscription: Maybe<PlanSubscriptionType>;
  readonly plansSection: SubscribeAnnualLpPlansSection;
  readonly redirectUrl: Maybe<Scalars['String']>;
};

export type SubscribeAnnualLpButton = {
  readonly __typename?: 'SubscribeAnnualLPButton';
  readonly kind: Maybe<ButtonKindEnum>;
  readonly label: Scalars['String'];
};

export type SubscribeAnnualLpCard = {
  readonly __typename?: 'SubscribeAnnualLPCard';
  readonly benefitsList: ReadonlyArray<Scalars['String']>;
  readonly button: SubscribeAnnualLpButton;
  readonly discountLabel: Maybe<Scalars['String']>;
  readonly highlightText: Maybe<Scalars['String']>;
  readonly offer: SubscribeAnnualLpOffer;
  readonly planId: Maybe<Scalars['Int']>;
  readonly planType: Maybe<PlanSubscriptionType>;
  readonly savingsText: Maybe<Scalars['String']>;
  readonly segment: Maybe<Scalars['String']>;
  readonly submitData: SubscribeAnnualLpSubmitData;
  readonly tags: ReadonlyArray<Scalars['String']>;
  readonly templateId: Maybe<Scalars['Int']>;
};

export type SubscribeAnnualLpfaq = {
  readonly __typename?: 'SubscribeAnnualLPFAQ';
  readonly description: Scalars['String'];
  readonly questions: ReadonlyArray<SubscribeAnnualLpfaqQuestion>;
  readonly title: Scalars['String'];
};

export type SubscribeAnnualLpfaqQuestion = {
  readonly __typename?: 'SubscribeAnnualLPFAQQuestion';
  readonly body: ReadonlyArray<Scalars['String']>;
  readonly title: Scalars['String'];
};

export type SubscribeAnnualLpFeatures = {
  readonly __typename?: 'SubscribeAnnualLPFeatures';
  readonly aiFeatureDescription: Scalars['String'];
  readonly pageTitle: Scalars['String'];
  readonly primaryServiceDescription: Scalars['String'];
  readonly stats: ReadonlyArray<SubscribeAnnualLpStat>;
};

export type SubscribeAnnualLpFooter = {
  readonly __typename?: 'SubscribeAnnualLPFooter';
  readonly linkText: Maybe<Scalars['String']>;
  readonly linkUrl: Maybe<Scalars['String']>;
  readonly supportLinkUrl: Maybe<Scalars['String']>;
  readonly supportText: Maybe<Scalars['String']>;
  readonly text: Scalars['String'];
};

export type SubscribeAnnualLpHero = {
  readonly __typename?: 'SubscribeAnnualLPHero';
  readonly badgeText: Scalars['String'];
  readonly ctaButtonText: Scalars['String'];
  readonly discountPercentage: Maybe<Scalars['Int']>;
  readonly headline: Scalars['String'];
  readonly subtitle: Scalars['String'];
};

export type SubscribeAnnualLpJusIaFeature = {
  readonly __typename?: 'SubscribeAnnualLPJusIAFeature';
  readonly description: Scalars['String'];
  readonly icon: Scalars['String'];
  readonly title: Scalars['String'];
};

export type SubscribeAnnualLpJusIaSection = {
  readonly __typename?: 'SubscribeAnnualLPJusIASection';
  readonly ctaButtonText: Scalars['String'];
  readonly features: ReadonlyArray<SubscribeAnnualLpJusIaFeature>;
  readonly subtitle: Scalars['String'];
  readonly testimonial: SubscribeAnnualLpJusiaTestimonial;
  readonly title: Scalars['String'];
};

export type SubscribeAnnualLpJusiaTestimonial = {
  readonly __typename?: 'SubscribeAnnualLPJusiaTestimonial';
  readonly author: Scalars['String'];
  readonly avatarUrl: Scalars['String'];
  readonly quote: Scalars['String'];
  readonly role: Scalars['String'];
};

export type SubscribeAnnualLpOffer = {
  readonly __typename?: 'SubscribeAnnualLPOffer';
  readonly currentPlanHelpText: Maybe<Scalars['String']>;
  readonly frequency: Maybe<Scalars['String']>;
  readonly frequencyPeriodText: Maybe<Scalars['String']>;
  readonly installmentsText: Maybe<Scalars['String']>;
  readonly isCurrentPlan: Maybe<Scalars['Boolean']>;
  readonly isJusAIOffer: Maybe<Scalars['Boolean']>;
  readonly presentationDescription: Maybe<Scalars['String']>;
  readonly presentationName: Scalars['String'];
  readonly priceAfterPromotionalPeriodText: Maybe<Scalars['String']>;
  readonly pricePerInstallments: Maybe<Scalars['String']>;
  readonly priceText: Maybe<Scalars['String']>;
  readonly priceTitle: Maybe<Scalars['String']>;
  readonly promotional: Maybe<Scalars['Boolean']>;
  readonly upgradeAdditionalPriceText: Maybe<Scalars['String']>;
};

export type SubscribeAnnualLpPlansSection = {
  readonly __typename?: 'SubscribeAnnualLPPlansSection';
  readonly subtitle: Scalars['String'];
  readonly title: Scalars['String'];
};

export type SubscribeAnnualLpStat = {
  readonly __typename?: 'SubscribeAnnualLPStat';
  readonly label: Scalars['String'];
  readonly value: Scalars['String'];
};

export type SubscribeAnnualLpSubmitData = {
  readonly __typename?: 'SubscribeAnnualLPSubmitData';
  readonly hash: Scalars['String'];
  readonly jwt: Scalars['String'];
  readonly submitUrl: Scalars['String'];
};

export type SubscribeDoctrineLp = {
  readonly __typename?: 'SubscribeDoctrineLP';
  readonly hero: SubscribeDoctrineLpHero;
  readonly planGroupId: Maybe<Scalars['Int']>;
  readonly planOffer: ReadonlyArray<Maybe<SubscribeDoctrineLpOffer>>;
  readonly planSubscription: Maybe<PlanSubscriptionType>;
  readonly submitData: ReadonlyArray<Maybe<SubmitData>>;
  readonly toggle: Maybe<Toggle>;
  readonly topbar: SubscribeDoctrineLpTopbar;
  readonly userPlanStatus: Maybe<UserPlanStatusType>;
};

export type SubscribeDoctrineLpHero = {
  readonly __typename?: 'SubscribeDoctrineLPHero';
  readonly alternativeText: Scalars['String'];
  readonly currentPlanHelpText: Maybe<Scalars['String']>;
  readonly promotionalHelpText: Maybe<Scalars['String']>;
  readonly text: Scalars['String'];
};

export type SubscribeDoctrineLpOffer = {
  readonly __typename?: 'SubscribeDoctrineLPOffer';
  readonly benefits: ReadonlyArray<Maybe<Scalars['String']>>;
  readonly ctaAlternativeText: Scalars['String'];
  readonly ctaText: Scalars['String'];
  readonly currentPlanPrice: Maybe<Scalars['String']>;
  readonly description: Scalars['String'];
  readonly frequencyLabel: Maybe<Scalars['String']>;
  readonly helpText: Maybe<Scalars['String']>;
  readonly installments: Maybe<Scalars['String']>;
  readonly isYearlyPlan: Maybe<Scalars['Boolean']>;
  readonly name: Scalars['String'];
  readonly price: Maybe<Scalars['String']>;
  readonly pricePerInstallments: Maybe<Scalars['String']>;
  readonly priceSubtitle: Scalars['String'];
  readonly promotional: Maybe<Scalars['Boolean']>;
  readonly promotionalHelpText: Maybe<Scalars['String']>;
  readonly renewMessage: Maybe<Scalars['String']>;
};

export type SubscribeDoctrineLpTopbar = {
  readonly __typename?: 'SubscribeDoctrineLPTopbar';
  readonly alternativeText: Scalars['String'];
  readonly text: Scalars['String'];
};

export type SubscribeLink = {
  readonly __typename?: 'SubscribeLink';
  readonly isJusIA: Maybe<Scalars['Boolean']>;
  readonly label: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
};

export type SubscribeOabPartnershipLp = {
  readonly __typename?: 'SubscribeOABPartnershipLP';
  readonly advancedPlanOffer: SubscribeOabPartnershipLpOffer;
  readonly aiPlanOffer: SubscribeOabPartnershipLpOffer;
  readonly basicPlanOffer: SubscribeOabPartnershipLpOffer;
  readonly footer: SubscribeOabPartnershipLpFooter;
  readonly hasPixSubscription: Maybe<Scalars['Boolean']>;
  readonly hero: SubscribeOabPartnershipLpHero;
  readonly inviteId: Maybe<Scalars['String']>;
  readonly isInOABPartnershipOffersPlanGroup: Maybe<Scalars['Boolean']>;
  readonly partnershipStatus: Maybe<OabPartnershipStatusType>;
  readonly planCommonConfig: SubscribeOabPartnershipLpCommonConfig;
  readonly planSubscription: Maybe<PlanSubscriptionType>;
  readonly topbar: SubscribeOabPartnershipLpTopbar;
};

export type SubscribeOabPartnershipLpCommonConfig = {
  readonly __typename?: 'SubscribeOABPartnershipLPCommonConfig';
  readonly frequencyLabel: Scalars['String'];
  readonly installmentsText: Scalars['String'];
  readonly priceSubtitle: Scalars['String'];
};

export type SubscribeOabPartnershipLpFooter = {
  readonly __typename?: 'SubscribeOABPartnershipLPFooter';
  readonly text: Scalars['String'];
};

export type SubscribeOabPartnershipLpHero = {
  readonly __typename?: 'SubscribeOABPartnershipLPHero';
  readonly alternativeText: Scalars['String'];
  readonly text: Scalars['String'];
};

export type SubscribeOabPartnershipLpOffer = {
  readonly __typename?: 'SubscribeOABPartnershipLPOffer';
  readonly benefits: ReadonlyArray<Maybe<Scalars['String']>>;
  readonly ctaAlternativeText: Scalars['String'];
  readonly ctaText: Scalars['String'];
  readonly discountLabel: Maybe<Scalars['String']>;
  readonly highlightText: Maybe<Scalars['String']>;
  readonly isAvailable: Maybe<Scalars['Boolean']>;
  readonly name: Scalars['String'];
  readonly pixPriceText: Maybe<Scalars['String']>;
  readonly presentationDescription: Maybe<Scalars['String']>;
  readonly price: Maybe<Scalars['String']>;
  readonly pricePerInstallments: Maybe<Scalars['String']>;
  readonly priceTitle: Maybe<Scalars['String']>;
  readonly submitData: SubmitData;
};

export type SubscribeOabPartnershipLpTopbar = {
  readonly __typename?: 'SubscribeOABPartnershipLPTopbar';
  readonly alternativeText: Scalars['String'];
  readonly loginButtonText: Scalars['String'];
  readonly subscribeButtonText: Scalars['String'];
};

export type SubscribeProLp = {
  readonly __typename?: 'SubscribeProLP';
  readonly annualOfferBanner: Maybe<SubscribeProLpAnnualBanner>;
  readonly comparePlans: Maybe<SubscribeProLpComparePlans>;
  readonly contentOrgs: Maybe<SubscribeProLpContentOrgs>;
  readonly faq: SubscribeProLpFaq;
  readonly jusAiSection: Maybe<SubscribeProLpJusAiSection>;
  readonly layoutVariant: Maybe<LayoutVariantEnum>;
  readonly offersSection: SubscribeProLpOffersSection;
  readonly seo: SubscribeProLpSeo;
  readonly socialProof: SubscribeProLpSocialProof;
  readonly socialUsage: Maybe<SubscribeProLpSocialUsage>;
};

export type SubscribeProLpAnnualBanner = {
  readonly __typename?: 'SubscribeProLPAnnualBanner';
  readonly chipLabel: Scalars['String'];
  readonly ctaLabel: Scalars['String'];
  readonly description: Scalars['String'];
  readonly title: Scalars['String'];
};

export type SubscribeProLpCompareCell = {
  readonly __typename?: 'SubscribeProLPCompareCell';
  readonly helpText: Maybe<Scalars['String']>;
  readonly iconName: Maybe<Scalars['String']>;
  readonly text: Maybe<Scalars['String']>;
};

export type SubscribeProLpCompareColumnHeader = {
  readonly __typename?: 'SubscribeProLPCompareColumnHeader';
  readonly iconName: Maybe<Scalars['String']>;
  readonly label: Scalars['String'];
};

export type SubscribeProLpComparePlans = {
  readonly __typename?: 'SubscribeProLPComparePlans';
  readonly caseTracking: ReadonlyArray<SubscribeProLpCompareTable>;
  readonly legalResearch: ReadonlyArray<SubscribeProLpCompareTable>;
  readonly sectionTitle: Scalars['String'];
};

export type SubscribeProLpCompareRow = {
  readonly __typename?: 'SubscribeProLPCompareRow';
  readonly cells: ReadonlyArray<SubscribeProLpCompareCell>;
};

export type SubscribeProLpCompareTable = {
  readonly __typename?: 'SubscribeProLPCompareTable';
  readonly columnHeaders: ReadonlyArray<SubscribeProLpCompareColumnHeader>;
  readonly rows: ReadonlyArray<SubscribeProLpCompareRow>;
};

export type SubscribeProLpContentOrgs = {
  readonly __typename?: 'SubscribeProLPContentOrgs';
  readonly ctaLabel: Scalars['String'];
  readonly description: Scalars['String'];
  readonly title: Scalars['String'];
};

export type SubscribeProLpFaq = {
  readonly __typename?: 'SubscribeProLPFaq';
  readonly caseTracking: ReadonlyArray<SubscribeProLpFaqItem>;
  readonly legalResearch: ReadonlyArray<SubscribeProLpFaqItem>;
};

export type SubscribeProLpFaqItem = {
  readonly __typename?: 'SubscribeProLPFaqItem';
  readonly answer: Scalars['String'];
  readonly question: Scalars['String'];
};

export type SubscribeProLpJusAiFeature = {
  readonly __typename?: 'SubscribeProLPJusAiFeature';
  readonly description: Scalars['String'];
  readonly title: Scalars['String'];
};

export type SubscribeProLpJusAiSection = {
  readonly __typename?: 'SubscribeProLPJusAiSection';
  readonly ctaButtonText: Scalars['String'];
  readonly features: ReadonlyArray<SubscribeProLpJusAiFeature>;
  readonly subtitle: Maybe<Scalars['String']>;
  readonly title: Scalars['String'];
};

export type SubscribeProLpOffersSection = {
  readonly __typename?: 'SubscribeProLPOffersSection';
  readonly header: SubscribeProLpOffersSectionHeader;
  readonly landingPageOffers: LandingPageOffers;
  readonly renewalDisclaimer: SubscribeProLpRenewalDisclaimer;
};

export type SubscribeProLpOffersSectionHeader = {
  readonly __typename?: 'SubscribeProLPOffersSectionHeader';
  readonly subtitle: Maybe<Scalars['String']>;
  readonly title: Scalars['String'];
};

export type SubscribeProLpRenewalDisclaimer = {
  readonly __typename?: 'SubscribeProLPRenewalDisclaimer';
  readonly monthlyText: Scalars['String'];
  readonly yearlyText: Scalars['String'];
};

export type SubscribeProLpSeo = {
  readonly __typename?: 'SubscribeProLPSeo';
  readonly pageTitle: Scalars['String'];
};

export type SubscribeProLpSocialProof = {
  readonly __typename?: 'SubscribeProLPSocialProof';
  readonly caseTracking: SubscribeProLpSocialProofSegment;
  readonly legalResearch: SubscribeProLpSocialProofSegment;
};

export type SubscribeProLpSocialProofSegment = {
  readonly __typename?: 'SubscribeProLPSocialProofSegment';
  readonly testimonials: ReadonlyArray<SubscribeProLpTestimonial>;
  readonly title: Scalars['String'];
};

export type SubscribeProLpSocialUsage = {
  readonly __typename?: 'SubscribeProLPSocialUsage';
  readonly items: ReadonlyArray<SubscribeProLpSocialUsageItem>;
  readonly title: Scalars['String'];
};

export type SubscribeProLpSocialUsageItem = {
  readonly __typename?: 'SubscribeProLPSocialUsageItem';
  readonly description: Scalars['String'];
  readonly iconName: Scalars['String'];
  readonly title: Scalars['String'];
};

export type SubscribeProLpTestimonial = {
  readonly __typename?: 'SubscribeProLPTestimonial';
  readonly authorName: Scalars['String'];
  readonly authorRole: Maybe<Scalars['String']>;
  readonly quote: Scalars['String'];
};

export type SubscribeToCpfMonitoringInput = {
  readonly birthDate?: InputMaybe<Scalars['String']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cpf: Scalars['String'];
  readonly fullName: Scalars['String'];
  readonly phone: Scalars['String'];
};

export type SubscribeToCpfMonitoringPayload = {
  readonly __typename?: 'SubscribeToCpfMonitoringPayload';
  readonly alreadyHasActiveMonitoring: Maybe<Scalars['Boolean']>;
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly personPageUrl: Maybe<Scalars['String']>;
};

export type SubscriptionChangePlanInput = {
  readonly changeType?: InputMaybe<SubscriptionChangeType>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly currentSubscriptionId: Scalars['NumericID'];
  readonly orderCode?: InputMaybe<Scalars['String']>;
  readonly toPlanGroupId: Scalars['Int'];
  readonly toPlanId: Scalars['Int'];
};

export type SubscriptionChangePlanPayload = {
  readonly __typename?: 'SubscriptionChangePlanPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export enum SubscriptionChangeType {
  DelayedChange = 'DELAYED_CHANGE',
  ImmediateChange = 'IMMEDIATE_CHANGE'
}

export type SubscriptionInconsistency = {
  readonly __typename?: 'SubscriptionInconsistency';
  readonly autoResolvable: Maybe<Scalars['Boolean']>;
  readonly clientId: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly details: Maybe<Scalars['JSON']>;
  readonly id: Maybe<Scalars['String']>;
  readonly orderCode: Maybe<Scalars['String']>;
  readonly resolvedAt: Maybe<Scalars['String']>;
  readonly resolvedBy: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly type: Maybe<Scalars['String']>;
};

export type SuggestionItem = {
  readonly __typename?: 'SuggestionItem';
  readonly score: Maybe<Scalars['Float']>;
  readonly suggestion: Scalars['String'];
};

export enum SuitsStatusType {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Finished = 'FINISHED',
  Hidden = 'HIDDEN',
  Hired = 'HIRED',
  Inactive = 'INACTIVE',
  Merged = 'MERGED',
  Pending = 'PENDING',
  Searched = 'SEARCHED'
}

export type SummaryPrecedentSearchSnippet = {
  readonly __typename?: 'SummaryPrecedentSearchSnippet';
  readonly statement: Maybe<Scalars['String']>;
  readonly statusLabel: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['Float']>;
};

export enum SupportPlatform {
  AppLawsuit = 'APP_LAWSUIT',
  AppOnlineOffice = 'APP_ONLINE_OFFICE',
  Others = 'OTHERS',
  SiteJusbrasil = 'SITE_JUSBRASIL'
}

export type SuspendStudentBenefitAsAdminInput = {
  readonly benefitId: Scalars['Int'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type SuspendStudentBenefitAsAdminPayload = {
  readonly __typename?: 'SuspendStudentBenefitAsAdminPayload';
  readonly boxSubscriptionsCancelled: Scalars['Int'];
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly studentBenefit: StudentBenefit;
};

export type Tag = Node & {
  readonly __typename?: 'Tag';
  readonly id: Scalars['ID'];
  readonly identifier: Maybe<Scalars['String']>;
  readonly topics: Maybe<TagTopicsConnection>;
};


export type TagTopicsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};

export type TagTopicsConnection = {
  readonly __typename?: 'TagTopicsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<TagTopicsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type TagTopicsEdge = {
  readonly __typename?: 'TagTopicsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Topic>;
};

export type TagsConnection = {
  readonly __typename?: 'TagsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<TagsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type TagsEdge = {
  readonly __typename?: 'TagsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Tag>;
};

export type TakeOverInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly pid: Scalars['Float'];
};

export type TakeOverPayload = {
  readonly __typename?: 'TakeOverPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly cookie: Maybe<Scalars['String']>;
  readonly userData: Maybe<Scalars['JSON']>;
  readonly userDataItemKey: Maybe<Scalars['String']>;
};

export type TargetPlanInputType = {
  readonly id?: InputMaybe<Scalars['Int']>;
  readonly price?: InputMaybe<Scalars['Float']>;
  readonly promotional?: InputMaybe<Scalars['Boolean']>;
  readonly templateId?: InputMaybe<Scalars['Int']>;
};

export type TemporaryOffer = {
  readonly __typename?: 'TemporaryOffer';
  readonly isAlreadySubscribed: Maybe<Scalars['Boolean']>;
  readonly offer: Maybe<Offer>;
};

export type TemporaryOfferBanner = {
  readonly __typename?: 'TemporaryOfferBanner';
  readonly cta: TemporaryOfferBannerCta;
  readonly subtitle: Scalars['String'];
  readonly title: Scalars['String'];
  readonly type: Scalars['String'];
};

export type TemporaryOfferBannerCta = {
  readonly __typename?: 'TemporaryOfferBannerCTA';
  readonly label: Scalars['String'];
  readonly link: Scalars['String'];
};

export enum TemporaryOfferType {
  ExpressoTrabalhista = 'EXPRESSO_TRABALHISTA',
  ExpressoTributario = 'EXPRESSO_TRIBUTARIO'
}

export type TextPosition = {
  readonly __typename?: 'TextPosition';
  readonly end: Scalars['Int'];
  readonly start: Scalars['Int'];
};

export type Thesis = {
  readonly __typename?: 'Thesis';
  readonly author: Maybe<Scalars['String']>;
  readonly chips: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly commentary: Maybe<Commentary>;
  readonly court: Maybe<Scalars['String']>;
  readonly networkDocument: Maybe<Document>;
  readonly relatedDocuments: Maybe<ReadonlyArray<Maybe<Document>>>;
  readonly text: Maybe<Scalars['String']>;
  readonly thesisId: Maybe<Scalars['NumericID']>;
  readonly yearsRange: Maybe<YearsRange>;
};

export type ThesisFilterInput = {
  readonly ensureHasChips?: InputMaybe<Scalars['Boolean']>;
  readonly ensureHasComment?: InputMaybe<Scalars['Boolean']>;
  readonly ensureHasNetworkDocId?: InputMaybe<Scalars['Boolean']>;
  readonly ensureHasRelatedDocs?: InputMaybe<Scalars['Boolean']>;
  readonly ensureHasThesisText?: InputMaybe<Scalars['Boolean']>;
  readonly ensureHasYearsRange?: InputMaybe<Scalars['Boolean']>;
};

export type ThreadType = {
  readonly __typename?: 'ThreadType';
  readonly id: Maybe<Scalars['String']>;
  readonly resourceId: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
};

export type ThumborImage = {
  readonly __typename?: 'ThumborImage';
  readonly directUrl: Maybe<Scalars['String']>;
  readonly isDefined: Maybe<Scalars['Boolean']>;
  readonly originalUrl: Maybe<Scalars['String']>;
  readonly rawValue: Maybe<Scalars['String']>;
  readonly thumbUrl: Maybe<Scalars['String']>;
};


export type ThumborImageThumbUrlArgs = {
  size: Scalars['String'];
};

export enum TimelineGroupType {
  Network = 'NETWORK',
  None = 'NONE'
}

export enum TimelineItemType {
  LawsuitActivity = 'LAWSUIT_ACTIVITY',
  LawsuitAttachmentsOfDay = 'LAWSUIT_ATTACHMENTS_OF_DAY',
  Publication = 'PUBLICATION'
}

export type TimelineItemsConnection = {
  readonly __typename?: 'TimelineItemsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<TimelineItemsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type TimelineItemsEdge = {
  readonly __typename?: 'TimelineItemsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<CrmTimelineItem>;
};

export type Toggle = {
  readonly __typename?: 'Toggle';
  readonly benefitLP: Maybe<Scalars['String']>;
  readonly defaultOption: Scalars['String'];
  readonly description: ToggleDescription;
  readonly options: ReadonlyArray<Scalars['String']>;
};

export type ToggleDescription = {
  readonly __typename?: 'ToggleDescription';
  readonly benefit: Scalars['String'];
  readonly text: Scalars['String'];
};

export type ToggleFollowEntityInput = {
  readonly action: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly entityId: Scalars['Int'];
  readonly entityType: Scalars['String'];
};

export type ToggleFollowEntityPayload = {
  readonly __typename?: 'ToggleFollowEntityPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly followedEntity: Maybe<FollowableEntity>;
  readonly followersEdge: Maybe<EntityFollowersEdge>;
};

export type ToggleMonitoringCrmLawsuitsInput = {
  readonly boxOptions?: InputMaybe<Scalars['JSON']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly desiredMonitoringStatus?: InputMaybe<Scalars['Boolean']>;
  readonly lawsuitIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type ToggleMonitoringCrmLawsuitsPayload = {
  readonly __typename?: 'ToggleMonitoringCRMLawsuitsPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuits: Maybe<ReadonlyArray<Maybe<CrmLawsuit>>>;
};

export type ToggleSaveDocumentInput = {
  readonly action: Scalars['String'];
  readonly artifact: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId?: InputMaybe<Scalars['NumericID']>;
  readonly id?: InputMaybe<Scalars['Int']>;
};

export type ToggleSaveDocumentPayload = {
  readonly __typename?: 'ToggleSaveDocumentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly document: Maybe<Document>;
};

export type TokenExpireInfo = {
  readonly __typename?: 'TokenExpireInfo';
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly expireAmount: Maybe<Scalars['Int']>;
  readonly expireAt: Maybe<Scalars['Float']>;
};

export type TokenStat = {
  readonly __typename?: 'TokenStat';
  readonly constraints: Maybe<ReadonlyArray<Maybe<FeatureTokens>>>;
  readonly featureCode: Maybe<Scalars['String']>;
  readonly subscriptionId: Maybe<Scalars['Int']>;
  readonly subscriptionType: Maybe<Scalars['String']>;
};

export type Topic = FollowableEntity & Node & ShareableEntity & {
  readonly __typename?: 'Topic';
  readonly acronym: Maybe<Scalars['String']>;
  readonly alias: Maybe<Scalars['String']>;
  readonly articleAmount: Maybe<Scalars['Int']>;
  readonly attachmentsAmount: Maybe<Scalars['Int']>;
  readonly backUrlTopic: Maybe<Scalars['String']>;
  readonly cachedDocuments: Maybe<CachedDocuments>;
  readonly cachedSerpItems: Maybe<Scalars['JSON']>;
  readonly childrenLocationTopics: Maybe<ChildrenLocationTopicsConnection>;
  readonly childrenTopics: Maybe<ChildrenTopicsConnection>;
  readonly cnjNumber: Maybe<CnjNumber>;
  readonly compactTitle: Maybe<Scalars['String']>;
  readonly contact: Maybe<Contact>;
  readonly county: Maybe<Scalars['String']>;
  readonly crawlerMetadata: Maybe<CrawlerMetadata>;
  readonly creator: Maybe<Profile>;
  readonly crmLawsuit: Maybe<CrmLawsuit>;
  readonly definitionAmount: Maybe<Scalars['Int']>;
  readonly description: Maybe<Scalars['String']>;
  readonly detectedAnalysisType: Maybe<Scalars['String']>;
  readonly detectedEntityType: Maybe<Scalars['String']>;
  readonly directoryUrl: Maybe<Scalars['String']>;
  readonly doctrineSectionAmount: Maybe<Scalars['Int']>;
  readonly documentsAmount: Maybe<Scalars['Int']>;
  readonly entityId: Maybe<Scalars['NumericID']>;
  readonly entityRefId: Maybe<Scalars['String']>;
  readonly entityRefType: Maybe<Scalars['String']>;
  readonly entityType: Maybe<Scalars['String']>;
  readonly followers: Maybe<EntityFollowersConnection>;
  readonly followersAmount: Maybe<Scalars['Int']>;
  readonly forwardUrlTopic: Maybe<Scalars['String']>;
  readonly hotDocuments: Maybe<TopicHotDocumentsConnection>;
  readonly id: Scalars['ID'];
  readonly idsPrecedentesObrigatorios: Maybe<ReadonlyArray<Maybe<Scalars['Int']>>>;
  readonly image: Maybe<Scalars['String']>;
  readonly isFollowedByViewer: Maybe<Scalars['Boolean']>;
  readonly isLawsuit: Maybe<Scalars['Boolean']>;
  readonly isLegalSubjectMapped: Maybe<Scalars['Boolean']>;
  readonly isMainLegalSubject: Maybe<Scalars['Boolean']>;
  readonly isMonitoredByViewer: Maybe<Scalars['Boolean']>;
  readonly isPerson: Maybe<Scalars['Boolean']>;
  readonly isRemoved: Maybe<Scalars['Boolean']>;
  readonly journalAmount: Maybe<Scalars['Int']>;
  readonly journalBlocksAmount: Maybe<Scalars['Int']>;
  readonly judicialRequest: Scalars['Boolean'];
  readonly jurisprudenceAmount: Maybe<Scalars['Int']>;
  readonly keywords: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly lastDocuments: Maybe<TopicLastDocumentsConnection>;
  readonly lawAnchor: Maybe<Scalars['String']>;
  readonly lawItemDescription: Maybe<Scalars['String']>;
  readonly lawItemRevoked: Maybe<Scalars['Boolean']>;
  readonly lawItemType: Maybe<Scalars['String']>;
  readonly lawSubItems: ReadonlyArray<TopicLawItem>;
  readonly lawTitle: Maybe<Scalars['String']>;
  readonly lawTopic: Maybe<Topic>;
  readonly lawUpperItems: ReadonlyArray<TopicLawItem>;
  readonly lawsuitActivityItems: Maybe<LawsuitActivityItemsConnection>;
  readonly lawsuitAmount: Maybe<Scalars['Int']>;
  readonly lawsuitAttachments: Maybe<LawsuitAttachmentsConnection>;
  readonly lawsuitFollowupsAmount: Maybe<Scalars['Int']>;
  readonly lawsuitNumber: Maybe<Scalars['String']>;
  readonly lawsuitTimelineItems: Maybe<TimelineItemsConnection>;
  readonly legalSubjectSEOMetaTags: Maybe<Scalars['JSON']>;
  readonly legalSubjectSynonyms: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly legalSubjectsChildren: ReadonlyArray<Topic>;
  readonly legalSubjectsParents: ReadonlyArray<Topic>;
  readonly legisId: Maybe<Scalars['Float']>;
  readonly legislationAmount: Maybe<Scalars['Int']>;
  readonly mergedTopic: Maybe<Topic>;
  readonly modelAmount: Maybe<Scalars['Int']>;
  readonly motionAmount: Maybe<Scalars['Int']>;
  readonly nearbyLocationCities: Maybe<NearbyCitiesConnection>;
  readonly newsAmount: Maybe<Scalars['Int']>;
  readonly origin: Maybe<Scalars['String']>;
  readonly parentLocationTopic: Maybe<Topic>;
  readonly parentTopics: Maybe<ParentTopicsConnection>;
  readonly postBlogAmount: Maybe<Scalars['Int']>;
  readonly referenceLaw: Maybe<Document>;
  readonly referenceLawAnchor: Maybe<Scalars['String']>;
  readonly relatedDocuments: Maybe<TopicRelatedDocumentsConnection>;
  readonly relatedJurisprudentialGuidancesDocuments: Maybe<ReadonlyArray<Maybe<RelatedDocumentAtoNormativo>>>;
  readonly relatedLegis: ReadonlyArray<RelatedLegisItem>;
  readonly relatedMandatoryPrecedents: Maybe<ReadonlyArray<Maybe<Document>>>;
  readonly relatedSumulasDocuments: Maybe<ReadonlyArray<Maybe<RelatedDocumentAtoNormativo>>>;
  readonly relatedTopics: Maybe<RelatedTopicsConnection>;
  readonly removalRequest: Maybe<Scalars['Int']>;
  readonly seoNoIndex: Maybe<Scalars['Boolean']>;
  readonly shouldRedirectToSERP: Maybe<Scalars['Boolean']>;
  readonly slug: Maybe<Scalars['String']>;
  readonly slugAbout: Maybe<Scalars['String']>;
  readonly state: Maybe<Scalars['String']>;
  readonly staticSerp: ReadonlyArray<StaticSerpGroup>;
  readonly staticSerpRelatedQuestions: Maybe<ReadonlyArray<StaticSerpRelatedQuestions>>;
  readonly staticSerpSummary: Maybe<StaticSerpSummary>;
  readonly staticSerpSummaryList: Maybe<ReadonlyArray<StaticSerpSummary>>;
  readonly status: Maybe<Scalars['String']>;
  readonly summary: Maybe<Scalars['String']>;
  readonly synonyms: Maybe<TopicsSynonymsConnection>;
  readonly tags: Maybe<TagsConnection>;
  readonly thumborImage: Maybe<ThumborImage>;
  readonly tid: Scalars['Int'];
  readonly title: Maybe<Scalars['String']>;
  readonly titleWithNickname: Maybe<Scalars['String']>;
  readonly topicType: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
  readonly viewerCanMonitorLawsuit: Maybe<Scalars['Boolean']>;
  readonly viewerCanQueryLawsuit: Maybe<Scalars['Boolean']>;
  readonly viewerCanUseFeature: Maybe<Scalars['Boolean']>;
  readonly visibility: Scalars['String'];
};


export type TopicCachedDocumentsArgs = {
  artifact: InputMaybe<Scalars['String']>;
};


export type TopicChildrenLocationTopicsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type TopicChildrenTopicsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type TopicCrmLawsuitArgs = {
  usePrivateLawsuit: InputMaybe<Scalars['Boolean']>;
};


export type TopicFollowersArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type TopicHotDocumentsArgs = {
  after: InputMaybe<Scalars['String']>;
  artifact: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type TopicLastDocumentsArgs = {
  after: InputMaybe<Scalars['String']>;
  artifact: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type TopicLawsuitActivityItemsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type TopicLawsuitAttachmentsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  kind: InputMaybe<Scalars['String']>;
  kindGroup: InputMaybe<Scalars['String']>;
  source: InputMaybe<Scalars['String']>;
  sources: InputMaybe<ReadonlyArray<InputMaybe<AttachmentSourcesType>>>;
};


export type TopicLawsuitTimelineItemsArgs = {
  after: InputMaybe<Scalars['String']>;
  enableLimitDate?: InputMaybe<Scalars['Boolean']>;
  eventType: InputMaybe<Scalars['String']>;
  eventTypes: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  first: InputMaybe<Scalars['Int']>;
  groupType?: InputMaybe<TimelineGroupType>;
  providers: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  types: InputMaybe<ReadonlyArray<InputMaybe<TimelineItemType>>>;
  usePrivateLawsuit?: InputMaybe<Scalars['Boolean']>;
  withAttachmentsOfDay?: InputMaybe<Scalars['Boolean']>;
};


export type TopicLegalSubjectsChildrenArgs = {
  onlyMappedSubject: InputMaybe<Scalars['Boolean']>;
};


export type TopicNearbyLocationCitiesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type TopicParentTopicsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type TopicRelatedDocumentsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  filterOutArtifacts?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type TopicRelatedTopicsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type TopicStaticSerpArgs = {
  artifacts: ReadonlyArray<Scalars['String']>;
};


export type TopicSynonymsArgs = {
  after: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};


export type TopicTagsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
};


export type TopicUrlArgs = {
  useLegacy?: InputMaybe<Scalars['Boolean']>;
};


export type TopicViewerCanUseFeatureArgs = {
  featureCode: Scalars['String'];
  useLastActivityDateLimiter: InputMaybe<Scalars['Boolean']>;
};

export type TopicEntity = Node & {
  readonly __typename?: 'TopicEntity';
  readonly entityValue: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly slug: Maybe<Scalars['String']>;
  readonly topic: Maybe<Topic>;
  readonly url: Maybe<Scalars['String']>;
};

export type TopicHotDocumentsConnection = {
  readonly __typename?: 'TopicHotDocumentsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<TopicHotDocumentsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type TopicHotDocumentsEdge = {
  readonly __typename?: 'TopicHotDocumentsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Document>;
};

export type TopicLastDocumentsConnection = {
  readonly __typename?: 'TopicLastDocumentsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<TopicLastDocumentsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type TopicLastDocumentsEdge = {
  readonly __typename?: 'TopicLastDocumentsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Document>;
};

export type TopicLawItem = {
  readonly __typename?: 'TopicLawItem';
  readonly description: Maybe<Scalars['String']>;
  readonly hasToBeCompiled: Maybe<Scalars['Boolean']>;
  readonly itemId: Maybe<Scalars['Int']>;
  readonly relatedJurisprudentialGuidancesDocuments: Maybe<ReadonlyArray<Maybe<RelatedDocumentAtoNormativo>>>;
  readonly relatedMandatoryPrecedents: Maybe<ReadonlyArray<Maybe<Document>>>;
  readonly relatedSumulasDocuments: Maybe<ReadonlyArray<Maybe<RelatedDocumentAtoNormativo>>>;
  readonly revoked: Maybe<Scalars['Boolean']>;
  readonly topicId: Maybe<Scalars['Int']>;
  readonly type: Maybe<Scalars['String']>;
};

export type TopicRating = {
  readonly __typename?: 'TopicRating';
  readonly rating: Maybe<Rating>;
  readonly tid: Maybe<Scalars['Int']>;
  readonly topic: Maybe<Topic>;
};

export type TopicRelatedDocumentsConnection = {
  readonly __typename?: 'TopicRelatedDocumentsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<TopicRelatedDocumentsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type TopicRelatedDocumentsEdge = {
  readonly __typename?: 'TopicRelatedDocumentsEdge';
  readonly anchor: Maybe<Scalars['String']>;
  readonly cursor: Scalars['String'];
  readonly description: Maybe<Scalars['String']>;
  readonly node: Maybe<Document>;
};

export enum TopicTipoEnum {
  AssuntoJuridico = 'ASSUNTO_JURIDICO',
  Profissao = 'PROFISSAO'
}

export type TopicsSynonymsConnection = {
  readonly __typename?: 'TopicsSynonymsConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<TopicsSynonymsEdge>>>;
  readonly pageInfo: PageInfo;
};

export type TopicsSynonymsEdge = {
  readonly __typename?: 'TopicsSynonymsEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Topic>;
};

export type TransferHubUserInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly toUserCompanyId: Scalars['Int'];
  readonly transferUserData?: InputMaybe<Scalars['Boolean']>;
  readonly userId: Scalars['Int'];
};

export type TransferHubUserPayload = {
  readonly __typename?: 'TransferHubUserPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
  readonly userId: Scalars['Int'];
};

export type TransferOabInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly jwt: Scalars['String'];
};

export type TransferOabPayload = {
  readonly __typename?: 'TransferOabPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type TransferRelatedCrmEventsInput = {
  readonly calendarId: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly destEntityRefId: Scalars['String'];
  readonly entityRefType: Scalars['String'];
  readonly srcEntityRefId: Scalars['String'];
};

export type TransferRelatedCrmEventsPayload = {
  readonly __typename?: 'TransferRelatedCRMEventsPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
};

export type UnImpersonateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type UnImpersonatePayload = {
  readonly __typename?: 'UnImpersonatePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly cookie: Maybe<Scalars['String']>;
  readonly magicLink: Maybe<Scalars['String']>;
};

export type UnfavoriteCrmEntityInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly entityRefId: Scalars['String'];
  readonly entityRefType: Scalars['String'];
};

export type UnfavoriteCrmEntityPayload = {
  readonly __typename?: 'UnfavoriteCRMEntityPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly entity: Maybe<CrmEntity>;
};

export type UnidentifiedDecisionPart = {
  readonly __typename?: 'UnidentifiedDecisionPart';
  readonly type: Maybe<Scalars['String']>;
  readonly value: Maybe<Scalars['String']>;
};

export type UnlinkCrmTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly entityId: Scalars['String'];
  readonly entityType: Scalars['String'];
  readonly tagId: Scalars['String'];
};

export type UnlinkCrmTagPayload = {
  readonly __typename?: 'UnlinkCRMTagPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly entity: Maybe<CrmTaggable>;
  readonly link: Maybe<CrmTagLink>;
  readonly linkEdge: Maybe<CrmEntityTagsEdge>;
};

export type UnloggedValidateCpfInput = {
  readonly birthdate: Scalars['Int64'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cpf: Scalars['String'];
};

export type UnloggedValidateCpfPayload = {
  readonly __typename?: 'UnloggedValidateCPFPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly isValid: Scalars['Boolean'];
};

export type UnreadProfileConnection = {
  readonly __typename?: 'UnreadProfileConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<UnreadProfileEdge>>>;
  readonly pageInfo: PageInfo;
};

export type UnreadProfileEdge = {
  readonly __typename?: 'UnreadProfileEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Profile>;
};

export type UpdateAcademyUserInfoInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly sawWelcomeModal?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateAcademyUserInfoPayload = {
  readonly __typename?: 'UpdateAcademyUserInfoPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly id: Maybe<Scalars['Int']>;
  readonly sawWelcomeModal: Maybe<Scalars['Boolean']>;
};

export type UpdateB2BAreaInput = {
  readonly areaUuid: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly companyUuid: Scalars['String'];
  readonly name?: InputMaybe<Scalars['String']>;
  readonly seats?: InputMaybe<Scalars['Int']>;
  readonly status?: InputMaybe<Scalars['String']>;
};

export type UpdateB2BAreaPayload = {
  readonly __typename?: 'UpdateB2BAreaPayload';
  readonly area: Maybe<HubB2BAreaResult>;
  readonly clientMutationId: Maybe<Scalars['String']>;
};

export type UpdateB2BCompanyInput = {
  readonly brandName?: InputMaybe<Scalars['String']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cproEmbeddedUrl?: InputMaybe<Scalars['String']>;
  readonly expiresAt?: InputMaybe<Scalars['String']>;
  readonly isTrial?: InputMaybe<Scalars['Boolean']>;
  readonly legalName?: InputMaybe<Scalars['String']>;
  readonly legalNumber?: InputMaybe<Scalars['String']>;
  readonly uuid: Scalars['String'];
};

export type UpdateB2BCompanyPayload = {
  readonly __typename?: 'UpdateB2BCompanyPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly company: Maybe<HubB2BCompanyResult>;
};

export type UpdateCproUserFeaturesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly features: ReadonlyArray<InputMaybe<Scalars['String']>>;
  readonly organizationId: Scalars['String'];
  readonly userId: Scalars['String'];
};

export type UpdateCproUserFeaturesPayload = {
  readonly __typename?: 'UpdateCPROUserFeaturesPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly saved: Maybe<Scalars['Boolean']>;
};

export type UpdateCrmLawsuitPartyEntityHistoryInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly entityId: Scalars['String'];
};

export type UpdateCrmLawsuitPartyEntityHistoryPayload = {
  readonly __typename?: 'UpdateCRMLawsuitPartyEntityHistoryPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type UpdateCompanyQuotaInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly featureCode: Scalars['String'];
  readonly limit: Scalars['Int'];
  readonly profileId: Scalars['Int'];
};

export type UpdateCompanyQuotaPayload = {
  readonly __typename?: 'UpdateCompanyQuotaPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type UpdateContactInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly contact: Scalars['JSON'];
  readonly contactId: Scalars['String'];
};

export type UpdateContactPayload = {
  readonly __typename?: 'UpdateContactPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly contact: Maybe<Contact>;
  readonly crmEntity: Maybe<CrmEntity>;
};

export type UpdateCpfValidationInfoAsAdminInput = {
  readonly changes: Scalars['JSON'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type UpdateCpfValidationInfoAsAdminPayload = {
  readonly __typename?: 'UpdateCpfValidationInfoAsAdminPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type UpdateDocumentIndexableStatusInput = {
  readonly artifact: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId: Scalars['NumericID'];
  readonly noIndexable: Scalars['Boolean'];
};

export type UpdateDocumentIndexableStatusPayload = {
  readonly __typename?: 'UpdateDocumentIndexableStatusPayload';
  readonly artifact: Maybe<Scalars['String']>;
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly docId: Maybe<Scalars['NumericID']>;
  readonly noIndexable: Maybe<Scalars['Boolean']>;
};

export type UpdateExpertiseAreaInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly description?: InputMaybe<Scalars['String']>;
  readonly expertiseId: Scalars['Float'];
  readonly frequency: Scalars['Int'];
};

export type UpdateExpertiseAreaPayload = {
  readonly __typename?: 'UpdateExpertiseAreaPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type UpdateExpertisesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly expertisesIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Float']>>>;
};

export type UpdateExpertisesPayload = {
  readonly __typename?: 'UpdateExpertisesPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type UpdateFacebookConnectionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly facebookToken: Scalars['String'];
};

export type UpdateFacebookConnectionPayload = {
  readonly __typename?: 'UpdateFacebookConnectionPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type UpdateHubCompanyRequestPlanInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly planId: Scalars['Int'];
};

export type UpdateHubCompanyRequestPlanPayload = {
  readonly __typename?: 'UpdateHubCompanyRequestPlanPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly hubCompanyRequest: Maybe<HubCompanyRequest>;
};

export type UpdateHubInviteAreaInput = {
  readonly areaUuid: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly uuid: Scalars['String'];
};

export type UpdateHubInviteAreaPayload = {
  readonly __typename?: 'UpdateHubInviteAreaPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly errorCode: Maybe<Scalars['String']>;
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly invite: Maybe<HubInvite>;
};

export type UpdateHubInviteRoleInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly role: ReadonlyArray<InputMaybe<Scalars['String']>>;
  readonly uuid: Scalars['String'];
};

export type UpdateHubInviteRolePayload = {
  readonly __typename?: 'UpdateHubInviteRolePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly errorCode: Maybe<Scalars['String']>;
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly invite: Maybe<HubInvite>;
};

export type UpdateHubOrganizationInput = {
  readonly brandName?: InputMaybe<Scalars['String']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cproEmbeddedUrl?: InputMaybe<Scalars['String']>;
  readonly legalName?: InputMaybe<Scalars['String']>;
  readonly legalNumber?: InputMaybe<Scalars['String']>;
  readonly uuid: Scalars['String'];
};

export type UpdateHubOrganizationPayload = {
  readonly __typename?: 'UpdateHubOrganizationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly hubOrganization: Maybe<HubOrganization>;
};

export type UpdateInstitutionalProfileAdminsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly newProfilesIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']>>>;
  readonly removeProfilesIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']>>>;
};

export type UpdateInstitutionalProfileAdminsPayload = {
  readonly __typename?: 'UpdateInstitutionalProfileAdminsPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type UpdateLawServiceLocationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly idsLawServicesLocation?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Float']>>>;
  readonly remove?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateLawServiceLocationPayload = {
  readonly __typename?: 'UpdateLawServiceLocationPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type UpdateLawsuitSummaryInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly expiresInDays?: InputMaybe<Scalars['Int']>;
  readonly lawsuitId: Scalars['String'];
  readonly summary: Scalars['String'];
};

export type UpdateLawsuitSummaryPayload = {
  readonly __typename?: 'UpdateLawsuitSummaryPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly summarization: Maybe<CrmLawsuitSummarization>;
};

export type UpdateLawsuitTitleInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly expiresInDays?: InputMaybe<Scalars['Int']>;
  readonly lawsuitId: Scalars['String'];
  readonly title: Scalars['String'];
};

export type UpdateLawsuitTitlePayload = {
  readonly __typename?: 'UpdateLawsuitTitlePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly llmTitle: Maybe<CrmLawsuitLlmTitle>;
};

export type UpdateMagicLinkConfigInput = {
  readonly areaUuid?: InputMaybe<Scalars['String']>;
  readonly autoInvite?: InputMaybe<Scalars['Boolean']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly companyUuid: Scalars['String'];
  readonly configUuid: Scalars['String'];
  readonly domain?: InputMaybe<Scalars['String']>;
  readonly inactivityTtlSecs?: InputMaybe<Scalars['Int']>;
  readonly renewalTtlSecs?: InputMaybe<Scalars['Int']>;
};

export type UpdateMagicLinkConfigPayload = {
  readonly __typename?: 'UpdateMagicLinkConfigPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly magicLinkConfig: Maybe<HubMagicLinkConfig>;
};

export type UpdateNamesIndexableStatusInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly indexable: Scalars['Boolean'];
  readonly tid: Scalars['Int'];
};

export type UpdateNamesIndexableStatusPayload = {
  readonly __typename?: 'UpdateNamesIndexableStatusPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly indexable: Maybe<Scalars['Boolean']>;
  readonly pid: Maybe<Scalars['NumericID']>;
  readonly tid: Maybe<Scalars['Int']>;
};

export type UpdateOabValidationInfoInput = {
  readonly changes?: InputMaybe<Scalars['JSON']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly pid: Scalars['Int'];
};

export type UpdateOabValidationInfoPayload = {
  readonly __typename?: 'UpdateOabValidationInfoPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type UpdateProfileBadgesInput = {
  readonly addBadgeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Float']>>>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly pid?: InputMaybe<Scalars['Int']>;
  readonly removeBadgeIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Float']>>>;
};

export type UpdateProfileBadgesPayload = {
  readonly __typename?: 'UpdateProfileBadgesPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type UpdateProfileLastSeenCasesDashboardInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
};

export type UpdateProfileLastSeenCasesDashboardPayload = {
  readonly __typename?: 'UpdateProfileLastSeenCasesDashboardPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type UpdateProfilePlanInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly currentPlanId?: InputMaybe<Scalars['Float']>;
  readonly pid: Scalars['Int'];
  readonly toPlanId: Scalars['Float'];
};

export type UpdateProfilePlanPayload = {
  readonly __typename?: 'UpdateProfilePlanPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type UpdatePublicationMonitoringInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly monitoringId: Scalars['String'];
  readonly monitoringName: Scalars['String'];
  readonly payload: Scalars['JSON'];
  readonly shouldMonitorLawsuits?: InputMaybe<Scalars['Boolean']>;
};

export type UpdatePublicationMonitoringPayload = {
  readonly __typename?: 'UpdatePublicationMonitoringPayload';
  readonly alert: Maybe<PublicationAlert>;
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly organization: Maybe<Organization>;
};

export type UpdateSessionItemsCookieInput = {
  readonly artifact: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId: Scalars['NumericID'];
};

export type UpdateSessionItemsCookiePayload = {
  readonly __typename?: 'UpdateSessionItemsCookiePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly sessionItems: ReadonlyArray<Scalars['String']>;
};

export type UpdateUserCollectionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly collection: Scalars['JSON'];
  readonly collectionId: Scalars['String'];
};

export type UpdateUserCollectionPayload = {
  readonly __typename?: 'UpdateUserCollectionPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly cnjSubject: Maybe<Scalars['Int']>;
  readonly collectionId: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
  readonly documents: Maybe<ReadonlyArray<Maybe<UserCollectionDocument>>>;
  readonly isPublic: Maybe<Scalars['Boolean']>;
  readonly title: Maybe<Scalars['String']>;
  readonly userProfileId: Maybe<Scalars['Int']>;
};

export type UpdateWorkLocationsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly idsLocation?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Float']>>>;
};

export type UpdateWorkLocationsPayload = {
  readonly __typename?: 'UpdateWorkLocationsPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type UploadStudentEnrollmentDocInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly documentUrl: Scalars['String'];
};

export type UploadStudentEnrollmentDocPayload = {
  readonly __typename?: 'UploadStudentEnrollmentDocPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly rejectionReason: Maybe<Scalars['String']>;
  readonly status: Maybe<StudentBenefitStatusEnum>;
};

export type UpsertBatchMetadataInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly documents?: InputMaybe<ReadonlyArray<DocumentBatchInput>>;
  readonly names?: InputMaybe<ReadonlyArray<NameBatchInput>>;
  readonly serps?: InputMaybe<ReadonlyArray<SerpSeoMetadataBatchInput>>;
};

export type UpsertBatchMetadataPayload = {
  readonly __typename?: 'UpsertBatchMetadataPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly documentResults: Maybe<ReadonlyArray<Maybe<Document>>>;
  readonly failedIds: Maybe<ReadonlyArray<Maybe<Scalars['NumericID']>>>;
  readonly metadataResults: Maybe<ReadonlyArray<Maybe<SerpSeoMetadata>>>;
};

export type UpsertMetadataInput = {
  readonly advertisable: Scalars['Boolean'];
  readonly artifact?: InputMaybe<SerpSeoMetadataArtifacts>;
  readonly canonicalUrl?: InputMaybe<Scalars['String']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly indexable: Scalars['Boolean'];
  readonly queryText: Scalars['String'];
  readonly redirectTo?: InputMaybe<Scalars['String']>;
  readonly source?: InputMaybe<Scalars['String']>;
};

export type UpsertMetadataPayload = {
  readonly __typename?: 'UpsertMetadataPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly serpSEOMetadata: Maybe<SerpSeoMetadata>;
};

export type UpsertVirtualFeatureConfigInput = {
  readonly active: Scalars['Boolean'];
  readonly approved: Scalars['Boolean'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly constraintType: Scalars['String'];
  readonly featureCode: Scalars['String'];
  readonly limit: Scalars['Int'];
  readonly virtualFeatureConfigId?: InputMaybe<Scalars['Int']>;
};

export type UpsertVirtualFeatureConfigPayload = {
  readonly __typename?: 'UpsertVirtualFeatureConfigPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly virtualFeatureConfig: VirtualFeatureConfig;
};

export type UseCrmLawsuitPartyEntityFeatureInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly entityId: Scalars['String'];
  readonly feature: Scalars['String'];
  readonly fromComponent?: InputMaybe<Scalars['String']>;
};

export type UseCrmLawsuitPartyEntityFeaturePayload = {
  readonly __typename?: 'UseCRMLawsuitPartyEntityFeaturePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type UseDocumentFeatureInput = {
  readonly artifact: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId: Scalars['Float'];
  readonly feature: Scalars['String'];
  readonly fromComponent?: InputMaybe<Scalars['String']>;
};

export type UseDocumentFeaturePayload = {
  readonly __typename?: 'UseDocumentFeaturePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type UseSearchFeatureInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly feature: Scalars['String'];
  readonly query: Scalars['String'];
};

export type UseSearchFeaturePayload = {
  readonly __typename?: 'UseSearchFeaturePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type UseThirdPartySearchFeatureInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly entityId?: InputMaybe<Scalars['String']>;
  readonly fromComponent?: InputMaybe<Scalars['String']>;
};

export type UseThirdPartySearchFeaturePayload = {
  readonly __typename?: 'UseThirdPartySearchFeaturePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
  readonly upperBoundLimitReached: Maybe<Scalars['Boolean']>;
};

export type UseTopicFeatureInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly feature: Scalars['String'];
  readonly fromComponent?: InputMaybe<Scalars['String']>;
  readonly tid: Scalars['Int'];
  readonly useLastActivityDateLimiter?: InputMaybe<Scalars['Boolean']>;
};

export type UseTopicFeaturePayload = {
  readonly __typename?: 'UseTopicFeaturePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type UsedResource = {
  readonly __typename?: 'UsedResource';
  readonly document: Maybe<Document>;
  readonly expertise: Maybe<Topic>;
  readonly featureCode: Maybe<Scalars['String']>;
  readonly legalCase: Maybe<LegacyLegalCase>;
  readonly profile: Maybe<Profile>;
  readonly resourceId: Maybe<Scalars['String']>;
  readonly subscriptionId: Maybe<Scalars['Int']>;
  readonly user: Maybe<Scalars['String']>;
  readonly when: Maybe<Scalars['Float']>;
};

export type User = Node & {
  readonly __typename?: 'User';
  readonly allOnboardingReminders: Maybe<Scalars['JSON']>;
  readonly b2bUser: Maybe<Scalars['Boolean']>;
  readonly candidateEmail: Maybe<Scalars['String']>;
  readonly confirmedEmail: Maybe<Scalars['Boolean']>;
  readonly cproUser: Maybe<CproAuthUser>;
  readonly crmBetaGroup: Maybe<Scalars['String']>;
  readonly dataCrmBetaTester: Maybe<Scalars['Float']>;
  readonly deletionRequestedAt: Maybe<Scalars['Float']>;
  readonly digestoUser: Maybe<DigestoUser>;
  readonly email: Maybe<Scalars['String']>;
  readonly facebookId: Maybe<Scalars['String']>;
  readonly googleId: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly idJC: Maybe<Scalars['Int']>;
  readonly isActive: Maybe<Scalars['Boolean']>;
  readonly isAdmin: Maybe<Scalars['Boolean']>;
  readonly isBigAccountUser: Maybe<Scalars['Boolean']>;
  readonly isCrmBetaTester: Maybe<Scalars['Boolean']>;
  readonly isDeleted: Maybe<Scalars['Boolean']>;
  readonly keycloakAuthorization: Maybe<KeycloakAuthorization>;
  readonly mainProfile: Maybe<Profile>;
  readonly obfuscatedEmail: Maybe<Scalars['String']>;
  readonly onboardingReminders: Maybe<Scalars['Float']>;
  readonly onboardingSteps: Maybe<Scalars['JSON']>;
  /** @deprecated Please use `onboarding` from the profile. */
  readonly onboardingStopStep: Scalars['Int'];
  readonly passwordPending: Maybe<Scalars['Boolean']>;
  readonly profile: Maybe<Profile>;
  readonly profiles: Maybe<UserAssociatedProfilesConnection>;
  readonly rawEmail: Maybe<Scalars['String']>;
  readonly startedOnboardingSteps: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly uid: Maybe<Scalars['Int']>;
};


export type UserObfuscatedEmailArgs = {
  obfuscationLevel: InputMaybe<Scalars['String']>;
};


export type UserOnboardingRemindersArgs = {
  onboarding: Scalars['String'];
};


export type UserOnboardingStopStepArgs = {
  onboardingName: Scalars['String'];
};


export type UserProfilesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  onlyActive: InputMaybe<Scalars['Boolean']>;
};

export type UserAssociatedProfilesConnection = {
  readonly __typename?: 'UserAssociatedProfilesConnection';
  readonly edges: Maybe<ReadonlyArray<Maybe<UserAssociatedProfilesEdge>>>;
  readonly pageInfo: PageInfo;
};

export type UserAssociatedProfilesEdge = {
  readonly __typename?: 'UserAssociatedProfilesEdge';
  readonly cursor: Scalars['String'];
  readonly node: Maybe<Profile>;
};

export type UserCollection = {
  readonly __typename?: 'UserCollection';
  readonly cnjSubject: Maybe<Scalars['Int']>;
  readonly collectionId: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
  readonly documents: Maybe<ReadonlyArray<Maybe<UserCollectionDocument>>>;
  readonly isPublic: Maybe<Scalars['Boolean']>;
  readonly title: Maybe<Scalars['String']>;
  readonly userProfileId: Maybe<Scalars['Int']>;
};

export type UserCollectionDetail = {
  readonly __typename?: 'UserCollectionDetail';
  readonly cnjSubject: Maybe<Scalars['Int']>;
  readonly collectionId: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
  readonly documents: Maybe<ReadonlyArray<Maybe<UserCollectionDocumentDetail>>>;
  readonly isPublic: Maybe<Scalars['Boolean']>;
  readonly title: Maybe<Scalars['String']>;
  readonly userProfileId: Maybe<Scalars['Int']>;
};

export type UserCollectionDocument = {
  readonly __typename?: 'UserCollectionDocument';
  readonly artifact: Maybe<Scalars['String']>;
  readonly id: Maybe<Scalars['Int']>;
};

export type UserCollectionDocumentDetail = {
  readonly __typename?: 'UserCollectionDocumentDetail';
  readonly artifact: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
  readonly id: Maybe<Scalars['Int']>;
  readonly title: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
};

export type UserCompany = {
  readonly __typename?: 'UserCompany';
  readonly createdAt: Maybe<Scalars['String']>;
  readonly id: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly updatedAt: Maybe<Scalars['String']>;
  readonly uri: Maybe<Scalars['String']>;
};

export type UserFeature = {
  readonly __typename?: 'UserFeature';
  readonly name: Scalars['String'];
  readonly type: Scalars['String'];
};

export enum UserPlanStatusType {
  AdvancedSubscription = 'ADVANCED_SUBSCRIPTION',
  BasicSubscription = 'BASIC_SUBSCRIPTION',
  Logged = 'LOGGED',
  Unlogged = 'UNLOGGED'
}

export type UserReportProblemInput = {
  readonly additionalInformation?: InputMaybe<Scalars['JSON']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly problem: Scalars['String'];
  readonly type?: InputMaybe<Scalars['String']>;
};

export type UserReportProblemPayload = {
  readonly __typename?: 'UserReportProblemPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly user: Maybe<User>;
};

export type UserRequestedUpdateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
};

export type UserRequestedUpdatePayload = {
  readonly __typename?: 'UserRequestedUpdatePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuit: Maybe<CrmLawsuit>;
};

export type ValidateAuthTokenInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly token: Scalars['String'];
};

export type ValidateAuthTokenPayload = {
  readonly __typename?: 'ValidateAuthTokenPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly uid: Maybe<Scalars['String']>;
};

export type ValidateCpfInput = {
  readonly birthdate: Scalars['Float'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cpf: Scalars['String'];
  readonly documentData?: InputMaybe<Scalars['String']>;
  readonly documentName?: InputMaybe<Scalars['String']>;
  readonly matchValidationFirst?: InputMaybe<Scalars['Boolean']>;
  readonly origin?: InputMaybe<Scalars['String']>;
  readonly pid?: InputMaybe<Scalars['Int']>;
  readonly saveCpfDataOnError?: InputMaybe<Scalars['Boolean']>;
};

export type ValidateCpfPayload = {
  readonly __typename?: 'ValidateCPFPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type ValidateInviteCsvInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly csvBase64: Scalars['String'];
};

export type ValidateInviteCsvPayload = {
  readonly __typename?: 'ValidateInviteCsvPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly errorRows: Maybe<ReadonlyArray<Maybe<ValidateInviteCsvRow>>>;
  readonly rows: Maybe<ReadonlyArray<Maybe<ValidateInviteCsvRow>>>;
  readonly totalRows: Maybe<Scalars['Int']>;
  readonly validRows: Maybe<Scalars['Int']>;
};

export type ValidateInviteCsvRow = {
  readonly __typename?: 'ValidateInviteCsvRow';
  readonly email: Maybe<Scalars['String']>;
  readonly errors: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly name: Maybe<Scalars['String']>;
  readonly row: Maybe<Scalars['Int']>;
  readonly valid: Maybe<Scalars['Boolean']>;
};

export type ValidateLawsuitProfileInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
};

export type ValidateLawsuitProfilePayload = {
  readonly __typename?: 'ValidateLawsuitProfilePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuitValidatedProfile: Maybe<CrmLawsuitValidatedProfile>;
};

export type ValidateLawsuitRepresentedPersonInput = {
  readonly birthdate?: InputMaybe<Scalars['Float']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly cnpj?: InputMaybe<Scalars['String']>;
  readonly cpf?: InputMaybe<Scalars['String']>;
  readonly lawsuitId: Scalars['String'];
  readonly relationship: Scalars['String'];
};

export type ValidateLawsuitRepresentedPersonPayload = {
  readonly __typename?: 'ValidateLawsuitRepresentedPersonPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly lawsuitValidatedProfile: Maybe<CrmLawsuitValidatedProfile>;
};

export type ValidateOabInput = {
  readonly birthDate?: InputMaybe<Scalars['Float']>;
  readonly checkDuplicatedValidatedOabOnly?: InputMaybe<Scalars['Boolean']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly collectIfMissing?: InputMaybe<Scalars['Boolean']>;
  readonly cpf?: InputMaybe<Scalars['String']>;
  readonly documentData?: InputMaybe<Scalars['String']>;
  readonly documentName?: InputMaybe<Scalars['String']>;
  readonly followUpEnvironment?: InputMaybe<FollowUpEnvironment>;
  readonly oab: Scalars['String'];
  readonly oabType: Scalars['String'];
  readonly oabUf: Scalars['Int'];
  readonly origin?: InputMaybe<Scalars['String']>;
  readonly pid?: InputMaybe<Scalars['Int']>;
  readonly saveDetails?: InputMaybe<Scalars['Boolean']>;
  readonly throwErrorWhenIsInvalid?: InputMaybe<Scalars['Boolean']>;
};

export type ValidateOabPayload = {
  readonly __typename?: 'ValidateOabPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly profile: Maybe<Profile>;
};

export type ValidateSmsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly docId?: InputMaybe<Scalars['Float']>;
  readonly legalCaseId?: InputMaybe<Scalars['Float']>;
  readonly migrationId?: InputMaybe<Scalars['Float']>;
  readonly phoneNumber: Scalars['String'];
};

export type ValidateSmsPayload = {
  readonly __typename?: 'ValidateSMSPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
};

export type ValidateSignupTokenInput = {
  readonly app: Scalars['String'];
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly token: Scalars['String'];
};

export type ValidateSignupTokenPayload = {
  readonly __typename?: 'ValidateSignupTokenPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly email: Maybe<Scalars['String']>;
};

export type ValidateStudentEnrollmentDocumentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly course: Scalars['String'];
  readonly documentData: Scalars['String'];
  readonly documentName: Scalars['String'];
  readonly enrollmentPeriod: Scalars['String'];
  readonly institution: Scalars['String'];
  readonly mimeType?: InputMaybe<Scalars['String']>;
};

export type ValidateStudentEnrollmentDocumentPayload = {
  readonly __typename?: 'ValidateStudentEnrollmentDocumentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly rejectionReason: Maybe<StudentEnrollmentRejectionReasonEnum>;
  readonly status: Maybe<StudentBenefitStatusEnum>;
};

export type ValidateTurnstileTokenInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly token: Scalars['String'];
};

export type ValidateTurnstileTokenPayload = {
  readonly __typename?: 'ValidateTurnstileTokenPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly errorCodes: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly success: Scalars['Boolean'];
};

export type VariationTypes = {
  readonly __typename?: 'VariationTypes';
  readonly featureCodes: ReadonlyArray<Scalars['String']>;
  readonly lockTypes: ReadonlyArray<Scalars['String']>;
  readonly product: Maybe<Scalars['String']>;
};

export type VerifyOtpCodeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly otp: Scalars['String'];
};

export type VerifyOtpCodePayload = {
  readonly __typename?: 'VerifyOTPCodePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly token: Maybe<Scalars['String']>;
};

export type ViewerRestrictionInput = {
  readonly isICPValidatedLawyer: Scalars['Boolean'];
  readonly isVerifiedLawsuitParty: Scalars['Boolean'];
};

export type VirtualFeatureConfig = {
  readonly __typename?: 'VirtualFeatureConfig';
  readonly active: Maybe<Scalars['Boolean']>;
  readonly approved: Maybe<Scalars['Boolean']>;
  readonly constraintType: Maybe<Scalars['String']>;
  readonly featureCode: Maybe<Scalars['String']>;
  readonly limit: Maybe<Scalars['Int']>;
  readonly virtualFeatureConfigId: Maybe<Scalars['Int']>;
};

export type VisionEntity = {
  readonly __typename?: 'VisionEntity';
  readonly entityClass: Maybe<Scalars['String']>;
  readonly externalReferenceId: Maybe<Scalars['Int']>;
  readonly idEntity: Maybe<Scalars['JSON']>;
  readonly properties: Maybe<Scalars['JSON']>;
  readonly propertyValue: Maybe<Scalars['String']>;
  readonly relationships: Maybe<EntityRelationshipsConnection>;
};


export type VisionEntityRelationshipsArgs = {
  after: InputMaybe<Scalars['String']>;
  destinationClass: InputMaybe<Scalars['String']>;
  first: InputMaybe<Scalars['Int']>;
};

export type VisionRelation = {
  readonly __typename?: 'VisionRelation';
  readonly entity: Maybe<VisionEntity>;
  readonly occurrences: Maybe<Scalars['Int']>;
  readonly relationName: Maybe<Scalars['String']>;
};

export type VoteDocumentCommentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly commentId: Scalars['NumericID'];
  readonly vote?: InputMaybe<VoteTypeEnum>;
};

export type VoteDocumentCommentPayload = {
  readonly __typename?: 'VoteDocumentCommentPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly currentVote: Scalars['String'];
  readonly oldVote: Scalars['String'];
  readonly totalVotes: Scalars['Int'];
};

export enum VoteTypeEnum {
  Negative = 'NEGATIVE',
  None = 'NONE',
  Positive = 'POSITIVE'
}

export enum WaitlistReasonEnum {
  CapReached = 'cap_reached',
  Variant = 'variant'
}

export type WhatsappMessage = {
  readonly __typename?: 'WhatsappMessage';
  readonly createdAt: Maybe<Scalars['Float']>;
  readonly id: Scalars['String'];
  readonly idempotencyKey: Maybe<Scalars['String']>;
  readonly phoneNumber: Scalars['String'];
  readonly profileId: Scalars['Int'];
  readonly providerCode: Maybe<Scalars['String']>;
  readonly providerErrorCode: Maybe<Scalars['String']>;
  readonly providerErrorMessage: Maybe<Scalars['String']>;
  readonly providerMessageId: Maybe<Scalars['String']>;
  readonly providerMessageStatus: Maybe<Scalars['String']>;
  readonly status: Maybe<MessageStatus>;
  readonly templateId: Maybe<Scalars['String']>;
  readonly templateVariables: Maybe<Scalars['JSON']>;
  readonly updatedAt: Maybe<Scalars['Float']>;
};

export type WingmanAvailability = {
  readonly __typename?: 'WingmanAvailability';
  readonly canUse: Scalars['Boolean'];
  readonly condition: Scalars['String'];
  readonly participateExperiment: Maybe<Experiment>;
  readonly preparationDetails: Maybe<Scalars['JSON']>;
};

export type WingmanDocumentGptSnippetSummary = {
  readonly __typename?: 'WingmanDocumentGPTSnippetSummary';
  readonly factsHtmlWithCitations: Maybe<Scalars['String']>;
  readonly wingmanAvailability: WingmanAvailability;
};

export type WingmanDocumentGptSummaryOnDocview = {
  readonly __typename?: 'WingmanDocumentGPTSummaryOnDocview';
  readonly factsHtmlWithCitations: Maybe<Scalars['String']>;
  readonly wingmanAvailability: WingmanAvailability;
};

export type WingmanUndoFeatureUsageInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly featureCode: Scalars['String'];
  readonly itemId: Scalars['String'];
};

export type WingmanUndoFeatureUsagePayload = {
  readonly __typename?: 'WingmanUndoFeatureUsagePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
};

export type WingmanUseFeatureInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly conversationId: Scalars['String'];
  readonly featureCode: Scalars['String'];
  readonly fromComponent?: InputMaybe<Scalars['String']>;
  readonly itemId: Scalars['String'];
};

export type WingmanUseFeaturePayload = {
  readonly __typename?: 'WingmanUseFeaturePayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Scalars['Boolean'];
};

export type YearsRange = {
  readonly __typename?: 'YearsRange';
  readonly end: Maybe<Scalars['Int']>;
  readonly start: Maybe<Scalars['Int']>;
};

export type BoxClaimFeature = {
  readonly __typename?: 'boxClaimFeature';
  readonly featureCode: Scalars['String'];
  readonly featureName: Scalars['String'];
  readonly isActive: Scalars['Boolean'];
  readonly productTitle: Scalars['String'];
};

export type BoxCompanyClaimFeature = {
  readonly __typename?: 'boxCompanyClaimFeature';
  readonly featureCode: Scalars['String'];
  readonly featureName: Scalars['String'];
  readonly featureType: Maybe<FeatureType>;
  readonly isActive: Scalars['Boolean'];
  readonly limit: Maybe<Scalars['Int']>;
  readonly productTitle: Scalars['String'];
};

export type CreateCrmLawsuitSearchUserInteractionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly query: Scalars['String'];
  readonly queryId: Scalars['String'];
  readonly relation: Scalars['String'];
  readonly saveProfile?: InputMaybe<Scalars['Boolean']>;
};

export type CreateCrmLawsuitSearchUserInteractionPayload = {
  readonly __typename?: 'createCRMLawsuitSearchUserInteractionPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly crmLawsuitSearchUserInteraction: Maybe<CrmLawsuitSearchUserInteraction>;
};

export type DecodeEmailAndAuthenticateUserInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly token: Scalars['String'];
};

export type DecodeEmailAndAuthenticateUserPayload = {
  readonly __typename?: 'decodeEmailAndAuthenticateUserPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly cookie: Maybe<Scalars['String']>;
  readonly user: Maybe<User>;
};

export type IncrementCrmLawsuitSearchUserInteractionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly queryId: Scalars['String'];
};

export type IncrementCrmLawsuitSearchUserInteractionPayload = {
  readonly __typename?: 'incrementCRMLawsuitSearchUserInteractionPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly crmLawsuitSearchUserInteraction: Maybe<CrmLawsuitSearchUserInteraction>;
};

export enum MessageType {
  AskLawsuit = 'ASK_LAWSUIT',
  CurrentSituation = 'CURRENT_SITUATION',
  Forecast = 'FORECAST',
  NextSteps = 'NEXT_STEPS'
}

export type SendForgotPasswordMailInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly email: Scalars['String'];
};

export type SendForgotPasswordMailPayload = {
  readonly __typename?: 'sendForgotPasswordMailPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type SendLawsuitPreviewLinkMailInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly lawsuitId: Scalars['String'];
  readonly lawsuitNumber: Scalars['String'];
  readonly uid?: InputMaybe<Scalars['Int']>;
};

export type SendLawsuitPreviewLinkMailPayload = {
  readonly __typename?: 'sendLawsuitPreviewLinkMailPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type VerifyEmailForErpMobileSignupInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']>;
  readonly encodedValue: Scalars['String'];
};

export type VerifyEmailForErpMobileSignupPayload = {
  readonly __typename?: 'verifyEmailForERPMobileSignupPayload';
  readonly clientMutationId: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};
